import { TOUR_IMAGES } from "@/data/tourImages";
// Rich sample dataset for Royal Tours — India tour packages.
// Images use Unsplash (India landmarks) with a guaranteed local fallback (see SmartImage).

const U = (id, w = 900) =>
  String(id).startsWith("/") ? id : `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

// Local fallbacks that always exist in /public/assets/media
export const FALLBACK_IMAGES = [
  "/assets/media/030-images-unsplash-com-photo-1564507592333-c60657eea523.jpg",
  "/assets/media/037-images-unsplash-com-photo-1599661046289-e31897846e41.jpg",
  "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg",
  "/assets/media/042-images-unsplash-com-photo-1626621341517-bbf3d9990a23.jpg",
];

const INDIA_TOURS = [
  {
    slug: "mathura-vrindavan-gokul-govardhan",
    title: "Mathura Vrindavan Gokul Govardhan",
    scope: "india",
    image: "/assets/media/wiki-prem-mandir.jpg",
    gallery: ["/assets/media/wiki-prem-mandir.jpg", "/assets/media/wiki-ayodhya.jpg"],
    code: "RTMV",
    tourType: "GROUP TOUR",
    speciality: "Family Pilgrimage",
    allInclusive: true,
    days: 4,
    nights: 3,
    statesCount: 2,
    citiesCount: 4,
    region: "Uttar Pradesh",
    zone: "North",
    interest: "Pilgrimage",
    packageType: "Group Tour",
    startingPrice: 34000,
    joiningLeavingPrice: 23000,
    emiPerMonth: 3311,
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Delhi (Joining/leaving)"],
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Delhi", stops: ["Delhi Airport"] },
      { state: "Uttar Pradesh", stops: ["Mathura (3N)", "Gokul", "Vrindavan", "Govardhan", "Barsana"] },
    ],
    highlights: [
      "Govardhan Hill",
      "Barsana cable car ride",
      "Radha Rani Temple",
      "Brahmand Ghat",
      "Chintaharan Mahadev Temple",
      "Chaurasi Khamba",
      "Raman Reti",
      "Shri Krishna Janmabhoomi",
      "Banke Bihari Temple",
      "Prem Mandir",
      "ISKCON Temple",
      "Chandrodaya Temple",
    ],
    itinerary: [
      {
        day: 1,
        title: "Mumbai · Delhi · Mathura",
        state: "Uttar Pradesh",
        desc: "Meet the group at Mumbai airport for the scheduled flight to Delhi. On arrival, join the group transfer to Mathura and check in. Joining guests meet the tour manager at the agreed point. Dinner and overnight stay in Mathura.",
        nights: 3,
      },
      {
        day: 2,
        title: "Mathura · Govardhan · Barsana · Gokul · Mathura",
        state: "Uttar Pradesh",
        desc: "Visit Govardhan Hill, then continue to Barsana for the cable car ride and Radha Rani Temple. In Gokul, visit Brahmand Ghat, Chintaharan Mahadev Temple, Chaurasi Khamba and Raman Reti before returning to Mathura. Breakfast, lunch and dinner; overnight in Mathura.",
      },
      {
        day: 3,
        title: "Mathura · Vrindavan · Mathura",
        state: "Uttar Pradesh",
        desc: "Visit Shri Krishna Janmabhoomi in Mathura, followed by Banke Bihari Temple, Prem Mandir, ISKCON Temple and Chandrodaya Temple in Vrindavan. Return to Mathura. Breakfast, lunch and dinner; overnight in Mathura.",
      },
      {
        day: 4,
        title: "Mathura · Delhi · Mumbai",
        state: "Delhi",
        desc: "After breakfast, travel to Delhi for the scheduled return flight to Mumbai. Joining/leaving guests continue with their independently arranged onward travel from Delhi. Tour concludes.",
      },
    ],
    dates: [
      { date: "Wed Mar 24, 2027", price: 34000, tag: "Available departure" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true },
  },
  {
    slug: "delhi-agra",
    title: "Delhi Agra",
    scope: "india",
    image: U("1564507592333-c60657eea523"),
    gallery: [U("1564507592333-c60657eea523"), U("1548013146-72479768bada"), U("1587135941948-670b381f08ce")],
    code: "STAD",
    tourType: "GROUP TOUR",
    speciality: "Short Trips",
    allInclusive: true,
    days: 5,
    nights: 4,
    statesCount: 2,
    citiesCount: 5,
    region: "Uttar Pradesh",
    zone: "North",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 28000,
    emiPerMonth: 2726,
    rating: 5,
    reviewsCount: 44,
    guestsRated: "1.7k",
    guestPhotos: 45,
    route: [
      { state: "Delhi", stops: ["Delhi (2N)"] },
      { state: "Uttar Pradesh", stops: ["Mathura", "Vrindavan", "Agra (2N)", "Fatehpur Sikri"] },
    ],
    highlights: ["Fatehpur Sikri", "Taj Mahal", "Mehtab Bagh", "Agra Fort", "Mathura", "Akshardham Temple", "Qutub Minar", "Red Fort", "Ugrasen ki Baoli"],
    departureCities: ["Delhi (Joining/leaving)"],
    dates: [
      { date: "Fri Aug 21, 2026", price: 28000, tag: "Lowest Price" },
      { date: "Fri Sep 18, 2026", price: 29000 },
      { date: "Fri Oct 09, 2026", price: 32000, note: "Durga Pujo Special" },
      { date: "Fri Nov 06, 2026", price: 35000 },
      { date: "Fri Nov 20, 2026", price: 38000 },
      { date: "Fri Dec 25, 2026", price: 42000, note: "Christmas Special" },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true },
    review: {
      text: "Nice experience, all are very nice, tour manager Atish is very cooperative and very much helping, Atish is very good informative. Hotels is also very nice.",
      author: "Kaweri",
      date: "Travelled Jan 18, 2026",
      manager: "Atish Berde",
    },
  },
  {
    slug: "jaipur-mandawa",
    title: "Jaipur & Mandawa Heritage Tour",
    image: U("1477587458883-47145ed94245"),
    gallery: [U("1477587458883-47145ed94245"), U("1599661046289-e31897846e41"), U("1599661046289-e31897846e41")],
    code: "RTJM",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 4,
    nights: 3,
    statesCount: 1,
    citiesCount: 3,
    region: "Rajasthan",
    zone: "West & Central",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 30000,
    emiPerMonth: 2921,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Rajasthan", stops: ["Jaipur (2N)", "Mandawa (1N)"] },
    ],
    highlights: [
      "Mandawa Fort",
      "Morarka Haveli",
      "Podar Haveli Museum",
      "Nawalgarh heritage town",
      "Amer Fort sound & light show",
      "Hawa Mahal",
      "Jantar Mantar",
      "City Palace Jaipur",
      "Panna Meena ka Kund",
    ],
    departureCities: ["Jaipur (Joining/leaving)"],
    departureCity: "Jaipur",
    dates: [],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Jaipur · Amer Fort",
        state: "Rajasthan",
        desc: "Arrive in Jaipur and meet the Royal Tours team for your hotel transfer. After check-in, explore the Amber Fort area and Panna Meena ka Kund. In the evening, enjoy the sound and light show at Amer Fort before returning to the hotel. Overnight in Jaipur.",
        nights: 2,
      },
      {
        day: 2,
        title: "Jaipur city heritage",
        state: "Rajasthan",
        desc: "Discover Jaipur’s historic centre with visits to City Palace and Jantar Mantar, followed by a view of the iconic Hawa Mahal. Enjoy time to browse the old city’s colourful bazaars before returning to your hotel. Overnight in Jaipur.",
      },
      {
        day: 3,
        title: "Jaipur · Mandawa havelis",
        state: "Rajasthan",
        desc: "After breakfast, drive to Mandawa in the Shekhawati region. Visit Mandawa Fort and explore the frescoed merchant mansions, including Morarka Haveli and Podar Haveli Museum. Overnight in Mandawa.",
        nights: 1,
      },
      {
        day: 4,
        title: "Nawalgarh · Return to Jaipur",
        state: "Rajasthan",
        desc: "Visit Nawalgarh to see its historic havelis and painted streets. Later, travel back to Jaipur for your onward connection. Tour concludes on arrival in Jaipur.",
      },
    ],
  },
  {
    slug: "best-of-kashmir",
    title: "Best of Kashmir",
    image: "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg",
    gallery: ["/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg", "/assets/media/046-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg"],
    code: "JKBK",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 6,
    nights: 5,
    statesCount: 1,
    citiesCount: 5,
    region: "Jammu And Kashmir",
    zone: "North",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 51000,
    emiPerMonth: 4966,
    rating: 5,
    reviewsCount: 97,
    guestsRated: "3.4k",
    guestPhotos: 120,
    route: [
      { state: "Jammu & Kashmir", stops: ["Srinagar (2N)", "Gulmarg (1N)", "Pahalgam (1N)", "Sonmarg", "Dal Lake"] },
    ],
    highlights: ["Dal Lake Shikara Ride", "Gulmarg Gondola", "Betaab Valley", "Sonmarg", "Mughal Gardens", "Pahalgam"],
    departureCities: ["Srinagar (Joining/leaving)"],
    dates: [
      { date: "Fri Apr 10, 2026", price: 51000, tag: "Lowest Price" },
      { date: "Fri May 08, 2026", price: 56000, note: "Tulip Season" },
      { date: "Fri Jun 12, 2026", price: 58000 },
      { date: "Fri Jul 10, 2026", price: 54000 },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true },
    review: {
      text: "10/10 for the tour manager for his perfect planning. Kashmir is heaven on earth and Royal Tours made it seamless.",
      author: "Ninad",
      date: "Travelled Mar 12, 2026",
      manager: "Umesh Vishe",
    },
  },
  {
    slug: "highlights-of-kerala",
    title: "Highlights of Kerala",
    image: U("1602216056096-3b40cc0c9944"),
    gallery: [U("1602216056096-3b40cc0c9944"), U("1590050752117-238cb0fb12b1")],
    code: "KLHK",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 7,
    nights: 6,
    statesCount: 1,
    citiesCount: 6,
    region: "Kerala",
    zone: "South",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 35000,
    emiPerMonth: 3407,
    rating: 5,
    reviewsCount: 128,
    guestsRated: "10.6k",
    guestPhotos: 210,
    route: [
      { state: "Kerala", stops: ["Cochin (1N)", "Munnar (2N)", "Thekkady (1N)", "Alleppey (1N)", "Kovalam (1N)"] },
    ],
    highlights: ["Munnar Tea Gardens", "Alleppey Houseboat", "Periyar Wildlife", "Kathakali Show", "Fort Kochi", "Kovalam Beach"],
    departureCities: ["Cochin (Joining/leaving)"],
    dates: [
      { date: "Sat Aug 08, 2026", price: 35000, tag: "Lowest Price" },
      { date: "Sat Sep 05, 2026", price: 36500 },
      { date: "Sat Oct 03, 2026", price: 39000, note: "Onam Special" },
      { date: "Sat Dec 19, 2026", price: 44000, note: "Christmas Special" },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true },
    review: {
      text: "Very nice experience. All Royal Tours staff was very good, the houseboat stay in Alleppey was the highlight of our trip.",
      author: "Vandana",
      date: "Travelled Jan 28, 2026",
      manager: "Saurabh Shinde",
    },
  },
  {
    slug: "best-of-ladakh",
    title: "Best of Ladakh",
    image: "/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg",
    gallery: ["/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg", "/assets/media/043-images-unsplash-com-photo-1645033393637-9089ab100756.jpg"],
    code: "LDBL",
    tourType: "GROUP TOUR",
    speciality: "Road Trips",
    allInclusive: true,
    days: 8,
    nights: 7,
    statesCount: 1,
    citiesCount: 4,
    region: "Leh Ladakh",
    zone: "North",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 78000,
    emiPerMonth: 7594,
    rating: 5,
    reviewsCount: 74,
    guestsRated: "5.9k",
    guestPhotos: 95,
    route: [
      { state: "Ladakh", stops: ["Leh (3N)", "Nubra Valley (1N)", "Pangong Tso (1N)", "Kargil (1N)"] },
    ],
    highlights: ["Pangong Lake", "Nubra Valley", "Khardung La Pass", "Thiksey Monastery", "Magnetic Hill", "Shanti Stupa"],
    departureCities: ["Leh (Joining/leaving)"],
    dates: [
      { date: "Fri Jun 05, 2026", price: 78000, tag: "Lowest Price" },
      { date: "Fri Jul 03, 2026", price: 82000 },
      { date: "Fri Aug 07, 2026", price: 84000 },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true },
    review: {
      text: "Breathtaking landscapes and superbly managed acclimatisation. The Pangong Lake camp night was unforgettable.",
      author: "Rahul",
      date: "Travelled Jul 20, 2025",
      manager: "Umesh Vishe",
    },
  },
  {
    slug: "shimla-manali",
    title: "Shimla Manali",
    image: U("1626621341517-bbf3d9990a23", 901),
    gallery: [U("1544634076-a90160ddf44c"), U("1626621341517-bbf3d9990a23")],
    code: "HPSM",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 6,
    nights: 5,
    statesCount: 1,
    citiesCount: 3,
    region: "Himachal Pradesh",
    zone: "North",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 42000,
    emiPerMonth: 4090,
    rating: 4,
    reviewsCount: 156,
    guestsRated: "9.2k",
    guestPhotos: 130,
    route: [
      { state: "Himachal Pradesh", stops: ["Shimla (2N)", "Manali (3N)", "Kufri"] },
    ],
    highlights: ["Solang Valley", "Rohtang Pass", "Mall Road Shimla", "Hadimba Temple", "Kufri", "Jakhoo Temple"],
    departureCities: ["Chandigarh (Joining/leaving)", "Delhi"],
    dates: [
      { date: "Sat Aug 01, 2026", price: 42000, tag: "Lowest Price" },
      { date: "Sat Sep 05, 2026", price: 43500 },
      { date: "Sat Dec 26, 2026", price: 52000, note: "New Year Special" },
    ],
    inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true },
    review: {
      text: "Perfect family holiday. Kids loved the snow at Solang Valley and the hotels were well located.",
      author: "Priyanka",
      date: "Travelled Dec 30, 2025",
      manager: "Santosh Dhamke",
    },
  },
  {
    slug: "golden-temple-amritsar",
    title: "Golden Temple Amritsar",
    image: U("/assets/media/royal-amritsar-golden-temple.jpg"),
    gallery: [U("/assets/media/royal-amritsar-golden-temple.jpg")],
    code: "PBAM",
    tourType: "GROUP TOUR",
    speciality: "Pilgrimage",
    allInclusive: true,
    days: 3,
    nights: 2,
    statesCount: 1,
    citiesCount: 1,
    region: "North India",
    zone: "North",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 18000,
    emiPerMonth: 1753,
    rating: 5,
    reviewsCount: 89,
    guestsRated: "4.1k",
    guestPhotos: 60,
    route: [{ state: "Punjab", stops: ["Amritsar (2N)"] }],
    highlights: ["Golden Temple", "Wagah Border Ceremony", "Jallianwala Bagh", "Partition Museum", "Local Punjabi Cuisine"],
    departureCities: ["Amritsar (Joining/leaving)"],
    dates: [
      { date: "Fri Aug 14, 2026", price: 18000, tag: "Lowest Price" },
      { date: "Fri Sep 11, 2026", price: 19000 },
    ],
    inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true },
    review: {
      text: "Deeply spiritual and beautifully arranged. The Wagah border ceremony was a goosebump moment.",
      author: "Harpreet",
      date: "Travelled Nov 10, 2025",
      manager: "Atish Berde",
    },
  },
  {
    slug: "royal-rajasthan",
    title: "Royal Rajasthan",
    image: U("1599661046289-e31897846e41"),
    gallery: [U("1599661046289-e31897846e41"), U("1599661046289-e31897846e41")],
    code: "RJRR",
    tourType: "GROUP TOUR",
    speciality: "Customized Holidays",
    allInclusive: true,
    days: 9,
    nights: 8,
    statesCount: 1,
    citiesCount: 5,
    region: "Rajasthan",
    zone: "West & Central",
    interest: null,
    packageType: "Customized Holidays",
    startingPrice: 74000,
    emiPerMonth: 7205,
    rating: 5,
    reviewsCount: 112,
    guestsRated: "6.7k",
    guestPhotos: 180,
    route: [
      { state: "Rajasthan", stops: ["Jaipur (2N)", "Jodhpur (2N)", "Jaisalmer (2N)", "Udaipur (2N)"] },
    ],
    highlights: ["Amber Fort", "Mehrangarh Fort", "Jaisalmer Desert Safari", "Lake Pichola", "City Palace Udaipur", "Sam Sand Dunes"],
    departureCities: ["Jaipur (Joining/leaving)"],
    dates: [
      { date: "Sat Oct 10, 2026", price: 74000, tag: "Lowest Price" },
      { date: "Sat Nov 07, 2026", price: 78000 },
      { date: "Sat Dec 26, 2026", price: 88000, note: "New Year Special" },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true },
    review: {
      text: "A regal experience end to end. Palace hotels, desert camps and warm hospitality — worth every rupee.",
      author: "Aditi",
      date: "Travelled Oct 25, 2025",
      manager: "Saurabh Shinde",
    },
  },
  {
    slug: "varanasi-ayodhya",
    title: "Varanasi Ayodhya",
    image: U("/assets/media/wiki-varanasi-ghat.jpg"),
    gallery: [U("/assets/media/wiki-varanasi-ghat.jpg")],
    code: "UPVA",
    tourType: "GROUP TOUR",
    speciality: "Pilgrimage",
    allInclusive: true,
    days: 5,
    nights: 4,
    statesCount: 1,
    citiesCount: 3,
    region: "Uttar Pradesh",
    zone: "North",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 26000,
    emiPerMonth: 2531,
    rating: 5,
    reviewsCount: 71,
    guestsRated: "3.0k",
    guestPhotos: 48,
    route: [
      { state: "Uttar Pradesh", stops: ["Varanasi (2N)", "Ayodhya (1N)", "Prayagraj (1N)"] },
    ],
    highlights: ["Ganga Aarti", "Kashi Vishwanath", "Ram Mandir Ayodhya", "Triveni Sangam", "Sarnath", "Boat Ride at Dawn"],
    departureCities: ["Varanasi (Joining/leaving)"],
    dates: [
      { date: "Fri Sep 04, 2026", price: 26000, tag: "Lowest Price" },
      { date: "Fri Oct 02, 2026", price: 28000, note: "Navratri Special" },
    ],
    inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true },
    review: {
      text: "The Ganga Aarti at dawn was surreal. Very well planned spiritual circuit across UP.",
      author: "Suresh",
      date: "Travelled Dec 05, 2025",
      manager: "Atish Berde",
    },
  },
  {
    slug: "sikkim-darjeeling",
    title: "Sikkim Darjeeling",
    image: U("1544634076-a90160ddf44c"),
    gallery: [U("1544634076-a90160ddf44c")],
    code: "NESD",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 7,
    nights: 6,
    statesCount: 2,
    citiesCount: 4,
    region: "North East",
    zone: "East & North East",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 46000,
    emiPerMonth: 4479,
    rating: 5,
    reviewsCount: 84,
    guestsRated: "5.1k",
    guestPhotos: 90,
    route: [
      { state: "West Bengal", stops: ["Darjeeling (2N)"] },
      { state: "Sikkim", stops: ["Gangtok (3N)", "Lachung (1N)", "Pelling"] },
    ],
    highlights: ["Tiger Hill Sunrise", "Nathula Pass", "Tsomgo Lake", "Batasia Loop Toy Train", "Yumthang Valley", "Rumtek Monastery"],
    departureCities: ["Bagdogra (Joining/leaving)"],
    dates: [
      { date: "Sat Sep 12, 2026", price: 46000, tag: "Lowest Price" },
      { date: "Sat Oct 10, 2026", price: 49000 },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true },
    review: {
      text: "The Himalayan views from Tiger Hill and the toy train ride were magical. Great for families.",
      author: "Debarati",
      date: "Travelled Oct 18, 2025",
      manager: "Umesh Vishe",
    },
  },
  {
    slug: "gujarat-rann-utsav",
    title: "Gujarat Rann Utsav",
    image: U("1599661046289-e31897846e41"),
    gallery: [U("1599661046289-e31897846e41")],
    code: "GJRU",
    tourType: "GROUP TOUR",
    speciality: "Fixed Date Holiday",
    allInclusive: true,
    days: 6,
    nights: 5,
    statesCount: 1,
    citiesCount: 4,
    region: "Gujarat",
    zone: "West & Central",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 39000,
    emiPerMonth: 3797,
    rating: 4,
    reviewsCount: 58,
    guestsRated: "2.6k",
    guestPhotos: 55,
    route: [
      { state: "Gujarat", stops: ["Ahmedabad (1N)", "Bhuj (2N)", "Rann of Kutch (1N)", "Dwarka (1N)"] },
    ],
    highlights: ["White Rann of Kutch", "Tent City", "Statue of Unity", "Sabarmati Ashram", "Dwarkadhish Temple", "Kutchi Handicrafts"],
    departureCities: ["Ahmedabad (Joining/leaving)"],
    dates: [
      { date: "Fri Nov 20, 2026", price: 39000, tag: "Lowest Price" },
      { date: "Fri Dec 18, 2026", price: 43000, note: "Full Moon Special" },
    ],
    inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true },
    review: {
      text: "The white desert under a full moon is something everyone must witness once. Fantastic arrangements.",
      author: "Mehul",
      date: "Travelled Dec 22, 2025",
      manager: "Santosh Dhamke",
    },
  },
  {
    slug: "womens-special-mathura-vrindavan",
    title: "Women's Special Mathura Vrindavan",
    image: U("1548013146-72479768bada"),
    gallery: [U("1548013146-72479768bada")],
    code: "UPWM",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 4,
    nights: 3,
    statesCount: 1,
    citiesCount: 2,
    region: "Uttar Pradesh",
    zone: "North",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 24000,
    emiPerMonth: 2336,
    rating: 5,
    reviewsCount: 66,
    guestsRated: "2.8k",
    guestPhotos: 42,
    route: [
      { state: "Uttar Pradesh", stops: ["Mathura (1N)", "Vrindavan (2N)"] },
    ],
    highlights: ["Banke Bihari Temple", "Prem Mandir", "Krishna Janmabhoomi", "Govardhan Parikrama", "ISKCON Temple", "Yamuna Aarti"],
    departureCities: ["Delhi (Joining/leaving)"],
    dates: [
      { date: "Fri Aug 21, 2026", price: 24000, tag: "Lowest Price" },
      { date: "Fri Sep 18, 2026", price: 25000 },
    ],
    inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true },
    review: {
      text: "A safe, comfortable and soulful women-only pilgrimage. The all-women group made it so special.",
      author: "Sunita",
      date: "Travelled Nov 15, 2025",
      manager: "Saurabh Shinde",
    },
  },
];

// ── World tours ──────────────────────────────────────────────────
const WORLD_TOURS = [
  {
    slug: "london-paris-swiss-italy",
    title: "London Paris Swiss Italy",
    scope: "world",
    image: U("1502602898657-3e91760cbb34"),
    gallery: [U("1502602898657-3e91760cbb34"), U("1499856871958-5b9627545d1a"), U("1541849546-216549ae216d")],
    code: "EUUL",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 9,
    nights: 8,
    countriesCount: 4,
    statesCount: 4,
    citiesCount: 8,
    region: "Europe",
    zone: "Europe",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 285000,
    joiningLeavingPrice: 205000,
    emiPerMonth: 27750,
    rating: 5,
    reviewsCount: 31,
    guestsRated: "1.4k",
    guestPhotos: 63,
    route: [
      { state: "England", stops: ["London (2N)"] },
      { state: "France", stops: ["Paris (2N)", "Versailles"] },
      { state: "Switzerland", stops: ["Lucerne (2N)", "Engelberg"] },
      { state: "Italy", stops: ["Pisa (2N)", "Florence", "Milan"] },
    ],
    highlights: ["London Eye", "Madame Tussauds Wax Museum", "Top level of the Eiffel Tower", "Palace of Versailles", "Mt. Titlis", "Lucerne Lake Cruise", "Leaning Tower of Pisa", "Vatican City"],
    departureCities: ["Delhi (Joining/leaving)", "Mumbai"],
    dates: [
      { date: "Thu Aug 13, 2026", price: 285000, tag: "Dates Filling Fast", seats: 5 },
      { date: "Thu Sep 10, 2026", price: 292000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    review: {
      text: "Really good arrangement. Had a really good time with the group members. Things were well planned and conducted professionally. Tour manager Mr. Sandesh handled everything very well.",
      author: "Srikant",
      date: "Travelled Jun 11, 2026",
      manager: "Sandesh Wagh",
    },
  },
  {
    slug: "european-panorama",
    title: "European Panorama",
    scope: "world",
    image: U("1499856871958-5b9627545d1a"),
    gallery: [U("1499856871958-5b9627545d1a"), U("1502602898657-3e91760cbb34")],
    code: "EUPA",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 8,
    nights: 7,
    countriesCount: 8,
    statesCount: 8,
    citiesCount: 12,
    region: "Europe",
    zone: "Europe",
    packageType: "Group Tour",
    startingPrice: 260000,
    joiningLeavingPrice: 189000,
    emiPerMonth: 25316,
    rating: 5,
    reviewsCount: 58,
    guestsRated: "3.2k",
    guestPhotos: 88,
    route: [
      { state: "France", stops: ["Paris (2N)"] },
      { state: "Belgium", stops: ["Brussels"] },
      { state: "Netherlands", stops: ["Amsterdam (1N)"] },
      { state: "Germany", stops: ["Frankfurt (1N)"] },
      { state: "Switzerland", stops: ["Lucerne (2N)"] },
      { state: "Italy", stops: ["Venice", "Rome (1N)"] },
    ],
    highlights: ["Eiffel Tower", "Atomium Brussels", "Keukenhof Gardens", "Rhine Falls", "Mt. Titlis", "Gondola Ride Venice", "Colosseum"],
    departureCities: ["Delhi (Joining/leaving)", "Mumbai"],
    dates: [
      { date: "Fri Aug 14, 2026", price: 260000, tag: "Dates Filling Fast", seats: 2 },
      { date: "Fri Sep 18, 2026", price: 268000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    review: {
      text: "Eight countries in eight days sounds hectic but it was superbly paced. Loved every city and the coach was very comfortable.",
      author: "Meera",
      date: "Travelled Jul 02, 2026",
      manager: "Sandesh Wagh",
    },
  },
  {
    slug: "seniors-special-sri-lanka",
    title: "Seniors' Special Sri Lanka",
    scope: "world",
    image: U("1566296314736-6eaac1ca0cb9"),
    gallery: [U("1566296314736-6eaac1ca0cb9"), U("1564507592333-c60657eea523"), U("1500530855697-b586d89ba3ee")],
    code: "ASZPN",
    tourType: "GROUP TOUR",
    speciality: "Seniors' Special",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Sri Lanka",
    zone: "Asia",
    interest: "Seniors' Special",
    packageType: "Group Tour",
    startingPrice: 78774,
    emiPerMonth: 7675,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Sri Lanka", stops: ["Kandy (2N)", "Nuwara Eliya (1N)", "Bentota (1N)", "Colombo"] },
    ],
    highlights: [
      "Colombo City Tour",
      "Kelaniya Temple",
      "Pinnawala Elephant Orphanage",
      "Temple of the Tooth Relic",
      "Kandy Lake",
      "Gems Gallery and Lapidary",
      "Peradeniya Botanical Gardens",
      "Sri Lankan Dance Show",
      "Anjaneyar (Hanuman) Temple",
      "Tea Factory",
      "Seetha Amman Temple",
      "Gregory Lake Speedboat",
      "Hakgala Botanical Gardens",
      "Mask Museum",
      "Bentota River Safari",
      "Kosgoda Turtle Hatchery",
    ],
    departureCity: "Colombo",
    departureCities: ["Mumbai", "Bengaluru", "Colombo (Joining/leaving)"],
    dates: [
      { date: "Wed Dec 16, 2026" },
      { date: "Wed Jan 20, 2027" },
      { date: "Wed Feb 17, 2027" },
      { date: "Wed Mar 17, 2027", tag: "Lowest Price" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Colombo · Kandy",
        state: "Sri Lanka",
        desc: "Arrive in Colombo and travel to Kandy. En route, visit Pinnawala Elephant Orphanage. In Kandy, see the Temple of the Tooth Relic, Kandy Lake and Gems Gallery. Overnight in Kandy.",
        nights: 2,
      },
      {
        day: 2,
        title: "Kandy sightseeing",
        state: "Sri Lanka",
        desc: "Explore Kandy with visits to Peradeniya Botanical Gardens, the Temple of the Tooth Relic and local cultural sights, including a Sri Lankan dance show. Overnight in Kandy.",
      },
      {
        day: 3,
        title: "Kandy · Nuwara Eliya",
        state: "Sri Lanka",
        desc: "Travel into the hill country, visiting Anjaneyar (Hanuman) Temple, a tea factory, Seetha Amman Temple, Gregory Lake and Hakgala Botanical Gardens. Overnight in Nuwara Eliya.",
        nights: 1,
      },
      {
        day: 4,
        title: "Nuwara Eliya · Bentota",
        state: "Sri Lanka",
        desc: "Journey from Nuwara Eliya to Bentota, stopping at the Mask Museum along the way. Enjoy a Bentota River Safari and visit Kosgoda Turtle Hatchery. Overnight in Bentota.",
        nights: 1,
      },
      {
        day: 5,
        title: "Bentota · Colombo · Departure",
        state: "Sri Lanka",
        desc: "Travel to Colombo for a city tour, including Kelaniya Temple. Later, transfer to the airport for your return journey. Tour concludes in Colombo.",
      },
    ],
  },
  {
    slug: "womens-special-sri-lanka",
    title: "Women's Special Sri Lanka",
    scope: "world",
    image: U("1566296314736-6eaac1ca0cb9"),
    gallery: [U("1566296314736-6eaac1ca0cb9"), U("1564507592333-c60657eea523"), U("1500530855697-b586d89ba3ee")],
    code: "ASWPN",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Sri Lanka",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 75840,
    emiPerMonth: 7390,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Sri Lanka", stops: ["Kandy (1N)", "Nuwara Eliya (1N)", "Bentota (1N)", "Colombo (1N)"] },
    ],
    highlights: [
      "Colombo City Tour",
      "Pinnawala Elephant Orphanage",
      "Temple of the Tooth Relic",
      "Kandy Lake",
      "Gems Gallery",
      "Peradeniya Botanical Gardens",
      "Hanuman Temple Ramboda",
      "Tea Factory",
      "Seetha Amman Temple",
      "Gregory Lake Speedboat",
      "Hakgala Botanical Gardens",
      "Mask Museum",
      "Bentota River Safari",
      "Kosgoda Turtle Hatchery",
    ],
    departureCity: "Colombo",
    departureCities: ["Mumbai", "Colombo (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Colombo · Pinnawala · Kandy",
        state: "Sri Lanka",
        desc: "Arrive in Colombo and travel inland to Pinnawala Elephant Orphanage. Continue to Kandy and visit the Temple of the Tooth Relic, Kandy Lake and Gems Gallery. Overnight in Kandy.",
        nights: 1,
      },
      {
        day: 2,
        title: "Kandy · Peradeniya · Nuwara Eliya",
        state: "Sri Lanka",
        desc: "Visit Peradeniya Botanical Gardens before travelling through the hill country. Stop at Hanuman Temple in Ramboda and a tea factory, then explore Nuwara Eliya’s Seetha Amman Temple, Gregory Lake and Hakgala Botanical Gardens. Overnight in Nuwara Eliya.",
        nights: 1,
      },
      {
        day: 3,
        title: "Nuwara Eliya · Bentota",
        state: "Sri Lanka",
        desc: "Travel south to Bentota, stopping at the Mask Museum en route. Check in at your hotel and enjoy the coastal setting. Overnight in Bentota.",
        nights: 1,
      },
      {
        day: 4,
        title: "Bentota · Kosgoda · Colombo",
        state: "Sri Lanka",
        desc: "Enjoy a Bentota River Safari and visit Kosgoda Turtle Hatchery. Continue to Colombo for a city tour. Overnight in Colombo.",
        nights: 1,
      },
      {
        day: 5,
        title: "Colombo · Departure",
        state: "Sri Lanka",
        desc: "After breakfast, transfer to the airport for your return journey. Tour concludes in Colombo.",
      },
    ],
  },
  {
    slug: "best-of-sri-lanka",
    title: "Best of Sri Lanka",
    scope: "world",
    image: U("1566296314736-6eaac1ca0cb9"),
    gallery: [U("1566296314736-6eaac1ca0cb9"), U("1564507592333-c60657eea523"), U("1500530855697-b586d89ba3ee")],
    code: "ASSE",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 7,
    nights: 6,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 5,
    region: "South East Asia",
    zone: "Asia",
    packageType: "Group Tour",
    startingPrice: 101749,
    emiPerMonth: 9907,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Sri Lanka", stops: ["Colombo (1N)", "Kandy (2N)", "Nuwara Eliya (1N)", "Bentota (1N)", "Colombo (1N)"] },
    ],
    highlights: [
      "Colombo City Tour",
      "Pinnawala Elephant Orphanage",
      "Temple of the Tooth Relic",
      "Kandy Lake",
      "Gems Gallery and Lapidary",
      "Peradeniya Botanical Gardens",
      "Sri Lankan Dance Show",
      "Anjaneyar (Hanuman) Temple",
      "Tea Factory",
      "Seetha Amman Temple",
      "Gregory Lake Speedboat",
      "Hakgala Botanical Gardens",
      "Mask Museum",
      "Bentota River Safari",
      "Kosgoda Turtle Hatchery",
      "Kelaniya Temple",
    ],
    departureCity: "Colombo",
    departureCities: ["Mumbai", "Colombo (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Colombo",
        state: "Sri Lanka",
        desc: "Arrive in Colombo and begin your Sri Lanka tour with a city orientation. Check in to your hotel for the night.",
        nights: 1,
      },
      {
        day: 2,
        title: "Colombo · Pinnawala · Kandy",
        state: "Sri Lanka",
        desc: "Travel to Kandy, stopping at Pinnawala Elephant Orphanage en route. Explore Kandy Lake and visit the Temple of the Tooth Relic and Gems Gallery. Overnight in Kandy.",
        nights: 2,
      },
      {
        day: 3,
        title: "Kandy",
        state: "Sri Lanka",
        desc: "Visit Peradeniya Botanical Gardens and discover Kandy's cultural landmarks. Enjoy a Sri Lankan dance performance before returning to your hotel.",
      },
      {
        day: 4,
        title: "Kandy · Nuwara Eliya",
        state: "Sri Lanka",
        desc: "Journey into the hill country, stopping at Anjaneyar (Hanuman) Temple and a tea factory. In Nuwara Eliya, visit Seetha Amman Temple, Gregory Lake and Hakgala Botanical Gardens. Overnight in Nuwara Eliya.",
        nights: 1,
      },
      {
        day: 5,
        title: "Nuwara Eliya · Bentota",
        state: "Sri Lanka",
        desc: "Travel south toward the coast and visit the Mask Museum en route. Enjoy a Bentota River Safari and visit Kosgoda Turtle Hatchery. Overnight in Bentota.",
        nights: 1,
      },
      {
        day: 6,
        title: "Bentota · Colombo",
        state: "Sri Lanka",
        desc: "Return to Colombo and visit Kelaniya Temple, followed by a city tour and time to explore the capital. Overnight in Colombo.",
        nights: 1,
      },
      {
        day: 7,
        title: "Colombo · Departure",
        state: "Sri Lanka",
        desc: "Transfer to the airport for your return journey. The tour concludes in Colombo.",
      },
    ],
  },
  {
    slug: "highlights-of-sri-lanka",
    title: "Highlights of Sri Lanka",
    scope: "world",
    image: U("1566296314736-6eaac1ca0cb9"),
    gallery: [U("1566296314736-6eaac1ca0cb9")],
    code: "ASPN",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "South East Asia",
    zone: "Asia",
    packageType: "Group Tour",
    startingPrice: 75840,
    emiPerMonth: 7390,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Sri Lanka", stops: ["Kandy (1N)", "Nuwara Eliya (1N)", "Bentota (1N)", "Colombo (1N)"] },
    ],
    highlights: [
      "Colombo City Tour",
      "Pinnawala Elephant Orphanage",
      "Temple of the Tooth Relic",
      "Kandy Lake",
      "Gems Gallery",
      "Peradeniya Botanical Gardens",
      "Hanuman Temple Ramboda",
      "Tea Factory",
      "Seetha Amman Temple",
      "Gregory Lake Speedboat",
      "Hakgala Botanical Gardens",
      "Mask Museum",
      "Bentota River Safari",
      "Kosgoda Turtle Hatchery",
    ],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Colombo (Joining/leaving)"],
    dates: [
      { date: "Wed Oct 28, 2026" },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Colombo · Pinnawala · Kandy",
        state: "Sri Lanka",
        desc: "Arrive in Colombo and travel inland to Pinnawala Elephant Orphanage. Continue to Kandy and visit the Temple of the Tooth Relic, Kandy Lake and Gems Gallery. Overnight in Kandy.",
        nights: 1,
      },
      {
        day: 2,
        title: "Kandy · Peradeniya · Nuwara Eliya",
        state: "Sri Lanka",
        desc: "Visit Peradeniya Botanical Gardens before travelling through Sri Lanka’s hill country. Stop at Hanuman Temple in Ramboda and a tea factory, then explore Nuwara Eliya’s Seetha Amman Temple, Gregory Lake and Hakgala Botanical Gardens. Overnight in Nuwara Eliya.",
        nights: 1,
      },
      {
        day: 3,
        title: "Nuwara Eliya · Bentota",
        state: "Sri Lanka",
        desc: "Travel south from the hill country to Bentota. Visit the Mask Museum en route and check in at your hotel. Overnight in Bentota.",
        nights: 1,
      },
      {
        day: 4,
        title: "Bentota · Kosgoda · Colombo",
        state: "Sri Lanka",
        desc: "Enjoy a Bentota River Safari and visit Kosgoda Turtle Hatchery. Continue to Colombo and take in the city’s highlights. Overnight in Colombo.",
        nights: 1,
      },
      {
        day: 5,
        title: "Colombo · Departure",
        state: "Sri Lanka",
        desc: "After breakfast, transfer to the airport for your return journey. Tour concludes in Colombo.",
      },
    ],
  },
  {
    slug: "womens-special-nepal",
    title: "Women's Special Nepal",
    scope: "world",
    image: U("1605640840605-14ac1855827b"),
    gallery: [U("1605640840605-14ac1855827b"), U("1501785888041-af3ef285b470"), U("1544735716-392fe2489ffa")],
    code: "RTWN",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 3,
    region: "Nepal",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 77000,
    emiPerMonth: 7497,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Nepal", stops: ["Kathmandu (3N)", "Chitwan (2N)", "Pokhara (2N)"] },
    ],
    highlights: [
      "Manakamana Devi Ropeway",
      "Chitwan National Park",
      "Folk Dance of Nepal",
      "Elephant Safari",
      "Canoe Ride",
      "Pokhara Boat Ride",
      "Phewa Lake",
      "Sarangkot Sunrise Point",
      "Devi’s Fall",
      "Gupteshwar Caves",
      "Vindyabasini Temple",
      "International Mountaineering Museum",
      "Bhaktapur Durbar Square",
      "Pashupatinath Temple",
      "Budhanilkantha (Sleeping Vishnu)",
      "Kathmandu Durbar Square",
      "Swayambhunath Stupa",
    ],
    departureCity: "Kathmandu",
    departureCities: ["Mumbai", "Kathmandu (Joining/leaving)"],
    dates: [{ date: "Sun Nov 22, 2026" }],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Kathmandu",
        state: "Nepal",
        desc: "Arrive in Kathmandu and meet the Royal Tours team for your hotel transfer. Settle in and enjoy an introduction to Nepal’s capital. Overnight in Kathmandu.",
        nights: 1,
      },
      {
        day: 2,
        title: "Kathmandu · Chitwan",
        state: "Nepal",
        desc: "Travel from Kathmandu to Chitwan, with a stop at Manakamana for the Devi temple ropeway. Check in at your Chitwan lodge. Overnight in Chitwan.",
        nights: 2,
      },
      {
        day: 3,
        title: "Chitwan National Park",
        state: "Nepal",
        desc: "Explore Chitwan National Park with an elephant safari and canoe ride, and enjoy an evening of traditional Nepali folk dance. Overnight in Chitwan.",
      },
      {
        day: 4,
        title: "Chitwan · Pokhara",
        state: "Nepal",
        desc: "Travel to Pokhara, a lakeside city set against Himalayan scenery. Check in to your hotel and enjoy time by Phewa Lake. Overnight in Pokhara.",
        nights: 2,
      },
      {
        day: 5,
        title: "Pokhara sightseeing",
        state: "Nepal",
        desc: "Take a boat ride on Phewa Lake and visit Sarangkot Sunrise Point, Devi’s Fall, Gupteshwar Caves, Vindyabasini Temple and the International Mountaineering Museum. Overnight in Pokhara.",
      },
      {
        day: 6,
        title: "Pokhara · Kathmandu",
        state: "Nepal",
        desc: "Fly back to Kathmandu and continue exploring the capital. Overnight in Kathmandu.",
        nights: 2,
      },
      {
        day: 7,
        title: "Kathmandu heritage",
        state: "Nepal",
        desc: "Visit Pashupatinath Temple, Budhanilkantha’s Sleeping Vishnu, Kathmandu Durbar Square, Swayambhunath Stupa and Bhaktapur Durbar Square. Overnight in Kathmandu.",
      },
      {
        day: 8,
        title: "Kathmandu · Departure",
        state: "Nepal",
        desc: "After breakfast, transfer to the airport for your onward journey. Tour concludes in Kathmandu.",
      },
    ],
  },
  {
    slug: "seniors-special-nepal",
    title: "Senior's Special Nepal",
    scope: "world",
    image: U("1605640840605-14ac1855827b"),
    gallery: [U("1605640840605-14ac1855827b"), U("1501785888041-af3ef285b470"), U("1544735716-392fe2489ffa")],
    code: "RTSN",
    tourType: "GROUP TOUR",
    speciality: "Seniors' Special",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 3,
    region: "Nepal",
    zone: "Asia",
    interest: "Seniors' Special",
    packageType: "Group Tour",
    startingPrice: 81000,
    emiPerMonth: 7886,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Nepal", stops: ["Kathmandu (3N)", "Chitwan (2N)", "Pokhara (2N)"] },
    ],
    highlights: [
      "Manakamana Devi Ropeway",
      "Chitwan National Park",
      "Folk Dance of Nepal",
      "Elephant Safari",
      "Canoe Ride",
      "Pokhara Boat Ride",
      "Phewa Lake",
      "Sarangkot Sunrise Point",
      "Devi’s Fall",
      "Gupteshwar Caves",
      "Vindyabasini Temple",
      "International Mountaineering Museum",
      "Bhaktapur Durbar Square",
      "Pashupatinath Temple",
      "Budhanilkantha (Sleeping Vishnu)",
      "Kathmandu Durbar Square",
      "Swayambhunath Stupa",
    ],
    departureCity: "Kathmandu",
    departureCities: ["Mumbai", "Kathmandu (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Kathmandu",
        state: "Nepal",
        desc: "Arrive in Kathmandu and meet the Royal Tours team for your hotel transfer. Settle in and enjoy an introduction to Nepal’s capital. Overnight in Kathmandu.",
        nights: 1,
      },
      {
        day: 2,
        title: "Kathmandu · Chitwan",
        state: "Nepal",
        desc: "Travel from Kathmandu to Chitwan, with a stop at Manakamana for the Devi temple ropeway. Check in at your Chitwan lodge. Overnight in Chitwan.",
        nights: 2,
      },
      {
        day: 3,
        title: "Chitwan National Park",
        state: "Nepal",
        desc: "Explore Chitwan National Park with an elephant safari and canoe ride, and enjoy an evening of traditional Nepali folk dance. Overnight in Chitwan.",
      },
      {
        day: 4,
        title: "Chitwan · Pokhara",
        state: "Nepal",
        desc: "Travel to Pokhara, a lakeside city set against Himalayan scenery. Check in to your hotel and enjoy time by Phewa Lake. Overnight in Pokhara.",
        nights: 2,
      },
      {
        day: 5,
        title: "Pokhara sightseeing",
        state: "Nepal",
        desc: "Take a boat ride on Phewa Lake and visit Sarangkot Sunrise Point, Devi’s Fall, Gupteshwar Caves, Vindyabasini Temple and the International Mountaineering Museum. Overnight in Pokhara.",
      },
      {
        day: 6,
        title: "Pokhara · Kathmandu",
        state: "Nepal",
        desc: "Fly back to Kathmandu and continue exploring the capital. Overnight in Kathmandu.",
        nights: 2,
      },
      {
        day: 7,
        title: "Kathmandu heritage",
        state: "Nepal",
        desc: "Visit Pashupatinath Temple, Budhanilkantha’s Sleeping Vishnu, Kathmandu Durbar Square, Swayambhunath Stupa and Bhaktapur Durbar Square. Overnight in Kathmandu.",
      },
      {
        day: 8,
        title: "Kathmandu · Departure",
        state: "Nepal",
        desc: "After breakfast, transfer to the airport for your onward journey. Tour concludes in Kathmandu.",
      },
    ],
  },
  {
    slug: "best-of-nepal",
    title: "Best of Nepal",
    scope: "world",
    image: U("1605640840605-14ac1855827b"),
    gallery: [U("1605640840605-14ac1855827b")],
    code: "NPCP",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 3,
    region: "Nepal",
    zone: "Asia",
    packageType: "Group Tour",
    startingPrice: 73000,
    emiPerMonth: 7108,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Nepal", stops: ["Kathmandu (3N)", "Chitwan (2N)", "Pokhara (2N)"] },
    ],
    highlights: [
      "Manakamana Devi Ropeway",
      "Chitwan National Park",
      "Folk Dance of Nepal",
      "Elephant Safari",
      "Canoe Ride",
      "Pokhara Boat Ride",
      "Phewa Lake",
      "Sarangkot Sunrise Point",
      "Devi’s Fall",
      "Gupteshwar Caves",
      "Vindyabasini Temple",
      "International Mountaineering Museum",
      "Bhaktapur Durbar Square",
      "Pashupatinath Temple",
      "Budhanilkantha (Sleeping Vishnu)",
      "Kathmandu Durbar Square",
      "Swayambhunath Stupa",
    ],
    departureCity: "Kathmandu",
    departureCities: ["Mumbai", "Kathmandu (Joining/leaving)"],
    dates: [
      { date: "Sun Nov 01, 2026", tag: "Dates Filling Fast", seats: 6 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Kathmandu",
        state: "Nepal",
        desc: "Arrive in Kathmandu and meet the Royal Tours team for your hotel transfer. Settle in and enjoy an introduction to Nepal’s lively capital. Overnight in Kathmandu.",
        nights: 1,
      },
      {
        day: 2,
        title: "Kathmandu · Chitwan",
        state: "Nepal",
        desc: "Travel from Kathmandu to Chitwan, with a stop at Manakamana for the Devi temple ropeway experience. Check in at your lodge in the Chitwan region. Overnight in Chitwan.",
        nights: 2,
      },
      {
        day: 3,
        title: "Chitwan National Park",
        state: "Nepal",
        desc: "Explore Chitwan National Park with an elephant safari and canoe ride, and enjoy an evening of traditional Nepali folk dance. Overnight in Chitwan.",
      },
      {
        day: 4,
        title: "Chitwan · Pokhara",
        state: "Nepal",
        desc: "Travel to Pokhara, the lakeside city framed by Himalayan peaks. Check in to your hotel and enjoy time by Phewa Lake. Overnight in Pokhara.",
        nights: 2,
      },
      {
        day: 5,
        title: "Pokhara sightseeing",
        state: "Nepal",
        desc: "Take a boat ride on Phewa Lake and visit Sarangkot Sunrise Point, Devi’s Fall, Gupteshwar Caves, Vindyabasini Temple and the International Mountaineering Museum. Overnight in Pokhara.",
      },
      {
        day: 6,
        title: "Pokhara · Kathmandu",
        state: "Nepal",
        desc: "Fly back to Kathmandu and continue exploring the capital. Overnight in Kathmandu.",
        nights: 2,
      },
      {
        day: 7,
        title: "Kathmandu heritage",
        state: "Nepal",
        desc: "Visit Pashupatinath Temple, Budhanilkantha’s Sleeping Vishnu, Kathmandu Durbar Square, Swayambhunath Stupa and Bhaktapur Durbar Square. Overnight in Kathmandu.",
      },
      {
        day: 8,
        title: "Kathmandu · Departure",
        state: "Nepal",
        desc: "After breakfast, transfer to the airport for your onward journey. Tour concludes in Kathmandu.",
      },
    ],
  },
  {
    slug: "honeymoon-special-thailand",
    title: "Honeymoon Special Thailand",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASHA",
    tourType: "GROUP TOUR",
    speciality: "Honeymoon Special",
    allInclusive: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Thailand",
    zone: "Asia",
    interest: "Honeymoon Special",
    packageType: "Group Tour",
    startingPrice: 98000,
    emiPerMonth: 9545,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (3N)", "Bangkok (2N)"] },
    ],
    highlights: [
      "Pattaya Tower",
      "Alcazar Show",
      "Coral Island",
      "Scientific Thai massage",
      "Gems Gallery",
      "Nong Nooch village",
      "Art in Paradise",
      "TopGolf",
      "Safari World and Marine Park",
      "Chao Phraya River Dinner Cruise",
    ],
    departureCity: "Bangkok",
    departureCities: ["Mumbai", "Bangkok (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Bangkok · Pattaya",
        state: "Thailand",
        desc: "Arrive in Bangkok and travel to Pattaya. Check in to your hotel and enjoy the start of your Thailand honeymoon. Overnight in Pattaya.",
        nights: 3,
      },
      {
        day: 2,
        title: "Pattaya · Coral Island",
        state: "Thailand",
        desc: "Take a speedboat excursion to Coral Island and enjoy time by the beach. Later, experience the Alcazar Show. Overnight in Pattaya.",
      },
      {
        day: 3,
        title: "Pattaya",
        state: "Thailand",
        desc: "Explore Pattaya Tower, Nong Nooch Village and Art in Paradise. Visit Gems Gallery and enjoy a scientific Thai massage. Overnight in Pattaya.",
      },
      {
        day: 4,
        title: "Pattaya · Bangkok",
        state: "Thailand",
        desc: "Travel to Bangkok and check in to your hotel. Enjoy the evening on a Chao Phraya River dinner cruise. Overnight in Bangkok.",
        nights: 2,
      },
      {
        day: 5,
        title: "Bangkok · Safari World",
        state: "Thailand",
        desc: "Spend the day at Safari World and Marine Park. Return to your Bangkok hotel for the night.",
      },
      {
        day: 6,
        title: "Bangkok · Departure",
        state: "Thailand",
        desc: "After breakfast, transfer to the airport for your onward journey. The tour concludes in Bangkok.",
      },
    ],
  },
  {
    slug: "seniors-special-thailand",
    title: "Seniors’ Special Thailand",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASZA",
    tourType: "GROUP TOUR",
    speciality: "Seniors’ Special",
    allInclusive: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Thailand",
    zone: "Asia",
    interest: "Seniors’ Special",
    packageType: "Group Tour",
    startingPrice: 95000,
    emiPerMonth: 9250,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (3N)", "Bangkok (2N)"] },
    ],
    highlights: [
      "Pattaya Tower",
      "Alcazar Show",
      "Coral Island",
      "Scientific Thai massage",
      "Gems Gallery",
      "Nong Nooch Village",
      "Art in Paradise",
      "TopGolf",
      "Safari World and Marine Park",
      "Chao Phraya River Dinner Cruise",
    ],
    departureCity: "Bangkok",
    departureCities: ["Mumbai", "Bangkok (Joining/leaving)"],
    dates: [{ date: "Wed Dec 09, 2026" }],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Bangkok · Pattaya",
        state: "Thailand",
        desc: "Arrive in Bangkok and travel to Pattaya. Check in to your hotel and settle in for your Thailand tour. Overnight in Pattaya.",
        nights: 3,
      },
      {
        day: 2,
        title: "Pattaya · Coral Island",
        state: "Thailand",
        desc: "Enjoy an excursion to Coral Island, visit Pattaya Tower and experience the Alcazar Show. Overnight in Pattaya.",
      },
      {
        day: 3,
        title: "Pattaya sightseeing",
        state: "Thailand",
        desc: "Visit Nong Nooch Village, Art in Paradise, TopGolf and Gems Gallery, with a scientific Thai massage experience. Overnight in Pattaya.",
      },
      {
        day: 4,
        title: "Pattaya · Bangkok",
        state: "Thailand",
        desc: "Travel to Bangkok and check in to your hotel. In the evening, enjoy a Chao Phraya River dinner cruise. Overnight in Bangkok.",
        nights: 2,
      },
      {
        day: 5,
        title: "Bangkok · Safari World",
        state: "Thailand",
        desc: "Explore Safari World and Marine Park before returning to your Bangkok hotel. Overnight in Bangkok.",
      },
      {
        day: 6,
        title: "Bangkok · Departure",
        state: "Thailand",
        desc: "After breakfast, transfer to the airport for your onward journey. The tour concludes in Bangkok.",
      },
    ],
  },
  {
    slug: "womens-special-thailand",
    title: "Women's Special Thailand",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASWA",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Thailand",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 90000,
    emiPerMonth: 8761,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (3N)", "Bangkok (2N)"] },
    ],
    highlights: ["Pattaya Tower", "Alcazar Show", "Coral Island", "Scientific Thai massage", "Gems Gallery", "Nong Nooch Village", "Art in Paradise", "TopGolf", "Safari World & Marine Park", "Chao Phraya River Dinner Cruise"],
    departureCity: "Bangkok",
    departureCities: ["Bangkok (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Bangkok · Pattaya",
        state: "Thailand",
        desc: "Meet your Royal Tours group on arrival in Bangkok and travel to Pattaya. Check in to your hotel and settle in for the start of your Thailand escape. Overnight in Pattaya.",
        nights: 3,
      },
      {
        day: 2,
        title: "Pattaya · Coral Island · Alcazar Show",
        state: "Thailand",
        desc: "Enjoy an excursion to Coral Island, visit Pattaya Tower and experience the lively Alcazar Show. Overnight in Pattaya.",
      },
      {
        day: 3,
        title: "Pattaya sightseeing",
        state: "Thailand",
        desc: "Visit Nong Nooch Village, Art in Paradise, TopGolf and Gems Gallery, with a scientific Thai massage experience. Overnight in Pattaya.",
      },
      {
        day: 4,
        title: "Pattaya · Bangkok",
        state: "Thailand",
        desc: "Travel to Bangkok and check in to your hotel. In the evening, enjoy a Chao Phraya River dinner cruise. Overnight in Bangkok.",
        nights: 2,
      },
      {
        day: 5,
        title: "Bangkok · Safari World",
        state: "Thailand",
        desc: "Explore Safari World and Marine Park before returning to your Bangkok hotel. Overnight in Bangkok.",
      },
      {
        day: 6,
        title: "Bangkok · Departure",
        state: "Thailand",
        desc: "After breakfast, transfer to the airport for your onward journey. The tour concludes in Bangkok.",
      },
    ],
  },
  {
    slug: "womens-special-thailand-aswb",
    title: "Women's Special Thailand",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASWB",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 4,
    nights: 3,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Thailand",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 65000,
    emiPerMonth: 6336,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (2N)", "Bangkok (1N)"] },
    ],
    highlights: ["Alcazar Show", "Coral Island", "Gems Gallery", "Scientific Thai Massage", "Safari World & Marine Park"],
    departureCity: "Bangkok",
    departureCities: ["Mumbai", "Ahmedabad", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Bangkok (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Bangkok · Pattaya",
        state: "Thailand",
        desc: "Arrive in Bangkok and travel to Pattaya. Check in to your hotel and settle in for the trip. Overnight in Pattaya.",
        nights: 2,
      },
      {
        day: 2,
        title: "Pattaya · Coral Island · Alcazar Show",
        state: "Thailand",
        desc: "Enjoy an excursion to Coral Island and experience the Alcazar Show. Overnight in Pattaya.",
      },
      {
        day: 3,
        title: "Pattaya · Bangkok",
        state: "Thailand",
        desc: "Visit Gems Gallery and enjoy a scientific Thai massage experience before travelling to Bangkok. Overnight in Bangkok.",
        nights: 1,
      },
      {
        day: 4,
        title: "Bangkok · Safari World · Departure",
        state: "Thailand",
        desc: "Visit Safari World and Marine Park, then transfer for your onward journey. The tour concludes in Bangkok.",
      },
    ],
  },  {
    slug: "highlights-of-thailand",
    title: "Highlights of Thailand",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASTL",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 4,
    nights: 3,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Thailand",
    zone: "Asia",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 71000,
    emiPerMonth: 6914,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (2N)", "Bangkok (1N)"] },
    ],
    highlights: ["Alcazar Show", "Coral Island", "Gems Gallery", "Scientific Thai Massage", "Safari World & Marine Park"],
    departureCity: "Bangkok",
    departureCities: ["Mumbai", "Ahmedabad", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Bangkok (Joining/leaving)"],
    dates: [
      { date: "Sun Nov 22, 2026" },
      { date: "Sun Dec 27, 2026" },
      { date: "Wed Feb 10, 2027" },
      { date: "Thu Mar 11, 2027" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Bangkok · Pattaya",
        state: "Thailand",
        desc: "Arrive in Bangkok and meet the Royal Tours group before travelling to Pattaya. Check in to your hotel and settle in for the trip. Overnight in Pattaya.",
        nights: 2,
      },
      {
        day: 2,
        title: "Pattaya · Coral Island",
        state: "Thailand",
        desc: "Take an excursion to Coral Island and enjoy time by the sea. Later, experience the spectacular Alcazar Show. Overnight in Pattaya.",
      },
      {
        day: 3,
        title: "Pattaya · Bangkok",
        state: "Thailand",
        desc: "Visit Gems Gallery and enjoy a scientific Thai massage experience before travelling to Bangkok. Check in to your hotel for the night.",
        nights: 1,
      },
      {
        day: 4,
        title: "Bangkok · Safari World · Departure",
        state: "Thailand",
        desc: "Visit Safari World and Marine Park, then transfer for your onward journey. The tour concludes in Bangkok.",
      },
    ],
  },
  {
    slug: "best-of-thailand",
    title: "Best of Thailand",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa")],
    code: "ASTJ",
    tourType: "GROUP TOUR",
    speciality: "Honeymoon Special",
    allInclusive: true,
    popularToday: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "South East Asia",
    zone: "Asia",
    interest: "Honeymoon Special",
    packageType: "Group Tour",
    startingPrice: 89000,
    joiningLeavingPrice: 68000,
    emiPerMonth: 8666,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Bangkok (2N)", "Pattaya (3N)"] },
    ],
    highlights: ["Pattaya Tower", "Alcazar Show", "Coral Island", "Scientific Thai massage", "Gems Gallery", "Nong Nooch Village", "Art in Paradise", "TopGolf", "Safari World & Marine Park", "Chao Phraya River Dinner Cruise"],
    departureCity: "Bangkok",
    departureCities: ["Bangkok (Joining/leaving)"],
    dates: [
      { date: "Wed Oct 28, 2026" },
      { date: "Fri Nov 06, 2026" },
      { date: "Mon Nov 09, 2026" },
      { date: "Tue Nov 10, 2026" },
      { date: "Thu Nov 12, 2026" },
      { date: "Fri Nov 13, 2026" },
      { date: "Fri Nov 20, 2026" },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Bangkok · Pattaya",
        state: "Thailand",
        desc: "Arrive in Bangkok and travel to Pattaya. Check in to your hotel and enjoy time to settle in. Overnight in Pattaya.",
        nights: 3,
      },
      {
        day: 2,
        title: "Pattaya · Coral Island",
        state: "Thailand",
        desc: "Take a speedboat excursion to Coral Island and enjoy time by the beach. Return to Pattaya and spend the evening at leisure. Overnight in Pattaya.",
      },
      {
        day: 3,
        title: "Pattaya sightseeing",
        state: "Thailand",
        desc: "Explore Pattaya with visits to Pattaya Tower, Nong Nooch Village and Art in Paradise. Enjoy the Alcazar Show and visit Gems Gallery. Overnight in Pattaya.",
      },
      {
        day: 4,
        title: "Pattaya · Bangkok",
        state: "Thailand",
        desc: "Travel from Pattaya to Bangkok. Enjoy a scientific Thai massage experience and check in to your hotel. Overnight in Bangkok.",
        nights: 2,
      },
      {
        day: 5,
        title: "Bangkok sightseeing",
        state: "Thailand",
        desc: "Explore Bangkok’s Grand Palace and enjoy a Chao Phraya River dinner cruise. Overnight in Bangkok.",
      },
      {
        day: 6,
        title: "Bangkok · Safari World · Departure",
        state: "Thailand",
        desc: "Visit Safari World and Marine Park before transferring to the airport for your onward journey. Tour concludes in Bangkok.",
      },
    ],
  },
  {
    slug: "womens-special-with-kids-thailand",
    title: "Women’s Special with Kids Thailand",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASWKT",
    tourType: "GROUP TOUR",
    speciality: "Women’s Special with Kids",
    allInclusive: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Thailand",
    zone: "Asia",
    interest: "Women’s Special with Kids",
    packageType: "Group Tour",
    startingPrice: 98000,
    emiPerMonth: 9538,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (3N)", "Bangkok (2N)"] },
    ],
    highlights: [
      "Pattaya Tower",
      "Coral Island",
      "Scientific Thai massage",
      "Gems Gallery",
      "Nong Nooch Village",
      "Art in Paradise",
      "TopGolf",
      "Safari World and Marine Park",
      "Chao Phraya River Dinner Cruise",
    ],
    departureCity: "Bangkok",
    departureCities: ["Mumbai", "Bangkok (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Bangkok · Pattaya",
        state: "Thailand",
        desc: "Arrive in Bangkok and travel to Pattaya. Check in to your hotel and settle in for the family-friendly Thailand tour. Overnight in Pattaya.",
        nights: 3,
      },
      {
        day: 2,
        title: "Pattaya · Coral Island",
        state: "Thailand",
        desc: "Enjoy an excursion to Coral Island and spend time by the sea. Later, take in the views from Pattaya Tower. Overnight in Pattaya.",
      },
      {
        day: 3,
        title: "Pattaya sightseeing",
        state: "Thailand",
        desc: "Visit Nong Nooch Village, Art in Paradise, TopGolf and Gems Gallery, with a scientific Thai massage experience. Overnight in Pattaya.",
      },
      {
        day: 4,
        title: "Pattaya · Bangkok",
        state: "Thailand",
        desc: "Travel to Bangkok and check in to your hotel. Enjoy the evening on a Chao Phraya River dinner cruise. Overnight in Bangkok.",
        nights: 2,
      },
      {
        day: 5,
        title: "Bangkok · Safari World",
        state: "Thailand",
        desc: "Spend the day exploring Safari World and Marine Park, then return to your hotel. Overnight in Bangkok.",
      },
      {
        day: 6,
        title: "Bangkok · Departure",
        state: "Thailand",
        desc: "After breakfast, transfer to the airport for your onward journey. The tour concludes in Bangkok.",
      },
    ],
  },
  {
    slug: "phuket-krabi",
    title: "Phuket Krabi",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASPK",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 4,
    nights: 3,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Thailand",
    zone: "Asia",
    packageType: "Group Tour",
    startingPrice: 96000,
    emiPerMonth: 9345,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Phuket (2N)", "Krabi (1N)"] },
    ],
    highlights: [
      "Ao Nang Beach",
      "Four Island Tour",
      "Phra Nang Cave",
      "Tup Island",
      "Chicken Island",
      "Poda Island",
      "Patong Beach",
      "Ao Phang Nga National Park",
      "James Bond Island",
      "Needle Rock",
    ],
    departureCity: "Phuket",
    departureCities: ["Mumbai", "Phuket (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Phuket",
        state: "Thailand",
        desc: "Arrive in Phuket, meet the Royal Tours team and transfer to your hotel. Spend the rest of the day settling in near the island’s beaches. Overnight in Phuket.",
        nights: 2,
      },
      {
        day: 2,
        title: "Phuket · Phang Nga Bay",
        state: "Thailand",
        desc: "Explore Ao Phang Nga National Park, including the dramatic limestone scenery around James Bond Island and Needle Rock. Return to Phuket for the night.",
      },
      {
        day: 3,
        title: "Phuket · Krabi",
        state: "Thailand",
        desc: "Travel to Krabi and enjoy the coastal views around Ao Nang Beach. Overnight in Krabi.",
        nights: 1,
      },
      {
        day: 4,
        title: "Krabi · Four Island Tour · Departure",
        state: "Thailand",
        desc: "Discover the Krabi islands, including Phra Nang Cave, Tup Island, Chicken Island and Poda Island, before your onward transfer.",
      },
    ],
  },
  {
    slug: "womens-special-bangkok-pattaya-phuket-krabi",
    title: "Women's Special Bangkok Pattaya Phuket Krabi",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASWTK",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Thailand",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 143000,
    emiPerMonth: 13918,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Thailand", stops: ["Krabi (1N)", "Phuket (2N)", "Pattaya (2N)", "Bangkok (2N)"] }],
    highlights: ["Ao Nang Beach", "Krabi island-hopping tour", "Patong Beach", "Ao Phang Nga National Park", "James Bond Island", "Alcazar Show", "Coral Island", "Nong Nooch Village", "Pattaya Tower", "Gems Gallery", "Safari World & Marine Park", "Chao Phraya River Dinner Cruise"],
    departureCity: "Bangkok",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Phuket (Joining/leaving)", "Bangkok (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Phuket · Krabi", state: "Thailand", desc: "Arrive in Phuket and continue to Krabi. Enjoy the coastal scenery around Ao Nang Beach and settle in for your stay.", nights: 1 },
      { day: 2, title: "Krabi · Island Hopping · Phuket", state: "Thailand", desc: "Explore Krabi's islands on a scenic island-hopping tour before continuing to Phuket. Check in for a two-night stay.", nights: 2, highlights: ["Krabi island-hopping tour"] },
      { day: 3, title: "Phuket · Phang Nga Bay · James Bond Island", state: "Thailand", desc: "Discover Ao Phang Nga National Park and the limestone scenery around James Bond Island. Return to Phuket for the evening.", highlights: ["Ao Phang Nga National Park", "James Bond Island"] },
      { day: 4, title: "Phuket · Bangkok · Pattaya", state: "Thailand", desc: "Travel onward to Pattaya. In the evening, enjoy the Alcazar Show and check in for a two-night stay.", nights: 2, highlights: ["Alcazar Show"] },
      { day: 5, title: "Pattaya · Coral Island · Nong Nooch Village", state: "Thailand", desc: "Take a boat excursion to Coral Island and visit Nong Nooch Village. Return to Pattaya for the night.", highlights: ["Coral Island", "Nong Nooch Village"] },
      { day: 6, title: "Pattaya · Pattaya Tower · Bangkok", state: "Thailand", desc: "Take in views from Pattaya Tower and visit Gems Gallery before travelling to Bangkok. Check in for a two-night stay.", nights: 2, highlights: ["Pattaya Tower", "Gems Gallery"] },
      { day: 7, title: "Bangkok · Safari World · Chao Phraya River Dinner Cruise", state: "Thailand", desc: "Spend the day at Safari World and Marine Park. In the evening, enjoy a dinner cruise along the Chao Phraya River.", highlights: ["Safari World & Marine Park", "Chao Phraya River Dinner Cruise"] },
      { day: 8, title: "Bangkok · Departure", state: "Thailand", desc: "After breakfast, transfer to the airport for your onward journey. The tour concludes in Bangkok." },
    ],
  },
  {
    slug: "honeymoon-special-bangkok-pattaya-phuket-krabi",
    title: "Honeymoon Special Bangkok Pattaya Phuket Krabi",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASHY",
    tourType: "GROUP TOUR",
    speciality: "Honeymoon Special",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Thailand",
    zone: "Asia",
    interest: "Honeymoon Special",
    packageType: "Group Tour",
    startingPrice: 141000,
    emiPerMonth: 13724,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Thailand", stops: ["Krabi (1N)", "Phuket (2N)", "Pattaya (2N)", "Bangkok (2N)"] }],
    highlights: ["Ao Nang Beach", "Krabi island-hopping tour", "Patong Beach", "Ao Phang Nga National Park", "James Bond Island", "Alcazar Show", "Coral Island", "Nong Nooch Village", "Pattaya Tower", "Gems Gallery", "Safari World & Marine Park", "Chao Phraya River Dinner Cruise"],
    departureCity: "Bangkok",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Phuket (Joining/leaving)", "Bangkok (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Phuket · Krabi", state: "Thailand", desc: "Arrive in Phuket and continue to Krabi. Enjoy the coastal scenery around Ao Nang Beach and settle in for your stay.", nights: 1 },
      { day: 2, title: "Krabi · Island Hopping · Phuket", state: "Thailand", desc: "Explore Krabi's islands on a scenic island-hopping tour before continuing to Phuket. Check in for a two-night stay.", nights: 2, highlights: ["Krabi island-hopping tour"] },
      { day: 3, title: "Phuket · Phang Nga Bay · James Bond Island", state: "Thailand", desc: "Discover Ao Phang Nga National Park and the limestone scenery around James Bond Island. Return to Phuket for the evening.", highlights: ["Ao Phang Nga National Park", "James Bond Island"] },
      { day: 4, title: "Phuket · Bangkok · Pattaya", state: "Thailand", desc: "Travel onward to Pattaya. In the evening, enjoy the Alcazar Show and check in for a two-night stay.", nights: 2, highlights: ["Alcazar Show"] },
      { day: 5, title: "Pattaya · Coral Island · Nong Nooch Village", state: "Thailand", desc: "Take a boat excursion to Coral Island and visit Nong Nooch Village. Return to Pattaya for the night.", highlights: ["Coral Island", "Nong Nooch Village"] },
      { day: 6, title: "Pattaya · Pattaya Tower · Bangkok", state: "Thailand", desc: "Take in views from Pattaya Tower and visit Gems Gallery before travelling to Bangkok. Check in for a two-night stay.", nights: 2, highlights: ["Pattaya Tower", "Gems Gallery"] },
      { day: 7, title: "Bangkok · Safari World · Chao Phraya River Dinner Cruise", state: "Thailand", desc: "Spend the day at Safari World and Marine Park. In the evening, enjoy a dinner cruise along the Chao Phraya River.", highlights: ["Safari World & Marine Park", "Chao Phraya River Dinner Cruise"] },
      { day: 8, title: "Bangkok · Departure", state: "Thailand", desc: "After breakfast, transfer to the airport for your onward journey. The tour concludes in Bangkok." },
    ],
  },
  {
    slug: "bangkok-pattaya-phuket-krabi",
    title: "Bangkok Pattaya Phuket Krabi",
    scope: "world",
    image: U("1506665531195-3566af2b4dfa"),
    gallery: [U("1506665531195-3566af2b4dfa"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "ASTK",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Thailand",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 135000,
    emiPerMonth: 13140,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Krabi (1N)", "Phuket (2N)", "Pattaya (2N)", "Bangkok (2N)"] },
    ],
    highlights: [
      "Ao Nang Beach",
      "Patong Beach",
      "Four Island Tour",
      "Ao Phang Nga National Park",
      "James Bond Island",
      "Alcazar Cabaret Show",
      "Coral Island",
      "Nong Nooch Village",
      "Scientific Thai Massage",
      "Pattaya Tower",
      "Gems Gallery",
      "Safari World and Marine Park",
      "Chao Phraya River Cruise",
      "Wat Pho Reclining Buddha",
    ],
    departureCity: "Bangkok",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Phuket (Joining/leaving)", "Bangkok (Joining/leaving)"],
    dates: [
      { date: "Thu Oct 22, 2026" },
      { date: "Fri Nov 06, 2026" },
      { date: "Mon Nov 09, 2026" },
      { date: "Sat Dec 19, 2026" },
      { date: "Fri Dec 25, 2026" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Phuket · Krabi",
        state: "Thailand",
        desc: "Fly to Phuket and continue to Krabi. On arrival, enjoy the coastal scenery at Ao Nang Beach and settle in for the night.",
        nights: 1,
      },
      {
        day: 2,
        title: "Krabi · Four Island Tour · Phuket",
        state: "Thailand",
        desc: "Explore Krabi's islands, including Phra Nang Cave, Tup Island, Chicken Island and Poda Island. Continue to Phuket and enjoy Patong Beach. Check in for a two-night stay.",
        nights: 2,
      },
      {
        day: 3,
        title: "Phuket · Phang Nga Bay · James Bond Island",
        state: "Thailand",
        desc: "Discover Ao Phang Nga National Park and the limestone scenery around James Bond Island. Return to Phuket for the evening.",
      },
      {
        day: 4,
        title: "Phuket · Bangkok · Pattaya",
        state: "Thailand",
        desc: "Fly from Phuket to Bangkok and continue to Pattaya. In the evening, enjoy the Alcazar Cabaret Show and check in for a two-night stay.",
        nights: 2,
      },
      {
        day: 5,
        title: "Pattaya · Coral Island · Nong Nooch Village",
        state: "Thailand",
        desc: "Take a boat excursion to Coral Island, then visit Nong Nooch Village. Enjoy time to relax with a scientific Thai massage before returning to Pattaya.",
      },
      {
        day: 6,
        title: "Pattaya · Pattaya Tower · Bangkok",
        state: "Thailand",
        desc: "Take in views from Pattaya Tower and visit Gems Gallery before travelling to Bangkok. Check in for a two-night stay.",
        nights: 2,
      },
      {
        day: 7,
        title: "Bangkok · Safari World · Chao Phraya River Cruise",
        state: "Thailand",
        desc: "Spend the day at Safari World and Marine Park. In the evening, enjoy a cruise along the Chao Phraya River before returning to your hotel.",
      },
      {
        day: 8,
        title: "Bangkok · Wat Pho · Departure",
        state: "Thailand",
        desc: "Enjoy a Bangkok city orientation and visit Wat Pho, home of the Reclining Buddha, before transferring to the airport for your onward journey.",
      },
    ],
  },
  {
    slug: "best-of-bali",
    title: "Best of Bali",
    scope: "world",
    image: U("1537996194471-e657df975ab4"),
    gallery: [U("1537996194471-e657df975ab4"), U("1518548419970-58e3b4079ab2"), U("1533105079780-92b9be482077")],
    code: "ASBM",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 7,
    nights: 6,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Bali",
    zone: "Asia",
    packageType: "Group Tour",
    startingPrice: 136000,
    emiPerMonth: 13237,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Indonesia", stops: ["Ubud (3N)", "Kuta (3N)"] }],
    highlights: ["Bali Swing", "Tirta Empul Temple", "Ayung River Rafting", "Tanah Lot Temple", "Bali Safari", "Devdan Show", "Nusa Penida", "Tanjung Benoa Beach", "Coffee Plantations Tour"],
    departureCity: "Kuta",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Bali (Joining)", "Kuta (Leaving)"],
    dates: [
      { date: "Fri Oct 23, 2026", tag: "Lowest Price" },
      { date: "Thu Oct 29, 2026" },
      { date: "Fri Nov 6, 2026" },
      { date: "Sun Nov 8, 2026" },
      { date: "Wed Nov 11, 2026" },
      { date: "Fri Nov 13, 2026" },
      { date: "Wed Nov 18, 2026" },
      { date: "Thu Dec 3, 2026" },
      { date: "Sat Dec 19, 2026" },
      { date: "Sat Dec 26, 2026" },
      { date: "Mon Jan 11, 2027" },
      { date: "Sat Jan 23, 2027" },
      { date: "Tue Feb 23, 2027" },
      { date: "Tue Mar 9, 2027" },
      { date: "Wed Mar 24, 2027" },
    ],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true, visa: false },
    itinerary: [
      { day: 1, title: "Arrival at Bali · Ubud", state: "Indonesia", desc: "Arrive in Bali and transfer to Ubud. Check in and settle in for a three-night stay. The rest of the day is at leisure.", nights: 3 },
      { day: 2, title: "Ubud · Kintamani · Ubud", state: "Indonesia", desc: "Discover the Kintamani region and its dramatic volcanic scenery. Visit Tirta Empul Temple and a local coffee plantation before returning to Ubud.", highlights: ["Tirta Empul Temple", "Coffee Plantations Tour"] },
      { day: 3, title: "Ubud", state: "Indonesia", desc: "Enjoy an adventurous day in Ubud with the famous Bali Swing and an exciting rafting experience on the Ayung River.", highlights: ["Bali Swing", "Ayung River Rafting"] },
      { day: 4, title: "Ubud · Tanah Lot · Kuta", state: "Indonesia", desc: "Visit the iconic Tanah Lot Temple before travelling to Kuta. Check in for a three-night stay by the coast.", nights: 3, highlights: ["Tanah Lot Temple"] },
      { day: 5, title: "Kuta · Nusa Penida · Kuta", state: "Indonesia", desc: "Take a full-day excursion to Nusa Penida and explore the island's celebrated coastal scenery. Return to Kuta in the evening.", highlights: ["Nusa Penida"] },
      { day: 6, title: "Kuta · Tanjung Benoa · Bali Safari · Devdan Show", state: "Indonesia", desc: "Enjoy time at Tanjung Benoa Beach, visit Bali Safari and end the day with the spectacular Devdan Show.", highlights: ["Tanjung Benoa Beach", "Bali Safari", "Devdan Show"] },
      { day: 7, title: "Kuta · Departure", state: "Indonesia", desc: "After breakfast, check out and transfer for your onward journey. The tour concludes in Kuta." },
    ],
  },
  {
    slug: "honeymoon-special-bali",
    title: "Honeymoon Special Bali",
    scope: "world",
    image: U("1537996194471-e657df975ab4"),
    gallery: [U("1537996194471-e657df975ab4"), U("1518548419970-58e3b4079ab2"), U("1533105079780-92b9be482077")],
    code: "ASHL",
    tourType: "GROUP TOUR",
    speciality: "Honeymoon Special",
    allInclusive: true,
    days: 7,
    nights: 6,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Bali",
    zone: "Asia",
    interest: "Honeymoon Special",
    packageType: "Group Tour",
    startingPrice: 143000,
    joiningLeavingPrice: 108000,
    emiPerMonth: 13924,
    rating: 5,
    reviewsCount: 11,
    guestsRated: "528+",
    guestPhotos: 0,
    route: [{ state: "Indonesia", stops: ["Ubud (3N)", "Kuta (3N)"] }],
    highlights: ["Bali Swing", "Tirta Empul Temple", "Ayung River Rafting", "Tanah Lot Temple", "Bali Safari", "Devdan Show", "Nusa Penida", "Tanjung Benoa Beach", "Coffee Plantations Tour"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Bali (Joining/leaving)"],
    dates: [{ date: "Thu Dec 10, 2026", price: 143000, tag: "Lowest Price" }],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrival at Bali · Ubud", state: "Indonesia", desc: "Arrive in Bali and transfer to Ubud. Check in and settle in for a three-night stay. The rest of the day is at leisure.", nights: 3 },
      { day: 2, title: "Ubud · Kintamani · Ubud", state: "Indonesia", desc: "Discover the Kintamani region and its volcanic scenery. Visit Tirta Empul Temple and a local coffee plantation before returning to Ubud.", highlights: ["Tirta Empul Temple", "Coffee Plantations Tour"] },
      { day: 3, title: "Ubud", state: "Indonesia", desc: "Enjoy a memorable day in Ubud with the famous Bali Swing and an exciting rafting experience on the Ayung River.", highlights: ["Bali Swing", "Ayung River Rafting"] },
      { day: 4, title: "Ubud · Tanah Lot · Kuta", state: "Indonesia", desc: "Visit the iconic Tanah Lot Temple before travelling to Kuta. Check in for a three-night stay by the coast.", nights: 3, highlights: ["Tanah Lot Temple"] },
      { day: 5, title: "Kuta · Nusa Penida · Kuta", state: "Indonesia", desc: "Take a full-day excursion to Nusa Penida and explore the island's celebrated coastal scenery. Return to Kuta in the evening.", highlights: ["Nusa Penida"] },
      { day: 6, title: "Kuta · Tanjung Benoa · Bali Safari · Devdan Show", state: "Indonesia", desc: "Enjoy time at Tanjung Benoa Beach, visit Bali Safari and end the day with the spectacular Devdan Show.", highlights: ["Tanjung Benoa Beach", "Bali Safari", "Devdan Show"] },
      { day: 7, title: "Kuta · Departure", state: "Indonesia", desc: "After breakfast, check out and transfer for your onward journey. The tour concludes in Kuta." },
    ],
  },
  {
    slug: "womens-special-bali",
    title: "Women's Special Bali",
    scope: "world",
    image: U("1537996194471-e657df975ab4"),
    gallery: [U("1537996194471-e657df975ab4"), U("1518548419970-58e3b4079ab2"), U("1533105079780-92b9be482077")],
    code: "ASWI",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 7,
    nights: 6,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Bali",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 142000,
    emiPerMonth: 13821,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Indonesia", stops: ["Ubud (3N)", "Kuta (3N)"] }],
    highlights: ["Bali Swing", "Tirta Empul Temple", "Ayung River Rafting", "Tanah Lot Temple", "Bali Safari", "Devdan Show", "Nusa Penida", "Coffee Plantations Tour"],
    departureCity: "Kuta",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Bali (Joining)", "Kuta (Leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrival at Bali · Ubud", state: "Indonesia", desc: "Arrive in Bali and transfer to Ubud. Check in and settle in for a three-night stay. The rest of the day is at leisure.", nights: 3 },
      { day: 2, title: "Ubud · Kintamani · Ubud", state: "Indonesia", desc: "Discover the Kintamani region and its volcanic scenery. Visit Tirta Empul Temple and a local coffee plantation before returning to Ubud.", highlights: ["Tirta Empul Temple", "Coffee Plantations Tour"] },
      { day: 3, title: "Ubud", state: "Indonesia", desc: "Enjoy a memorable day in Ubud with the famous Bali Swing and an exciting rafting experience on the Ayung River.", highlights: ["Bali Swing", "Ayung River Rafting"] },
      { day: 4, title: "Ubud · Tanah Lot · Kuta", state: "Indonesia", desc: "Visit the iconic Tanah Lot Temple before travelling to Kuta. Check in for a three-night stay by the coast.", nights: 3, highlights: ["Tanah Lot Temple"] },
      { day: 5, title: "Kuta · Nusa Penida · Kuta", state: "Indonesia", desc: "Take a full-day excursion to Nusa Penida and explore the island's celebrated coastal scenery. Return to Kuta in the evening.", highlights: ["Nusa Penida"] },
      { day: 6, title: "Kuta · Bali Safari · Devdan Show", state: "Indonesia", desc: "Enjoy a visit to Bali Safari and experience the spectacular Devdan Show. Spend the rest of the day at leisure in Kuta.", highlights: ["Bali Safari", "Devdan Show"] },
      { day: 7, title: "Kuta · Departure", state: "Indonesia", desc: "After breakfast, check out and transfer for your onward journey. The tour concludes in Kuta." },
    ],
  },
  {
    slug: "best-of-singapore",
    title: "Best of Singapore",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1513415564515-763d91423bdd"), U("1496939376851-89342e90adcd")],
    code: "ASSGR",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 1,
    region: "Singapore",
    zone: "Asia",
    packageType: "Group Tour",
    startingPrice: 139000,
    emiPerMonth: 13530,
    rating: 5,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Singapore", stops: ["Singapore (4N)"] }],
    highlights: ["Singapore City Tour", "Night Safari", "Gardens by the Bay", "Marina Bay Sands SkyPark", "Sentosa Island Cable Car", "SkyHelix Sentosa", "Universal Studios Singapore", "Mandai Bird Paradise"],
    departureCity: "Singapore",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Singapore (Joining/leaving)"],
    dates: [
      { date: "Wed Nov 11, 2026", tag: "Filling Fast" },
      { date: "Sat Nov 14, 2026" },
      { date: "Tue Nov 24, 2026" },
      { date: "Thu Dec 24, 2026" },
      { date: "Mon Dec 28, 2026", tag: "Filling Fast" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrival at Singapore", state: "Singapore", desc: "Arrive in Singapore and transfer to your hotel. Meet the group and settle in for a four-night stay.", nights: 4 },
      { day: 2, title: "Singapore City Tour · Night Safari", state: "Singapore", desc: "Get to know the city on a Singapore city tour, with its landmark skyline and vibrant cultural districts. In the evening, experience the Night Safari.", highlights: ["Singapore City Tour", "Night Safari"] },
      { day: 3, title: "Gardens by the Bay · Marina Bay Sands", state: "Singapore", desc: "Explore the spectacular Gardens by the Bay and enjoy panoramic city views from the Marina Bay Sands SkyPark.", highlights: ["Gardens by the Bay", "Marina Bay Sands SkyPark"] },
      { day: 4, title: "Sentosa Island · Universal Studios Singapore", state: "Singapore", desc: "Spend an exciting day on Sentosa Island. Ride the cable car, enjoy the SkyHelix and discover the attractions at Universal Studios Singapore.", highlights: ["Sentosa Island Cable Car", "SkyHelix Sentosa", "Universal Studios Singapore"] },
      { day: 5, title: "Singapore · Departure", state: "Singapore", desc: "After breakfast, check out and transfer to the airport for your onward journey. The tour concludes in Singapore." },
    ],
  },
  {
    slug: "kuala-lumpur-malaysia",
    title: "Kuala Lumpur Malaysia",
    scope: "world",
    image: U("1596422846543-75c6fc197f07"),
    gallery: [U("1596422846543-75c6fc197f07")],
    code: "ASKM",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 4,
    nights: 3,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "South East Asia",
    zone: "Asia",
    packageType: "Group Tour",
    startingPrice: 86000,
    joiningLeavingPrice: 60000,
    emiPerMonth: 8374,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Malaysia", stops: ["Kuala Lumpur (3N)", "Genting Highlands"] },
    ],
    highlights: ["Observatory Deck of the K. L. Tower", "Genting Sky Worlds Outdoor Theme Park", "Batu Caves", "KL Bird Park", "Aquaria KLCC", "Putrajaya City Tour", "Kuala Lumpur City Tour"],
    departureCity: "Kuala Lumpur",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Hyderabad", "Kolkata", "New Delhi", "Kuala Lumpur (Joining/leaving)"],
    dates: [
      { date: "Tue Oct 27, 2026", price: 86000, tag: "Lowest Price" },
      { date: "Thu Nov 19, 2026", price: 95000 },
      { date: "Thu Dec 10, 2026", price: 94000 },
      { date: "Wed Dec 23, 2026", price: 110000 },
      { date: "Thu Feb 11, 2027", price: 93000 },
      { date: "Sat Mar 20, 2027", price: 91000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrival at Kuala Lumpur",
        state: "Malaysia",
        desc: "Arrive in Kuala Lumpur and transfer to your hotel. Settle in and enjoy the start of your Malaysia holiday. Overnight in Kuala Lumpur.",
        nights: 3,
      },
      {
        day: 2,
        title: "Kuala Lumpur · Genting Highlands · Kuala Lumpur",
        state: "Malaysia",
        desc: "Travel to Genting Highlands and enjoy the Genting SkyWorlds Outdoor Theme Park. Visit Batu Caves before returning to Kuala Lumpur for the night.",
      },
      {
        day: 3,
        title: "Kuala Lumpur",
        state: "Malaysia",
        desc: "Enjoy a Kuala Lumpur city tour and visit the KL Bird Park, Aquaria KLCC and the observatory deck of the K. L. Tower. Also explore Putrajaya on a city tour. Overnight in Kuala Lumpur.",
      },
      {
        day: 4,
        title: "Kuala Lumpur · Departure",
        state: "Malaysia",
        desc: "After breakfast, transfer to the airport for your return journey. The tour concludes in Kuala Lumpur.",
      },
    ],
  },
  {
    slug: "seniors-special-mauritius",
    title: "Seniors' Special Mauritius",
    scope: "world",
    image: U("1544644181-1484b3fdfc62"),
    gallery: [U("1544644181-1484b3fdfc62")],
    code: "AFZM",
    tourType: "GROUP TOUR",
    speciality: "Seniors' Special",
    allInclusive: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 1,
    region: "Mauritius",
    zone: "Africa & Middle East",
    interest: "Seniors' Special",
    packageType: "Group Tour",
    startingPrice: 176765,
    emiPerMonth: 17193,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Mauritius", stops: ["Port Louis (5N)"] }],
    highlights: ["Port Louis City", "High-Speed Boat Ride", "Ile Aux Cerfs Island", "Parasailing Ride", "Model Ship Factory", "Trou Aux Cerfs", "Grand Bassin", "Shiva Temple", "La Vallée des Couleurs", "Seven Colored Earths", "Casela Bird Park", "Cascavelle Mall", "Boating and Kayaking", "Pamplemousses Botanic Garden", "Citadel Fort", "Le Caudan Waterfront"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Joining/leaving (Port Louis)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Mauritius · Port Louis", state: "Mauritius", desc: "Arrive in Mauritius and transfer to your hotel in Port Louis. Settle in for a comfortable five-night stay.", nights: 5 },
      { day: 2, title: "Port Louis · Pamplemousses · Citadel Fort", state: "Mauritius", desc: "Explore Port Louis, visit Pamplemousses Botanic Garden and see the city from Citadel Fort. Stop at the model ship factory and Le Caudan Waterfront.", highlights: ["Port Louis City", "Pamplemousses Botanic Garden", "Citadel Fort", "Model Ship Factory", "Le Caudan Waterfront"] },
      { day: 3, title: "Ile Aux Cerfs Island", state: "Mauritius", desc: "Take a high-speed boat to Ile Aux Cerfs Island and enjoy the lagoon, with time for parasailing and boating or kayaking.", highlights: ["High-Speed Boat Ride", "Ile Aux Cerfs Island", "Parasailing Ride", "Boating and Kayaking"] },
      { day: 4, title: "Trou Aux Cerfs · Grand Bassin · La Vallée des Couleurs", state: "Mauritius", desc: "Visit Trou Aux Cerfs and Grand Bassin, including the Shiva Temple, then discover the colourful landscapes at La Vallée des Couleurs.", highlights: ["Trou Aux Cerfs", "Grand Bassin", "Shiva Temple", "La Vallée des Couleurs", "Seven Colored Earths"] },
      { day: 5, title: "Casela Bird Park · Cascavelle Mall", state: "Mauritius", desc: "Spend time at Casela Bird Park and visit Cascavelle Mall.", highlights: ["Casela Bird Park", "Cascavelle Mall"] },
      { day: 6, title: "Mauritius · Departure", state: "Mauritius", desc: "Transfer to the airport for your onward journey. The tour concludes in Mauritius." },
    ],
  },  {
    slug: "best-of-mauritius",
    title: "Best of Mauritius",
    scope: "world",
    image: U("1544644181-1484b3fdfc62"),
    gallery: [U("1544644181-1484b3fdfc62")],
    code: "AFMU",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 1,
    region: "Mauritius",
    zone: "Africa & Middle East",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 168636,
    emiPerMonth: 16410,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Mauritius", stops: ["Port Louis (5N)"] }],
    highlights: ["Port Louis City Tour", "High-Speed Boat Ride", "Ile Aux Cerfs Island", "Parasailing Adventure", "Model Ship Factory Visit", "Trou Aux Cerfs Volcano", "Grand Bassin Lake", "Sacred Shiva Temple", "La Vallée des Couleurs", "Seven Colored Earths", "Casela Bird Park", "Exotic Bird Watching", "Cascavelle Mall Shopping", "Pamplemousses Botanic Gardens", "Giant Water Lilies", "Citadel Fort Visit"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "New Delhi", "Port Louis (Joining/leaving)"],
    dates: [{ date: "Sat Oct 24, 2026", price: 168636 }],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Mauritius · Port Louis", state: "Mauritius", desc: "Arrive in Mauritius and transfer to your hotel in Port Louis. Settle in for a five-night stay.", nights: 5 },
      { day: 2, title: "Port Louis · Pamplemousses · Citadel Fort", state: "Mauritius", desc: "Explore Port Louis on a city tour, visit the Pamplemousses Botanic Gardens and see the capital from Citadel Fort. Stop at the model ship factory and Le Caudan Waterfront.", highlights: ["Port Louis City Tour", "Pamplemousses Botanic Gardens", "Giant Water Lilies", "Citadel Fort", "Model Ship Factory"] },
      { day: 3, title: "Ile Aux Cerfs Island", state: "Mauritius", desc: "Take a high-speed boat to Ile Aux Cerfs Island. Enjoy the island and its lagoon, with time for parasailing.", highlights: ["High-Speed Boat Ride", "Ile Aux Cerfs Island", "Parasailing Adventure"] },
      { day: 4, title: "Trou Aux Cerfs · Grand Bassin · La Vallée des Couleurs", state: "Mauritius", desc: "Discover Trou Aux Cerfs volcano, Grand Bassin Lake and the Sacred Shiva Temple, then explore La Vallée des Couleurs and its Seven Colored Earths.", highlights: ["Trou Aux Cerfs Volcano", "Grand Bassin Lake", "Sacred Shiva Temple", "La Vallée des Couleurs", "Seven Colored Earths"] },
      { day: 5, title: "Casela Bird Park · Cascavelle Mall", state: "Mauritius", desc: "Visit Casela Bird Park for exotic bird watching, followed by time to shop at Cascavelle Mall.", highlights: ["Casela Bird Park", "Exotic Bird Watching", "Cascavelle Mall Shopping"] },
      { day: 6, title: "Mauritius · Departure", state: "Mauritius", desc: "Transfer to the airport for your onward journey. The tour concludes in Mauritius." },
    ],
  },
  {
    slug: "honeymoon-special-mauritius",
    title: "Honeymoon Special Mauritius",
    scope: "world",
    image: U("1544644181-1484b3fdfc62"),
    gallery: [U("1544644181-1484b3fdfc62")],
    code: "AFHM",
    tourType: "GROUP TOUR",
    speciality: "Honeymoon Special",
    allInclusive: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 1,
    region: "Mauritius",
    zone: "Africa & Middle East",
    interest: "Honeymoon Special",
    packageType: "Group Tour",
    startingPrice: 171326,
    emiPerMonth: 16681,
    rating: 5,
    reviewsCount: 14,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Mauritius", stops: ["Port Louis (5N)"] },
    ],
    highlights: ["Port Louis City Tour", "High-Speed Boat Ride", "Ile Aux Cerfs Island", "Parasailing Adventure", "Model Ship Factory Visit", "Trou Aux Cerfs Volcano", "Grand Bassin Lake", "Sacred Shiva Temple", "La Vallée des Couleurs", "Seven Colored Earths", "Casela Bird Park", "Exotic Bird Watching", "Cascavelle Mall Shopping", "Pamplemousses Botanic Gardens", "Giant Water Lilies", "Citadel Fort Visit"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Port Louis (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Mauritius · Port Louis", state: "Mauritius", desc: "Arrive in Mauritius and transfer to Port Louis. Settle in for a five-night stay.", nights: 5 },
      { day: 2, title: "Port Louis · Pamplemousses · Citadel Fort", state: "Mauritius", desc: "Explore Port Louis on a city tour, visit the Pamplemousses Botanic Gardens and see the capital from Citadel Fort. Stop at the model ship factory and Le Caudan Waterfront.", highlights: ["Port Louis City Tour", "Pamplemousses Botanic Gardens", "Giant Water Lilies", "Citadel Fort Visit", "Model Ship Factory Visit"] },
      { day: 3, title: "Ile Aux Cerfs Island", state: "Mauritius", desc: "Take a high-speed boat to Ile Aux Cerfs Island and enjoy time by the lagoon, with an opportunity to try parasailing.", highlights: ["High-Speed Boat Ride", "Ile Aux Cerfs Island", "Parasailing Adventure"] },
      { day: 4, title: "Trou Aux Cerfs · Grand Bassin · La Vallée des Couleurs", state: "Mauritius", desc: "Visit Trou Aux Cerfs volcano, Grand Bassin Lake and the Sacred Shiva Temple, then explore La Vallée des Couleurs and its Seven Colored Earths.", highlights: ["Trou Aux Cerfs Volcano", "Grand Bassin Lake", "Sacred Shiva Temple", "La Vallée des Couleurs", "Seven Colored Earths"] },
      { day: 5, title: "Casela Bird Park · Cascavelle Mall", state: "Mauritius", desc: "Visit Casela Bird Park for exotic bird watching, followed by time to shop at Cascavelle Mall.", highlights: ["Casela Bird Park", "Exotic Bird Watching", "Cascavelle Mall Shopping"] },
      { day: 6, title: "Mauritius · Departure", state: "Mauritius", desc: "Transfer to the airport for your onward journey. The tour concludes in Mauritius." },
    ],
  },
  {
    slug: "womens-special-bhutan",
    title: "Women's Special Bhutan",
    scope: "world",
    image: U("/assets/media/royal-bhutan-tigers-nest.jpg"),
    gallery: [U("/assets/media/royal-bhutan-tigers-nest.jpg"), U("1501785888041-af3ef285b470")],
    code: "BTWHL",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 7,
    nights: 6,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 5,
    region: "Bhutan",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 89000,
    emiPerMonth: 8665,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Bhutan", stops: ["Phuentsholing (1N)", "Thimphu (2N)", "Paro (2N)"] },
      { state: "India", stops: ["Siliguri (1N)"] },
    ],
    highlights: [
      "Kharbandi Gompa",
      "BBS Clock Tower",
      "Royal Takin Preserve",
      "Standing Buddha Park",
      "National Library and the Handicraft Centre",
      "National Museum (Ta Dzong) and Paro Dzong",
      "Bhutanese cultural program",
      "Taktshang Monastery",
      "Bhutanese Beer brewery",
    ],
    departureCity: "Bagdogra",
    departureCities: ["Mumbai", "Bagdogra (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Bagdogra · Phuentsholing",
        state: "Bhutan",
        desc: "Arrive at Bagdogra and travel to Phuentsholing, Bhutan’s gateway town. Visit Kharbandi Gompa and check in for the night.",
        nights: 1,
      },
      {
        day: 2,
        title: "Phuentsholing · Thimphu",
        state: "Bhutan",
        desc: "Complete the entry formalities and drive through mountain scenery to Thimphu. Check in to your hotel for a two-night stay.",
        nights: 2,
      },
      {
        day: 3,
        title: "Thimphu",
        state: "Bhutan",
        desc: "Explore Thimphu, including the BBS Clock Tower, Royal Takin Preserve, Standing Buddha Park, National Library and Handicraft Centre. Enjoy time to discover the capital’s local culture.",
      },
      {
        day: 4,
        title: "Thimphu · Paro",
        state: "Bhutan",
        desc: "Travel from Thimphu to Paro and check in to your hotel. Visit the National Museum at Ta Dzong and Paro Dzong.",
        nights: 2,
      },
      {
        day: 5,
        title: "Paro · Taktshang Monastery · Paro",
        state: "Bhutan",
        desc: "Visit Taktshang Monastery, also known as Tiger’s Nest, dramatically set above the Paro valley. Return to Paro and visit a Bhutanese beer brewery.",
      },
      {
        day: 6,
        title: "Paro · Phuentsholing · Siliguri",
        state: "India",
        desc: "Drive from Paro through Phuentsholing and continue to Siliguri. Check in to your hotel for the final night of the tour.",
        nights: 1,
      },
      {
        day: 7,
        title: "Siliguri · Bagdogra · Departure",
        state: "India",
        desc: "Transfer to Bagdogra Airport for your return flight. The tour concludes on arrival at the airport.",
      },
    ],
  },
  {
    slug: "womens-special-bhutan-9-days",
    title: "Women's Special Bhutan",
    scope: "world",
    image: U("/assets/media/royal-bhutan-tigers-nest.jpg"),
    gallery: [U("/assets/media/royal-bhutan-tigers-nest.jpg"), U("1501785888041-af3ef285b470")],
    code: "BTWB",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 9,
    nights: 8,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 6,
    region: "Bhutan",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 101000,
    emiPerMonth: 9829,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Bhutan", stops: ["Phuentsholing (1N)", "Thimphu (2N)", "Punakha (1N)", "Paro (3N)"] },
      { state: "India", stops: ["Siliguri (1N)"] },
    ],
    highlights: [
      "Kharbandi Gompa",
      "BBS Clock Tower",
      "Tashichho Dzong",
      "Royal Takin Preserve",
      "Buddha Dordenma Statue",
      "Standing Buddha Park",
      "National Library and Handicraft Center",
      "Simply Bhutan",
      "Dochula Pass",
      "Chimi Lhakhang",
      "White water rafting",
      "Punakha Dzong",
      "Lamperi Botanical Garden",
      "Bhutanese Beer brewery",
      "Chele-la-Pass",
      "Ta-Dzong",
      "Paro Dzong",
      "Bhutanese cultural program",
      "Taktshang Monastery - Tiger's Nest",
    ],
    departureCity: "Bagdogra",
    departureCities: ["Mumbai", "Bagdogra (Joining/leaving)"],
    dates: [
      { date: "Sat Nov 21, 2026" },
      { date: "Wed Dec 02, 2026" },
      { date: "Sat Jan 23, 2027", tag: "Lowest Price" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Bagdogra · Phuentsholing",
        state: "Bhutan",
        desc: "Arrive at Bagdogra and travel to Phuentsholing. Visit Kharbandi Gompa before checking in for the night.",
        nights: 1,
      },
      {
        day: 2,
        title: "Phuentsholing · Thimphu",
        state: "Bhutan",
        desc: "Complete the entry formalities and drive through mountain scenery to Thimphu. Check in for a two-night stay.",
        nights: 2,
      },
      {
        day: 3,
        title: "Thimphu",
        state: "Bhutan",
        desc: "Explore Thimphu's landmarks, including Tashichho Dzong, the Royal Takin Preserve, Buddha Dordenma, Standing Buddha Park, the National Library and Simply Bhutan.",
      },
      {
        day: 4,
        title: "Thimphu · Punakha",
        state: "Bhutan",
        desc: "Drive to Punakha via Dochula Pass. Visit Chimi Lhakhang and Punakha Dzong, with an opportunity for white water rafting. Overnight in Punakha.",
        nights: 1,
      },
      {
        day: 5,
        title: "Punakha · Paro",
        state: "Bhutan",
        desc: "Visit Lamperi Botanical Garden and travel to Paro. Check in for a three-night stay and enjoy a Bhutanese cultural program.",
        nights: 3,
      },
      {
        day: 6,
        title: "Paro · Chele La Pass",
        state: "Bhutan",
        desc: "Take a scenic excursion to Chele La Pass and return to Paro. Visit a Bhutanese beer brewery.",
      },
      {
        day: 7,
        title: "Paro · Taktshang Monastery",
        state: "Bhutan",
        desc: "Visit Taktshang Monastery, the iconic Tiger's Nest, set high above the Paro valley. See Ta-Dzong and Paro Dzong.",
      },
      {
        day: 8,
        title: "Paro · Phuentsholing · Siliguri",
        state: "India",
        desc: "Travel from Paro through Phuentsholing and continue to Siliguri for the final night of the tour.",
        nights: 1,
      },
      {
        day: 9,
        title: "Siliguri · Bagdogra · Departure",
        state: "India",
        desc: "Transfer to Bagdogra Airport for your return journey. The tour concludes at the airport.",
      },
    ],
  },
  {
    slug: "seniors-special-bhutan",
    title: "Seniors' Special Bhutan",
    scope: "world",
    image: U("/assets/media/royal-bhutan-tigers-nest.jpg"),
    gallery: [U("/assets/media/royal-bhutan-tigers-nest.jpg"), U("1501785888041-af3ef285b470")],
    code: "BTZB",
    tourType: "GROUP TOUR",
    speciality: "Seniors' Special",
    allInclusive: true,
    days: 9,
    nights: 8,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 6,
    region: "Bhutan",
    zone: "Asia",
    interest: "Seniors' Special",
    packageType: "Group Tour",
    startingPrice: 102000,
    emiPerMonth: 9927,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Bhutan", stops: ["Phuentsholing (1N)", "Thimphu (2N)", "Punakha (1N)", "Paro (3N)"] },
      { state: "India", stops: ["Siliguri (1N)"] },
    ],
    highlights: [
      "Kharbandi Gompa",
      "BBS Clock Tower",
      "Tashichho Dzong",
      "Royal Takin Preserve",
      "Buddha Dordenma Statue",
      "Standing Buddha Park",
      "National Library and Handicraft Center",
      "Simply Bhutan",
      "Dochula Pass",
      "Chimi Lhakhang",
      "White water rafting",
      "Punakha Dzong",
      "Lamperi Botanical Garden",
      "Bhutanese Beer brewery",
      "Chele-la-Pass",
      "Ta-Dzong",
      "Paro Dzong",
      "Bhutanese cultural program",
      "Taktshang Monastery - Tiger's Nest",
    ],
    departureCity: "Bagdogra",
    departureCities: ["Mumbai", "Bagdogra (Joining/leaving)"],
    dates: [{ date: "Sat Feb 20, 2027", price: 102000, tag: "Lowest Price" }],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Bagdogra · Phuentsholing",
        state: "Bhutan",
        desc: "Arrive at Bagdogra and travel to Phuentsholing. Visit Kharbandi Gompa before checking in for the night.",
        nights: 1,
      },
      {
        day: 2,
        title: "Phuentsholing · Thimphu",
        state: "Bhutan",
        desc: "Complete the entry formalities and drive through mountain scenery to Thimphu. Check in for a two-night stay.",
        nights: 2,
      },
      {
        day: 3,
        title: "Thimphu",
        state: "Bhutan",
        desc: "Explore Thimphu's landmarks, including Tashichho Dzong, the Royal Takin Preserve, Buddha Dordenma, Standing Buddha Park, the National Library and Simply Bhutan.",
      },
      {
        day: 4,
        title: "Thimphu · Punakha",
        state: "Bhutan",
        desc: "Drive to Punakha via Dochula Pass. Visit Chimi Lhakhang and Punakha Dzong, with an opportunity for white water rafting. Overnight in Punakha.",
        nights: 1,
      },
      {
        day: 5,
        title: "Punakha · Paro",
        state: "Bhutan",
        desc: "Visit Lamperi Botanical Garden and travel to Paro. Check in for a three-night stay and enjoy a Bhutanese cultural program.",
        nights: 3,
      },
      {
        day: 6,
        title: "Paro · Chele La Pass",
        state: "Bhutan",
        desc: "Take a scenic excursion to Chele La Pass and return to Paro. Visit a Bhutanese beer brewery.",
      },
      {
        day: 7,
        title: "Paro · Taktshang Monastery",
        state: "Bhutan",
        desc: "Visit Taktshang Monastery, the iconic Tiger's Nest, set high above the Paro valley. See Ta-Dzong and Paro Dzong.",
      },
      {
        day: 8,
        title: "Paro · Phuentsholing · Siliguri",
        state: "India",
        desc: "Travel from Paro through Phuentsholing and continue to Siliguri for the final night of the tour.",
        nights: 1,
      },
      {
        day: 9,
        title: "Siliguri · Bagdogra · Departure",
        state: "India",
        desc: "Transfer to Bagdogra Airport for your return journey. The tour concludes at the airport.",
      },
    ],
  },
  {
    slug: "highlights-of-bhutan",
    title: "Highlights of Bhutan",
    scope: "world",
    image: U("/assets/media/royal-bhutan-tigers-nest.jpg"),
    gallery: [U("/assets/media/royal-bhutan-tigers-nest.jpg"), U("1501785888041-af3ef285b470")],
    code: "RTBH",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 7,
    nights: 6,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 4,
    region: "Bhutan",
    zone: "Asia",
    packageType: "Group Tour",
    startingPrice: 82000,
    joiningLeavingPrice: 55000,
    emiPerMonth: 7984,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Bhutan", stops: ["Phuentsholing (1N)", "Thimphu (2N)", "Paro (2N)"] },
      { state: "India", stops: ["Siliguri (1N)"] },
    ],
    highlights: [
      "Kharbandi Gompa",
      "BBS Clock Tower",
      "Royal Takin Preserve",
      "Standing Buddha Park",
      "National Library and the Handicraft Centre",
      "National Museum (Ta Dzong) and Paro Dzong",
      "Bhutanese cultural program",
      "Taktshang Monastery (Tiger’s Nest)",
      "Bhutanese beer brewery",
    ],
    departureCity: "Bagdogra",
    departureCities: ["Mumbai", "Bengaluru", "Bagdogra (Joining/leaving)"],
    dates: [
      { date: "Wed Oct 28, 2026", price: 89000 },
      { date: "Sat Nov 07, 2026", price: 68000, tag: "Joining/leaving only" },
      { date: "Thu Nov 12, 2026", price: 95000 },
      { date: "Sat Nov 14, 2026", price: 94000 },
      { date: "Sat Nov 28, 2026", price: 88000 },
      { date: "Sun Dec 20, 2026", price: 96000 },
      { date: "Sun Jan 24, 2027", price: 89000 },
      { date: "Sun Feb 14, 2027", price: 87000 },
      { date: "Sun Mar 28, 2027", price: 82000, tag: "Lowest Price" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Bagdogra · Phuentsholing",
        state: "Bhutan",
        desc: "Arrive at Bagdogra and travel to Phuentsholing, Bhutan’s gateway town. Visit Kharbandi Gompa and check in for the night.",
        nights: 1,
      },
      {
        day: 2,
        title: "Phuentsholing · Thimphu",
        state: "Bhutan",
        desc: "Complete the entry formalities and drive through mountain scenery to Thimphu. Check in to your hotel for a two-night stay.",
        nights: 2,
      },
      {
        day: 3,
        title: "Thimphu",
        state: "Bhutan",
        desc: "Explore Thimphu, including the BBS Clock Tower, Royal Takin Preserve, Standing Buddha Park, National Library and Handicraft Centre. Enjoy a Bhutanese cultural program.",
      },
      {
        day: 4,
        title: "Thimphu · Paro",
        state: "Bhutan",
        desc: "Travel from Thimphu to Paro and check in to your hotel. Visit the National Museum at Ta Dzong and Paro Dzong.",
        nights: 2,
      },
      {
        day: 5,
        title: "Paro · Taktshang Monastery · Paro",
        state: "Bhutan",
        desc: "Visit Taktshang Monastery, also known as Tiger’s Nest, dramatically set above the Paro valley. Return to Paro and visit a Bhutanese beer brewery.",
      },
      {
        day: 6,
        title: "Paro · Phuentsholing · Siliguri",
        state: "India",
        desc: "Drive from Paro through Phuentsholing and continue to Siliguri. Check in to your hotel for the final night of the tour.",
        nights: 1,
      },
      {
        day: 7,
        title: "Siliguri · Bagdogra · Departure",
        state: "India",
        desc: "Transfer to Bagdogra Airport for your return flight. The tour concludes on arrival at the airport.",
      },
    ],
  },
  {
    slug: "best-of-bhutan",
    title: "Best of Bhutan",
    scope: "world",
    image: U("/assets/media/royal-bhutan-tigers-nest.jpg"),
    gallery: [U("/assets/media/royal-bhutan-tigers-nest.jpg")],
    code: "BTJS",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 9,
    nights: 8,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 6,
    region: "Bhutan",
    zone: "Asia",
    interest: null,
    packageType: "Group Tour",
    startingPrice: 97000,
    emiPerMonth: 9433,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Bhutan", stops: ["Phuentsholing (1N)", "Thimphu (2N)", "Punakha (1N)", "Paro (3N)"] },
      { state: "India", stops: ["Siliguri (1N)"] },
    ],
    highlights: [
      "Kharbandi Gompa",
      "BBS Clock Tower",
      "Tashichho Dzong",
      "Royal Takin Preserve",
      "Buddha Dordenma Statue",
      "Phobjika Valley",
      "Punakha Dzong",
      "White water rafting in the Punakha River",
      "Chele-la Pass",
      "Paro Dzong",
      "Bhutanese cultural program",
      "Taktshang Monastery (Tiger’s Nest)",
    ],
    departureCity: "Bagdogra",
    departureCities: ["Mumbai", "Bagdogra (Joining/leaving)"],
    dates: [
      { date: "Sat Oct 24, 2026", price: 97000 },
      { date: "Sun Nov 15, 2026", price: 97000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive at Bagdogra · Phuentsholing",
        state: "Bhutan",
        desc: "Arrive at Bagdogra and travel to Phuentsholing, Bhutan’s gateway town. Visit Kharbandi Gompa and settle in for the night.",
        nights: 1,
      },
      {
        day: 2,
        title: "Phuentsholing · Thimphu",
        state: "Bhutan",
        desc: "Complete the border formalities and drive to Thimphu, Bhutan’s capital. Check in to your hotel for a two-night stay.",
        nights: 2,
      },
      {
        day: 3,
        title: "Thimphu sightseeing",
        state: "Bhutan",
        desc: "Explore Thimphu, with visits to Tashichho Dzong, BBS Clock Tower, the Royal Takin Preserve, Buddha Dordenma and the National Library.",
      },
      {
        day: 4,
        title: "Thimphu · Punakha",
        state: "Bhutan",
        desc: "Travel across the scenic Dochula Pass to Punakha. Visit Punakha Dzong and enjoy the valley’s riverside scenery. Overnight in Punakha.",
        nights: 1,
      },
      {
        day: 5,
        title: "Punakha · Phobjika Valley · Paro",
        state: "Bhutan",
        desc: "Discover the landscapes of Phobjika Valley before continuing to Paro. Check in to your hotel for a three-night stay.",
        nights: 3,
      },
      {
        day: 6,
        title: "Paro · Chele-la Pass",
        state: "Bhutan",
        desc: "Take a scenic drive to Chele-la Pass, with time to enjoy the mountain views, then return to Paro.",
      },
      {
        day: 7,
        title: "Paro · Taktshang Monastery",
        state: "Bhutan",
        desc: "Visit Taktshang Monastery, the iconic Tiger’s Nest, set high above the Paro valley. Return to Paro for the evening.",
      },
      {
        day: 8,
        title: "Paro · Phuentsholing · Siliguri",
        state: "India",
        desc: "Travel from Paro through Phuentsholing and continue to Siliguri for the final night of the tour.",
        nights: 1,
      },
      {
        day: 9,
        title: "Siliguri · Bagdogra · Departure",
        state: "India",
        desc: "Transfer to Bagdogra Airport for your return journey. The tour concludes at the airport.",
      },
    ],
  },
  {
    slug: "best-of-laos",
    title: "Best of Laos",
    scope: "world",
    image: U("1509030450996-dd1a26dda07a"),
    gallery: [U("1509030450996-dd1a26dda07a"), U("1528127269322-539801943592"), U("1513415277900-a62401e19be4")],
    code: "ASBO",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 6,
    nights: 5,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 3,
    region: "Laos",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 150000,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Laos", stops: ["Luang Prabang (3N)", "Vang Vieng (1N)", "Vientiane (1N)"] }],
    highlights: ["Luang Prabang Night Market", "Kuang Si Waterfall", "Royal Palace Museum", "Pak Ou Caves", "Tak Bat", "Blue Lagoon", "Pha That Luang", "Tail Boat Ride on the Nam Song River", "Wat Si Saket", "Wat Xieng Khouane Luang Buddha Park", "Lao Cruise on the Mekong River"],
    departureCity: "Luang Prabang",
    departureCities: ["Mumbai", "Delhi", "Nagpur", "Kolkata", "Indore", "Hyderabad", "Joining/leaving"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Luang Prabang",
        state: "Laos",
        desc: "Arrive in Luang Prabang and settle in. In the evening, explore the lively Luang Prabang Night Market.",
        nights: 3,
      },
      {
        day: 2,
        title: "Luang Prabang · Kuang Si Waterfall",
        state: "Laos",
        desc: "Experience Tak Bat in the morning, then visit the Royal Palace Museum and the turquoise pools of Kuang Si Waterfall.",
      },
      {
        day: 3,
        title: "Mekong River · Pak Ou Caves",
        state: "Laos",
        desc: "Cruise along the Mekong River to Pak Ou Caves, known for their collection of Buddha images, then return to Luang Prabang.",
      },
      {
        day: 4,
        title: "Luang Prabang · Vang Vieng",
        state: "Laos",
        desc: "Travel to Vang Vieng and enjoy the scenery around the Nam Song River, including a traditional tail boat ride and a visit to the Blue Lagoon.",
        nights: 1,
      },
      {
        day: 5,
        title: "Vang Vieng · Vientiane",
        state: "Laos",
        desc: "Continue to Vientiane and visit Pha That Luang and Wat Si Saket, two of the capital’s best-known landmarks.",
        nights: 1,
      },
      {
        day: 6,
        title: "Vientiane · Departure",
        state: "Laos",
        desc: "Visit Wat Xieng Khouane Luang Buddha Park before transferring for your onward journey. The tour concludes in Vientiane.",
      },
    ],
  },
  {
    slug: "best-of-vietnam-asvm",
    title: "Best of Vietnam",
    scope: "world",
    image: U("1509030450996-dd1a26dda07a"),
    gallery: [U("1509030450996-dd1a26dda07a"), U("1528127269322-539801943592"), U("1513415277900-a62401e19be4")],
    code: "ASVM",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 6,
    region: "Vietnam",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 149000,
    emiPerMonth: 14508,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Vietnam", stops: ["Ho Chi Minh City (2N)", "Da Nang (3N)", "Hanoi (1N)", "Halong Bay Cruise (1N)"] }],
    highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Water Puppet Show", "Halong Bay Cruise", "Tai Chi Session", "Dragon Bridge", "Sun World Ba Na Hills", "Golden Bridge", "Monkey Mountain", "Marble Mountains", "Cam Thanh Coconut Village", "Basket Boat Ride", "Hoi An Ancient Town", "Lantern Boat Ride", "Cu Chi Tunnels", "Mekong River Delta", "Coconut Candy Factory", "War Crime Museum"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Hyderabad", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [
      { date: "Sat Nov 21, 2026", price: 149000 },
      { date: "Tue Dec 8, 2026", price: 149000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrival at Ho Chi Minh City · Cu Chi Tunnels", state: "Vietnam", desc: "Arrive in Ho Chi Minh City and visit the historic Cu Chi Tunnels. Return to the city for a two-night stay.", nights: 2, highlights: ["Cu Chi Tunnels"] },
      { day: 2, title: "Ho Chi Minh City · Mekong River Delta", state: "Vietnam", desc: "Explore the Mekong River Delta, visit a coconut candy factory and experience the region's waterways before returning to Ho Chi Minh City.", highlights: ["Mekong River Delta", "Coconut Candy Factory"] },
      { day: 3, title: "Ho Chi Minh City · Da Nang", state: "Vietnam", desc: "Fly to Da Nang and settle in for a three-night stay. Discover the city and its Dragon Bridge.", nights: 3, highlights: ["Dragon Bridge"] },
      { day: 4, title: "Da Nang · Ba Na Hills · Golden Bridge", state: "Vietnam", desc: "Spend the day at Sun World Ba Na Hills, including the famous Golden Bridge, then return to Da Nang.", highlights: ["Sun World Ba Na Hills", "Golden Bridge"] },
      { day: 5, title: "Da Nang · Hoi An · Cam Thanh Coconut Village", state: "Vietnam", desc: "Visit Cam Thanh Coconut Village and enjoy a basket boat ride. Explore Hoi An Ancient Town and take a lantern boat ride before returning to Da Nang.", highlights: ["Cam Thanh Coconut Village", "Basket Boat Ride", "Hoi An Ancient Town", "Lantern Boat Ride"] },
      { day: 6, title: "Da Nang · Hanoi", state: "Vietnam", desc: "Fly to Hanoi and visit the Ho Chi Minh Complex and One Pillar Pagoda. In the evening, enjoy a traditional water puppet show. Overnight in Hanoi.", nights: 1, highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Water Puppet Show"] },
      { day: 7, title: "Hanoi · Halong Bay Overnight Cruise", state: "Vietnam", desc: "Travel to Halong Bay and board your overnight cruise. Enjoy the dramatic limestone landscapes and a Tai Chi session on board.", nights: 1, highlights: ["Halong Bay Cruise", "Tai Chi Session"] },
      { day: 8, title: "Halong Bay Cruise · Hanoi · Departure", state: "Vietnam", desc: "Enjoy the final moments of your Halong Bay cruise before returning to Hanoi for your onward flight." },
    ],
  },
  {
    slug: "best-of-vietnam",
    title: "Best of Vietnam",
    scope: "world",
    image: U("1509030450996-dd1a26dda07a"),
    gallery: [U("1509030450996-dd1a26dda07a"), U("1528127269322-539801943592"), U("1513415277900-a62401e19be4")],
    code: "ASVMH",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 7,
    region: "Vietnam",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 145000,
    emiPerMonth: 14119,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Vietnam", stops: ["Ho Chi Minh City (2N)", "Da Nang (3N)", "Hanoi (1N)", "Halong Bay Cruise (1N)"] }],
    highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Water Puppet Show", "Halong Bay Cruise", "Tai Chi Session", "Dragon Bridge", "Sun World Ba Na Hills", "Golden Bridge", "Monkey Mountain", "Marble Mountains", "Cam Thanh Coconut Village", "Basket Boat Ride", "Hoi An Ancient Town", "Lantern Boat Ride", "Cu Chi Tunnels", "Mekong River Delta", "Coconut Candy Factory", "War Crime Museum"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Hyderabad", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [
      { date: "Mon Nov 2, 2026", price: 150000, tag: "Lowest Price" },
      { date: "Wed Nov 4, 2026", price: 152000 },
      { date: "Tue Nov 10, 2026", price: 152000, tag: "Sold out" },
      { date: "Sat Nov 14, 2026", price: 155000, tag: "Sold out" },
      { date: "Wed Nov 18, 2026", price: 154000, tag: "Sold out" },
      { date: "Wed Nov 25, 2026", price: 151000, tag: "Sold out" },
      { date: "Fri Nov 27, 2026", price: 153000 },
      { date: "Fri Dec 4, 2026", price: 152000, tag: "Sold out" },
      { date: "Wed Dec 9, 2026", price: 152000 },
      { date: "Fri Dec 18, 2026", price: 170000, tag: "Sold out" },
      { date: "Wed Dec 23, 2026", price: 180000 },
      { date: "Mon Dec 28, 2026", price: 180000 },
      { date: "Wed Dec 30, 2026", price: 180000 },
      { date: "Fri Jan 8, 2027", price: 155000 },
      { date: "Mon Feb 1, 2027", price: 153000 },
      { date: "Fri Feb 19, 2027", price: 153000 },
      { date: "Mon Mar 15, 2027", price: 151000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrival at Ho Chi Minh City · Cu Chi Tunnels", state: "Vietnam", desc: "Arrive in Ho Chi Minh City and visit the historic Cu Chi Tunnels. Return to the city for a two-night stay.", nights: 2, highlights: ["Cu Chi Tunnels"] },
      { day: 2, title: "Ho Chi Minh City · Mekong River Delta", state: "Vietnam", desc: "Explore the Mekong River Delta, visit a coconut candy factory and experience the region's waterways before returning to Ho Chi Minh City.", highlights: ["Mekong River Delta", "Coconut Candy Factory"] },
      { day: 3, title: "Ho Chi Minh City · Da Nang", state: "Vietnam", desc: "Fly to Da Nang and settle in for a three-night stay. Discover the city and its Dragon Bridge.", nights: 3, highlights: ["Dragon Bridge"] },
      { day: 4, title: "Da Nang · Ba Na Hills · Golden Bridge", state: "Vietnam", desc: "Spend the day at Sun World Ba Na Hills, including the famous Golden Bridge, then return to Da Nang.", highlights: ["Sun World Ba Na Hills", "Golden Bridge"] },
      { day: 5, title: "Da Nang · Hoi An · Cam Thanh Coconut Village", state: "Vietnam", desc: "Visit Cam Thanh Coconut Village and enjoy a basket boat ride. Explore Hoi An Ancient Town and take a lantern boat ride before returning to Da Nang.", highlights: ["Cam Thanh Coconut Village", "Basket Boat Ride", "Hoi An Ancient Town", "Lantern Boat Ride"] },
      { day: 6, title: "Da Nang · Hanoi", state: "Vietnam", desc: "Fly to Hanoi and visit the Ho Chi Minh Complex and One Pillar Pagoda. In the evening, enjoy a traditional water puppet show. Overnight in Hanoi.", nights: 1, highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Water Puppet Show"] },
      { day: 7, title: "Hanoi · Halong Bay Overnight Cruise", state: "Vietnam", desc: "Travel to Halong Bay and board your overnight cruise. Enjoy the dramatic limestone landscapes and a Tai Chi session on board.", nights: 1, highlights: ["Halong Bay Cruise", "Tai Chi Session"] },
      { day: 8, title: "Halong Bay Cruise · Hanoi · Departure", state: "Vietnam", desc: "Enjoy the final moments of your Halong Bay cruise before returning to Hanoi for your onward flight." },
    ],
  },
  {
    slug: "seniors-special-vietnam",
    title: "Senior's Special Vietnam",
    scope: "world",
    image: U("1509030450996-dd1a26dda07a"),
    gallery: [U("1509030450996-dd1a26dda07a"), U("1528127269322-539801943592"), U("1513415277900-a62401e19be4")],
    code: "ASZVM",
    tourType: "GROUP TOUR",
    speciality: "Seniors' Special",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 6,
    region: "Vietnam",
    zone: "Asia",
    interest: "Seniors' Special",
    packageType: "Group Tour",
    startingPrice: 150000,
    emiPerMonth: 14600,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Vietnam", stops: ["Hanoi (1N)", "Halong Bay Cruise (1N)", "Da Nang (3N)", "Ho Chi Minh City (2N)"] }],
    highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Temple of Literature", "Musical Water Puppet Show", "Halong Bay Cruise", "Sun World Ba Na Hills", "Golden Bridge", "Marble Mountains", "Cam Thanh Coconut Village", "Lantern Boat Ride", "Cu Chi Tunnels", "Vinh Trang Pagoda", "Mekong River Delta", "Honey Tea Farm and Fruit Farm", "War Crime Museum"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Hyderabad", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Hanoi · City Heritage", state: "Vietnam", desc: "Arrive in Hanoi and explore the Ho Chi Minh Complex, One Pillar Pagoda and Temple of Literature. Enjoy a musical water puppet show in the evening.", nights: 1, highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Temple of Literature", "Musical Water Puppet Show"] },
      { day: 2, title: "Hanoi · Halong Bay Cruise", state: "Vietnam", desc: "Travel to Halong Bay and board your overnight cruise among its limestone islands and emerald waters.", nights: 1, highlights: ["Halong Bay Cruise"] },
      { day: 3, title: "Halong Bay · Hanoi · Da Nang", state: "Vietnam", desc: "Enjoy the cruise before returning to Hanoi and flying to Da Nang. Settle in for a three-night stay.", nights: 3 },
      { day: 4, title: "Da Nang · Ba Na Hills · Golden Bridge", state: "Vietnam", desc: "Visit Sun World Ba Na Hills and see the Golden Bridge, then return to Da Nang.", highlights: ["Sun World Ba Na Hills", "Golden Bridge"] },
      { day: 5, title: "Da Nang · Marble Mountains · Hoi An", state: "Vietnam", desc: "Explore the Marble Mountains and Cam Thanh Coconut Village, then visit Hoi An and enjoy a lantern boat ride.", highlights: ["Marble Mountains", "Cam Thanh Coconut Village", "Lantern Boat Ride"] },
      { day: 6, title: "Da Nang · Ho Chi Minh City", state: "Vietnam", desc: "Fly to Ho Chi Minh City and check in for a two-night stay.", nights: 2 },
      { day: 7, title: "Mekong Delta · Vinh Trang Pagoda", state: "Vietnam", desc: "Discover the Mekong River Delta, including Vinh Trang Pagoda and a visit to a honey tea and fruit farm.", highlights: ["Vinh Trang Pagoda", "Mekong River Delta", "Honey Tea Farm and Fruit Farm"] },
      { day: 8, title: "Cu Chi Tunnels · Ho Chi Minh City · Departure", state: "Vietnam", desc: "Visit the Cu Chi Tunnels and War Crime Museum before transferring for your departure.", highlights: ["Cu Chi Tunnels", "War Crime Museum"] },
    ],
  },
  {
    slug: "womens-special-vietnam",
    title: "Women's Special Vietnam",
    scope: "world",
    image: U("1509030450996-dd1a26dda07a"),
    gallery: [U("1509030450996-dd1a26dda07a"), U("1528127269322-539801943592"), U("1513415277900-a62401e19be4")],
    code: "ASWVM",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 6,
    region: "Vietnam",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 151000,
    emiPerMonth: 14700,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Vietnam", stops: ["Hanoi (1N)", "Halong Bay Cruise (1N)", "Da Nang (3N)", "Ho Chi Minh City (2N)"] }],
    highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Temple of Literature", "Musical Water Puppet Show", "Halong Bay Cruise", "Sun World Ba Na Hills", "Golden Bridge", "Marble Mountains", "Cam Thanh Coconut Village", "Lantern Boat Ride", "Cu Chi Tunnels", "Vinh Trang Pagoda", "Mekong River Delta", "Honey Tea Farm and Fruit Farm", "War Crime Museum"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Hyderabad", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Hanoi · City Heritage", state: "Vietnam", desc: "Arrive in Hanoi and explore the Ho Chi Minh Complex, One Pillar Pagoda and Temple of Literature. Enjoy a musical water puppet show in the evening.", nights: 1, highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Temple of Literature", "Musical Water Puppet Show"] },
      { day: 2, title: "Hanoi · Halong Bay Cruise", state: "Vietnam", desc: "Travel to Halong Bay and board your overnight cruise among its limestone islands and emerald waters.", nights: 1, highlights: ["Halong Bay Cruise"] },
      { day: 3, title: "Halong Bay · Hanoi · Da Nang", state: "Vietnam", desc: "Enjoy the cruise before returning to Hanoi and flying to Da Nang. Settle in for a three-night stay.", nights: 3 },
      { day: 4, title: "Da Nang · Ba Na Hills · Golden Bridge", state: "Vietnam", desc: "Visit Sun World Ba Na Hills and see the Golden Bridge, then return to Da Nang.", highlights: ["Sun World Ba Na Hills", "Golden Bridge"] },
      { day: 5, title: "Da Nang · Marble Mountains · Hoi An", state: "Vietnam", desc: "Explore the Marble Mountains and Cam Thanh Coconut Village, then visit Hoi An and enjoy a lantern boat ride.", highlights: ["Marble Mountains", "Cam Thanh Coconut Village", "Lantern Boat Ride"] },
      { day: 6, title: "Da Nang · Ho Chi Minh City", state: "Vietnam", desc: "Fly to Ho Chi Minh City and check in for a two-night stay.", nights: 2 },
      { day: 7, title: "Mekong Delta · Vinh Trang Pagoda", state: "Vietnam", desc: "Discover the Mekong River Delta, including Vinh Trang Pagoda and a visit to a honey tea and fruit farm.", highlights: ["Vinh Trang Pagoda", "Mekong River Delta", "Honey Tea Farm and Fruit Farm"] },
      { day: 8, title: "Cu Chi Tunnels · Ho Chi Minh City · Departure", state: "Vietnam", desc: "Visit the Cu Chi Tunnels and War Crime Museum before transferring for your departure.", highlights: ["Cu Chi Tunnels", "War Crime Museum"] },
    ],
  },
  {
    slug: "vietnam-sapa-phu-quoc",
    title: "Vietnam Sapa Phu Quoc",
    scope: "world",
    image: U("1509030450996-dd1a26dda07a"),
    gallery: [U("1509030450996-dd1a26dda07a"), U("1528127269322-539801943592"), U("1513415277900-a62401e19be4")],
    code: "ASPQ",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 7,
    nights: 6,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 3,
    region: "Vietnam",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 148000,
    emiPerMonth: 14376,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [{ state: "Vietnam", stops: ["Sapa (2N)", "Hanoi (1N)", "Phu Quoc (3N)"] }],
    highlights: ["Muong Hoa Valley", "Tram Ton Pass", "Cable Car Ride to Mount Fansipan", "Sun World Fansipan Legend", "Ho Quoc Pagoda", "Phu Quoc Pearl Farm", "Vinpearl Safari Phu Quoc", "VIN Wonders Phu Quoc", "Sao Beach", "Hon Thom Cable Car Ride", "Coconut Tree Prison"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [{ date: "Wed Dec 2, 2026", price: 148000 }],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Hanoi · Sapa", state: "Vietnam", desc: "Arrive in Hanoi and continue to Sapa, travelling through the mountain scenery of northern Vietnam. Settle in for a two-night stay.", nights: 2 },
      { day: 2, title: "Sapa · Muong Hoa Valley · Fansipan", state: "Vietnam", desc: "Explore Muong Hoa Valley and the Tram Ton Pass, then take a cable car into the Mount Fansipan region and visit Sun World Fansipan Legend.", highlights: ["Muong Hoa Valley", "Tram Ton Pass", "Mount Fansipan", "Sun World Fansipan Legend"] },
      { day: 3, title: "Sapa · Hanoi", state: "Vietnam", desc: "Return to Hanoi and stay overnight in the capital.", nights: 1 },
      { day: 4, title: "Hanoi · Phu Quoc", state: "Vietnam", desc: "Fly to Phu Quoc and check in for a three-night stay on the island.", nights: 3 },
      { day: 5, title: "Phu Quoc · Hon Thom · Sao Beach", state: "Vietnam", desc: "Enjoy an island day featuring the Hon Thom cable car and time at Sao Beach.", highlights: ["Hon Thom Cable Car Ride", "Sao Beach"] },
      { day: 6, title: "Phu Quoc · Safari · VIN Wonders", state: "Vietnam", desc: "Visit Vinpearl Safari and VIN Wonders, with a stop at a Phu Quoc pearl farm and Ho Quoc Pagoda.", highlights: ["Vinpearl Safari Phu Quoc", "VIN Wonders Phu Quoc", "Phu Quoc Pearl Farm", "Ho Quoc Pagoda"] },
      { day: 7, title: "Phu Quoc · Departure", state: "Vietnam", desc: "Visit Coconut Tree Prison before transferring to the airport for your onward journey.", highlights: ["Coconut Tree Prison"] },
    ],
  },
  {
    slug: "singapore-thailand",
    title: "Singapore Thailand",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1508009603885-50cf7c579365")],
    code: "ASST",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 8,
    nights: 7,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 3,
    region: "Singapore & Thailand",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 180000,
    emiPerMonth: 17524,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (2N)", "Bangkok (2N)"] },
      { state: "Singapore", stops: ["Singapore (3N)"] },
    ],
    highlights: ["Pattaya Tower", "Alcazar Show", "Coral Island", "Nong Nooch Village", "Gems Gallery", "Safari World & Marine Park", "Chao Phraya River Dinner Cruise", "Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum", "Universal Studios", "Singapore Oceanarium", "Wings of Time Show"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving (Bangkok to Singapore)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Bangkok · Pattaya", state: "Thailand", desc: "Arrive in Bangkok and travel to Pattaya. Check in for a two-night stay.", nights: 2 },
      { day: 2, title: "Pattaya · Coral Island", state: "Thailand", desc: "Enjoy Pattaya's Coral Island and visit Pattaya Tower, with an evening Alcazar Show.", highlights: ["Coral Island", "Pattaya Tower", "Alcazar Show"] },
      { day: 3, title: "Pattaya · Bangkok", state: "Thailand", desc: "Visit Nong Nooch Village and Gems Gallery, then continue to Bangkok for a two-night stay.", nights: 2, highlights: ["Nong Nooch Village", "Gems Gallery"] },
      { day: 4, title: "Bangkok · Safari World", state: "Thailand", desc: "Spend the day at Safari World and Marine Park, then enjoy a dinner cruise on the Chao Phraya River.", highlights: ["Safari World & Marine Park", "Chao Phraya River Dinner Cruise"] },
      { day: 5, title: "Bangkok · Singapore", state: "Thailand / Singapore", desc: "Fly from Bangkok to Singapore and check in for a three-night stay.", nights: 3 },
      { day: 6, title: "Singapore · Gardens by the Bay · Sentosa", state: "Singapore", desc: "Explore Gardens by the Bay and Mandai Bird Paradise, then take the cable car to Sentosa Island and visit Madame Tussauds.", highlights: ["Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum"] },
      { day: 7, title: "Singapore · Universal Studios", state: "Singapore", desc: "Enjoy a full day at Universal Studios Singapore, followed by the Singapore Oceanarium and Wings of Time show.", highlights: ["Universal Studios", "Singapore Oceanarium", "Wings of Time Show"] },
      { day: 8, title: "Singapore · Departure", state: "Singapore", desc: "Transfer to the airport for your onward journey. The tour concludes in Singapore." },
    ],
  },  {
    slug: "singapore-thailand-malaysia",
    title: "Singapore Thailand Malaysia",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASJW",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 10,
    nights: 9,
    countriesCount: 3,
    statesCount: 3,
    citiesCount: 5,
    region: "Singapore, Thailand & Malaysia",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 192000,
    emiPerMonth: 18691,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (2N)", "Bangkok (2N)"] },
      { state: "Malaysia", stops: ["Kuala Lumpur (2N)", "Genting Highlands"] },
      { state: "Singapore", stops: ["Singapore (3N)"] },
    ],
    highlights: ["Pattaya Tower", "Alcazar Show", "Coral Island", "Nong Nooch Village", "Scientific Thai massage", "Gems Gallery", "Safari World & Marine Park", "Chao Phraya River Dinner Cruise", "Observatory Deck of the K. L. Tower", "Genting Highlands", "Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum", "Universal Studios", "Wings of Time Show"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving (Bangkok to Singapore)"],
    dates: [
      { date: "Wed Oct 14, 2026", price: 192000 },
      { date: "Thu Oct 22, 2026", price: 192000, tag: "Durga Pujo Special · Lowest Price" },
      { date: "Thu Nov 5, 2026", price: 192000 },
      { date: "Tue Nov 10, 2026", price: 192000 },
      { date: "Thu Nov 12, 2026", price: 192000 },
      { date: "Wed Nov 18, 2026", price: 192000, seats: 5 },
      { date: "Mon Nov 30, 2026", price: 192000 },
      { date: "Fri Dec 4, 2026", price: 192000 },
      { date: "Mon Dec 14, 2026", price: 192000 },
      { date: "Mon Dec 21, 2026", price: 192000 },
      { date: "Sun Dec 27, 2026", price: 192000 },
      { date: "Sun Jan 10, 2027", price: 192000 },
      { date: "Wed Jan 27, 2027", price: 192000 },
      { date: "Fri Feb 19, 2027", price: 192000 },
      { date: "Fri Mar 19, 2027", price: 192000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Bangkok · Pattaya", state: "Thailand", desc: "Arrive in Bangkok and travel to Pattaya. Check in for a two-night stay.", nights: 2 },
      { day: 2, title: "Pattaya · Coral Island", state: "Thailand", desc: "Enjoy Coral Island, visit Pattaya Tower and Gems Gallery, and experience an Alcazar Show and traditional Thai massage.", highlights: ["Pattaya Tower", "Alcazar Show", "Coral Island", "Scientific Thai massage", "Gems Gallery"] },
      { day: 3, title: "Pattaya · Nong Nooch · Bangkok", state: "Thailand", desc: "Visit Nong Nooch Village before continuing to Bangkok for a two-night stay.", nights: 2, highlights: ["Nong Nooch Village"] },
      { day: 4, title: "Bangkok · Safari World", state: "Thailand", desc: "Spend the day at Safari World and Marine Park, then enjoy a dinner cruise on the Chao Phraya River.", highlights: ["Safari World & Marine Park", "Chao Phraya River Dinner Cruise"] },
      { day: 5, title: "Bangkok · Kuala Lumpur", state: "Thailand · Malaysia", desc: "Fly to Kuala Lumpur and settle in for a two-night stay. Take in the city from the K. L. Tower observatory deck.", nights: 2, highlights: ["Observatory Deck of the K. L. Tower"] },
      { day: 6, title: "Kuala Lumpur · Genting Highlands", state: "Malaysia", desc: "Enjoy an excursion to Genting Highlands, with time to explore its mountain resort attractions, before returning to Kuala Lumpur.", highlights: ["Genting Highlands"] },
      { day: 7, title: "Kuala Lumpur · Singapore", state: "Malaysia · Singapore", desc: "Travel onward to Singapore and check in for a three-night stay.", nights: 3 },
      { day: 8, title: "Singapore · Gardens by the Bay · Sentosa", state: "Singapore", desc: "Visit Gardens by the Bay and Mandai Bird Paradise, then take the cable car to Sentosa Island and Madame Tussauds.", highlights: ["Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum"] },
      { day: 9, title: "Singapore · Universal Studios", state: "Singapore", desc: "Enjoy a full day at Universal Studios Singapore, followed by the spectacular Wings of Time show.", highlights: ["Universal Studios", "Wings of Time Show"] },
      { day: 10, title: "Singapore · Departure", state: "Singapore", desc: "Transfer to the airport for your onward journey. The tour concludes in Singapore." },
    ],
  },  {
    slug: "singapore-malaysia",
    title: "Singapore Malaysia",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASSM",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 7,
    nights: 6,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 5,
    region: "Singapore & Malaysia",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 166000,
    emiPerMonth: 16170,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Malaysia", stops: ["Kuala Lumpur (2N)", "Malacca", "Johor Bahru (1N)"] },
      { state: "Singapore", stops: ["Singapore (3N)"] },
    ],
    highlights: ["Putrajaya City", "K. L. Tower Observatory Deck", "Batu Caves", "Genting SkyWorlds Outdoor Theme Park", "Malacca Trishaw Ride", "Legoland Malaysia", "Singapore River Bum Boat Ride", "Sentosa Island Cable Car", "Images of Singapore", "Madame Tussauds Singapore", "Universal Studios Singapore", "Singapore Oceanarium", "Wings of Time", "Mandai Bird Paradise"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [
      { date: "Mon Nov 9, 2026", price: 166000 },
      { date: "Thu Nov 12, 2026", price: 166000 },
      { date: "Tue Dec 15, 2026", price: 166000 },
      { date: "Sat Dec 26, 2026", price: 166000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Kuala Lumpur · Putrajaya", state: "Malaysia", desc: "Arrive in Kuala Lumpur and visit Putrajaya, Malaysia’s planned administrative city. Check in for a two-night stay.", nights: 2, highlights: ["Putrajaya City"] },
      { day: 2, title: "Kuala Lumpur · Genting Highlands", state: "Malaysia", desc: "Visit Batu Caves and ride the cable car to Genting Highlands for time at Genting SkyWorlds. Return to Kuala Lumpur.", highlights: ["Batu Caves", "Genting SkyWorlds Outdoor Theme Park"] },
      { day: 3, title: "Kuala Lumpur · Malacca · Johor Bahru", state: "Malaysia", desc: "Travel to Malacca for a trishaw ride, then continue to Johor Bahru for an overnight stay.", nights: 1, highlights: ["Malacca Trishaw Ride"] },
      { day: 4, title: "Johor Bahru · Legoland Malaysia · Singapore", state: "Malaysia / Singapore", desc: "Visit Legoland Malaysia before continuing across the border to Singapore. Check in for a three-night stay.", nights: 3, highlights: ["Legoland Malaysia"] },
      { day: 5, title: "Singapore City · Mandai Bird Paradise", state: "Singapore", desc: "Discover Singapore with a river bum boat ride and a visit to Mandai Bird Paradise.", highlights: ["Singapore River Bum Boat Ride", "Mandai Bird Paradise"] },
      { day: 6, title: "Singapore · Sentosa Island · Universal Studios", state: "Singapore", desc: "Take the cable car to Sentosa Island, explore Images of Singapore and Madame Tussauds, and enjoy Universal Studios Singapore and Wings of Time.", highlights: ["Sentosa Island Cable Car", "Images of Singapore", "Madame Tussauds Singapore", "Universal Studios Singapore", "Singapore Oceanarium", "Wings of Time"] },
      { day: 7, title: "Singapore · Departure", state: "Singapore", desc: "Enjoy your final moments in Singapore before transferring to the airport for your onward journey." },
    ],
  },
  {
    slug: "womens-special-singapore-malaysia",
    title: "Women's Special Singapore Malaysia",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASWM",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 7,
    nights: 6,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 5,
    region: "Singapore & Malaysia",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 173000,
    emiPerMonth: 16851,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Malaysia", stops: ["Kuala Lumpur (2N)", "Malacca", "Johor Bahru (1N)"] },
      { state: "Singapore", stops: ["Singapore (3N)"] },
    ],
    highlights: ["Putrajaya City", "K. L. Tower Observatory Deck", "Batu Caves", "Genting SkyWorlds Outdoor Theme Park", "Malacca Trishaw Ride", "Legoland Malaysia", "Singapore River Bum Boat Ride", "Sentosa Island Cable Car", "Images of Singapore", "Madame Tussauds Singapore", "Universal Studios Singapore", "Singapore Oceanarium", "Wings of Time", "Mandai Bird Paradise"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "New Delhi", "Joining/leaving (Kuala Lumpur to Singapore)"],
    dates: [{ date: "Mon Nov 23, 2026", price: 173000 }],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Kuala Lumpur · Putrajaya", state: "Malaysia", desc: "Arrive in Kuala Lumpur and explore Putrajaya, Malaysia's planned administrative city. Check in for a two-night stay.", nights: 2, highlights: ["Putrajaya City"] },
      { day: 2, title: "Kuala Lumpur · Genting Highlands", state: "Malaysia", desc: "Visit the K. L. Tower Observatory Deck and Batu Caves, then head to Genting Highlands for its outdoor theme park before returning to Kuala Lumpur.", highlights: ["K. L. Tower Observatory Deck", "Batu Caves", "Genting SkyWorlds Outdoor Theme Park"] },
      { day: 3, title: "Kuala Lumpur · Malacca · Johor Bahru", state: "Malaysia", desc: "Travel to Malacca for a trishaw ride through the historic city, then continue to Johor Bahru for an overnight stay.", nights: 1, highlights: ["Malacca Trishaw Ride"] },
      { day: 4, title: "Johor Bahru · Legoland Malaysia · Singapore", state: "Malaysia / Singapore", desc: "Visit Legoland Malaysia and continue across the border to Singapore. Check in for a three-night stay.", nights: 3, highlights: ["Legoland Malaysia"] },
      { day: 5, title: "Singapore · City sights · Sentosa", state: "Singapore", desc: "See Singapore from a river bum boat, take the cable car to Sentosa Island and explore Images of Singapore and Madame Tussauds.", highlights: ["Singapore River Bum Boat Ride", "Sentosa Island Cable Car", "Images of Singapore", "Madame Tussauds Singapore"] },
      { day: 6, title: "Singapore · Universal Studios", state: "Singapore", desc: "Enjoy Universal Studios Singapore, Singapore Oceanarium and the Wings of Time evening show.", highlights: ["Universal Studios Singapore", "Singapore Oceanarium", "Wings of Time"] },
      { day: 7, title: "Singapore · Mandai Bird Paradise · Departure", state: "Singapore", desc: "Visit Mandai Bird Paradise before transferring to the airport for your onward journey.", highlights: ["Mandai Bird Paradise"] },
    ],
  },
  {
    slug: "highlights-of-vietnam",
    title: "Highlights of Vietnam",
    scope: "world",
    image: U("1509030450996-dd1a26dda07a"),
    gallery: [U("1509030450996-dd1a26dda07a"), U("1528127269322-539801943592"), U("1513415277900-a62401e19be4")],
    code: "ASPV",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Vietnam",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 116000,
    emiPerMonth: 11277,
    rating: 4,
    reviewsCount: 7,
    guestsRated: 28,
    guestPhotos: 0,
    route: [
      { state: "Vietnam", stops: ["Halong Bay (1N)", "Hanoi (1N)", "Hoi An", "Da Nang (2N)"] },
    ],
    highlights: [
      "One Pillar Pagoda",
      "Temple of Literature",
      "Halong Bay Cruise",
      "Musical Water Puppet Show",
      "Walking city tour of Hoi An",
      "Lantern Boat Ride on the Hoai River",
      "Sun World Ba Na Hills",
      "Golden Bridge",
      "Marble Mountains",
      "Monkey Mountain",
    ],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [
      { date: "Mon Nov 02, 2026", price: 116000 },
      { date: "Mon Dec 14, 2026", price: 116000 },
      { date: "Mon Dec 21, 2026", price: 116000 },
      { date: "Mon Jan 18, 2027", price: 116000 },
      { date: "Wed Feb 17, 2027", price: 116000 },
      { date: "Fri Mar 19, 2027", price: 116000, tag: "Lowest Price" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrival at Hanoi · Halong Bay",
        state: "Vietnam",
        desc: "Arrive in Hanoi and continue to Halong Bay. Board a cruise and enjoy the striking limestone scenery. Overnight on the bay.",
        nights: 1,
      },
      {
        day: 2,
        title: "Halong Bay · Hanoi",
        state: "Vietnam",
        desc: "Enjoy the Halong Bay cruise before travelling back to Hanoi. Explore the capital and experience a musical water puppet show. Overnight in Hanoi.",
        nights: 1,
      },
      {
        day: 3,
        title: "Hanoi · Hoi An · Da Nang",
        state: "Vietnam",
        desc: "Visit Hanoi's One Pillar Pagoda and Temple of Literature, then fly to Da Nang. Continue to Hoi An for a walking tour and a lantern boat ride on the Hoai River. Stay in Da Nang for two nights.",
        nights: 2,
      },
      {
        day: 4,
        title: "Da Nang · Ba Na Hills · Golden Bridge",
        state: "Vietnam",
        desc: "Spend the day at Sun World Ba Na Hills, including the famous Golden Bridge, then return to Da Nang.",
      },
      {
        day: 5,
        title: "Da Nang · Marble Mountains · Monkey Mountain · Departure",
        state: "Vietnam",
        desc: "Visit the Marble Mountains and Monkey Mountain before transferring to Da Nang Airport for your onward flight.",
      },
    ],
  },
  {
    slug: "wonders-of-bhutan",
    title: "Wonders of Bhutan",
    scope: "world",
    image: U("/assets/media/royal-bhutan-tigers-nest.jpg"),
    gallery: [U("/assets/media/royal-bhutan-tigers-nest.jpg"), U("1501785888041-af3ef285b470"), U("1626621341517-bbf3d9990a23")],
    code: "BTBW",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 12,
    nights: 11,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 8,
    region: "Bhutan",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 126000,
    emiPerMonth: 12250,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Bhutan", stops: ["Phuentsholing (1N)", "Thimphu (2N)", "Gangtey / Phobjika Valley (2N)", "Bumthang (2N)", "Punakha (1N)", "Paro (2N)"] },
      { state: "India", stops: ["Siliguri (1N)"] },
    ],
    highlights: [
      "Kharbandi Gompa",
      "BBS Clock Tower",
      "Tashichho Dzong",
      "Royal Takin Preserve",
      "Buddha Dordenma Statue",
      "National Library and Handicraft Center",
      "Phobjika Valley",
      "Lamperi Botanical Garden",
      "Gangtey Monastery",
      "Kurjey Lhakhang Monastery",
      "Jambay Lhakhang",
      "Lhodrak Kharchhu Monastery",
      "Punakha Dzong",
      "White water rafting in the Punakha River",
      "Bhutanese Beer Brewery",
      "Taktshang Monastery (Tiger's Nest)",
      "Chele-la Pass",
      "Paro Dzong",
      "Bhutanese cultural program",
    ],
    departureCity: "Bagdogra",
    departureCities: ["Mumbai", "Bagdogra (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Bagdogra · Phuentsholing",
        state: "Bhutan",
        desc: "Arrive at Bagdogra and travel to Phuentsholing, Bhutan's gateway town. Visit Kharbandi Gompa and settle in for the night.",
        nights: 1,
      },
      {
        day: 2,
        title: "Phuentsholing · Thimphu",
        state: "Bhutan",
        desc: "Complete border formalities and drive through Bhutan's mountain scenery to Thimphu. Check in for a two-night stay.",
        nights: 2,
      },
      {
        day: 3,
        title: "Thimphu sightseeing",
        state: "Bhutan",
        desc: "Discover the capital, including Tashichho Dzong, BBS Clock Tower, the Royal Takin Preserve, Buddha Dordenma and the National Library.",
      },
      {
        day: 4,
        title: "Thimphu · Lamperi · Gangtey",
        state: "Bhutan",
        desc: "Travel toward Phobjika Valley, stopping at Lamperi Botanical Garden. Arrive in Gangtey for a two-night stay.",
        nights: 2,
      },
      {
        day: 5,
        title: "Gangtey · Phobjika Valley",
        state: "Bhutan",
        desc: "Spend the day in Phobjika Valley and visit Gangtey Monastery, taking time to enjoy the high valley's peaceful landscapes.",
      },
      {
        day: 6,
        title: "Gangtey · Bumthang",
        state: "Bhutan",
        desc: "Continue east through Bhutan's mountain scenery to Bumthang and check in for a two-night stay.",
        nights: 2,
      },
      {
        day: 7,
        title: "Bumthang monasteries",
        state: "Bhutan",
        desc: "Explore Bumthang's spiritual heritage with visits to Kurjey Lhakhang, Jambay Lhakhang and Lhodrak Kharchhu Monastery.",
      },
      {
        day: 8,
        title: "Bumthang · Punakha",
        state: "Bhutan",
        desc: "Travel to Punakha and settle in for the night, ready to discover the valley and its riverside dzong.",
        nights: 1,
      },
      {
        day: 9,
        title: "Punakha · Paro",
        state: "Bhutan",
        desc: "Visit Punakha Dzong and enjoy the valley. White water rafting on the Punakha River is included as a tour highlight, subject to conditions. Continue to Paro for a two-night stay.",
        nights: 2,
      },
      {
        day: 10,
        title: "Paro · Chele-la Pass",
        state: "Bhutan",
        desc: "Take a scenic excursion to Chele-la Pass and return to Paro to enjoy a Bhutanese cultural program.",
      },
      {
        day: 11,
        title: "Paro · Taktshang Monastery · Siliguri",
        state: "India",
        desc: "Visit Taktshang Monastery, the iconic Tiger's Nest, and Paro Dzong. Travel via Phuentsholing to Siliguri for the final night.",
        nights: 1,
      },
      {
        day: 12,
        title: "Siliguri · Bagdogra · Departure",
        state: "India",
        desc: "Transfer to Bagdogra Airport for your onward journey. The tour concludes at the airport.",
      },
    ],
  },
  {
    slug: "best-of-almaty",
    title: "Best of Almaty",
    scope: "world",
    image: U("1501785888041-af3ef285b470"),
    gallery: [U("1501785888041-af3ef285b470"), U("1626621341517-bbf3d9990a23"), U("1645033393637-9089ab100756")],
    code: "EUKA",
    tourType: "GROUP TOUR",
    speciality: "",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 1,
    region: "Central Asia",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 115000,
    emiPerMonth: 11200,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Kazakhstan", stops: ["Almaty (4N)"] },
    ],
    highlights: [
      "Republic Square",
      "Rakhat Chocolate Outlet",
      "Green Bazaar",
      "Medeo Gorge",
      "Shymbulak Ski Resort",
      "Kok-Tobe Hill",
      "Charyn Canyon",
      "Kolsai Lake",
      "Huns Ethno Village",
      "Traditional Falcon Show",
      "Issyllyk Lake",
      "Alma Arasan Hot Springs",
    ],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Almaty (Joining/leaving)"],
    dates: [
      { date: "Sun Nov 01, 2026", price: 115000, tag: "Lowest Price" },
      { date: "Sun Nov 08, 2026", price: 115000 },
      { date: "Sun Nov 15, 2026", price: 115000 },
      { date: "Sun Nov 22, 2026", price: 115000 },
      { date: "Sun Nov 29, 2026", price: 115000 },
      { date: "Sun Dec 06, 2026", price: 115000 },
      { date: "Sun Dec 20, 2026", price: 115000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrival at Almaty",
        state: "Kazakhstan",
        desc: "Arrive in Almaty, meet the tour team and transfer to your hotel. Settle in for your four-night stay.",
        nights: 4,
      },
      {
        day: 2,
        title: "Almaty · Medeo Gorge · Shymbulak Mountain",
        state: "Kazakhstan",
        desc: "Explore Medeo Gorge and Shymbulak Ski Resort, taking in the mountain scenery before returning to Almaty.",
      },
      {
        day: 3,
        title: "Almaty · Charyn Canyon · Kolsai Lake",
        state: "Kazakhstan",
        desc: "Journey out to Charyn Canyon and Kolsai Lake for a day among Kazakhstan's dramatic landscapes, then return to Almaty.",
      },
      {
        day: 4,
        title: "Almaty · Huns Ethno Village · Issylk Lake",
        state: "Kazakhstan",
        desc: "Visit Huns Ethno Village and enjoy a traditional falcon show, followed by a stop at Issylk Lake.",
      },
      {
        day: 5,
        title: "Almaty · Alma Arasan Hot Springs · Departure",
        state: "Kazakhstan",
        desc: "Visit Alma Arasan Hot Springs before heading to the airport for your departure from Almaty.",
      },
    ],
  },
  {
    slug: "womens-special-best-of-almaty",
    title: "Women's Special Best of Almaty",
    scope: "world",
    image: U("1501785888041-af3ef285b470"),
    gallery: [U("1501785888041-af3ef285b470"), U("1626621341517-bbf3d9990a23"), U("1645033393637-9089ab100756")],
    code: "EUWKA",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 1,
    region: "Central Asia",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 115000,
    emiPerMonth: 11200,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Kazakhstan", stops: ["Almaty (4N)"] },
    ],
    highlights: [
      "Republic Square",
      "Rakhat Chocolate Outlet",
      "Green Bazaar",
      "Medeo Gorge",
      "Shymbulak Ski Resort",
      "Kok-Tobe Hill",
      "Charyn Canyon",
      "Kolsai Lake",
      "Huns Ethno Village",
      "Traditional Falcon Show",
      "Issyllyk Lake",
      "Alma Arasan Hot Springs",
    ],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Almaty (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in Almaty",
        state: "Kazakhstan",
        desc: "Arrive in Almaty and check in to your hotel for a four-night stay. Explore central Almaty, including Republic Square, Green Bazaar and the Rakhat Chocolate Outlet.",
        nights: 4,
      },
      {
        day: 2,
        title: "Almaty · Medeo · Shymbulak",
        state: "Kazakhstan",
        desc: "Discover Medeo Gorge and ride the cable car to Shymbulak Ski Resort. Later, visit Kok-Tobe Hill for panoramic views of Almaty.",
      },
      {
        day: 3,
        title: "Almaty · Charyn Canyon · Kolsai Lake",
        state: "Kazakhstan",
        desc: "Take a full-day excursion from Almaty to Charyn Canyon and the scenic Kolsai Lake before returning to the city.",
      },
      {
        day: 4,
        title: "Almaty · Huns Ethno Village · Issyllyk Lake",
        state: "Kazakhstan",
        desc: "Experience local traditions at Huns Ethno Village, including a traditional falcon show, and visit Issyllyk Lake. Return to Almaty for the evening.",
      },
      {
        day: 5,
        title: "Almaty · Alma Arasan · Departure",
        state: "Kazakhstan",
        desc: "Visit Alma Arasan Hot Springs before transferring to the airport for your return journey. The tour concludes in Almaty.",
      },
    ],
  },
  {
    slug: "womens-special-dubai-abu-dhabi",
    title: "Women's Special Dubai Abu Dhabi",
    scope: "world",
    image: U("1512453979798-5ea266f8880c"),
    gallery: [U("1512453979798-5ea266f8880c"), U("1504214208698-ea1916a2195a"), U("1508009603885-50cf7c579365")],
    code: "MEWE",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Dubai Abu Dhabi Middle East",
    zone: "Africa & Middle East",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 115817,
    joiningLeavingPrice: 85817,
    emiPerMonth: 11277,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "United Arab Emirates", stops: ["Dubai (4N)", "Abu Dhabi"] },
    ],
    highlights: [
      "Jumeirah Beach walk",
      "Sheikh Zayed Road drive",
      "Museum of the Future",
      "Dubai Frame",
      "Deira City Centre shopping",
      "Fountain Show at Dubai Mall",
      "Dhow Dinner Cruise",
      "SeaWorld Abu Dhabi",
      "Ferrari World",
      "Formula Rossa ride",
      "BAPS Hindu Temple",
      "Burj Khalifa 124th floor",
      "Dubai Mall",
      "Dubai Aquarium",
      "Desert Safari by 4WD",
      "Desert Camp activities",
      "Gold Souk Water Taxi",
      "Sheikh Zayed Grand Mosque",
    ],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Coimbatore", "Goa", "Hyderabad", "Indore", "Kolkata", "New Delhi", "Dubai (Joining/leaving)"],
    dates: [{ date: "Fri Nov 20, 2026", price: 115817, tag: "Lowest Price" }],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive in the UAE · Dubai",
        state: "United Arab Emirates",
        desc: "Arrive in the UAE and transfer to Dubai. Check in to your hotel for a four-night stay.",
        nights: 4,
      },
      {
        day: 2,
        title: "Dubai city tour",
        state: "United Arab Emirates",
        desc: "Explore Dubai with a Jumeirah Beach walk and Sheikh Zayed Road drive. Visit Dubai Frame and the Museum of the Future, then see the Burj Khalifa, Dubai Mall and Dubai Aquarium. Enjoy the fountain show and a Dhow Dinner Cruise.",
      },
      {
        day: 3,
        title: "Dubai · Abu Dhabi · Dubai",
        state: "United Arab Emirates",
        desc: "Visit Abu Dhabi's Sheikh Zayed Grand Mosque, BAPS Hindu Temple, SeaWorld Abu Dhabi and Ferrari World, including the Formula Rossa ride. Return to Dubai in the evening.",
      },
      {
        day: 4,
        title: "Dubai · Desert Safari",
        state: "United Arab Emirates",
        desc: "Enjoy a 4WD desert safari and activities at a traditional desert camp. Explore Deira City Centre and take a water taxi to the Gold Souk.",
      },
      {
        day: 5,
        title: "Dubai · Abu Dhabi · Departure",
        state: "United Arab Emirates",
        desc: "Transfer from Dubai to Abu Dhabi for your return journey. The tour concludes at Abu Dhabi airport.",
      },
    ],
  },
  {
    slug: "highlights-of-dubai-abu-dhabi",
    title: "Highlights of Dubai Abu Dhabi",
    scope: "world",
    image: U("1512453979798-5ea266f8880c"),
    gallery: [U("1512453979798-5ea266f8880c")],
    code: "MEDE",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    days: 5,
    nights: 4,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 2,
    region: "Dubai Abu Dhabi Middle East",
    zone: "Africa & Middle East",
    packageType: "Group Tour",
    startingPrice: 99423,
    joiningLeavingPrice: 82000,
    emiPerMonth: 9681,
    rating: 5,
    reviewsCount: 120,
    guestsRated: "47.6k",
    guestPhotos: 160,
    route: [
      { state: "United Arab Emirates", stops: ["Dubai (4N)", "Abu Dhabi"] },
    ],
    highlights: ["Museum of the Future stop", "Deira City Centre shopping", "Dubai Fountain Show", "Dhow Dinner Cruise", "Burj Khalifa observation deck", "Dubai Aquarium", "Desert Safari by 4WD", "Dune bashing & sunset", "Traditional Desert Camp", "Henna Painting", "Live Belly Dance Show", "Water Taxi to Gold Souk", "Sheikh Zayed Grand Mosque", "SeaWorld Abu Dhabi", "Ferrari World", "BAPS Hindu Temple"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "New Delhi", "Dubai (Joining/leaving)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true, visa: true },
    itinerary: [
      {
        day: 1,
        title: "Arrive Abu Dhabi · Dubai",
        state: "United Arab Emirates",
        desc: "Arrive in Abu Dhabi and travel to Dubai. Check in to your hotel and settle in for your four-night stay.",
        nights: 4,
      },
      {
        day: 2,
        title: "Dubai city highlights",
        state: "United Arab Emirates",
        desc: "Explore Dubai's landmarks, including a stop at the Museum of the Future, the Burj Khalifa observation deck and Dubai Aquarium. Enjoy the fountain show and dinner cruise.",
      },
      {
        day: 3,
        title: "Dubai · Abu Dhabi · Dubai",
        state: "United Arab Emirates",
        desc: "Spend the day in Abu Dhabi visiting Sheikh Zayed Grand Mosque, SeaWorld Abu Dhabi, Ferrari World and BAPS Hindu Temple, then return to Dubai.",
      },
      {
        day: 4,
        title: "Dubai · Desert Safari",
        state: "United Arab Emirates",
        desc: "Enjoy a desert safari by 4WD with dune bashing, sunset views and an evening at a traditional desert camp. See Dubai's souks and take a water taxi to the Gold Souk.",
      },
      {
        day: 5,
        title: "Dubai · Abu Dhabi · Departure",
        state: "United Arab Emirates",
        desc: "Travel from Dubai to Abu Dhabi for your onward journey. The tour concludes at Abu Dhabi airport.",
      },
    ],
    review: {
      text: "Glitzy and grand! The desert safari and Burj Khalifa were unforgettable. Great for a family with kids.",
      author: "Sana",
      date: "Travelled Jan 09, 2026",
      manager: "Prasad Chavan",
    },
  },
  {
    slug: "swiss-paris-austria-germany",
    title: "Swiss Paris Austria Germany",
    scope: "world",
    image: U("1502602898657-3e91760cbb34"),
    gallery: [U("1502602898657-3e91760cbb34"), U("1541849546-216549ae216d"), U("1499856871958-5b9627545d1a")],
    code: "EUGP",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 6,
    nights: 5,
    countriesCount: 5,
    statesCount: 5,
    citiesCount: 9,
    region: "Europe",
    zone: "Europe",
    packageType: "Group Tour",
    startingPrice: 175000,
    emiPerMonth: 17039,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "France", stops: ["Paris (2N)"] },
      { state: "Switzerland", stops: ["Zurich (2N)", "Lucerne", "Rhine Falls"] },
      { state: "Liechtenstein", stops: ["Vaduz"] },
      { state: "Austria", stops: ["Innsbruck (1N)", "Wattens"] },
      { state: "Germany", stops: ["Munich"] },
    ],
    highlights: ["Paris City Tour", "2nd Level of the Eiffel Tower", "Seine River Cruise", "Rotair Cable Car to Mt. Titlis", "Lucerne City Tour", "Rhine Falls Boat Ride", "Vaduz Tram Ride", "Walking Tour of Innsbruck", "Swarovski Crystal World", "Munich City Tour"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving (Paris to Munich)"],
    dates: [
      { date: "Sun Oct 18, 2026", price: 175000 },
      { date: "Mon Oct 26, 2026", price: 175000, tag: "Durga Pujo Special" },
      { date: "Mon Nov 9, 2026", price: 175000 },
      { date: "Mon Nov 16, 2026", price: 175000, tag: "Lowest Price", seats: 7 },
      { date: "Mon Nov 30, 2026", price: 175000 },
      { date: "Mon Dec 7, 2026", price: 175000 },
      { date: "Mon Jan 25, 2027", price: 175000 },
      { date: "Mon Feb 15, 2027", price: 175000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Paris", state: "France", desc: "Arrive in Paris and begin your European journey. Settle in for a two-night stay in the City of Light.", nights: 2 },
      { day: 2, title: "Paris City Tour", state: "France", desc: "Discover Paris on a city tour, visit the second level of the Eiffel Tower and enjoy a Seine River cruise.", highlights: ["Paris City Tour", "2nd Level of the Eiffel Tower", "Seine River Cruise"] },
      { day: 3, title: "Paris · Zurich", state: "France / Switzerland", desc: "Travel from Paris to Zurich and check in for a two-night stay in Switzerland.", nights: 2 },
      { day: 4, title: "Mount Titlis · Lucerne", state: "Switzerland", desc: "Ride the rotating Rotair cable car to Mount Titlis, then explore Lucerne on a city tour.", highlights: ["Rotair Cable Car to Mt. Titlis", "Lucerne City Tour"] },
      { day: 5, title: "Zurich · Rhine Falls · Vaduz · Innsbruck", state: "Switzerland / Liechtenstein / Austria", desc: "See Rhine Falls and take a boat ride, continue to Vaduz for a tram ride, then travel to Innsbruck for an overnight stay.", nights: 1, highlights: ["Rhine Falls Boat Ride", "Vaduz Tram Ride"] },
      { day: 6, title: "Innsbruck · Wattens · Munich · Departure", state: "Austria / Germany", desc: "Take a walking tour of Innsbruck, visit Swarovski Crystal World in Wattens and continue to Munich for a city tour before departure.", highlights: ["Walking Tour of Innsbruck", "Swarovski Crystal World", "Munich City Tour"] },
    ],
  },  {
    slug: "swiss-paris-germany-amsterdam",
    title: "Swiss Paris Germany Amsterdam",
    scope: "world",
    image: U("1541849546-216549ae216d"),
    gallery: [U("1541849546-216549ae216d"), U("1502602898657-3e91760cbb34")],
    code: "EUAP",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 7,
    nights: 6,
    countriesCount: 4,
    statesCount: 4,
    citiesCount: 6,
    region: "Europe",
    zone: "Europe",
    packageType: "Group Tour",
    startingPrice: 169000,
    joiningLeavingPrice: 142000,
    emiPerMonth: 16455,
    rating: 5,
    reviewsCount: 76,
    guestsRated: "5.4k",
    guestPhotos: 110,
    route: [
      { state: "France", stops: ["Paris (2N)"] },
      { state: "Switzerland", stops: ["Lucerne (2N)"] },
      { state: "Germany", stops: ["Frankfurt (1N)"] },
      { state: "Netherlands", stops: ["Amsterdam (1N)"] },
    ],
    highlights: ["Eiffel Tower", "Seine River Cruise", "Mt. Titlis", "Rhine Falls", "Cologne Cathedral", "Amsterdam Canal Cruise"],
    departureCities: ["Delhi (Joining/leaving)", "Mumbai"],
    dates: [
      { date: "Sat Aug 22, 2026", price: 169000, tag: "Lowest Price" },
      { date: "Sat Sep 26, 2026", price: 176000 },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    review: {
      text: "Four countries, zero stress. The Swiss Alps and the Amsterdam canals were the highlights. Excellent tour manager.",
      author: "Vivek",
      date: "Travelled Jul 12, 2026",
      manager: "Sandesh Wagh",
    },
  },
  {
    slug: "best-of-georgia",
    title: "Best of Georgia",
    scope: "world",
    image: U("1519608487953-e999c86e7455"),
    gallery: [U("1519608487953-e999c86e7455"), U("1519681393784-d120267933ba"), U("1500530855697-b586d89ba3ee")],
    code: "EUGB",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 5,
    region: "Georgia",
    zone: "Europe",
    packageType: "Group Tour",
    startingPrice: 190000,
    emiPerMonth: 18478,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Georgia", stops: ["Tbilisi (3N)", "Gudauri (1N)", "Kutaisi (1N)", "Batumi (2N)"] },
    ],
    highlights: [
      "Tbilisi Old Town Walk",
      "Mother of Georgia Viewpoint",
      "Holy Trinity Cathedral",
      "Traditional Folklore Dance Show",
      "Mtskheta Ancient City",
      "Jvari Monastery",
      "Chateau Mukhrani Winery",
      "Batumi City Tour",
      "Monument of Ali and Nino",
      "Batumi Botanical Gardens",
      "Martvili Canyon Boat Tour",
      "Prometheus Cave",
      "Chronicles of Georgia",
      "Sighnaghi City Walls",
      "Bodbe Monastery",
      "Kakheti Winery Visit",
      "Jinvali Reservoir",
      "Ananuri Complex",
      "Gergeti Holy Trinity Church",
      "Gudauri Ski Resort",
      "Gudauri Panorama",
    ],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving (Tbilisi)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Tbilisi", state: "Georgia", desc: "Arrive in Georgia's capital and settle in. Enjoy a relaxed introduction to Tbilisi and its welcoming local culture.", nights: 3 },
      { day: 2, title: "Tbilisi City Tour", state: "Georgia", desc: "Explore the old town, visit the Holy Trinity Cathedral and take in the city from the Mother of Georgia viewpoint. In the evening, enjoy a traditional folklore dance show.", highlights: ["Tbilisi Old Town Walk", "Mother of Georgia Viewpoint", "Holy Trinity Cathedral", "Traditional Folklore Dance Show"] },
      { day: 3, title: "Mtskheta · Jvari · Mukhrani", state: "Georgia", desc: "Discover the ancient city of Mtskheta and visit Jvari Monastery. Continue to Chateau Mukhrani for a winery experience before returning to Tbilisi.", highlights: ["Mtskheta Ancient City", "Jvari Monastery", "Chateau Mukhrani Winery"] },
      { day: 4, title: "Tbilisi · Gudauri", state: "Georgia", desc: "Travel north through the Caucasus, stopping at the Jinvali Reservoir and Ananuri Complex. Enjoy the mountain scenery at Gudauri Panorama and Gudauri Ski Resort before an overnight stay in Gudauri.", nights: 1, highlights: ["Jinvali Reservoir", "Ananuri Complex", "Gudauri Ski Resort", "Gudauri Panorama"] },
      { day: 5, title: "Gudauri · Gergeti · Tbilisi", state: "Georgia", desc: "Visit Gergeti Holy Trinity Church against the dramatic mountain backdrop, then return to Tbilisi for the night.", highlights: ["Gergeti Holy Trinity Church"] },
      { day: 6, title: "Tbilisi · Sighnaghi · Kutaisi", state: "Georgia", desc: "Head into the Kakheti wine region. See Sighnaghi's historic city walls, visit Bodbe Monastery and enjoy a Kakheti winery visit before continuing to Kutaisi.", nights: 1, highlights: ["Sighnaghi City Walls", "Bodbe Monastery", "Kakheti Winery Visit"] },
      { day: 7, title: "Kutaisi · Martvili · Batumi", state: "Georgia", desc: "Explore Prometheus Cave and take a boat tour through Martvili Canyon, then continue to Batumi for a two-night stay.", nights: 2, highlights: ["Prometheus Cave", "Martvili Canyon Boat Tour"] },
      { day: 8, title: "Batumi City Tour · Departure", state: "Georgia", desc: "Discover Batumi, including the striking Monument of Ali and Nino and the lush Batumi Botanical Gardens, before your onward journey.", highlights: ["Batumi City Tour", "Monument of Ali and Nino", "Batumi Botanical Gardens"] },
    ],
  },
  {
    slug: "usa-east-coast-joining-and-leaving",
    title: "USA East Coast (Joining & Leaving)",
    scope: "world",
    image: U("1519501025264-65ba15a82390"),
    gallery: [U("1519501025264-65ba15a82390"), U("1485738422979-f5c462d49f74"), U("1518391846015-55a9cc003b25")],
    code: "AMEP",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 7,
    nights: 6,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 5,
    region: "United States",
    zone: "America",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 195000,
    joiningLeavingPrice: 195000,
    emiPerMonth: 18987,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "United States", stops: ["Philadelphia (1N)", "Washington, D.C. (1N)", "Niagara Falls / Buffalo (2N)", "New York / New Jersey (2N)"] },
    ],
    highlights: ["White House Photo Stop", "Lincoln Memorial", "Hershey's Chocolate World", "Niagara Falls Helicopter Ride", "Maid of the Mist Boat Ride", "Prospect Point Observation Tower", "Corning Museum of Glass", "Statue of Liberty", "Charging Bull", "9/11 Memorial", "One World Observatory", "Stroll at Times Square"],
    departureCity: "New York / New Jersey",
    departureCities: ["Joining/leaving (New York / New Jersey)"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
    itinerary: [
      { day: 1, title: "Arrive in New York · Philadelphia", state: "United States", desc: "Meet the tour manager in New York and travel to Philadelphia. Explore the city's historic district, including Independence Hall and the Liberty Bell, before your overnight stay.", nights: 1 },
      { day: 2, title: "Philadelphia · Washington, D.C.", state: "United States", desc: "Discover Philadelphia's City Hall, Independence Hall, Liberty Bell, Benjamin Franklin Parkway and Rocky Steps. Continue to Washington, D.C. for photo stops at the White House and Capitol Hill, and a visit to the Lincoln Memorial.", nights: 1, highlights: ["White House Photo Stop", "Lincoln Memorial"] },
      { day: 3, title: "Washington, D.C. · Hershey · Niagara Falls", state: "United States", desc: "Travel north toward Niagara Falls, stopping at Hershey's Chocolate World for its chocolate experience. Arrive in the Niagara Falls / Buffalo area for a two-night stay.", nights: 2, highlights: ["Hershey's Chocolate World"] },
      { day: 4, title: "Niagara Falls · Buffalo", state: "United States", desc: "Experience Niagara Falls from the air on a helicopter ride, weather permitting, then get close to the falls on the Maid of the Mist boat ride. Visit Prospect Point Observation Tower and enjoy time to take in the falls.", highlights: ["Niagara Falls Helicopter Ride", "Maid of the Mist Boat Ride", "Prospect Point Observation Tower"] },
      { day: 5, title: "Niagara Falls · Corning · New York", state: "United States", desc: "Travel back toward New York, stopping at the Corning Museum of Glass to see its collection and glassmaking demonstrations. Check in for a two-night stay in New York / New Jersey.", nights: 2, highlights: ["Corning Museum of Glass"] },
      { day: 6, title: "New York City Tour", state: "United States", desc: "Take a ferry to Liberty Island to see the Statue of Liberty. Continue through lower Manhattan to the Charging Bull and 9/11 Memorial, visit One World Observatory and stroll through the bright lights of Times Square.", highlights: ["Statue of Liberty", "Charging Bull", "9/11 Memorial", "One World Observatory", "Stroll at Times Square"] },
      { day: 7, title: "New York · Departure", state: "United States", desc: "The tour concludes in New York / New Jersey. Make your own onward travel arrangements from the hotel or airport." },
    ],
  },
  {
    slug: "chiang-mai-chiang-rai-phuket-krabi",
    title: "Chiang Mai Chiang Rai Phuket Krabi",
    scope: "world",
    image: U("1528181304800-259b08848526"),
    gallery: [U("1528181304800-259b08848526"), U("1537996194471-e657df975ab4"), U("1507525428034-b723cf961d3e")],
    code: "ASMR",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 9,
    nights: 8,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 5,
    region: "Thailand",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 195000,
    emiPerMonth: 18987,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Chiang Mai (3N)", "Chiang Rai (1N)", "Phuket (2N)", "Krabi (2N)"] },
    ],
    highlights: ["Elephant Safari in Elephant Sanctuary", "Bamboo Rafting", "Khum Khantoke Dinner with Dance Show", "Excursion to Chiang Rai", "Golden Triangle - Educational Park", "Wat Rong Khun", "River Rafting on the Mae Taeng River", "Bo Sang Village", "Dolphin Show", "Ao Nang Beach", "Krabi Island-Hopping Tour", "Ao Phang Nga National Park", "James Bond Island"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Chiang Mai", state: "Thailand", desc: "Arrive in Chiang Mai and settle in. In the evening, enjoy a Khum Khantoke dinner accompanied by a traditional dance show.", nights: 3, highlights: ["Khum Khantoke Dinner with Dance Show"] },
      { day: 2, title: "Chiang Mai · Elephant Sanctuary · Mae Taeng", state: "Thailand", desc: "Spend the day at an elephant sanctuary, then enjoy an outdoor adventure with bamboo rafting and river rafting on the Mae Taeng River.", highlights: ["Elephant Safari in Elephant Sanctuary", "Bamboo Rafting", "River Rafting on the Mae Taeng River"] },
      { day: 3, title: "Chiang Mai · Bo Sang Village", state: "Thailand", desc: "Visit Bo Sang, a village known for its traditional craft and colourful handmade umbrellas. Enjoy time to explore Chiang Mai at your own pace.", highlights: ["Bo Sang Village"] },
      { day: 4, title: "Chiang Mai · Chiang Rai · Golden Triangle", state: "Thailand", desc: "Take an excursion to Chiang Rai and explore the Golden Triangle Educational Park and the region's iconic Wat Rong Khun before an overnight stay in Chiang Rai.", nights: 1, highlights: ["Excursion to Chiang Rai", "Golden Triangle - Educational Park", "Wat Rong Khun"] },
      { day: 5, title: "Chiang Rai · Phuket", state: "Thailand", desc: "Transfer to Phuket and check in for a two-night stay. Enjoy a Dolphin Show as part of your island introduction.", nights: 2, highlights: ["Dolphin Show"] },
      { day: 6, title: "Phuket · Phang Nga Bay · James Bond Island", state: "Thailand", desc: "Explore Ao Phang Nga National Park by boat, passing dramatic limestone scenery and visiting the famous James Bond Island.", highlights: ["Ao Phang Nga National Park", "James Bond Island"] },
      { day: 7, title: "Phuket · Krabi", state: "Thailand", desc: "Travel to Krabi and settle in for a two-night stay near Ao Nang Beach.", nights: 2, highlights: ["Ao Nang Beach"] },
      { day: 8, title: "Krabi · Island-Hopping Tour", state: "Thailand", desc: "Enjoy a Krabi island-hopping tour, with time to take in the Andaman Sea, nearby islands and the beach scenery around Ao Nang.", highlights: ["Krabi Island-Hopping Tour", "Ao Nang Beach"] },
      { day: 9, title: "Krabi · Departure", state: "Thailand", desc: "Transfer to the airport for your onward journey. The tour concludes in Krabi." },
    ],
  },
  {
    slug: "seniors-special-singapore-thailand-malaysia",
    title: "Seniors' Special Singapore Thailand Malaysia",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASZJ",
    tourType: "GROUP TOUR",
    speciality: "Seniors' Special",
    allInclusive: true,
    popularToday: true,
    days: 10,
    nights: 9,
    countriesCount: 3,
    statesCount: 3,
    citiesCount: 5,
    region: "Singapore, Thailand & Malaysia",
    zone: "Asia",
    interest: "Seniors' Special",
    packageType: "Group Tour",
    startingPrice: 197000,
    joiningLeavingPrice: 162000,
    emiPerMonth: 19182,
    rating: 5,
    reviewsCount: 13,
    guestsRated: "16+",
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (2N)", "Bangkok (2N)"] },
      { state: "Malaysia", stops: ["Kuala Lumpur (2N)", "Genting Highlands"] },
      { state: "Singapore", stops: ["Singapore (3N)"] },
    ],
    highlights: ["Pattaya Tower", "Alcazar Show", "Coral Island", "Nong Nooch Village", "Scientific Thai massage", "Gems Gallery", "Safari World & Marine Park", "Chao Phraya River Dinner Cruise", "Observatory Deck of the K. L. Tower", "Genting Highlands", "Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum", "Universal Studios", "Wings of Time Show"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Joining/leaving (Bangkok to Singapore)"],
    dates: [
      { date: "Mon Nov 23, 2026", price: 197000, tag: "Lowest Price" },
      { date: "Wed Jan 20, 2027", price: 202000, tag: "Save ₹3,000" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Bangkok · Pattaya", state: "Thailand", desc: "Arrive in Bangkok and travel to Pattaya. Settle in for a two-night stay and ease into the journey.", nights: 2 },
      { day: 2, title: "Pattaya · Coral Island", state: "Thailand", desc: "Enjoy a gentle day around Pattaya with a visit to Coral Island, Pattaya Tower and Gems Gallery, followed by an Alcazar Show and a traditional Thai massage.", highlights: ["Pattaya Tower", "Alcazar Show", "Coral Island", "Scientific Thai massage", "Gems Gallery"] },
      { day: 3, title: "Pattaya · Nong Nooch · Bangkok", state: "Thailand", desc: "Visit Nong Nooch Village before travelling to Bangkok for a two-night stay.", nights: 2, highlights: ["Nong Nooch Village"] },
      { day: 4, title: "Bangkok · Safari World", state: "Thailand", desc: "Visit Safari World and Marine Park, then enjoy an evening dinner cruise along the Chao Phraya River.", highlights: ["Safari World & Marine Park", "Chao Phraya River Dinner Cruise"] },
      { day: 5, title: "Bangkok · Kuala Lumpur", state: "Thailand · Malaysia", desc: "Fly to Kuala Lumpur, settle in for a two-night stay, and take in city views from the K. L. Tower observatory deck.", nights: 2, highlights: ["Observatory Deck of the K. L. Tower"] },
      { day: 6, title: "Kuala Lumpur · Genting Highlands", state: "Malaysia", desc: "Enjoy an excursion to Genting Highlands, with time to explore the mountain resort before returning to Kuala Lumpur.", highlights: ["Genting Highlands"] },
      { day: 7, title: "Kuala Lumpur · Singapore", state: "Malaysia · Singapore", desc: "Continue to Singapore and check in for a three-night stay.", nights: 3 },
      { day: 8, title: "Singapore · Gardens by the Bay · Sentosa", state: "Singapore", desc: "Discover Gardens by the Bay and Mandai Bird Paradise, then ride the cable car to Sentosa Island and visit Madame Tussauds.", highlights: ["Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum"] },
      { day: 9, title: "Singapore · Universal Studios", state: "Singapore", desc: "Spend the day at Universal Studios Singapore and enjoy the evening Wings of Time show.", highlights: ["Universal Studios", "Wings of Time Show"] },
      { day: 10, title: "Singapore · Departure", state: "Singapore", desc: "Transfer to the airport for your onward journey. The tour concludes in Singapore." },
    ],
  },
  {
    slug: "womens-special-singapore-thailand-malaysia",
    title: "Women's Special Singapore Thailand Malaysia",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASWY",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    popularToday: true,
    days: 10,
    nights: 9,
    countriesCount: 3,
    statesCount: 3,
    citiesCount: 5,
    region: "Singapore, Thailand & Malaysia",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 199000,
    emiPerMonth: 19377,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Thailand", stops: ["Pattaya (2N)", "Bangkok (2N)"] },
      { state: "Malaysia", stops: ["Kuala Lumpur (2N)", "Genting Highlands"] },
      { state: "Singapore", stops: ["Singapore (3N)"] },
    ],
    highlights: ["Alcazar Show", "Coral Island", "Nong Nooch Village", "Scientific Thai massage", "Gems Gallery", "Safari World & Marine Park", "Chao Phraya River Dinner Cruise", "Observatory Deck of the K. L. Tower", "Genting Highlands", "Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum", "Universal Studios", "Wings of Time Show"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Joining/leaving (Bangkok to Singapore)"],
    dates: [
      { date: "Mon Dec 7, 2026", price: 199000, tag: "Lowest Price" },
      { date: "Fri Mar 5, 2027", price: 199000, tag: "Save ₹3,000" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrival at Bangkok · Pattaya", state: "Thailand", desc: "Arrive in Bangkok and transfer to Pattaya for a two-night stay.", nights: 2 },
      { day: 2, title: "Pattaya", state: "Thailand", desc: "Enjoy Pattaya, including Coral Island, Nong Nooch Village, an Alcazar Show, a Thai massage and a visit to Gems Gallery.", highlights: ["Alcazar Show", "Coral Island", "Nong Nooch Village", "Scientific Thai massage", "Gems Gallery"] },
      { day: 3, title: "Pattaya · Bangkok", state: "Thailand", desc: "Travel from Pattaya to Bangkok and check in for a two-night stay.", nights: 2 },
      { day: 4, title: "Bangkok", state: "Thailand", desc: "Visit Safari World and Marine Park, then enjoy a dinner cruise on the Chao Phraya River.", highlights: ["Safari World & Marine Park", "Chao Phraya River Dinner Cruise"] },
      { day: 5, title: "Bangkok · Kuala Lumpur", state: "Thailand · Malaysia", desc: "Fly to Kuala Lumpur and enjoy views from the K. L. Tower observatory deck.", nights: 2, highlights: ["Observatory Deck of the K. L. Tower"] },
      { day: 6, title: "Kuala Lumpur · Genting Highlands · Kuala Lumpur", state: "Malaysia", desc: "Take an excursion to Genting Highlands before returning to Kuala Lumpur.", highlights: ["Genting Highlands"] },
      { day: 7, title: "Kuala Lumpur · Singapore", state: "Malaysia · Singapore", desc: "Continue to Singapore and settle in for a three-night stay.", nights: 3 },
      { day: 8, title: "Singapore", state: "Singapore", desc: "Discover Gardens by the Bay and Mandai Bird Paradise, ride the cable car to Sentosa Island and visit Madame Tussauds.", highlights: ["Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum"] },
      { day: 9, title: "Singapore · Universal Studios · Singapore", state: "Singapore", desc: "Enjoy a full day at Universal Studios followed by the Wings of Time show.", highlights: ["Universal Studios", "Wings of Time Show"] },
      { day: 10, title: "Singapore · Departure", state: "Singapore", desc: "Transfer to the airport for your onward journey. The tour concludes in Singapore." },
    ],
  },
  {
    slug: "hong-kong-macao-shenzhen",
    title: "Hong Kong Macao Shenzhen",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASHS",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 7,
    nights: 6,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 3,
    region: "Hong Kong, Macao & Shenzhen",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 198000,
    joiningLeavingPrice: 154000,
    emiPerMonth: 19279,
    rating: 5,
    reviewsCount: 16,
    guestsRated: "35+",
    guestPhotos: 0,
    route: [
      { state: "Hong Kong", stops: ["Hong Kong (2N)", "Hong Kong (2N)"] },
      { state: "China", stops: ["Shenzhen (1N)", "Macao (1N)"] },
    ],
    highlights: ["Sky Terrace 428", "The Symphony of Lights", "Ocean Park", "Ngong Ping Cable Car Ride", "OH Bay", "Shenzhen Glass Bridge", "Wynn Fountain Show & Diamond Show", "Panda Pavilion", "A-Ma Temple", "Macao Tower's Observatory Deck", "Disneyland"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "New Delhi", "Joining/leaving"],
    dates: [
      { date: "Sat Oct 24, 2026", price: 207000, tag: "Durga Pujo Special" },
      { date: "Wed Nov 4, 2026", price: 205000 },
      { date: "Sat Nov 7, 2026", price: 194000, tag: "Sold out" },
      { date: "Thu Nov 12, 2026", price: 205000, tag: "7 seats" },
      { date: "Wed Nov 18, 2026", price: 205000 },
      { date: "Sat Nov 28, 2026", price: 198000, tag: "Lowest Price" },
      { date: "Fri Dec 11, 2026", price: 203000 },
      { date: "Sat Dec 19, 2026", price: 205000 },
      { date: "Sat Dec 26, 2026", price: 216000 },
      { date: "Sun Dec 27, 2026", price: 218000 },
      { date: "Wed Jan 20, 2027", price: 203000, tag: "Save ₹3,000" },
      { date: "Wed Feb 17, 2027", price: 202000, tag: "Save ₹4,000" },
      { date: "Wed Mar 10, 2027", price: 201000, tag: "Save ₹5,000" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrival at Hong Kong", state: "Hong Kong", desc: "Arrive in Hong Kong and settle in for a two-night stay.", nights: 2 },
      { day: 2, title: "Hong Kong", state: "Hong Kong", desc: "Enjoy Hong Kong sightseeing, including Sky Terrace 428, the Symphony of Lights, Ocean Park and the Ngong Ping Cable Car Ride.", highlights: ["Sky Terrace 428", "The Symphony of Lights", "Ocean Park", "Ngong Ping Cable Car Ride"] },
      { day: 3, title: "Hong Kong · Shenzhen", state: "Hong Kong · China", desc: "Travel to Shenzhen and discover OH Bay and the Shenzhen Glass Bridge. Overnight in Shenzhen.", nights: 1, highlights: ["OH Bay", "Shenzhen Glass Bridge"] },
      { day: 4, title: "Shenzhen · Macao", state: "China · Macao", desc: "Continue to Macao and enjoy the Wynn Fountain and Diamond shows. Overnight in Macao.", nights: 1, highlights: ["Wynn Fountain Show & Diamond Show"] },
      { day: 5, title: "Macao · Hong Kong", state: "Macao · Hong Kong", desc: "Visit the Panda Pavilion, A-Ma Temple and the Macao Tower Observatory Deck before returning to Hong Kong for a two-night stay.", nights: 2, highlights: ["Panda Pavilion", "A-Ma Temple", "Macao Tower's Observatory Deck"] },
      { day: 6, title: "Hong Kong · Disneyland · Hong Kong", state: "Hong Kong", desc: "Spend the day enjoying Hong Kong Disneyland.", highlights: ["Disneyland"] },
      { day: 7, title: "Hong Kong · Departure", state: "Hong Kong", desc: "Transfer to the airport for your onward journey. The tour concludes in Hong Kong." },
    ],
  },
  {
    slug: "singapore-bali",
    title: "Singapore Bali",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASBL",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 8,
    nights: 7,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 4,
    region: "Singapore & Bali",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 200000,
    emiPerMonth: 19472,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Singapore", stops: ["Singapore (3N)"] },
      { state: "Indonesia", stops: ["Bali (4N)", "Nusa Penida"] },
    ],
    highlights: ["Gardens by the Bay", "Mandai Bird Paradise", "Marina Bay Sands SkyPark Observation Deck or Singapore Flyer", "Images of Singapore", "Madame Tussauds Wax Museum", "Universal Studios", "Singapore Oceanarium", "Wings of Time", "Tanah Lot Sea Temple", "Tirta Empul", "Nusa Penida", "Devdan Show", "White-water Rafting at Ayung River"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Singapore", state: "Singapore", desc: "Arrive in Singapore and settle in for your stay in the city." },
      { day: 2, title: "Singapore · Gardens by the Bay", state: "Singapore", desc: "Explore Gardens by the Bay and Mandai Bird Paradise, with city views from the Marina Bay Sands SkyPark or Singapore Flyer.", highlights: ["Gardens by the Bay", "Mandai Bird Paradise", "Marina Bay Sands SkyPark Observation Deck or Singapore Flyer"] },
      { day: 3, title: "Singapore · Sentosa Island", state: "Singapore", desc: "Discover Sentosa Island, including Images of Singapore, Madame Tussauds, the Singapore Oceanarium and the Wings of Time show.", highlights: ["Images of Singapore", "Madame Tussauds Wax Museum", "Singapore Oceanarium", "Wings of Time"] },
      { day: 4, title: "Singapore · Universal Studios", state: "Singapore", desc: "Enjoy a day at Universal Studios Singapore.", highlights: ["Universal Studios"] },
      { day: 5, title: "Singapore · Bali", state: "Singapore · Indonesia", desc: "Fly to Bali and check in for your island stay." },
      { day: 6, title: "Bali · Tirta Empul · Tanah Lot", state: "Indonesia", desc: "Visit Tirta Empul and the iconic Tanah Lot Sea Temple.", highlights: ["Tirta Empul", "Tanah Lot Sea Temple"] },
      { day: 7, title: "Bali · Nusa Penida", state: "Indonesia", desc: "Explore Nusa Penida, then enjoy a Devdan cultural show and white-water rafting on the Ayung River as scheduled.", highlights: ["Nusa Penida", "Devdan Show", "White-water Rafting at Ayung River"] },
      { day: 8, title: "Bali · Departure", state: "Indonesia", desc: "Transfer to the airport for your onward journey. The tour concludes in Bali." },
    ],
  },
  {
    slug: "georgia-armenia",
    title: "Georgia Armenia",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "EUGA",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 8,
    nights: 7,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 7,
    region: "Georgia & Armenia",
    zone: "Europe",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 205000,
    emiPerMonth: 19958,
    rating: 5,
    reviewsCount: 21,
    guestsRated: "20+",
    guestPhotos: 0,
    route: [
      { state: "Georgia", stops: ["Tbilisi", "Kakheti", "Gudauri"] },
      { state: "Armenia", stops: ["Yerevan", "Lake Sevan", "Garni"] },
    ],
    highlights: ["Explore Tbilisi City", "Jvari Monastery", "Chateau Mukhrani", "Sighnaghi City Walls", "Bodbe Monastery", "Kakheti Winery", "Jinvali Reservoir", "Ananuri Complex", "Gergeti Holy Trinity Church", "Gudauri Ski Resort", "Gudauri Panorama", "Haghpat Monastery", "Lake Sevan Photo Stop", "Mother Armenia Monument", "Cascade Complex", "Charent's Arch", "Garni Temple", "Symphony of Stones", "Geghard Monastery"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
    dates: [
      { date: "Sun Nov 8, 2026", price: 205000, tag: "Lowest Price" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Tbilisi", state: "Georgia", desc: "Arrive in Tbilisi and settle in for your stay in Georgia." },
      { day: 2, title: "Tbilisi City Tour", state: "Georgia", desc: "Explore Tbilisi's historic centre and landmarks, including the Jvari Monastery and Chateau Mukhrani.", highlights: ["Explore Tbilisi City", "Jvari Monastery", "Chateau Mukhrani"] },
      { day: 3, title: "Tbilisi · Sighnaghi · Kakheti", state: "Georgia", desc: "Visit Sighnaghi's city walls, Bodbe Monastery and a Kakheti winery.", highlights: ["Sighnaghi City Walls", "Bodbe Monastery", "Kakheti Winery"] },
      { day: 4, title: "Tbilisi · Jinvali · Ananuri · Gudauri", state: "Georgia", desc: "Travel through the Caucasus scenery, stopping at Jinvali Reservoir and Ananuri Complex on the way to Gudauri.", highlights: ["Jinvali Reservoir", "Ananuri Complex", "Gudauri Ski Resort", "Gudauri Panorama"] },
      { day: 5, title: "Georgia · Armenia · Yerevan", state: "Georgia · Armenia", desc: "Cross into Armenia and continue to Yerevan, with a visit to Haghpat Monastery en route.", highlights: ["Haghpat Monastery"] },
      { day: 6, title: "Yerevan City Tour", state: "Armenia", desc: "Discover Yerevan's Cascade Complex and Mother Armenia monument, with a photo stop at Lake Sevan.", highlights: ["Lake Sevan Photo Stop", "Mother Armenia Monument", "Cascade Complex"] },
      { day: 7, title: "Yerevan · Garni · Geghard", state: "Armenia", desc: "Visit Charent's Arch, Garni Temple, the Symphony of Stones and Geghard Monastery.", highlights: ["Charent's Arch", "Garni Temple", "Symphony of Stones", "Geghard Monastery"] },
      { day: 8, title: "Yerevan · Departure", state: "Armenia", desc: "Transfer to the airport for your onward journey. The tour concludes in Yerevan." },
    ],
  },
  {
    slug: "womens-special-with-kids-hong-kong-macao-shenzhen",
    title: "Women's Special with Kids Hong Kong Macao Shenzhen",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASWKH",
    tourType: "GROUP TOUR",
    speciality: "Women's Special with Kids",
    allInclusive: true,
    popularToday: true,
    days: 7,
    nights: 6,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 3,
    region: "Hong Kong, Macao & Shenzhen",
    zone: "Asia",
    interest: "Women's Special with Kids",
    packageType: "Group Tour",
    startingPrice: 208000,
    emiPerMonth: 20253,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Hong Kong", stops: ["Hong Kong (2N)", "Hong Kong (2N)"] },
      { state: "China", stops: ["Shenzhen (1N)", "Macao (1N)"] },
    ],
    highlights: ["Sky Terrace 428", "The Symphony of Lights", "Ocean Park", "Ngong Ping Cable Car Ride", "OH Bay", "Shenzhen Glass Bridge", "Wynn Fountain Show & Diamond Show", "Panda Pavilion", "A-Ma Temple", "Macao Tower's Observatory Deck", "Disneyland"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "New Delhi", "Joining/leaving"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrival at Hong Kong", state: "Hong Kong", desc: "Arrive in Hong Kong and settle in for a two-night stay.", nights: 2 },
      { day: 2, title: "Hong Kong", state: "Hong Kong", desc: "Enjoy Hong Kong sightseeing, including Sky Terrace 428, the Symphony of Lights, Ocean Park and the Ngong Ping Cable Car Ride.", highlights: ["Sky Terrace 428", "The Symphony of Lights", "Ocean Park", "Ngong Ping Cable Car Ride"] },
      { day: 3, title: "Hong Kong · Shenzhen", state: "Hong Kong · China", desc: "Travel to Shenzhen and discover OH Bay and the Shenzhen Glass Bridge. Overnight in Shenzhen.", nights: 1, highlights: ["OH Bay", "Shenzhen Glass Bridge"] },
      { day: 4, title: "Shenzhen · Macao", state: "China · Macao", desc: "Continue to Macao and enjoy the Wynn Fountain and Diamond shows. Overnight in Macao.", nights: 1, highlights: ["Wynn Fountain Show & Diamond Show"] },
      { day: 5, title: "Macao · Hong Kong", state: "Macao · Hong Kong", desc: "Visit the Panda Pavilion, A-Ma Temple and Macao Tower Observatory Deck before returning to Hong Kong for a two-night stay.", nights: 2, highlights: ["Panda Pavilion", "A-Ma Temple", "Macao Tower's Observatory Deck"] },
      { day: 6, title: "Hong Kong · Disneyland · Hong Kong", state: "Hong Kong", desc: "Spend the day enjoying Hong Kong Disneyland, with family-friendly attractions for all ages.", highlights: ["Disneyland"] },
      { day: 7, title: "Hong Kong · Departure", state: "Hong Kong", desc: "Transfer to the airport for your onward journey. The tour concludes in Hong Kong." },
    ],
  },
  {
    slug: "philippines-manila-cebu",
    title: "Philippines Manila Cebu",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASPI",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 8,
    nights: 7,
    countriesCount: 1,
    statesCount: 1,
    citiesCount: 4,
    region: "Philippines",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 210000,
    emiPerMonth: 20447,
    rating: 5,
    reviewsCount: 2,
    guestsRated: "2+",
    guestPhotos: 0,
    route: [
      { state: "Philippines", stops: ["Manila", "Cebu", "Bohol", "Moalboal"] },
    ],
    highlights: ["Taoist Temple Complex", "Fort San Pedro", "Lapu Lapu City", "Vano Beach", "Bohol Ferry Ride", "Chocolate Hills", "Tarsier Conservation Area", "Bilar Man-made Forest", "Moalboal Sardine Run", "Kawasan Falls", "Binondo Chinatown", "Rizal Park", "Intramuros", "Fort Santiago", "National Museum", "Manila Ocean Park", "Glass Tunnel Walk"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "New Delhi", "Nagpur", "Kolkata", "Indore", "Hyderabad", "Goa", "Joining/leaving"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Manila", state: "Philippines", desc: "Arrive in Manila and settle in for your stay in the capital." },
      { day: 2, title: "Manila City Tour", state: "Philippines", desc: "Explore Manila's historic and cultural landmarks, including Binondo Chinatown, Rizal Park, Intramuros, Fort Santiago and the National Museum. Visit Manila Ocean Park and its Glass Tunnel Walk.", highlights: ["Binondo Chinatown", "Rizal Park", "Intramuros", "Fort Santiago", "National Museum", "Manila Ocean Park", "Glass Tunnel Walk"] },
      { day: 3, title: "Manila · Cebu", state: "Philippines", desc: "Fly to Cebu and settle in for your stay on the island." },
      { day: 4, title: "Cebu City Tour", state: "Philippines", desc: "Discover Cebu's heritage and city sights, including the Taoist Temple Complex, Fort San Pedro and Lapu Lapu City.", highlights: ["Taoist Temple Complex", "Fort San Pedro", "Lapu Lapu City"] },
      { day: 5, title: "Cebu · Bohol", state: "Philippines", desc: "Take the ferry to Bohol and explore the Chocolate Hills, Tarsier Conservation Area and Bilar Man-made Forest.", highlights: ["Bohol Ferry Ride", "Chocolate Hills", "Tarsier Conservation Area", "Bilar Man-made Forest"] },
      { day: 6, title: "Cebu · Moalboal", state: "Philippines", desc: "Visit Moalboal for its famous sardine run and continue to the scenic Kawasan Falls. Enjoy time at Vano Beach as scheduled.", highlights: ["Moalboal Sardine Run", "Kawasan Falls", "Vano Beach"] },
      { day: 7, title: "Cebu", state: "Philippines", desc: "Enjoy the remaining Cebu sightseeing and leisure time before your onward departure.", highlights: ["Taoist Temple Complex", "Fort San Pedro"] },
      { day: 8, title: "Departure", state: "Philippines", desc: "Transfer to the airport for your onward journey. The tour concludes in the Philippines." },
    ],
  },
  {
    slug: "singapore-malaysia-bali",
    title: "Singapore Malaysia Bali",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASMB",
    tourType: "GROUP TOUR",
    speciality: "Family",
    allInclusive: true,
    popularToday: true,
    days: 10,
    nights: 9,
    countriesCount: 3,
    statesCount: 3,
    citiesCount: 6,
    region: "Singapore, Malaysia & Bali",
    zone: "Asia",
    interest: "Family",
    packageType: "Group Tour",
    startingPrice: 220000,
    emiPerMonth: 21421,
    rating: 5,
    reviewsCount: 16,
    guestsRated: "520+",
    guestPhotos: 0,
    route: [
      { state: "Indonesia", stops: ["Kuta (4N)", "Ubud", "Nusa Penida"] },
      { state: "Malaysia", stops: ["Kuala Lumpur (2N)", "Genting Highlands"] },
      { state: "Singapore", stops: ["Singapore (3N)"] },
    ],
    highlights: ["Tirta Empul", "Tanah Lot Sea Temple", "Nusa Penida", "Kelingking Beach", "Devdan Show", "White-water Rafting at Ayung River", "Observatory Deck of the K. L. Tower", "Genting Highlands", "Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum", "Universal Studios", "Wings of Time Show"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi"],
    dates: [
      { date: "Tue Nov 17, 2026", price: 227000 },
      { date: "Tue Feb 9, 2027", price: 220000, tag: "Lowest Price · Save ₹4,000" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Arrive in Bali · Kuta", state: "Indonesia", desc: "Arrive in Bali and transfer to Kuta for a four-night stay.", nights: 4 },
      { day: 2, title: "Kuta · Ubud · Kuta", state: "Indonesia", desc: "Explore Ubud and the cultural heart of Bali, including a visit to Tirta Empul.", highlights: ["Tirta Empul"] },
      { day: 3, title: "Kuta · Nusa Penida · Kuta", state: "Indonesia", desc: "Take an excursion to Nusa Penida, with its dramatic island scenery and Kelingking Beach.", highlights: ["Nusa Penida", "Kelingking Beach"] },
      { day: 4, title: "Kuta · River Rafting · Kuta", state: "Indonesia", desc: "Enjoy white-water rafting on the Ayung River, then experience the Devdan show.", highlights: ["White-water Rafting at Ayung River", "Devdan Show"] },
      { day: 5, title: "Kuta · Kuala Lumpur", state: "Indonesia · Malaysia", desc: "Fly from Bali to Kuala Lumpur and settle in for a two-night stay. See the city from the K. L. Tower observatory deck.", nights: 2, highlights: ["Observatory Deck of the K. L. Tower"] },
      { day: 6, title: "Kuala Lumpur · Genting Highlands · Kuala Lumpur", state: "Malaysia", desc: "Enjoy an excursion to Genting Highlands before returning to Kuala Lumpur.", highlights: ["Genting Highlands"] },
      { day: 7, title: "Kuala Lumpur · Singapore", state: "Malaysia · Singapore", desc: "Continue to Singapore and check in for a three-night stay.", nights: 3 },
      { day: 8, title: "Singapore", state: "Singapore", desc: "Visit Gardens by the Bay and Mandai Bird Paradise, then enjoy the Sentosa cable car and Madame Tussauds.", highlights: ["Gardens by the Bay", "Mandai Bird Paradise", "Sentosa Island Cable Car Ride", "Madame Tussauds Wax Museum"] },
      { day: 9, title: "Singapore · Universal Studios · Singapore", state: "Singapore", desc: "Spend the day at Universal Studios and enjoy the Wings of Time show.", highlights: ["Universal Studios", "Wings of Time Show"] },
      { day: 10, title: "Singapore · Departure", state: "Singapore", desc: "Transfer to the airport for your onward journey. The tour concludes in Singapore." },
    ],
  },
  {
    slug: "seniors-special-vietnam-cambodia",
    title: "Senior's Special Vietnam Cambodia",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASZVO",
    tourType: "GROUP TOUR",
    speciality: "Seniors' Special",
    allInclusive: true,
    popularToday: true,
    days: 11,
    nights: 10,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 6,
    region: "Vietnam & Cambodia",
    zone: "Asia",
    interest: "Seniors' Special",
    packageType: "Group Tour",
    startingPrice: 223000,
    emiPerMonth: 21714,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Vietnam", stops: ["Hanoi (1N)", "Halong Bay Cruise (1N)", "Da Nang (3N)", "Hoi An", "Ho Chi Minh City (2N)"] },
      { state: "Cambodia", stops: ["Siem Reap (3N)"] },
    ],
    highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Temple of Literature", "Musical Water Puppet Show", "Halong Bay Overnight Cruise", "Sun World Ba Na Hills", "Golden Bridge", "Monkey Mountain", "Marble Mountains", "Lantern Boat Ride", "Angkor Wat Temples", "Banteay Srei", "Cambodian Circus", "Traditional Cambodian Massage", "Apsara Dance Show with Dinner", "War Crime Museum", "Mekong River Delta", "Unicorn Island", "Vinh Trang Pagoda", "Honey Tea Farm and Fruit Farm", "Coconut Candy Factory", "Cu Chi Tunnels"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi"],
    dates: [
      { date: "Sun Nov 29, 2026", price: 223000, tag: "Lowest Price" },
    ],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Hanoi City Tour", state: "Vietnam", desc: "Arrive in Hanoi and explore the Ho Chi Minh Complex, One Pillar Pagoda and Temple of Literature. In the evening, enjoy a traditional water puppet show.", nights: 1, highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Temple of Literature", "Musical Water Puppet Show"] },
      { day: 2, title: "Hanoi · Halong Bay Overnight Cruise", state: "Vietnam", desc: "Travel to Halong Bay and board an overnight cruise among its limestone islands and emerald waters.", nights: 1, highlights: ["Halong Bay Overnight Cruise"] },
      { day: 3, title: "Halong Bay · Hanoi · Da Nang", state: "Vietnam", desc: "Enjoy the bay and a morning Tai Chi session before returning to Hanoi for your flight to Da Nang.", nights: 3 },
      { day: 4, title: "Da Nang · Ba Na Hills · Golden Bridge", state: "Vietnam", desc: "Ride the cable car to Sun World Ba Na Hills and visit the Golden Bridge, then see Marble Mountains and Monkey Mountain.", highlights: ["Sun World Ba Na Hills", "Golden Bridge", "Marble Mountains", "Monkey Mountain"] },
      { day: 5, title: "Da Nang · Hoi An", state: "Vietnam", desc: "Visit Cam Thanh Coconut Village and take a basket boat ride, then explore Hoi An's ancient town and enjoy a lantern boat ride.", highlights: ["Cam Thanh Coconut Village", "Basket Boat Ride", "Lantern Boat Ride"] },
      { day: 6, title: "Da Nang · Siem Reap", state: "Vietnam · Cambodia", desc: "Fly to Siem Reap. Enjoy a traditional Cambodian massage and an Apsara dance show with dinner.", nights: 3, highlights: ["Traditional Cambodian Massage", "Apsara Dance Show with Dinner"] },
      { day: 7, title: "Siem Reap · Angkor Wat", state: "Cambodia", desc: "Explore Angkor Thom, Bayon, Ta Prohm and the magnificent Angkor Wat temple complex.", highlights: ["Angkor Wat Temples"] },
      { day: 8, title: "Siem Reap · Banteay Srei", state: "Cambodia", desc: "Visit Banteay Srei and other historic temples, followed by a performance at the Cambodian Circus.", highlights: ["Banteay Srei", "Cambodian Circus"] },
      { day: 9, title: "Siem Reap · Ho Chi Minh City", state: "Cambodia · Vietnam", desc: "Fly to Ho Chi Minh City and visit the War Crime Museum and city landmarks.", nights: 2, highlights: ["War Crime Museum"] },
      { day: 10, title: "Ho Chi Minh City · Mekong Delta", state: "Vietnam", desc: "Explore the Mekong River Delta, visit Vinh Trang Pagoda, Unicorn Island, a honey tea and fruit farm, and a coconut candy factory.", highlights: ["Mekong River Delta", "Unicorn Island", "Vinh Trang Pagoda", "Honey Tea Farm and Fruit Farm", "Coconut Candy Factory"] },
      { day: 11, title: "Ho Chi Minh City · Cu Chi Tunnels · Departure", state: "Vietnam", desc: "Visit the historic Cu Chi Tunnels, then transfer to the airport for your onward journey.", highlights: ["Cu Chi Tunnels"] },
    ],
  },
  {
    slug: "womens-special-vietnam-cambodia",
    title: "Women's Special Vietnam Cambodia",
    scope: "world",
    image: U("1525625293386-3f8f99389edd"),
    gallery: [U("1525625293386-3f8f99389edd"), U("1508009603885-50cf7c579365"), U("1565967511849-76a60a516170")],
    code: "ASWVO",
    tourType: "GROUP TOUR",
    speciality: "Women's Special",
    allInclusive: true,
    popularToday: true,
    days: 11,
    nights: 10,
    countriesCount: 2,
    statesCount: 2,
    citiesCount: 6,
    region: "Vietnam & Cambodia",
    zone: "Asia",
    interest: "Women's Special",
    packageType: "Group Tour",
    startingPrice: 226000,
    emiPerMonth: 21986,
    rating: null,
    reviewsCount: 0,
    guestsRated: null,
    guestPhotos: 0,
    route: [
      { state: "Vietnam", stops: ["Hanoi (1N)", "Halong Bay Cruise (1N)", "Da Nang (3N)", "Hoi An", "Ho Chi Minh City (2N)"] },
      { state: "Cambodia", stops: ["Siem Reap (3N)"] },
    ],
    highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Temple of Literature", "Musical Water Puppet Show", "Halong Bay Overnight Cruise", "Sun World Ba Na Hills", "Golden Bridge", "Marble Mountains", "Monkey Mountain", "Cam Thanh Coconut Village", "Basket Boat Ride", "Lantern Boat Ride", "Traditional Cambodian Massage", "Apsara Dance Show with Dinner", "Angkor Wat", "Banteay Srei", "War Crime Museum", "Mekong River Delta Boat Ride", "Vinh Trang Pagoda", "Honey Tea Farm and Fruit Farm", "Coconut Candy Factory", "Cu Chi Tunnels"],
    departureCity: "Mumbai",
    departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi"],
    dates: [],
    inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
    itinerary: [
      { day: 1, title: "Hanoi City Tour", state: "Vietnam", desc: "Arrive in Hanoi and explore the Ho Chi Minh Complex, One Pillar Pagoda and Temple of Literature. In the evening, enjoy a traditional water puppet show.", nights: 1, highlights: ["Ho Chi Minh Complex", "One Pillar Pagoda", "Temple of Literature", "Musical Water Puppet Show"] },
      { day: 2, title: "Hanoi · Halong Bay Overnight Cruise", state: "Vietnam", desc: "Travel to Halong Bay and board an overnight cruise among its limestone islands and emerald waters.", nights: 1, highlights: ["Halong Bay Overnight Cruise"] },
      { day: 3, title: "Halong Bay · Hanoi · Da Nang", state: "Vietnam", desc: "Enjoy the bay and a morning Tai Chi session before returning to Hanoi for your flight to Da Nang.", nights: 3 },
      { day: 4, title: "Da Nang · Ba Na Hills · Golden Bridge", state: "Vietnam", desc: "Ride the cable car to Sun World Ba Na Hills and visit the Golden Bridge, then see Marble Mountains and Monkey Mountain.", highlights: ["Sun World Ba Na Hills", "Golden Bridge", "Marble Mountains", "Monkey Mountain"] },
      { day: 5, title: "Da Nang · Hoi An", state: "Vietnam", desc: "Visit Cam Thanh Coconut Village and take a basket boat ride, then explore Hoi An's ancient town and enjoy a lantern boat ride.", highlights: ["Cam Thanh Coconut Village", "Basket Boat Ride", "Lantern Boat Ride"] },
      { day: 6, title: "Da Nang · Siem Reap", state: "Vietnam · Cambodia", desc: "Fly to Siem Reap. Enjoy a traditional Cambodian massage and an Apsara dance show with dinner.", nights: 3, highlights: ["Traditional Cambodian Massage", "Apsara Dance Show with Dinner"] },
      { day: 7, title: "Siem Reap · Angkor Wat", state: "Cambodia", desc: "Explore Angkor Thom, Bayon, Ta Prohm and the magnificent Angkor Wat temple complex.", highlights: ["Angkor Wat"] },
      { day: 8, title: "Siem Reap · Banteay Srei", state: "Cambodia", desc: "Visit Banteay Srei and other historic temples, followed by a performance at the Cambodian Circus.", highlights: ["Banteay Srei", "Cambodian Circus"] },
      { day: 9, title: "Siem Reap · Ho Chi Minh City", state: "Cambodia · Vietnam", desc: "Fly to Ho Chi Minh City and visit the War Crime Museum and city landmarks.", nights: 2, highlights: ["War Crime Museum"] },
      { day: 10, title: "Ho Chi Minh City · Mekong Delta", state: "Vietnam", desc: "Explore the Mekong River Delta, visit Vinh Trang Pagoda, Unicorn Island, a honey tea and fruit farm, and a coconut candy factory.", highlights: ["Mekong River Delta", "Vinh Trang Pagoda", "Honey Tea Farm and Fruit Farm", "Coconut Candy Factory"] },
      { day: 11, title: "Ho Chi Minh City · Cu Chi Tunnels · Departure", state: "Vietnam", desc: "Visit the historic Cu Chi Tunnels, then transfer to the airport for your onward journey.", highlights: ["Cu Chi Tunnels"] },
    ],
  },];


// Wonders of Japan package (Veena World code ASJD), styled with Royal Tours components.
WORLD_TOURS.push({
  slug: "wonders-of-japan-asjd",
  title: "Wonders of Japan",
  scope: "world",
  image: U("1493976040374-85c8e12f0c0e"),
  gallery: [U("1493976040374-85c8e12f0c0e"), U("1513407030348-c983a97b98d8"), U("1490806843957-31f4c9a91c65")],
  code: "ASJD",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 8,
  region: "Japan",
  zone: "Asia",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 235000,
  emiPerMonth: 22882,
  rating: null,
  reviewsCount: 0,
  guestsRated: null,
  guestPhotos: 0,
  route: [
    { state: "Japan", stops: ["Tokyo (1N)", "Hiroshima (1N)", "Osaka (3N)", "Kyoto", "Nagoya", "Shizuoka / Hakone (1N)", "Tokyo (2N)"] },
  ],
  highlights: ["Floating Torii Gate", "Hiroshima Peace Park", "Hiroshima History Museum", "Bomb Dome", "Bullet Train Ride", "Nara Deer Park", "Todaiji Temple", "Boat ride through Dotonbori (Tonbori) River", "Arashiyama Bamboo Grove", "Golden Pavilion", "Fushimi Inari Shrine", "Toyota Commemorative Museum of Industry and Technology", "SC Maglev Railway Park", "Lake Ashi Cruise", "Oshino Hakkai", "Mt. Fuji 5th Station", "TeamLab Planets", "Shibuya Crossing", "Shinjuku Garden", "Tokyo Skytree", "Asakusa Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrival in Tokyo", state: "Japan", desc: "Arrive in Tokyo, meet the tour team and settle in for your first night in Japan.", nights: 1 },
    { day: 2, title: "Tokyo · Miyajima · Hiroshima", state: "Japan", desc: "Travel to Hiroshima via Miyajima and visit the Floating Torii Gate before checking in for the night.", nights: 1, highlights: ["Floating Torii Gate"] },
    { day: 3, title: "Hiroshima · Osaka", state: "Japan", desc: "Visit Hiroshima Peace Park, the Hiroshima History Museum and the Bomb Dome, then continue to Osaka for a three-night stay.", nights: 3, highlights: ["Hiroshima Peace Park", "Hiroshima History Museum", "Bomb Dome", "Bullet Train Ride"] },
    { day: 4, title: "Osaka · Nara · Osaka", state: "Japan", desc: "Visit Nara Deer Park and Todaiji Temple, then return to Osaka for a boat ride through the Dotonbori River area.", highlights: ["Nara Deer Park", "Todaiji Temple", "Boat ride through Dotonbori (Tonbori) River"] },
    { day: 5, title: "Osaka · Kyoto · Osaka", state: "Japan", desc: "Explore Kyoto's Arashiyama Bamboo Grove, Golden Pavilion and Fushimi Inari Shrine before returning to Osaka.", highlights: ["Arashiyama Bamboo Grove", "Golden Pavilion", "Fushimi Inari Shrine"] },
    { day: 6, title: "Osaka · Nagoya · Shizuoka / Hakone", state: "Japan", desc: "Visit the Toyota Commemorative Museum of Industry and Technology and SC Maglev Railway Park, then continue to Shizuoka or Hakone for the night.", nights: 1, highlights: ["Toyota Commemorative Museum of Industry and Technology", "SC Maglev Railway Park"] },
    { day: 7, title: "Shizuoka / Hakone · Mt. Fuji · Tokyo", state: "Japan", desc: "Enjoy a Lake Ashi cruise, visit Oshino Hakkai and Mt. Fuji's 5th Station as conditions permit, then travel to Tokyo for a two-night stay.", nights: 2, highlights: ["Lake Ashi Cruise", "Oshino Hakkai", "Mt. Fuji 5th Station"] },
    { day: 8, title: "Tokyo", state: "Japan", desc: "Discover TeamLab Planets, Shibuya Crossing, Shinjuku Garden, Tokyo Skytree and Asakusa Temple.", highlights: ["TeamLab Planets", "Shibuya Crossing", "Shinjuku Garden", "Tokyo Skytree", "Asakusa Temple"] },
    { day: 9, title: "Tokyo · Departure", state: "Japan", desc: "Transfer to the airport for your onward journey. The tour concludes in Tokyo." },
  ],
});
WORLD_TOURS.push({
  slug: "greece-athens-santorini-rhodes-eugj",
  title: "Greece Athens Santorini Rhodes",
  scope: "world",
  image: U("1533105079780-92b9be482077"),
  gallery: [U("1533105079780-92b9be482077"), U("1601581875309-fafbf2d3ed3a"), U("1516483638261-f4dbaf036963")],
  code: "EUGJ",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Greece",
  zone: "Europe",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 315000,
  emiPerMonth: 30675,
  rating: 5,
  reviewsCount: 34,
  guestsRated: "30+",
  guestPhotos: 0,
  route: [
    { state: "Greece", stops: ["Athens (1N)", "Overnight Ferry to Rhodes (1N)", "Rhodes (3N)", "Symi", "Santorini (2N)", "Athens (1N)"] },
  ],
  highlights: ["Plaka walking tour", "Hadrian’s Arch", "Olympic Stadium", "Temple of Zeus", "Acropolis", "Parthenon", "Nestoridio Art Gallery", "Helios 9D experience", "Palace of the Grand Master", "Filerimos Hill", "Monastery of Archangel Michael", "Traditional Greek Night", "Kallithea Springs", "Fira town walk", "Santorini winery visit", "Akrotiri archaeological site", "Prophet Ilias Monastery", "Black Beach", "Megalochori village"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Athens", state: "Greece", desc: "Arrive in Athens, meet the tour team and settle in for your first night in Greece.", nights: 1 },
    { day: 2, title: "Athens · Overnight Ferry to Rhodes", state: "Greece", desc: "Explore Athens, including a Plaka walking tour and the city’s classical landmarks, before boarding the overnight ferry to Rhodes.", nights: 1, highlights: ["Plaka walking tour", "Hadrian’s Arch", "Olympic Stadium", "Temple of Zeus", "Acropolis", "Parthenon"] },
    { day: 3, title: "Rhodes", state: "Greece", desc: "Arrive in Rhodes and visit Nestoridio Art Gallery, enjoy the Helios 9D experience and explore the Palace of the Grand Master.", nights: 3, highlights: ["Nestoridio Art Gallery", "Helios 9D experience", "Palace of the Grand Master"] },
    { day: 4, title: "Rhodes · Symi · Rhodes", state: "Greece", desc: "Take an excursion to Symi and visit the Monastery of Archangel Michael. Return to Rhodes for a traditional Greek night.", highlights: ["Symi Island", "Monastery of Archangel Michael", "Traditional Greek Night"] },
    { day: 5, title: "Rhodes", state: "Greece", desc: "Explore Filerimos Hill and Monastery and relax at Kallithea Springs.", highlights: ["Filerimos Hill", "Kallithea Springs"] },
    { day: 6, title: "Rhodes · Santorini", state: "Greece", desc: "Travel from Rhodes to Santorini and settle in for a two-night island stay.", nights: 2 },
    { day: 7, title: "Santorini", state: "Greece", desc: "Explore Fira, visit a local winery and discover Akrotiri archaeological site, Prophet Ilias Monastery, Black Beach and Megalochori village.", highlights: ["Fira town walk", "Santorini winery visit", "Akrotiri archaeological site", "Prophet Ilias Monastery", "Black Beach", "Megalochori village"] },
    { day: 8, title: "Santorini · Athens", state: "Greece", desc: "Return to Athens and stay overnight before your departure.", nights: 1 },
    { day: 9, title: "Athens · Departure", state: "Greece", desc: "Transfer to the airport for your onward journey. The tour concludes in Athens." },
  ],
});
WORLD_TOURS.push({
  slug: "swiss-paris-italy-eust",
  title: "Swiss Paris Italy",
  scope: "world",
  image: U("1523906834658-6e24ef2386f9"),
  gallery: [U("1523906834658-6e24ef2386f9"), U("1500530855697-b586d89ba3ee")],
  code: "EUST",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 11,
  nights: 10,
  countriesCount: 4,
  statesCount: 4,
  citiesCount: 16,
  region: "Italy, Switzerland & France",
  zone: "Europe",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 320000,
  emiPerMonth: 32000,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Italy", stops: ["Rome", "Pisa", "Venice", "Lake Como"] },
    { state: "Vatican City", stops: ["Vatican City"] },
    { state: "Switzerland", stops: ["Lucerne", "Mt. Titlis", "Jungfraujoch", "Interlaken", "Bern", "Vevey", "Geneva"] },
    { state: "France", stops: ["Paris", "Versailles", "Disneyland Paris"] },
  ],
  highlights: [
    "Trevi Fountain", "Piazza Venezia", "Photo stop at Colosseum", "Vatican City", "Photo stop at St. Peter's Basilica", "Vatican Square",
    "Photo stop at Leaning Tower of Pisa", "Square of Miracles", "Venice Gondola Ride", "Bridge of Sighs", "Doge's Palace", "St. Mark's Square",
    "Bell Tower", "Lake Como", "Mt. Titlis", "Titlis Rotair", "Ice Grotto", "Ice Flyer Ride", "Mt. Titlis Cliff Walk",
    "Lucerne Lion Monument", "Kappelbrucke Bridge", "Lake Lucerne Cruise", "Jungfraujoch", "Eiger Express", "Ice Palace",
    "Sphinx Terrace", "Interlaken", "Bern Clock Tower", "Old Town Bern", "Einsteinhaus", "Vevey Chaplin's World",
    "Jet d'Eau", "Lake Geneva", "Flower Clock", "Eiffel Tower", "Versailles Palace", "Hall of Mirrors", "Louvre Museum",
    "Champs-Élysées", "Arc de Triomphe", "Place de la Concorde", "Disneyland Paris", "Seine River Cruise",
  ],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Rome", state: "Italy", desc: "Arrive in Rome and settle in. Daywise travel sequence below is an approximate outline based on the official package highlights.", nights: 1 },
    { day: 2, title: "Rome and Vatican City", state: "Italy", desc: "See Rome's historic landmarks, including Trevi Fountain, Piazza Venezia and a photo stop at the Colosseum, then visit Vatican City.", nights: 1, highlights: ["Trevi Fountain", "Piazza Venezia", "Colosseum", "St. Peter's Basilica"] },
    { day: 3, title: "Pisa and Venice", state: "Italy", desc: "Visit Pisa's Square of Miracles and see the Leaning Tower before continuing to Venice.", nights: 1, highlights: ["Leaning Tower of Pisa", "Square of Miracles"] },
    { day: 4, title: "Discover Venice", state: "Italy", desc: "Explore Venice's landmark square and palaces, with a gondola ride through its canals.", nights: 1, highlights: ["Venice Gondola Ride", "Bridge of Sighs", "Doge's Palace", "St. Mark's Square"] },
    { day: 5, title: "Lake Como and Switzerland", state: "Switzerland", desc: "Take in Lake Como and continue into Switzerland. The daywise routing is approximate.", highlights: ["Lake Como"] },
    { day: 6, title: "Mt. Titlis and Lucerne", state: "Switzerland", desc: "Enjoy the Titlis Rotair and mountain attractions, then see Lucerne's old town and lakeside sights.", nights: 1, highlights: ["Mt. Titlis", "Titlis Rotair", "Ice Grotto", "Ice Flyer Ride", "Mt. Titlis Cliff Walk", "Lucerne Lion Monument", "Kappelbrucke Bridge"] },
    { day: 7, title: "Jungfraujoch and Interlaken", state: "Switzerland", desc: "Take in the Jungfraujoch mountain experience and time in Interlaken.", nights: 1, highlights: ["Eiger Express", "Ice Palace", "Sphinx Terrace", "Interlaken"] },
    { day: 8, title: "Bern, Vevey and Lake Geneva", state: "Switzerland", desc: "See highlights around Bern and Lake Geneva, including Chaplin's World and Geneva's lakeside landmarks.", nights: 1, highlights: ["Bern Clock Tower", "Old Town Bern", "Einsteinhaus", "Chaplin's World", "Jet d'Eau", "Flower Clock"] },
    { day: 9, title: "Continue to Paris", state: "France", desc: "Travel onward to Paris and enjoy an introductory view of the city.", nights: 1, highlights: ["Paris"] },
    { day: 10, title: "Paris and Versailles", state: "France", desc: "Explore Paris landmarks, visit Versailles, and enjoy the Seine River Cruise. Disneyland Paris is also included among the package highlights.", nights: 1, highlights: ["Eiffel Tower", "Versailles Palace", "Hall of Mirrors", "Louvre Museum", "Champs-Élysées", "Arc de Triomphe", "Disneyland Paris", "Seine River Cruise"] },
    { day: 11, title: "Depart from Paris", state: "France", desc: "Conclude the tour and depart from Paris.", highlights: ["Paris"] },
  ],
});
WORLD_TOURS.push({
  slug: "european-highlights-euhl",
  title: "European Highlights",
  scope: "world",
  image: U("1513635269975-59663e0ac1ad"),
  gallery: [U("1513635269975-59663e0ac1ad"), U("1502602898657-3e91760cbb34"), U("1511739001486-6bfe10ce785f")],
  code: "EUHL",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 11,
  nights: 10,
  countriesCount: 11,
  statesCount: 11,
  citiesCount: 16,
  region: "Europe",
  zone: "Europe",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 327000,
  emiPerMonth: 32700,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "United Kingdom", stops: ["London"] },
    { state: "France", stops: ["Paris"] },
    { state: "Netherlands", stops: ["Amsterdam", "Madurodam"] },
    { state: "Belgium", stops: ["Brussels"] },
    { state: "Luxembourg", stops: ["Luxembourg City"] },
    { state: "Germany", stops: ["Titisee", "Rhine Falls"] },
    { state: "Switzerland", stops: ["Lucerne", "Zurich", "Mt. Titlis"] },
    { state: "Liechtenstein", stops: ["Vaduz"] },
    { state: "Austria", stops: ["Wattens", "Innsbruck"] },
    { state: "Italy", stops: ["Venice", "Bologna", "Rome"] },
    { state: "Vatican City", stops: ["Vatican City"] },
  ],
  highlights: [
    "London Eye", "Madame Tussauds Wax Museum", "Top level of the Eiffel Tower", "Seine River Cruise",
    "Miniature park of Holland – Madurodam", "Amsterdam Canal Cruise", "Luxembourg Tram Tour", "Rhine Falls Boat Ride",
    "Mt. Titlis Rotair", "Lake Lucerne Cruise", "Vaduz City Tram", "Swarovski Crystal World and Museum",
    "Golden Roof Innsbruck", "Vaporetto water bus ride to Venice Island", "Venice Gondola Ride", "Trevi Fountain",
  ],
  departureCity: "London",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in London", state: "United Kingdom", desc: "Arrive in London and settle in for a two-night stay.", nights: 2 },
    { day: 2, title: "Explore London", state: "United Kingdom", desc: "See London from the London Eye and visit Madame Tussauds Wax Museum.", highlights: ["London Eye", "Madame Tussauds Wax Museum"] },
    { day: 3, title: "London to Paris", state: "France", desc: "Travel from London to Paris and see the Eiffel Tower from its top level.", nights: 1, highlights: ["Top level of the Eiffel Tower"] },
    { day: 4, title: "Paris to Amsterdam", state: "Netherlands", desc: "Enjoy a Seine River Cruise before continuing to Amsterdam.", nights: 1, highlights: ["Seine River Cruise"] },
    { day: 5, title: "Amsterdam, Brussels and Luxembourg", state: "Luxembourg", desc: "Visit Madurodam and cruise Amsterdam's canals, then travel via Brussels to Luxembourg for a tram tour.", nights: 1, highlights: ["Madurodam", "Amsterdam Canal Cruise", "Brussels", "Luxembourg Tram Tour"] },
    { day: 6, title: "Luxembourg, Titisee, Rhine Falls and Lucerne/Zurich", state: "Switzerland", desc: "Travel through Titisee and enjoy a boat ride at Rhine Falls before reaching Lucerne or Zurich.", nights: 2, highlights: ["Rhine Falls Boat Ride"] },
    { day: 7, title: "Mt. Titlis and Lucerne", state: "Switzerland", desc: "Experience Mt. Titlis by Rotair and take a cruise on Lake Lucerne.", highlights: ["Mt. Titlis Rotair", "Lake Lucerne Cruise"] },
    { day: 8, title: "Lucerne/Zurich, Vaduz, Wattens and Innsbruck", state: "Austria", desc: "Visit Vaduz and its city tram, see Swarovski Crystal World and Museum in Wattens, then continue to Innsbruck.", nights: 1, highlights: ["Vaduz City Tram", "Swarovski Crystal World and Museum", "Golden Roof Innsbruck"] },
    { day: 9, title: "Innsbruck, Venice and Bologna", state: "Italy", desc: "Travel to Venice, take a vaporetto water bus to the island and enjoy a gondola ride, then continue to Bologna.", nights: 1, highlights: ["Vaporetto water bus ride to Venice Island", "Venice Gondola Ride"] },
    { day: 10, title: "Bologna to Rome", state: "Italy", desc: "Continue from Bologna to Rome and visit the Trevi Fountain.", nights: 1, highlights: ["Trevi Fountain"] },
    { day: 11, title: "Rome and Vatican, departure", state: "Italy", desc: "Visit Vatican City before the tour concludes with departure from Rome.", highlights: ["Vatican City"] },
  ],
});
WORLD_TOURS.push({
  slug: "european-wonders-eunr",
  title: "European Wonders",
  scope: "world",
  image: U("1502602898657-3e91760cbb34"),
  gallery: [U("1502602898657-3e91760cbb34"), U("1500530855697-b586d89ba3ee"), U("1523906834658-6e24ef2386f9")],
  code: "EUNR",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 13,
  nights: 12,
  countriesCount: 11,
  statesCount: 11,
  citiesCount: 21,
  region: "Europe",
  zone: "Europe",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 340000,
  emiPerMonth: 34000,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "France", stops: ["Paris"] },
    { state: "Netherlands", stops: ["Amsterdam", "Madurodam"] },
    { state: "Belgium", stops: ["Brussels"] },
    { state: "Luxembourg", stops: ["Luxembourg City"] },
    { state: "Germany", stops: ["Titisee", "Rhine Falls"] },
    { state: "Switzerland", stops: ["Zurich", "Lucerne", "Engelberg", "Mt. Titlis", "Jungfraujoch", "Interlaken"] },
    { state: "Liechtenstein", stops: ["Vaduz"] },
    { state: "Austria", stops: ["Salzburg", "Wattens", "Innsbruck"] },
    { state: "Italy", stops: ["Venice", "Ferrara", "Pisa", "Milan", "Rome"] },
    { state: "San Marino", stops: ["San Marino City"] },
    { state: "Vatican City", stops: ["Vatican City"] },
  ],
  highlights: [
    "Top level of the Eiffel Tower", "Seine River Cruise", "Miniature park of Holland – Madurodam", "Amsterdam Canal Cruise",
    "Luxembourg Tram Ride", "Cuckoo Clock Shop", "Rhine Falls Boat Ride", "Mt. Titlis Rotair Cable Car",
    "Lake Lucerne Cruise", "Jungfraujoch Excursion", "Vaduz City Tram", "Mirabell Gardens",
    "Swarovski Crystal World and Museum", "Vaporetto water bus ride to Venice Island", "Venice Gondola Ride",
    "Leaning Tower of Pisa", "Trevi Fountain",
  ],
  departureCity: "Paris",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Paris", state: "France", desc: "Arrive in Paris and settle in for a two-night stay.", nights: 2 },
    { day: 2, title: "Paris", state: "France", desc: "Enjoy Paris highlights, including the Eiffel Tower's top level and a Seine River Cruise.", highlights: ["Top level of the Eiffel Tower", "Seine River Cruise"] },
    { day: 3, title: "Paris to Amsterdam", state: "Netherlands", desc: "Continue from Paris to Amsterdam and visit the Madurodam miniature park.", nights: 1, highlights: ["Madurodam"] },
    { day: 4, title: "Amsterdam, Brussels and Luxembourg", state: "Luxembourg", desc: "Cruise Amsterdam's canals, pass through Brussels, and explore Luxembourg by tram.", nights: 1, highlights: ["Amsterdam Canal Cruise", "Luxembourg Tram Ride"] },
    { day: 5, title: "Luxembourg, Titisee, Rhine Falls and Lucerne/Zurich", state: "Switzerland", desc: "Travel via Titisee and the Rhine Falls boat ride to the Lucerne or Zurich area for a three-night Swiss stay.", nights: 3, highlights: ["Cuckoo Clock Shop", "Rhine Falls Boat Ride"] },
    { day: 6, title: "Mt. Titlis and Lucerne", state: "Switzerland", desc: "Take the Rotair cable car to Mt. Titlis and enjoy a Lake Lucerne cruise.", highlights: ["Mt. Titlis Rotair Cable Car", "Lake Lucerne Cruise"] },
    { day: 7, title: "Jungfraujoch excursion", state: "Switzerland", desc: "Discover the Jungfraujoch region and nearby Alpine towns.", highlights: ["Jungfraujoch Excursion", "Interlaken"] },
    { day: 8, title: "Vaduz, Wattens and Innsbruck", state: "Austria", desc: "Visit Vaduz, Swarovski Crystal World and Museum, and Innsbruck's Golden Roof.", nights: 1, highlights: ["Vaduz City Tram", "Swarovski Crystal World and Museum", "Golden Roof Innsbruck"] },
    { day: 9, title: "Innsbruck, Venice and Ferrara", state: "Italy", desc: "Continue to Venice, take a vaporetto to the island and enjoy a gondola ride before reaching Ferrara.", nights: 1, highlights: ["Vaporetto water bus ride to Venice Island", "Venice Gondola Ride"] },
    { day: 10, title: "Ferrara, San Marino and Rome", state: "Italy", desc: "Travel via San Marino City to Rome.", nights: 1, highlights: ["San Marino City"] },
    { day: 11, title: "Rome", state: "Italy", desc: "Explore Rome and visit the Trevi Fountain.", nights: 1, highlights: ["Trevi Fountain", "Vatican City"] },
    { day: 12, title: "Pisa and Milan", state: "Italy", desc: "See the Leaning Tower of Pisa and continue to Milan.", nights: 1, highlights: ["Leaning Tower of Pisa"] },
    { day: 13, title: "Depart from Milan", state: "Italy", desc: "Conclude the tour and depart from Milan.", highlights: ["Milan"] },
  ],
});
WORLD_TOURS.push({
  slug: "womens-special-australia-auwg",
  title: "Women's Special Australia",
  scope: "world",
  image: U("1506976785307-8732e854ad03"),
  gallery: [U("1506976785307-8732e854ad03"), U("1514395462725-fb4566210144"), U("1501594907352-04cda38ebc29")],
  code: "AUWG",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Australia",
  zone: "Australia & New Zealand",
  interest: "Women's Special",
  packageType: "Group Tour",
  startingPrice: 349108,
  emiPerMonth: 34911,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Australia", stops: ["Sydney", "Brisbane", "Gold Coast", "Cairns", "Great Barrier Reef", "Melbourne", "Phillip Island"] },
  ],
  highlights: [
    "Expert tour manager throughout the tour", "All meals included", "Music, fun and games every day",
    "Sydney", "Gold Coast", "Cairns", "Great Barrier Reef", "Melbourne",
  ],
  departureCity: "Sydney",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Sydney", state: "Australia", desc: "Arrive in Sydney and settle in. The route below is a sample outline based on the package's Australian city coverage; confirm the detailed sequence for your chosen departure.", nights: 2 },
    { day: 2, title: "Sydney", state: "Australia", desc: "Enjoy a full day to discover Sydney with the tour group.", highlights: ["Sydney"] },
    { day: 3, title: "Sydney to the Gold Coast", state: "Australia", desc: "Continue north via Brisbane to the Gold Coast for a two-night stay.", nights: 2, highlights: ["Brisbane", "Gold Coast"] },
    { day: 4, title: "Gold Coast", state: "Australia", desc: "Enjoy time on the Gold Coast with the group.", highlights: ["Gold Coast"] },
    { day: 5, title: "Gold Coast to Cairns", state: "Australia", desc: "Travel to Cairns and settle in for a two-night stay.", nights: 2, highlights: ["Cairns"] },
    { day: 6, title: "Cairns and Great Barrier Reef", state: "Australia", desc: "Explore the Cairns region and the Great Barrier Reef.", highlights: ["Cairns", "Great Barrier Reef"] },
    { day: 7, title: "Cairns to Melbourne", state: "Australia", desc: "Fly to Melbourne and settle in for a two-night stay.", nights: 2, highlights: ["Melbourne"] },
    { day: 8, title: "Melbourne and Phillip Island", state: "Australia", desc: "Enjoy Melbourne and the surrounding region with the group.", highlights: ["Melbourne", "Phillip Island"] },
    { day: 9, title: "Departure", state: "Australia", desc: "Conclude the tour and depart for your onward journey.", highlights: ["Australia"] },
  ],
});
WORLD_TOURS.push({
  slug: "best-of-australia-ausg",
  title: "Best of Australia",
  scope: "world",
  image: U("1506976785307-8732e854ad03"),
  gallery: [U("1506976785307-8732e854ad03"), U("1514395462725-fb4566210144"), U("1501594907352-04cda38ebc29")],
  code: "AUSG",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Australia",
  zone: "Australia & New Zealand",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 349108,
  emiPerMonth: 34911,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "New South Wales", stops: ["Sydney"] },
    { state: "Queensland", stops: ["Brisbane", "Gold Coast", "Cairns", "Great Barrier Reef"] },
    { state: "Victoria", stops: ["Melbourne", "Great Ocean Road", "Phillip Island"] },
  ],
  highlights: [
    "Sydney Cricket Ground", "Sydney Tower Observatory Deck", "Darling Harbour", "Sea Life Aquarium",
    "Sydney Opera House Tour", "Sydney Harbour Cruise", "Jet Boat Ride", "Currumbin Wildlife Sanctuary",
    "Sea World Gold Coast", "Surfers Paradise", "Kuranda Rainforest", "Skyrail Cableway",
    "Pamagirri Aboriginal Experience", "Army Duck Tour", "Great Barrier Reef Cruise",
    "Melbourne City Circle Tram", "Phillip Island Penguin Parade", "Great Ocean Road", "Twelve Apostles",
    "Helicopter Ride", "Fitzroy Gardens", "Captain Cook's Cottage",
  ],
  departureCity: "Sydney",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Sydney", state: "New South Wales", desc: "Arrive in Sydney and settle in for a two-night stay.", nights: 2 },
    { day: 2, title: "Explore Sydney", state: "New South Wales", desc: "See Sydney's sporting and harbour landmarks, visit the Sea Life Aquarium and tour the Sydney Opera House before a harbour cruise.", highlights: ["Sydney Cricket Ground", "Sydney Tower Observatory Deck", "Darling Harbour", "Sea Life Aquarium", "Sydney Opera House Tour", "Sydney Harbour Cruise"] },
    { day: 3, title: "Sydney, Brisbane and Gold Coast", state: "Queensland", desc: "Travel via Brisbane to the Gold Coast and settle in for a two-night stay.", nights: 2, highlights: ["Brisbane", "Gold Coast"] },
    { day: 4, title: "Gold Coast", state: "Queensland", desc: "Enjoy Gold Coast attractions and time at Surfers Paradise.", highlights: ["Jet Boat Ride", "Currumbin Wildlife Sanctuary", "Sea World Gold Coast", "Surfers Paradise"] },
    { day: 5, title: "Gold Coast to Cairns", state: "Queensland", desc: "Fly to Cairns and settle in for a two-night stay.", nights: 2, highlights: ["Cairns"] },
    { day: 6, title: "Cairns and the Great Barrier Reef", state: "Queensland", desc: "Enjoy a Great Barrier Reef cruise and discover the Kuranda rainforest region.", highlights: ["Great Barrier Reef Cruise", "Kuranda Rainforest", "Skyrail Cableway", "Pamagirri Aboriginal Experience", "Army Duck Tour"] },
    { day: 7, title: "Cairns to Melbourne", state: "Victoria", desc: "Fly to Melbourne and settle in for a two-night stay.", nights: 2, highlights: ["Melbourne"] },
    { day: 8, title: "Melbourne", state: "Victoria", desc: "Discover Melbourne by City Circle Tram and enjoy a visit to Phillip Island.", highlights: ["Melbourne City Circle Tram", "Phillip Island Penguin Parade", "Fitzroy Gardens", "Captain Cook's Cottage"] },
    { day: 9, title: "Great Ocean Road and departure", state: "Victoria", desc: "Travel along the Great Ocean Road, see the Twelve Apostles, and depart from Melbourne.", highlights: ["Great Ocean Road", "Twelve Apostles", "Helicopter Ride"] },
  ],
});
WORLD_TOURS.push({
  slug: "spain-portugal-eung",
  title: "Spain Portugal",
  scope: "world",
  image: U("1539037116277-4db20889f2d4"),
  gallery: [U("1539037116277-4db20889f2d4"), U("1555881400-74d7acaacd8b"), U("1502602898657-3e91760cbb34")],
  code: "EUNG",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 13,
  nights: 12,
  countriesCount: 2,
  statesCount: 2,
  citiesCount: 15,
  region: "Portugal & Spain",
  zone: "Europe",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 360000,
  emiPerMonth: 35000,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Portugal", stops: ["Porto", "Douro Valley", "Fátima", "Sintra", "Lisbon", "Algarve"] },
    { state: "Spain", stops: ["Seville", "Ronda", "Costa del Sol", "Mijas", "Granada", "Toledo", "Madrid", "Valencia", "Barcelona", "Montserrat"] },
  ],
  highlights: [
    "Praça da Ribeira", "Dom Luís I Bridge", "Clérigos Church", "Carmo Church", "Douro Valley", "Wine Tasting",
    "River Douro Boat Ride", "Sanctuary of Fátima", "Pena Palace", "Monument to the Discoveries", "Belém Tower",
    "Jerónimos Monastery", "Algarve Coast", "Sea Caves Boat Ride", "Catedral de Sevilla", "The Alcazar of Seville",
    "Plaza de España", "Flamenco Show", "Ronda Bullring", "Costa del Sol", "Mijas Burro-Taxi", "Avenida del Mar",
    "Alhambra Complex", "Mirador del Valle", "Santa Maria la Blanca", "Santiago Bernabéu Stadium",
    "Oceanogràfic València", "City of Arts and Sciences", "Park Güell", "Montserrat Monastery", "La Rambla",
  ],
  departureCity: "Porto",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Porto", state: "Portugal", desc: "Arrive in Porto and settle in for a two-night stay.", nights: 2 },
    { day: 2, title: "Porto and the Douro Valley", state: "Portugal", desc: "Explore Porto's riverside landmarks and the Douro Valley with a wine tasting and river boat ride.", highlights: ["Praça da Ribeira", "Dom Luís I Bridge", "Clérigos Church", "Carmo Church", "Douro Valley", "Wine Tasting", "River Douro Boat Ride"] },
    { day: 3, title: "Porto, Fátima and Lisbon", state: "Portugal", desc: "Visit the Sanctuary of Fátima and continue to Lisbon for a two-night stay.", nights: 2, highlights: ["Sanctuary of Fátima"] },
    { day: 4, title: "Lisbon and Sintra", state: "Portugal", desc: "Discover Lisbon's Belém landmarks and visit Pena Palace in Sintra.", highlights: ["Pena Palace", "Monument to the Discoveries", "Belém Tower", "Jerónimos Monastery"] },
    { day: 5, title: "Lisbon to the Algarve", state: "Portugal", desc: "Travel south along Portugal's coast and settle in the Algarve.", nights: 1, highlights: ["Algarve Coast"] },
    { day: 6, title: "Algarve to Seville", state: "Spain", desc: "Enjoy the Algarve sea caves boat ride before continuing to Seville for an overnight stay.", nights: 1, highlights: ["Sea Caves Boat Ride"] },
    { day: 7, title: "Seville and Costa del Sol", state: "Spain", desc: "Explore Seville's cathedral and Alcázar, with Plaza de España and a Flamenco show, then continue to Costa del Sol.", nights: 1, highlights: ["Catedral de Sevilla", "The Alcazar of Seville", "Plaza de España", "Flamenco Show"] },
    { day: 8, title: "Ronda, Mijas and Granada", state: "Spain", desc: "See Ronda and the Costa del Sol region, including Mijas, before continuing to Granada.", nights: 1, highlights: ["Ronda Bullring", "Costa del Sol", "Mijas Burro-Taxi", "Avenida del Mar"] },
    { day: 9, title: "Granada, Toledo and Madrid", state: "Spain", desc: "Visit the Alhambra Complex and travel via Toledo to Madrid for a two-night stay.", nights: 2, highlights: ["Alhambra Complex", "Mirador del Valle", "Santa Maria la Blanca"] },
    { day: 10, title: "Madrid", state: "Spain", desc: "Spend the day in Madrid and visit Santiago Bernabéu Stadium.", highlights: ["Santiago Bernabéu Stadium"] },
    { day: 11, title: "Madrid to Valencia", state: "Spain", desc: "Continue to Valencia and discover its Oceanogràfic and City of Arts and Sciences.", nights: 1, highlights: ["Oceanogràfic València", "City of Arts and Sciences"] },
    { day: 12, title: "Valencia to Barcelona", state: "Spain", desc: "Travel to Barcelona and explore Park Güell and La Rambla, with a visit to Montserrat.", nights: 1, highlights: ["Park Güell", "Montserrat Monastery", "La Rambla"] },
    { day: 13, title: "Depart from Barcelona", state: "Spain", desc: "Conclude the tour and depart for your onward journey.", highlights: ["Barcelona"] },
  ],
});
WORLD_TOURS.push({
  slug: "best-of-kenya-afke",
  title: "Best of Kenya",
  scope: "world",
  image: U("1516026672322-bc52d61a55d5"),
  gallery: [U("1516026672322-bc52d61a55d5"), U("1516426122078-c23e76319801"), U("1519659528534-7fd733a832a0")],
  code: "AFKE",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Kenya",
  zone: "Africa",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 296826,
  emiPerMonth: 28890,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Kenya", stops: ["Nairobi", "Nyahururu", "Lake Nakuru", "Lake Naivasha", "Masai Mara"] },
  ],
  highlights: [
    "Boat ride in Lake Naivasha", "Crescent Island", "Hell's Gate National Park", "View the majestic Thomson Falls",
    "Rhino Sanctuary", "Safari Game Drive in Masai Mara", "Masai village", "Ol Njorowa Gorge",
  ],
  departureCity: "Nairobi",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Nairobi", state: "Kenya", desc: "Arrive in Nairobi and settle in. The daywise route below is an approximate outline based on the official package highlights.", nights: 1 },
    { day: 2, title: "Nairobi to Nyahururu and Lake Nakuru", state: "Kenya", desc: "Travel through Kenya's highlands and stop to view the majestic Thomson Falls before reaching the Lake Nakuru region.", nights: 1, highlights: ["Thomson Falls"] },
    { day: 3, title: "Lake Nakuru and Lake Naivasha", state: "Kenya", desc: "Visit a rhino sanctuary and continue to Lake Naivasha.", nights: 1, highlights: ["Rhino Sanctuary"] },
    { day: 4, title: "Lake Naivasha and Hell's Gate", state: "Kenya", desc: "Enjoy a boat ride on Lake Naivasha, visit Crescent Island and explore Hell's Gate National Park and Ol Njorowa Gorge.", nights: 1, highlights: ["Boat ride in Lake Naivasha", "Crescent Island", "Hell's Gate National Park", "Ol Njorowa Gorge"] },
    { day: 5, title: "Lake Naivasha to Masai Mara", state: "Kenya", desc: "Travel to the Masai Mara and settle in for a two-night safari stay.", nights: 2, highlights: ["Masai Mara"] },
    { day: 6, title: "Masai Mara safari", state: "Kenya", desc: "Go on a safari game drive and visit a local Masai village.", highlights: ["Safari Game Drive in Masai Mara", "Masai village"] },
    { day: 7, title: "Masai Mara to Nairobi", state: "Kenya", desc: "Return to Nairobi for an overnight stay.", nights: 1 },
    { day: 8, title: "Depart from Nairobi", state: "Kenya", desc: "Conclude the tour and depart for your onward journey.", highlights: ["Nairobi"] },
  ],
});
WORLD_TOURS.push({
  slug: "jaipur-mandawa-rjjm",
  title: "Jaipur Mandawa",
  scope: "world",
  image: U("1599661046289-e31897846e41"),
  gallery: [U("1599661046289-e31897846e41"), U("1567157577867-05ccb1388e66"), U("1564507592333-c60657eea523")],
  code: "RJJM",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Rajasthan",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 30000,
  emiPerMonth: 3000,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Rajasthan", stops: ["Jaipur", "Mandawa", "Nawalgarh"] },
  ],
  highlights: [
    "Mandawa Fort", "Morarka Haveli", "Podar Haveli Museum", "Nawalgarh", "Sound and Light show at Amer Fort",
    "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund",
  ],
  departureCity: "Jaipur",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Jaipur", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur and travel to Mandawa", state: "Rajasthan", desc: "Arrive in Jaipur and continue to the Shekhawati region for your Mandawa stay. This daywise schedule is an outline based on the official package highlights.", nights: 1, highlights: ["Mandawa"] },
    { day: 2, title: "Mandawa and Nawalgarh", state: "Rajasthan", desc: "Discover Mandawa Fort and the region's painted havelis, including Morarka Haveli and Podar Haveli Museum, then visit Nawalgarh before continuing to Jaipur.", nights: 2, highlights: ["Mandawa Fort", "Morarka Haveli", "Podar Haveli Museum", "Nawalgarh"] },
    { day: 3, title: "Jaipur sightseeing", state: "Rajasthan", desc: "Explore Jaipur's historic landmarks, including Amer Fort's Sound and Light show, Hawa Mahal, Jantar Mantar, City Palace and Panna Meena ka Kund.", highlights: ["Sound and Light show at Amer Fort", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund"] },
    { day: 4, title: "Depart from Jaipur", state: "Rajasthan", desc: "Conclude your Jaipur Mandawa tour and depart for your onward journey.", highlights: ["Jaipur"] },
  ],
});
WORLD_TOURS.push({
  slug: "mathura-vrindavan-gokul-govardhan-upmg",
  title: "Mathura Vrindavan Gokul Govardhan",
  scope: "world",
  image: U("1599661046289-e31897846e41"),
  gallery: [U("1599661046289-e31897846e41"), U("1564507592333-c60657ff523"), U("1567157577867-05ccb1388e66")],
  code: "UPMG",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Uttar Pradesh",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 24000,
  emiPerMonth: 2400,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Uttar Pradesh", stops: ["Mathura", "Govardhan", "Barsana", "Gokul", "Vrindavan"] },
  ],
  highlights: [
    "Govardhan Hill", "Barsana cable car", "Radha Rani Temple", "Bramhand Ghat", "Chintaharan Mahadev",
    "Raman Reti", "Shri Krishna Janmabhoomi", "Banke Bihari Temple", "Prem Mandir", "Chandrodaya ISKCON Temple",
  ],
  departureCity: "Delhi",
  departureCities: ["Mumbai", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Delhi to Mathura", state: "Uttar Pradesh", desc: "Arrive in Delhi and travel to Mathura for a three-night stay.", nights: 3 },
    { day: 2, title: "Mathura, Govardhan, Barsana and Gokul", state: "Uttar Pradesh", desc: "Visit Govardhan Hill, Barsana and Gokul, including the region's devotional landmarks and temples.", highlights: ["Govardhan Hill", "Barsana cable car", "Radha Rani Temple", "Bramhand Ghat", "Chintaharan Mahadev", "Raman Reti"] },
    { day: 3, title: "Mathura and Vrindavan", state: "Uttar Pradesh", desc: "Explore Mathura and Vrindavan's major temples, including Shri Krishna Janmabhoomi, Banke Bihari Temple and Prem Mandir.", highlights: ["Shri Krishna Janmabhoomi", "Banke Bihari Temple", "Prem Mandir", "Chandrodaya ISKCON Temple"] },
    { day: 4, title: "Mathura to Delhi and departure", state: "Uttar Pradesh", desc: "Travel from Mathura to Delhi for your onward departure.", highlights: ["Delhi"] },
  ],
});
WORLD_TOURS.push({
  slug: "highlights-of-kerala-klhl",
  title: "Highlights of Kerala",
  scope: "world",
  image: U("1602216056096-3b40cc0c9944"),
  gallery: [U("1602216056096-3b40cc0c9944"), U("1590050752117-238cb0fb12b1"), U("1593693411515-c20261bcad6e")],
  code: "KLHL",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Kerala",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 35000,
  emiPerMonth: 3500,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Kerala", stops: ["Cochin", "Alleppey", "Periyar", "Munnar"] },
  ],
  highlights: [
    "Kerala Backwaters Ride", "Shopping at Kumily Spice Village", "Kalaripayattu show", "Kathakali show",
    "Periyar Wildlife Sanctuary", "Periyar Lake boat ride", "Speed boat ride at Mattupetty Dam", "Echo Point",
    "Eravikulam National Park", "Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue", "Dutch Palace",
  ],
  departureCity: "Cochin",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Cochin to Alleppey", state: "Kerala", desc: "Arrive in Cochin and travel to Alleppey, known for its scenic backwaters. Settle in for an overnight stay.", nights: 1, highlights: ["Kerala Backwaters Ride"] },
    { day: 2, title: "Alleppey to Periyar", state: "Kerala", desc: "Continue to Periyar, with time to explore Kumily Spice Village and enjoy a traditional performance.", nights: 1, highlights: ["Shopping at Kumily Spice Village", "Kalaripayattu show", "Kathakali show"] },
    { day: 3, title: "Periyar to Munnar", state: "Kerala", desc: "Visit Periyar Wildlife Sanctuary and continue to Munnar for a two-night stay.", nights: 2, highlights: ["Periyar Wildlife Sanctuary", "Periyar Lake boat ride"] },
    { day: 4, title: "Explore Munnar", state: "Kerala", desc: "Discover Munnar's hill country, including Mattupetty Dam, Echo Point and Eravikulam National Park.", highlights: ["Speed boat ride at Mattupetty Dam", "Echo Point", "Eravikulam National Park"] },
    { day: 5, title: "Munnar to Cochin", state: "Kerala", desc: "Travel back to Cochin and visit its historic waterfront and heritage landmarks.", nights: 1, highlights: ["Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue", "Dutch Palace"] },
    { day: 6, title: "Depart from Cochin", state: "Kerala", desc: "Conclude the Highlights of Kerala tour and depart from Cochin." },
  ],
});
WORLD_TOURS.push({
  slug: "seniors-special-kerala-klzl",
  title: "Seniors Special Kerala",
  scope: "world",
  image: U("1602216056096-3b40cc0c9944"),
  gallery: [U("1602216056096-3b40cc0c9944"), U("1590050752117-238cb0fb12b1"), U("1593693411515-c20261bcad6e")],
  code: "KLZL",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Kerala",
  zone: "India",
  interest: "Seniors' Special",
  packageType: "Group Tour",
  startingPrice: 36000,
  emiPerMonth: 3600,
  rating: null,
  reviewsCount: 76,
  route: [
    { state: "Kerala", stops: ["Cochin", "Alleppey", "Periyar", "Munnar"] },
  ],
  highlights: ["Chinese Fishing Nets", "St. Francis Church", "Fort Kochi", "Jewish Synagogue", "Dutch Palace", "Kumily Spice Village", "Kalaripayattu Show", "Kathakali Show", "Periyar Wildlife Sanctuary", "Periyar Lake Boat Ride", "Munnar Tea Plantations", "Mattupetty Dam Speed Boat", "Echo Point", "Eravikulam National Park", "Tea Museum", "Alleppey Backwaters Ride"],
  departureCity: "Cochin",
  departureCities: ["Mumbai", "Cochin", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Cochin to Alleppey", state: "Kerala", desc: "Arrive in Cochin and travel to Alleppey for an overnight stay.", nights: 1, highlights: ["Alleppey Backwaters Ride"] },
    { day: 2, title: "Alleppey to Periyar", state: "Kerala", desc: "Continue to Periyar and discover the local spice village and Kerala's traditional performance arts.", nights: 1, highlights: ["Kumily Spice Village", "Kalaripayattu Show", "Kathakali Show"] },
    { day: 3, title: "Periyar to Munnar", state: "Kerala", desc: "Visit Periyar Wildlife Sanctuary and enjoy a boat ride on Periyar Lake before travelling to Munnar for a two-night stay.", nights: 2, highlights: ["Periyar Wildlife Sanctuary", "Periyar Lake Boat Ride"] },
    { day: 4, title: "Explore Munnar", state: "Kerala", desc: "Explore Munnar's tea country, Mattupetty Dam, Echo Point, Eravikulam National Park and the Tea Museum.", highlights: ["Munnar Tea Plantations", "Mattupetty Dam Speed Boat", "Echo Point", "Eravikulam National Park", "Tea Museum"] },
    { day: 5, title: "Munnar to Cochin", state: "Kerala", desc: "Return to Cochin and visit Fort Kochi's heritage sights and waterfront landmarks for an overnight stay.", nights: 1, highlights: ["Chinese Fishing Nets", "St. Francis Church", "Fort Kochi", "Jewish Synagogue", "Dutch Palace"] },
    { day: 6, title: "Depart from Cochin", state: "Kerala", desc: "Conclude the tour and depart from Cochin." },
  ],
});
WORLD_TOURS.push({
  slug: "ayodhya-lucknow-stla",
  title: "Ayodhya Lucknow",
  scope: "world",
  image: U("/assets/media/wiki-ayodhya.jpg"),
  gallery: [U("/assets/media/wiki-ayodhya.jpg"), U("1602216056096-3b40cc0c9944")],
  code: "STLA",
  tourType: "GROUP TOUR",
  speciality: "Short Trips",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Uttar Pradesh",
  zone: "India",
  interest: "Short Trips",
  packageType: "Group Tour",
  startingPrice: 34000,
  emiPerMonth: 3400,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Uttar Pradesh", stops: ["Lucknow", "Ayodhya"] },
  ],
  highlights: [
    "Ambedkar Park", "Rumi Darwaja", "Bada Imambara", "British Residency", "Sita Rasoi",
    "Shri Ram Janmabhumi", "Shri Nageshwar Nath Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan",
  ],
  departureCity: "Lucknow",
  departureCities: ["Mumbai", "Lucknow", "Ayodhya", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Lucknow", state: "Uttar Pradesh", desc: "Arrive in Lucknow and settle in for a two-night stay.", nights: 2 },
    { day: 2, title: "Explore Lucknow", state: "Uttar Pradesh", desc: "Discover Lucknow's heritage landmarks, including Ambedkar Park, Rumi Darwaja, Bada Imambara and British Residency.", highlights: ["Ambedkar Park", "Rumi Darwaja", "Bada Imambara", "British Residency"] },
    { day: 3, title: "Lucknow to Ayodhya", state: "Uttar Pradesh", desc: "Travel to Ayodhya and settle in for a two-night stay.", nights: 2 },
    { day: 4, title: "Explore Ayodhya", state: "Uttar Pradesh", desc: "Visit Ayodhya's revered sites, including Shri Ram Janmabhumi, Hanuman Garhi, Dashrath Mahal and Kanak Bhavan.", highlights: ["Sita Rasoi", "Shri Ram Janmabhumi", "Shri Nageshwar Nath Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan"] },
    { day: 5, title: "Departure", state: "Uttar Pradesh", desc: "Conclude the tour and depart from Ayodhya or Lucknow according to your selected departure arrangement." },
  ],
});
WORLD_TOURS.push({
  slug: "womens-special-mathura-vrindavan-gokul-govardhan-upwmg",
  title: "Women's Special Mathura Vrindavan Gokul Govardhan",
  scope: "world",
  image: U("1599661046289-e31897846e41"),
  gallery: [U("1599661046289-e31897846e41"), U("1567157577867-05ccb1388e66"), U("/assets/media/wiki-prem-mandir.jpg")],
  code: "UPWMG",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Uttar Pradesh",
  zone: "India",
  interest: "Women's Special",
  packageType: "Group Tour",
  startingPrice: 35000,
  emiPerMonth: 3500,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Uttar Pradesh", stops: ["Mathura", "Govardhan", "Barsana", "Gokul", "Vrindavan"] },
  ],
  highlights: ["Govardhan Hill", "Barsana cable car", "Radha Rani Temple", "Bramhand Ghat", "Chintaharan Mahadev", "Raman Reti", "Shri Krishna Janmabhoomi", "Banke Bihari Temple", "Prem Mandir", "Chandrodaya ISKCON Temple"],
  departureCity: "Delhi",
  departureCities: ["Mumbai", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Delhi to Mathura", state: "Uttar Pradesh", desc: "Arrive in Delhi and travel to Mathura for a three-night stay.", nights: 3 },
    { day: 2, title: "Mathura, Govardhan, Barsana and Gokul", state: "Uttar Pradesh", desc: "Explore Govardhan, Barsana and Gokul, including Govardhan Hill, the Barsana cable car, Radha Rani Temple and other devotional landmarks.", highlights: ["Govardhan Hill", "Barsana cable car", "Radha Rani Temple", "Bramhand Ghat", "Chintaharan Mahadev", "Raman Reti"] },
    { day: 3, title: "Mathura and Vrindavan", state: "Uttar Pradesh", desc: "Visit Mathura and Vrindavan's temples, including Shri Krishna Janmabhoomi, Banke Bihari Temple, Prem Mandir and Chandrodaya ISKCON Temple.", highlights: ["Shri Krishna Janmabhoomi", "Banke Bihari Temple", "Prem Mandir", "Chandrodaya ISKCON Temple"] },
    { day: 4, title: "Mathura to Delhi and departure", state: "Uttar Pradesh", desc: "Travel from Mathura to Delhi and depart for your onward journey." },
  ],
});
WORLD_TOURS.push({
  slug: "womens-special-kerala-klwl",
  title: "Women's Special Kerala",
  scope: "world",
  image: U("1602216056096-3b40cc0c9944"),
  gallery: [U("1602216056096-3b40cc0c9944"), U("1590050752117-238cb0fb12b1"), U("1593693411515-c20261bcad6e")],
  code: "KLWL",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Kerala",
  zone: "India",
  interest: "Women's Special",
  packageType: "Group Tour",
  startingPrice: 38000,
  emiPerMonth: 3800,
  rating: null,
  reviewsCount: 89,
  route: [
    { state: "Kerala", stops: ["Cochin", "Alleppey", "Periyar", "Munnar"] },
  ],
  highlights: [
    "Alleppey backwaters ride", "Kumily Spice Village shopping", "Kalaripayattu martial art show",
    "Kathakali theatre performance", "Periyar Wildlife Sanctuary", "Periyar Lake boat cruise",
    "Munnar tea plantations", "Mattupetty Dam speed boat", "Echo Point visit", "Eravikulam National Park",
    "Fort Kochi sightseeing", "Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue visit", "Dutch Palace",
  ],
  departureCity: "Cochin",
  departureCities: ["Mumbai", "Cochin", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Cochin to Alleppey", state: "Kerala", desc: "Arrive in Cochin and travel to Alleppey for an overnight stay.", nights: 1, highlights: ["Alleppey backwaters ride"] },
    { day: 2, title: "Alleppey to Periyar", state: "Kerala", desc: "Continue to Periyar and discover Kumily Spice Village and traditional Kalaripayattu and Kathakali performances.", nights: 1, highlights: ["Kumily Spice Village shopping", "Kalaripayattu martial art show", "Kathakali theatre performance"] },
    { day: 3, title: "Periyar to Munnar", state: "Kerala", desc: "Visit Periyar Wildlife Sanctuary, enjoy a Periyar Lake boat cruise and continue to Munnar for a two-night stay.", nights: 2, highlights: ["Periyar Wildlife Sanctuary", "Periyar Lake boat cruise"] },
    { day: 4, title: "Explore Munnar", state: "Kerala", desc: "Explore the tea plantations and Munnar's scenic sights, including Mattupetty Dam, Echo Point and Eravikulam National Park.", highlights: ["Munnar tea plantations", "Mattupetty Dam speed boat", "Echo Point visit", "Eravikulam National Park"] },
    { day: 5, title: "Munnar to Cochin", state: "Kerala", desc: "Return to Cochin and explore Fort Kochi's historic landmarks and waterfront for an overnight stay.", nights: 1, highlights: ["Fort Kochi sightseeing", "Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue visit", "Dutch Palace"] },
    { day: 6, title: "Depart from Cochin", state: "Kerala", desc: "Conclude your Women's Special Kerala tour and depart from Cochin." },
  ],
});
WORLD_TOURS.push({
  slug: "honeymoon-special-shimla-manali-hphsn",
  title: "Honeymoon Special Shimla Manali",
  scope: "world",
  image: U("1626621341517-bbf3d9990a23"),
  gallery: [U("1544634076-a90160ddf44c"), U("1626621341517-bbf3d9990a23"), U("1602216056096-3b40cc0c9944")],
  code: "HPHSN",
  tourType: "GROUP TOUR",
  speciality: "Honeymoon Special",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Himachal Pradesh",
  zone: "India",
  interest: "Honeymoon Special",
  packageType: "Group Tour",
  startingPrice: 52000,
  emiPerMonth: 5200,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Himachal Pradesh", stops: ["Delhi", "Shimla", "Manali", "Solang Valley", "Chandigarh"] },
  ],
  highlights: [
    "Shimla Mall Road", "Kullu Shawl Factory", "Rohtang Road Snow Point", "Hidimba Mandir",
    "Himalayan Tibetan Monastery", "Himachali Folk Dance", "Atal Tunnel (Subject to Operation)",
    "Solang Valley", "Rock Garden",
  ],
  departureCity: "Delhi",
  departureCities: ["Mumbai", "Pune", "Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and settle in for an overnight stay.", nights: 1 },
    { day: 2, title: "Delhi to Shimla", state: "Himachal Pradesh", desc: "Travel from Delhi to Shimla and settle in for an overnight stay.", nights: 1 },
    { day: 3, title: "Shimla to Manali", state: "Himachal Pradesh", desc: "Travel to Manali via Kullu, including a visit to the Kullu Shawl Factory. Settle in for a three-night stay.", nights: 3, highlights: ["Kullu Shawl Factory"] },
    { day: 4, title: "Explore Manali", state: "Himachal Pradesh", desc: "Discover Manali's temples, monastery and local culture.", highlights: ["Hidimba Mandir", "Himalayan Tibetan Monastery", "Himachali Folk Dance"] },
    { day: 5, title: "Manali and Solang Valley", state: "Himachal Pradesh", desc: "Enjoy the Solang Valley region and visit Rohtang Road Snow Point and Atal Tunnel, subject to operation.", highlights: ["Solang Valley", "Rohtang Road Snow Point", "Atal Tunnel (Subject to Operation)"] },
    { day: 6, title: "Manali to Chandigarh", state: "Himachal Pradesh", desc: "Travel from Manali to Chandigarh for an overnight stay.", nights: 1 },
    { day: 7, title: "Chandigarh to Delhi and departure", state: "Chandigarh", desc: "Continue to Delhi and depart for your onward journey.", highlights: ["Rock Garden"] },
  ],
});
WORLD_TOURS.push({
  slug: "shimla-manali-hpsn",
  title: "Shimla Manali",
  scope: "world",
  image: U("1626621341517-bbf3d9990a23"),
  gallery: [U("1544634076-a90160ddf44c"), U("1626621341517-bbf3d9990a23"), U("1602216056096-3b40cc0c9944")],
  code: "HPSN",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Himachal Pradesh",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 41000,
  emiPerMonth: 4100,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Himachal Pradesh", stops: ["Delhi", "Shimla", "Manali", "Solang Valley", "Chandigarh"] },
  ],
  highlights: [
    "Shimla Mall Road", "Kullu Shawl Factory", "Rohtang Road Snow Point", "Hidimba Mandir",
    "Himalayan Tibetan Monastery", "Himachali Folk Dance", "Atal Tunnel (Subject to Operation)",
    "Solang Valley", "Rock Garden",
  ],
  departureCity: "Delhi",
  departureCities: ["Mumbai", "Pune", "Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and settle in for an overnight stay.", nights: 1 },
    { day: 2, title: "Delhi to Shimla", state: "Himachal Pradesh", desc: "Travel from Delhi to Shimla and settle in for an overnight stay.", nights: 1, highlights: ["Shimla Mall Road"] },
    { day: 3, title: "Shimla to Manali", state: "Himachal Pradesh", desc: "Travel to Manali via Kullu, including a visit to the Kullu Shawl Factory. Settle in for a three-night stay.", nights: 3, highlights: ["Kullu Shawl Factory"] },
    { day: 4, title: "Explore Manali", state: "Himachal Pradesh", desc: "Discover Manali's temples, monastery and local culture.", highlights: ["Hidimba Mandir", "Himalayan Tibetan Monastery", "Himachali Folk Dance"] },
    { day: 5, title: "Manali and Solang Valley", state: "Himachal Pradesh", desc: "Enjoy the Solang Valley region and visit Rohtang Road Snow Point and Atal Tunnel, subject to operation.", highlights: ["Solang Valley", "Rohtang Road Snow Point", "Atal Tunnel (Subject to Operation)"] },
    { day: 6, title: "Manali to Chandigarh", state: "Himachal Pradesh", desc: "Travel from Manali to Chandigarh for an overnight stay.", nights: 1 },
    { day: 7, title: "Chandigarh to Delhi and departure", state: "Chandigarh", desc: "Continue to Delhi and depart for your onward journey.", highlights: ["Rock Garden"] },
  ],
});
WORLD_TOURS.push({
  slug: "mysore-belur-halebid-kams",
  title: "Mysore Belur Halebid",
  scope: "world",
  image: "/assets/media/wiki-mysore.jpg",
  gallery: ["/assets/media/wiki-mysore.jpg"],
  code: "KAMS",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Karnataka",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 43000,
  emiPerMonth: 4300,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Karnataka", stops: ["Bengaluru", "Mysore", "Srirangapatna", "Belur", "Halebid"] },
  ],
  highlights: [
    "Brindavan Gardens", "Mysore Palace", "Mysore Zoo", "Sand Sculpture Museum", "Shri Chamundeshwari Temple",
    "Chennakeshava Temple", "Hoysaleswara Temple", "Tipu Sultan's Summer Palace", "Lalbagh Botanical Gardens",
  ],
  departureCity: "Bengaluru",
  departureCities: ["Mumbai", "Bengaluru", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Bengaluru", state: "Karnataka", desc: "Arrive in Bengaluru and explore its gardens and heritage landmarks, including Lalbagh Botanical Gardens and Tipu Sultan's Summer Palace. Overnight in Bengaluru.", nights: 1, highlights: ["Lalbagh Botanical Gardens", "Tipu Sultan's Summer Palace"] },
    { day: 2, title: "Bengaluru to Mysore", state: "Karnataka", desc: "Travel to Mysore via Srirangapatna and discover the city's royal landmarks. Settle in for a two-night stay.", nights: 2, highlights: ["Mysore Palace", "Brindavan Gardens"] },
    { day: 3, title: "Explore Mysore", state: "Karnataka", desc: "Spend the day discovering Mysore's cultural attractions, including Mysore Zoo, the Sand Sculpture Museum and Shri Chamundeshwari Temple.", highlights: ["Mysore Zoo", "Sand Sculpture Museum", "Shri Chamundeshwari Temple"] },
    { day: 4, title: "Mysore to Belur and Halebid", state: "Karnataka", desc: "Visit the Hoysala architectural landmarks at Belur and Halebid, including Chennakeshava Temple and Hoysaleswara Temple. Overnight in the region.", nights: 1, highlights: ["Chennakeshava Temple", "Hoysaleswara Temple"] },
    { day: 5, title: "Depart from Bengaluru", state: "Karnataka", desc: "Travel onward to Bengaluru and depart for your return journey." },
  ],
});
WORLD_TOURS.push({
  slug: "highlights-of-rajasthan-rjup",
  title: "Highlights of Rajasthan",
  scope: "world",
  image: "/assets/media/wiki-udaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-udaipur.jpg"],
  code: "RJUP",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Rajasthan",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 43000,
  joiningLeavingPrice: 32000,
  emiPerMonth: 4187,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Rajasthan", stops: ["Jaipur (2N)", "Pushkar (1N)", "Chittorgarh", "Udaipur (2N)"] },
  ],
  highlights: [
    "Moti Magri", "Udaipur City Palace", "Boat Ride to Jag Mandir", "Traditional Music & Dance Show",
    "Chittorgarh Fort", "Brahma Mandir", "Pushkar Tirth", "Kishangarh", "Hawa Mahal", "Jantar Mantar",
    "Jaipur City Palace", "Panna Meena ka Kund", "Amer Fort",
  ],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad", "Bengaluru", "Chennai", "Cochin", "Goa", "Hyderabad", "Indore", "Kolkata", "Nagpur", "New Delhi", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur", state: "Rajasthan", desc: "Arrive in Jaipur and settle in for a two-night stay. Scheduled tour guests arrive by flight from Mumbai; joining guests meet the group in Jaipur.", nights: 2 },
    { day: 2, title: "Jaipur", state: "Rajasthan", desc: "Explore Jaipur's historic landmarks, including Hawa Mahal, Jantar Mantar, Jaipur City Palace, Panna Meena ka Kund and Amer Fort.", highlights: ["Hawa Mahal", "Jantar Mantar", "Jaipur City Palace", "Panna Meena ka Kund", "Amer Fort"] },
    { day: 3, title: "Jaipur to Pushkar", state: "Rajasthan", desc: "Continue to Pushkar and visit Brahma Mandir and Pushkar Tirth. Overnight in Pushkar.", nights: 1, highlights: ["Brahma Mandir", "Pushkar Tirth"] },
    { day: 4, title: "Pushkar to Chittorgarh to Udaipur", state: "Rajasthan", desc: "Travel via Chittorgarh, with a visit to Chittorgarh Fort, and continue to Udaipur for a two-night stay.", nights: 2, highlights: ["Chittorgarh Fort"] },
    { day: 5, title: "Udaipur", state: "Rajasthan", desc: "Discover Udaipur's Moti Magri and City Palace, enjoy a boat ride to Jag Mandir and watch a traditional music and dance show.", highlights: ["Moti Magri", "Udaipur City Palace", "Boat Ride to Jag Mandir", "Traditional Music & Dance Show"] },
    { day: 6, title: "Depart from Udaipur", state: "Rajasthan", desc: "Conclude the tour in Udaipur and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests arrange their own flights.", highlights: ["Udaipur"] },
  ],
});
WORLD_TOURS.push({
  slug: "delhi-agra-stad",
  title: "Delhi Agra",
  scope: "world",
  image: "/assets/media/wiki-taj-mahal.jpg",
  gallery: ["/assets/media/wiki-delhi.jpg", "/assets/media/wiki-taj-mahal.jpg", "/assets/media/wiki-prayagraj.jpg"],
  code: "STAD",
  tourType: "GROUP TOUR",
  speciality: "Short Trips",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Delhi & Uttar Pradesh",
  zone: "India",
  interest: "Short Trips",
  packageType: "Group Tour",
  startingPrice: 28000,
  joiningLeavingPrice: 28000,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Delhi", stops: ["Delhi (2N)"] },
    { state: "Uttar Pradesh", stops: ["Mathura", "Vrindavan", "Agra (2N)", "Fatehpur Sikri"] },
  ],
  highlights: [
    "Fatehpur Sikri", "Taj Mahal", "Mehtab Bagh", "Agra Fort", "Mathura", "Akshardham Temple",
    "Qutub Minar", "Red Fort", "Ugrasen ki Baoli",
  ],
  departureCity: "Delhi",
  departureCities: ["Mumbai", "Delhi (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and settle in for a two-night stay. Scheduled tour guests arrive from Mumbai; joining guests meet the tour manager at Delhi Airport.", nights: 2 },
    { day: 2, title: "Delhi", state: "Delhi", desc: "Explore Delhi, including Akshardham Temple, Qutub Minar, Red Fort and Ugrasen ki Baoli.", highlights: ["Akshardham Temple", "Qutub Minar", "Red Fort", "Ugrasen ki Baoli"] },
    { day: 3, title: "Delhi · Mathura · Vrindavan · Agra", state: "Uttar Pradesh", desc: "Travel from Delhi via Mathura and Vrindavan to Agra, then check in for a two-night stay.", nights: 2, highlights: ["Mathura", "Vrindavan"] },
    { day: 4, title: "Agra", state: "Uttar Pradesh", desc: "Visit the Taj Mahal, Mehtab Bagh and Agra Fort.", highlights: ["Taj Mahal", "Mehtab Bagh", "Agra Fort"] },
    { day: 5, title: "Agra · Fatehpur Sikri · Delhi · Departure", state: "Uttar Pradesh", desc: "Visit Fatehpur Sikri and return to Delhi for your onward flight. The tour concludes at Delhi Airport.", highlights: ["Fatehpur Sikri"] },
  ],
});
WORLD_TOURS.push({
  slug: "womens-special-indore-ujjain-mandu-mpwi",
  title: "Women's Special Indore Ujjain Mandu",
  scope: "world",
  image: "/assets/media/wiki-madurai.jpg",
  gallery: ["/assets/media/wiki-madurai.jpg"],
  code: "MPWI",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Madhya Pradesh",
  zone: "India",
  interest: "Women's Special",
  packageType: "Group Tour",
  startingPrice: 44000,
  joiningLeavingPrice: 34000,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Madhya Pradesh", stops: ["Indore (4N)", "Omkareshwar", "Maheshwar", "Mandu", "Ujjain"] }],
  highlights: ["Rajwada Palace", "Chappan Dukan", "Omkareshwar", "Maheshwar", "Royal Ahilya Fort", "Rehwa Society", "Boat ride at Narmada Ghat", "Jahaz Mahal", "Baz Bahadur's Palace", "Jami Masjid", "Rani Roopmati Pavilion", "Lalbaug Palace", "Mahakaleshwar Temple", "Kal Bhairav Temple", "Harsiddhi Mata Temple", "Shri Mahakal Lok Corridor", "Shopping"],
  departureCity: "Indore",
  departureCities: ["Mumbai", "Indore (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Indore", state: "Madhya Pradesh", desc: "Arrive in Indore, visit Pitra Parvat, Rajwada Palace and Chappan Dukan. Overnight in Indore.", nights: 4, highlights: ["Pitra Parvat", "Rajwada Palace", "Chappan Dukan"] },
    { day: 2, title: "Indore · Omkareshwar · Maheshwar · Indore", state: "Madhya Pradesh", desc: "Visit Omkareshwar, then Maheshwar's Royal Ahilya Fort and Rehwa Society, followed by a boat ride at Narmada Ghat. Return to Indore.", highlights: ["Omkareshwar", "Royal Ahilya Fort", "Rehwa Society", "Boat ride at Narmada Ghat"] },
    { day: 3, title: "Indore · Mandu · Indore", state: "Madhya Pradesh", desc: "Explore Jahaz Mahal, Baz Bahadur's Palace, Jami Masjid and Rani Roopmati Pavilion in Mandu. Return to Indore for shopping and a Women's Special celebration.", highlights: ["Jahaz Mahal", "Baz Bahadur's Palace", "Jami Masjid", "Rani Roopmati Pavilion", "Shopping"] },
    { day: 4, title: "Indore · Ujjain · Indore", state: "Madhya Pradesh", desc: "Visit Lalbaug Palace and Ujjain's Kal Bhairav Temple, Mahakaleshwar Temple, Shri Mahakal Lok Corridor and Harsiddhi Mata Temple. Return to Indore.", highlights: ["Lalbaug Palace", "Kal Bhairav Temple", "Mahakaleshwar Temple", "Shri Mahakal Lok Corridor", "Harsiddhi Mata Temple"] },
    { day: 5, title: "Depart from Indore", state: "Madhya Pradesh", desc: "Transfer to Indore Airport for the return flight. Tour concludes.", highlights: ["Indore"] },
  ],
});
WORLD_TOURS.push({
  slug: "womens-special-shimla-manali-hpwsn",
  title: "Women's Special Shimla Manali",
  scope: "world",
  image: "/assets/media/wiki-shimla.jpg",
  gallery: [],
  code: "HPWSN",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Himachal Pradesh",
  zone: "India",
  interest: "Women's Special",
  packageType: "Group Tour",
  startingPrice: 44000,
  joiningLeavingPrice: 32000,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Delhi", stops: ["Delhi (1N)"] },
    { state: "Himachal Pradesh", stops: ["Shimla (1N)", "Manali (3N)"] },
    { state: "Chandigarh", stops: ["Chandigarh (1N)"] },
  ],
  highlights: ["Shimla Mall Road", "Kullu Shawl Factory", "Rohtang Road Snow Point", "Hidimba Mandir", "Himalayan Tibetan Monastery", "Himachali Folk Dance", "Atal Tunnel (Subject to Operation)", "Solang Valley", "Rock Garden"],
  departureCity: "Delhi",
  departureCities: ["Mumbai", "Pune", "Delhi (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and settle in for an overnight stay. Scheduled guests travel from Mumbai; joining guests meet the group in Delhi.", nights: 1 },
    { day: 2, title: "Delhi · Shimla", state: "Himachal Pradesh", desc: "Travel from Delhi to Shimla and check in for an overnight stay.", nights: 1 },
    { day: 3, title: "Shimla · Manali", state: "Himachal Pradesh", desc: "Enjoy time along Shimla Mall Road before continuing to Manali for a three-night stay.", nights: 3, highlights: ["Shimla Mall Road"] },
    { day: 4, title: "Manali", state: "Himachal Pradesh", desc: "Explore Manali, including Hidimba Mandir, a Himalayan Tibetan Monastery and a Himachali folk dance performance.", highlights: ["Hidimba Mandir", "Himalayan Tibetan Monastery", "Himachali Folk Dance"] },
    { day: 5, title: "Manali · Solang Valley · Manali", state: "Himachal Pradesh", desc: "Visit Solang Valley and travel along Rohtang Road to the snow point. Atal Tunnel visit is subject to operation.", highlights: ["Solang Valley", "Rohtang Road Snow Point", "Atal Tunnel (Subject to Operation)"] },
    { day: 6, title: "Manali · Chandigarh", state: "Chandigarh", desc: "Visit a Kullu shawl factory, then continue to Chandigarh for an overnight stay.", nights: 1, highlights: ["Kullu Shawl Factory"] },
    { day: 7, title: "Chandigarh · Delhi · Departure", state: "Delhi", desc: "Visit Rock Garden in Chandigarh, then travel to Delhi Airport for your onward flight. Tour concludes.", highlights: ["Rock Garden"] },
  ],
});
WORLD_TOURS.push({
  slug: "seniors-special-rajasthan-rjzp",
  title: "Seniors' Special Rajasthan",
  scope: "world",
  image: "/assets/media/wiki-jaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-chittorgarh.jpg", "/assets/media/wiki-udaipur.jpg"],
  code: "RJZP",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Rajasthan",
  zone: "India",
  interest: "Seniors' Special",
  packageType: "Group Tour",
  startingPrice: 39000,
  joiningLeavingPrice: 32000,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Jaipur (2N)", "Pushkar (1N)", "Chittorgarh", "Udaipur (2N)"] }],
  highlights: ["Sound and light show", "Amer Fort", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Bapu Market shopping", "Kishangarh scenic stop", "Brahma Mandir", "Pushkar Tirth", "Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace", "Rajasthani outfit photos", "Moti Magri", "Udaipur City Palace", "Boat ride Lake Pichola", "Jag Mandir", "Traditional music & dance show"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jaipur (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur", state: "Rajasthan", desc: "Arrive in Jaipur and settle in for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Jaipur.", nights: 2 },
    { day: 2, title: "Jaipur", state: "Rajasthan", desc: "Visit Amer Fort and enjoy the sound and light show, then see Hawa Mahal, Jantar Mantar, City Palace Jaipur and Panna Meena ka Kund. Enjoy time for shopping at Bapu Market.", highlights: ["Sound and light show", "Amer Fort", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Bapu Market shopping"] },
    { day: 3, title: "Jaipur · Pushkar", state: "Rajasthan", desc: "Travel via a scenic stop at Kishangarh, then visit Brahma Mandir and Pushkar Tirth. Overnight in Pushkar.", nights: 1, highlights: ["Kishangarh scenic stop", "Brahma Mandir", "Pushkar Tirth"] },
    { day: 4, title: "Pushkar · Chittorgarh · Udaipur", state: "Rajasthan", desc: "Visit Chittorgarh Fort, including Ranakumbha Palace, Meera Mandir, Vijay Stambha and Queen Padmini's Palace, before continuing to Udaipur for a two-night stay.", nights: 2, highlights: ["Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace", "Rajasthani outfit photos"] },
    { day: 5, title: "Udaipur", state: "Rajasthan", desc: "Discover Moti Magri and Udaipur City Palace, enjoy a boat ride on Lake Pichola to Jag Mandir and watch a traditional music and dance show.", highlights: ["Moti Magri", "Udaipur City Palace", "Boat ride Lake Pichola", "Jag Mandir", "Traditional music & dance show"] },
    { day: 6, title: "Udaipur · Departure", state: "Rajasthan", desc: "Depart from Udaipur for your onward journey. Scheduled tour guests fly to Mumbai; joining/leaving guests continue independently.", highlights: ["Udaipur"] },
  ],
});
WORLD_TOURS.push({
  slug: "best-of-shimla-hpbs",
  title: "Best of Shimla",
  scope: "world",
  image: "/assets/media/wiki-shimla.jpg",
  gallery: [],
  code: "HPBS",
  tourType: "GROUP TOUR",
  speciality: "Short Trips",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 3,
  citiesCount: 4,
  region: "Himachal Pradesh",
  zone: "India",
  interest: "Short Trips",
  packageType: "Group Tour",
  startingPrice: 46000,
  joiningLeavingPrice: 29000,
  emiPerMonth: 4479,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Chandigarh", stops: ["Chandigarh"] },
    { state: "Himachal Pradesh", stops: ["Shimla (2N)", "Solan (2N)", "Barog"] },
  ],
  highlights: ["Shimla Mall Road", "Chail Palace", "Kali Ka Tibba", "Kufri Himalayan Zoo", "Shoolini Mata Temple", "Mohan Meakin Brewery", "Barog Railway Station", "Jatoli Shiv Temple", "Pinjore Garden", "Rock Garden"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Chandigarh (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Chandigarh · Shimla", state: "Himachal Pradesh", desc: "Arrive in Chandigarh and travel to Shimla for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at Chandigarh Airport.", nights: 2 },
    { day: 2, title: "Shimla", state: "Himachal Pradesh", desc: "Explore Shimla Mall Road and visit Chail Palace, Kali Ka Tibba and Kufri Himalayan Zoo.", highlights: ["Shimla Mall Road", "Chail Palace", "Kali Ka Tibba", "Kufri Himalayan Zoo"] },
    { day: 3, title: "Shimla · Solan", state: "Himachal Pradesh", desc: "Visit Shoolini Mata Temple and Mohan Meakin Brewery, then continue to Solan for a two-night stay.", nights: 2, highlights: ["Shoolini Mata Temple", "Mohan Meakin Brewery"] },
    { day: 4, title: "Solan · Barog · Solan", state: "Himachal Pradesh", desc: "Visit Barog Railway Station and Jatoli Shiv Temple, then return to Solan.", highlights: ["Barog Railway Station", "Jatoli Shiv Temple"] },
    { day: 5, title: "Solan · Chandigarh · Departure", state: "Chandigarh", desc: "Travel to Chandigarh, visit Pinjore Garden and Rock Garden, then continue to the airport for your onward journey. Tour concludes.", highlights: ["Pinjore Garden", "Rock Garden"] },
  ],
});
WORLD_TOURS.push({
  slug: "womens-special-rajasthan-rjwp",
  title: "Women's Special Rajasthan",
  scope: "world",
  image: "/assets/media/wiki-udaipur.jpg",
  gallery: ["/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-chittorgarh.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-jaipur.jpg"],
  code: "RJWP",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Rajasthan",
  zone: "India",
  interest: "Women's Special",
  packageType: "Group Tour",
  startingPrice: 39000,
  joiningLeavingPrice: 32000,
  route: [{ state: "Rajasthan", stops: ["Udaipur (2N)", "Chittorgarh", "Pushkar (1N)", "Jaipur (2N)"] }],
  highlights: ["Moti Magri", "Fateh Sagar Lake", "Udaipur City Palace", "Boat Ride – Lake Pichola", "Jag Mandir", "Shopping in Udaipur", "Traditional Music and Dance Show", "Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace", "Rajasthani Outfit Photoshoot", "Pushkar", "Brahma Mandir", "Pushkar Tirth", "Kishangarh", "Sound and Light Show – Amer Fort", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Amer Fort", "Bapu Market Shopping"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Udaipur (Joining)", "Jaipur (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Udaipur", state: "Rajasthan", desc: "Arrive in Udaipur and settle in for a two-night stay. Scheduled tour guests fly from Mumbai; joining guests meet the group in Udaipur.", nights: 2 },
    { day: 2, title: "Udaipur", state: "Rajasthan", desc: "Visit Moti Magri and Udaipur City Palace, enjoy a boat ride on Lake Pichola to Jag Mandir, browse local shops and watch a traditional music and dance show.", highlights: ["Moti Magri", "Fateh Sagar Lake", "Udaipur City Palace", "Boat Ride – Lake Pichola", "Jag Mandir", "Shopping in Udaipur", "Traditional Music and Dance Show"] },
    { day: 3, title: "Udaipur · Chittorgarh · Pushkar", state: "Rajasthan", desc: "Travel via Chittorgarh Fort and explore Ranakumbha Palace, Meera Mandir, Vijay Stambha and Queen Padmini's Palace. Continue to Pushkar for an overnight stay and enjoy a Rajasthani outfit photoshoot.", nights: 1, highlights: ["Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace", "Rajasthani Outfit Photoshoot"] },
    { day: 4, title: "Pushkar · Jaipur", state: "Rajasthan", desc: "Visit Brahma Mandir and Pushkar Tirth, stop at Kishangarh and continue to Jaipur for a two-night stay.", nights: 2, highlights: ["Brahma Mandir", "Pushkar Tirth", "Kishangarh"] },
    { day: 5, title: "Jaipur", state: "Rajasthan", desc: "Explore Amer Fort and its sound and light show, Hawa Mahal, Jantar Mantar, City Palace Jaipur and Panna Meena ka Kund. Enjoy shopping at Bapu Market.", highlights: ["Sound and Light Show – Amer Fort", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Amer Fort", "Bapu Market Shopping"] },
    { day: 6, title: "Jaipur · Departure", state: "Rajasthan", desc: "Depart from Jaipur for your onward journey. Scheduled guests fly to Mumbai; leaving guests continue independently.", highlights: ["Jaipur"] },
  ],
});
WORLD_TOURS.push({
  slug: "highlights-of-rajasthan-rjupu",
  title: "Highlights of Rajasthan",
  scope: "world",
  image: "/assets/media/wiki-jaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-chittorgarh.jpg", "/assets/media/wiki-udaipur.jpg"],
  code: "RJUPU",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Rajasthan",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 40000,
  joiningLeavingPrice: 32000,
  emiPerMonth: 3895,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Jaipur (2N)", "Pushkar (1N)", "Chittorgarh", "Udaipur (2N)"] }],
  highlights: ["Moti Magri", "Udaipur City Palace", "Boat Ride to Jag Mandir", "Traditional Music & Dance Show", "Chittorgarh Fort", "Brahma Mandir", "Pushkar Tirth", "Kishangarh", "Hawa Mahal", "Jantar Mantar", "Jaipur City Palace", "Panna Meena ka Kund", "Amer Fort"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jaipur (Joining)", "Udaipur (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur", state: "Rajasthan", desc: "Arrive in Jaipur and settle in for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Jaipur.", nights: 2 },
    { day: 2, title: "Jaipur", state: "Rajasthan", desc: "Explore Jaipur, including Hawa Mahal, Jantar Mantar, Jaipur City Palace, Panna Meena ka Kund and Amer Fort.", highlights: ["Hawa Mahal", "Jantar Mantar", "Jaipur City Palace", "Panna Meena ka Kund", "Amer Fort"] },
    { day: 3, title: "Jaipur · Pushkar", state: "Rajasthan", desc: "Travel via Kishangarh and continue to Pushkar, visiting Brahma Mandir and Pushkar Tirth. Overnight in Pushkar.", nights: 1, highlights: ["Kishangarh", "Brahma Mandir", "Pushkar Tirth"] },
    { day: 4, title: "Pushkar · Chittorgarh · Udaipur", state: "Rajasthan", desc: "Travel via Chittorgarh Fort and continue to Udaipur for a two-night stay.", nights: 2, highlights: ["Chittorgarh Fort"] },
    { day: 5, title: "Udaipur", state: "Rajasthan", desc: "Visit Moti Magri and Udaipur City Palace, enjoy a boat ride to Jag Mandir and watch a traditional music and dance show.", highlights: ["Moti Magri", "Udaipur City Palace", "Boat Ride to Jag Mandir", "Traditional Music & Dance Show"] },
    { day: 6, title: "Udaipur · Departure", state: "Rajasthan", desc: "Depart from Udaipur for your onward journey. Scheduled tour guests fly to Mumbai; joining/leaving guests continue independently.", highlights: ["Udaipur"] },
  ],
});
WORLD_TOURS.push({
  slug: "haridwar-rishikesh-kurukshetra-panipat-nikp",
  title: "Haridwar Rishikesh Kurukshetra Panipat",
  scope: "world",
  image: "/assets/media/wiki-haridwar-aarti.jpg",
  gallery: ["/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg", "/assets/media/wiki-delhi.jpg"],
  code: "NIKP",
  tourType: "GROUP TOUR",
  speciality: "Short Trips",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 3,
  citiesCount: 6,
  region: "North India",
  zone: "India",
  interest: "Short Trips",
  packageType: "Group Tour",
  startingPrice: 45000,
  joiningLeavingPrice: 33000,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Delhi", stops: ["Delhi"] },
    { state: "Haryana", stops: ["Panipat", "Karnal", "Kurukshetra"] },
    { state: "Uttarakhand", stops: ["Haridwar (3N)", "Rishikesh"] },
  ],
  highlights: ["Devi Temple", "Panipat Museum", "Brahma Sarovar", "Kurukshetra Panorama and Science Centre", "Ganga Aarti at Har Ki Pauri", "Prati Badri Kedarnath Temple", "White Water Rafting at Rishikesh"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Delhi · Panipat · Karnal", state: "Haryana", desc: "Arrive in Delhi and travel to Panipat. Visit Devi Temple and Panipat Museum, then continue to Karnal for an overnight stay.", nights: 1, highlights: ["Devi Temple", "Panipat Museum"] },
    { day: 2, title: "Karnal · Kurukshetra · Haridwar", state: "Uttarakhand", desc: "Visit Bhrama Sarovar and Kurukshetra Panorama and Science Centre, then continue to Haridwar for a three-night stay.", nights: 3, highlights: ["Brahma Sarovar", "Kurukshetra Panorama and Science Centre"] },
    { day: 3, title: "Haridwar", state: "Uttarakhand", desc: "Visit Har Ki Pauri and experience the evening Ganga Aarti.", highlights: ["Ganga Aarti at Har Ki Pauri"] },
    { day: 4, title: "Haridwar · Rishikesh · Haridwar", state: "Uttarakhand", desc: "Visit Prati Badri Kedarnath Temple in Rishikesh and enjoy white water rafting before returning to Haridwar.", highlights: ["Prati Badri Kedarnath Temple", "White Water Rafting at Rishikesh"] },
    { day: 5, title: "Haridwar · Delhi · Departure", state: "Delhi", desc: "Travel to Delhi for your onward journey. Scheduled tour guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Delhi"] },
  ],
});
WORLD_TOURS.push({
  slug: "best-of-manali-hpbm",
  title: "Best of Manali",
  scope: "world",
  image: "/assets/media/wiki-manali.jpg",
  gallery: ["/assets/media/wiki-rishikesh.jpg"],
  code: "HPBM",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 3,
  region: "Himachal Pradesh",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 45000,
  joiningLeavingPrice: 32000,
  route: [
    { state: "Chandigarh", stops: ["Chandigarh (1N)"] },
    { state: "Himachal Pradesh", stops: ["Manali (4N)", "Solang Valley", "Manikaran"] },
    { state: "Chandigarh", stops: ["Chandigarh (1N)"] },
  ],
  highlights: ["Pinjore Garden", "Kullu Shawl Factory", "Rohtang Road Snow Point", "Hidimba Mandir", "Tibetan Buddhist Monastery", "Himachali Folk Dance", "Atal Tunnel (Subject to Operation)", "Solang Valley", "Manikaran", "Scenic & Pleasant River Sidewalk", "River Rafting", "Rock Garden"],
  departureCity: "Chandigarh",
  departureCities: ["Chandigarh (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Chandigarh", state: "Chandigarh", desc: "Arrive in Chandigarh and settle in for an overnight stay. Joining guests meet the group at Chandigarh Airport.", nights: 1 },
    { day: 2, title: "Chandigarh · Manali", state: "Himachal Pradesh", desc: "Travel to Manali and check in for a four-night stay.", nights: 4 },
    { day: 3, title: "Manali", state: "Himachal Pradesh", desc: "Explore Manali, including Hidimba Mandir, a Tibetan Buddhist Monastery and a Himachali folk dance performance.", highlights: ["Hidimba Mandir", "Tibetan Buddhist Monastery", "Himachali Folk Dance"] },
    { day: 4, title: "Manali · Solang Valley · Manali", state: "Himachal Pradesh", desc: "Visit Solang Valley and the Rohtang Road snow point. Atal Tunnel visit is subject to operation.", highlights: ["Solang Valley", "Rohtang Road Snow Point", "Atal Tunnel (Subject to Operation)"] },
    { day: 5, title: "Manali · Manikaran · Manali", state: "Himachal Pradesh", desc: "Visit Manikaran and enjoy the scenic riverside walk. River rafting is available as part of the tour highlights.", highlights: ["Manikaran", "Scenic & Pleasant River Sidewalk", "River Rafting"] },
    { day: 6, title: "Manali · Chandigarh", state: "Chandigarh", desc: "Visit Kullu Shawl Factory and Pinjore Garden en route to Chandigarh for an overnight stay.", nights: 1, highlights: ["Kullu Shawl Factory", "Pinjore Garden"] },
    { day: 7, title: "Chandigarh · Departure", state: "Chandigarh", desc: "Visit Rock Garden and depart from Chandigarh. Tour concludes.", highlights: ["Rock Garden"] },
  ],
});
WORLD_TOURS.push({
  slug: "indore-ujjain-mandu-stum",
  title: "Indore Ujjain Mandu",
  scope: "world",
  image: "/assets/media/wiki-madurai.jpg",
  gallery: ["/assets/media/wiki-madurai.jpg"],
  code: "STUM",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Madhya Pradesh",
  zone: "India",
  interest: "Family",
  packageType: "Group Tour",
  startingPrice: 45000,
  joiningLeavingPrice: 35000,
  emiPerMonth: 4382,
  route: [{ state: "Madhya Pradesh", stops: ["Indore (4N)", "Omkareshwar", "Maheshwar", "Mandu", "Ujjain"] }],
  highlights: ["Pitra Parvat", "Rajwada Palace", "Chappan Dukan", "Omkareshwar", "Maheshwar", "Royal Ahilya Fort", "Rehwa Society", "Boat ride at Narmada Ghat", "Jahaz Mahal", "Baz Bahadur's Palace", "Jami Masjid", "Rani Roopmati Pavilion", "Lalbaug Palace", "Mahakaleshwar Temple", "Shri Mahakal Lok Corridor", "Kal Bhairav Temple", "Harsiddhi Mata Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Indore (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Indore", state: "Madhya Pradesh", desc: "Fly from Mumbai to Indore with the tour manager. Visit Pitra Parvat, Rajwada Palace and Chappan Dukan. Stay in Indore for four nights.", nights: 4, highlights: ["Pitra Parvat", "Rajwada Palace", "Chappan Dukan"] },
    { day: 2, title: "Indore · Omkareshwar · Maheshwar · Indore", state: "Madhya Pradesh", desc: "Visit Omkareshwar, then continue to Maheshwar to see Royal Ahilya Fort and Rehwa Society. Enjoy a boat ride at Narmada Ghat before returning to Indore.", highlights: ["Omkareshwar", "Maheshwar", "Royal Ahilya Fort", "Rehwa Society", "Boat ride at Narmada Ghat"] },
    { day: 3, title: "Indore · Mandu · Indore", state: "Madhya Pradesh", desc: "Explore Mandu's historic landmarks, including Jahaz Mahal, Baz Bahadur's Palace, Jami Masjid and Rani Roopmati Pavilion. Return to Indore.", highlights: ["Jahaz Mahal", "Baz Bahadur's Palace", "Jami Masjid", "Rani Roopmati Pavilion"] },
    { day: 4, title: "Indore · Ujjain · Indore", state: "Madhya Pradesh", desc: "Visit Lalbaug Palace, then continue to Ujjain to see Mahakaleshwar Temple, Shri Mahakal Lok Corridor, Kal Bhairav Temple and Harsiddhi Mata Temple. Return to Indore.", highlights: ["Lalbaug Palace", "Mahakaleshwar Temple", "Shri Mahakal Lok Corridor", "Kal Bhairav Temple", "Harsiddhi Mata Temple"] },
    { day: 5, title: "Depart from Indore", state: "Madhya Pradesh", desc: "Transfer to Indore Airport for the return flight to Mumbai. Joining and leaving guests depart independently. Tour concludes.", highlights: ["Indore"] },
  ],
});
WORLD_TOURS.push({
  slug: "seniors-special-shimla-manali-hpzsn",
  title: "Seniors' Special Shimla Manali",
  scope: "world",
  image: "/assets/media/wiki-shimla.jpg",
  gallery: [],
  code: "HPZSN",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 3,
  citiesCount: 5,
  region: "Himachal Pradesh",
  zone: "India",
  interest: "Seniors' Special",
  packageType: "Group Tour",
  startingPrice: 47000,
  joiningLeavingPrice: 32000,
  route: [
    { state: "Delhi", stops: ["Delhi (1N)"] },
    { state: "Himachal Pradesh", stops: ["Shimla (1N)", "Manali (3N)", "Solang Valley"] },
    { state: "Chandigarh", stops: ["Chandigarh (1N)"] },
  ],
  highlights: ["Shimla Mall Road", "Kullu Shawl Factory", "Rohtang Road Snow Point", "Hidimba Mandir", "Himalayan Tibetan Monastery", "Himachali Folk Dance", "Atal Tunnel (Subject to Operation)", "Solang Valley", "Rock Garden"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining/leaving)", "Chandigarh (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and settle in for an overnight stay. Scheduled tour guests arrive from Mumbai; joining guests meet the tour manager in Delhi.", nights: 1 },
    { day: 2, title: "Delhi · Shimla", state: "Himachal Pradesh", desc: "Travel from Delhi to Shimla and check in for an overnight stay.", nights: 1 },
    { day: 3, title: "Shimla · Manali", state: "Himachal Pradesh", desc: "Enjoy time in Shimla before continuing to Manali for a three-night stay.", nights: 3, highlights: ["Shimla Mall Road"] },
    { day: 4, title: "Manali", state: "Himachal Pradesh", desc: "Visit Hidimba Mandir and a Himalayan Tibetan Monastery, and enjoy a Himachali folk dance performance.", highlights: ["Hidimba Mandir", "Himalayan Tibetan Monastery", "Himachali Folk Dance"] },
    { day: 5, title: "Manali · Solang Valley · Manali", state: "Himachal Pradesh", desc: "Visit Solang Valley and the Rohtang Road snow point. Atal Tunnel visit is subject to operation.", highlights: ["Solang Valley", "Rohtang Road Snow Point", "Atal Tunnel (Subject to Operation)"] },
    { day: 6, title: "Manali · Chandigarh", state: "Chandigarh", desc: "Visit a Kullu Shawl Factory and continue to Chandigarh for an overnight stay.", nights: 1, highlights: ["Kullu Shawl Factory"] },
    { day: 7, title: "Chandigarh · Delhi · Departure", state: "Delhi", desc: "Visit Rock Garden in Chandigarh, then continue to Delhi for your onward departure. Tour concludes.", highlights: ["Rock Garden"] },
  ],
});
WORLD_TOURS.push({
  slug: "sarnath-varanasi-stsv",
  title: "Sarnath Varanasi",
  scope: "world",
  image: "/assets/media/wiki-varanasi-ghat.jpg",
  gallery: ["/assets/media/wiki-varanasi-ghat.jpg", "/assets/media/wiki-varanasi-aarti.jpg", "/assets/media/wiki-prayagraj.jpg"],
  code: "STSV",
  tourType: "GROUP TOUR",
  speciality: "Short Trips",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Uttar Pradesh",
  zone: "India",
  interest: "Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 47000,
  joiningLeavingPrice: 35000,
  emiPerMonth: 4570,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Uttar Pradesh", stops: ["Prayagraj", "Varanasi (4N)", "Sarnath"] },
  ],
  highlights: ["Anand Bhavan", "Laying Hanuman Temple", "Triveni Sangam Boat Ride", "Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Dhamek Stupa", "Sarai Mohana Weavers’ Village", "Swarved Mahamandir"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Varanasi (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Prayagraj", state: "Uttar Pradesh", desc: "Arrive in Prayagraj and visit Anand Bhavan and Laying Hanuman Temple. Overnight in Prayagraj.", nights: 1, highlights: ["Anand Bhavan", "Laying Hanuman Temple"] },
    { day: 2, title: "Prayagraj · Varanasi", state: "Uttar Pradesh", desc: "Enjoy a boat ride at Triveni Sangam, then travel to Varanasi for the next part of the journey.", nights: 3, highlights: ["Triveni Sangam Boat Ride"] },
    { day: 3, title: "Varanasi", state: "Uttar Pradesh", desc: "Explore Varanasi’s sacred landmarks, including Kaal Bhairav Temple, Kashi Vishwanath Temple, Banaras Hindu University and Birla Mandir. Visit Dashashwamedh Ghat.", highlights: ["Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat"] },
    { day: 4, title: "Varanasi · Sarnath", state: "Uttar Pradesh", desc: "Visit Sarnath’s Dhamek Stupa, stop at Sarai Mohana Weavers’ Village and see Swarved Mahamandir.", highlights: ["Dhamek Stupa", "Sarai Mohana Weavers’ Village", "Swarved Mahamandir"] },
    { day: 5, title: "Varanasi · Departure", state: "Uttar Pradesh", desc: "Depart from Varanasi for your onward journey. Scheduled guests fly to Mumbai; joining/leaving guests depart independently.", highlights: ["Varanasi"] },
  ],
});WORLD_TOURS.push({
  slug: "jodhpur-jaisalmer-rjjs",
  title: "Jodhpur Jaisalmer",
  scope: "world",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-pushkar.jpg"],
  code: "RJJS",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Rajasthan",
  zone: "India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 39000,
  joiningLeavingPrice: 27000,
  emiPerMonth: 3795,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Jodhpur (2N)", "Jaisalmer (2N)"] }],
  highlights: ["Gadisar Lake Boat Ride", "Jaisalmer Puppet Show", "Golden Jaisalmer Fort", "Jaisalmer Fort Palace & Heritage Centre", "Patwon Ki Haveli Museum", "Kuldhara Abandoned Village", "Sam Sand Dunes", "Dune Bashing", "Camel Ride at Sunset", "Desert Folk Dance", "Rajasthani Cultural Dinner", "Blue City Jodhpur", "Bishnoi Village Safari", "Umaid Bhawan Palace Museum", "Mehrangarh Fort", "Moti Mahal", "Phool Mahal", "Sheesh Mahal", "Jaswant Thada", "Sanganeri Block Prints Demo"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jodhpur (Joining)", "Jaisalmer (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jodhpur", state: "Rajasthan", desc: "Arrive in Jodhpur and settle in for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Jodhpur.", nights: 2 },
    { day: 2, title: "Jodhpur", state: "Rajasthan", desc: "Explore the Blue City with a Bishnoi Village Safari, Umaid Bhawan Palace Museum, Mehrangarh Fort and its palaces, and Jaswant Thada. See a Sanganeri block prints demonstration.", highlights: ["Blue City Jodhpur", "Bishnoi Village Safari", "Umaid Bhawan Palace Museum", "Mehrangarh Fort", "Moti Mahal", "Phool Mahal", "Sheesh Mahal", "Jaswant Thada", "Sanganeri Block Prints Demo"] },
    { day: 3, title: "Jodhpur · Jaisalmer", state: "Rajasthan", desc: "Travel from Jodhpur to Jaisalmer and check in for a two-night stay.", nights: 2 },
    { day: 4, title: "Jaisalmer", state: "Rajasthan", desc: "Visit Gadisar Lake and Jaisalmer Fort, explore Patwon Ki Haveli Museum and Kuldhara, then enjoy Sam Sand Dunes with a camel ride at sunset, desert folk dance and a Rajasthani cultural dinner.", highlights: ["Gadisar Lake Boat Ride", "Jaisalmer Puppet Show", "Golden Jaisalmer Fort", "Jaisalmer Fort Palace & Heritage Centre", "Patwon Ki Haveli Museum", "Kuldhara Abandoned Village", "Sam Sand Dunes", "Dune Bashing", "Camel Ride at Sunset", "Desert Folk Dance", "Rajasthani Cultural Dinner"] },
    { day: 5, title: "Jaisalmer · Departure", state: "Rajasthan", desc: "Depart from Jaisalmer for your onward journey. Scheduled tour guests return to Mumbai; joining/leaving guests depart independently.", highlights: ["Jaisalmer"] },
  ],
});WORLD_TOURS.push({
  slug: "seniors-special-nainital-mussoorie-haridwar-nizh",
  title: "Seniors’ Special Nainital Mussoorie Haridwar",
  scope: "world",
  image: "/assets/media/wiki-nainital.jpg",
  gallery: ["/assets/media/wiki-nainital.jpg", "/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg"],
  code: "NIZH",
  tourType: "GROUP TOUR",
  speciality: "Seniors’ Special",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 6,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Nature & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 48000,
  joiningLeavingPrice: 36000,
  emiPerMonth: 4668,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Delhi", stops: ["Delhi (1N)"] },
    { state: "Uttarakhand", stops: ["Bhimtal / Nainital (2N)", "Mussoorie (2N)", "Rishikesh", "Haridwar (1N)"] },
  ],
  highlights: ["Kainchi Dham", "Cable Car Ride", "Snow View Point", "Nainadevi Temple", "Naini Lake Boating", "Mussoorie Sightseeing", "Jim Corbett Museum", "Kempty Falls", "Gun Hill Ropeway", "Haridwar Sightseeing", "Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White Water Rafting", "Ganga Aarti", "Har Ki Pauri"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and check in for an overnight stay before travelling into Uttarakhand. Scheduled guests fly from Mumbai; joining guests meet the group in Delhi.", nights: 1 },
    { day: 2, title: "Delhi · Bhimtal", state: "Uttarakhand", desc: "Travel from Delhi to the Nainital region and check in for a two-night stay near Bhimtal/Nainital.", nights: 2 },
    { day: 3, title: "Nainital", state: "Uttarakhand", desc: "Visit Kainchi Dham, take the cable car to Snow View Point, see Nainadevi Temple and enjoy boating on Naini Lake.", highlights: ["Kainchi Dham", "Cable Car Ride", "Snow View Point", "Nainadevi Temple", "Naini Lake Boating"] },
    { day: 4, title: "Nainital · Mussoorie", state: "Uttarakhand", desc: "Travel to Mussoorie and check in for a two-night stay. En route, visit the Jim Corbett Museum where scheduled sightseeing permits.", nights: 2, highlights: ["Jim Corbett Museum"] },
    { day: 5, title: "Mussoorie", state: "Uttarakhand", desc: "Enjoy Mussoorie sightseeing, including Kempty Falls and a ride on the Gun Hill ropeway.", highlights: ["Mussoorie Sightseeing", "Kempty Falls", "Gun Hill Ropeway"] },
    { day: 6, title: "Mussoorie · Rishikesh · Haridwar", state: "Uttarakhand", desc: "Travel via Rishikesh and visit Prati Badri Kedarnath Temple, Lakshman Mandir and Lakshman Jhula. Continue to Haridwar for an overnight stay and experience Ganga Aarti at Har Ki Pauri.", nights: 1, highlights: ["Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White Water Rafting", "Ganga Aarti", "Har Ki Pauri"] },
    { day: 7, title: "Haridwar · Delhi · Departure", state: "Delhi", desc: "Travel from Haridwar to Delhi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart from Delhi independently.", highlights: ["Delhi"] },
  ],
});WORLD_TOURS.push({
  slug: "womens-special-nainital-mussoorie-haridwar-niwh",
  title: "Women's Special Nainital Mussoorie Haridwar",
  scope: "world",
  image: "/assets/media/wiki-nainital.jpg",
  gallery: ["/assets/media/wiki-nainital.jpg", "/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg"],
  code: "NIWH",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 6,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Nature & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 49000,
  joiningLeavingPrice: 37000,
  emiPerMonth: 4765,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Delhi", stops: ["Delhi (1N)"] },
    { state: "Uttarakhand", stops: ["Bhimtal / Nainital (2N)", "Mussoorie (2N)", "Rishikesh", "Haridwar (1N)"] },
  ],
  highlights: ["Nainital Lake District", "Kainchi Dham Ashram", "Cable Car Ride", "Snow View Point", "Nainadevi Temple", "Naini Lake Boating", "Mall Road Stroll", "Mussoorie Queen of Hills", "Jim Corbett Museum", "Kempty Falls", "Gun Hill Ropeway", "Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White Water Rafting Rishikesh", "Ganga Aarti Har Ki Pauri"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and check in for an overnight stay before travelling into Uttarakhand. Scheduled guests fly from Mumbai; joining guests meet the group in Delhi.", nights: 1 },
    { day: 2, title: "Delhi · Bhimtal", state: "Uttarakhand", desc: "Travel from Delhi to the Nainital region and check in for a two-night stay near Bhimtal/Nainital.", nights: 2 },
    { day: 3, title: "Nainital", state: "Uttarakhand", desc: "Explore the Nainital Lake District. Visit Kainchi Dham Ashram, take the cable car to Snow View Point, see Nainadevi Temple, enjoy boating on Naini Lake and stroll along Mall Road.", highlights: ["Nainital Lake District", "Kainchi Dham Ashram", "Cable Car Ride", "Snow View Point", "Nainadevi Temple", "Naini Lake Boating", "Mall Road Stroll"] },
    { day: 4, title: "Nainital · Mussoorie", state: "Uttarakhand", desc: "Travel to Mussoorie and check in for a two-night stay. Visit the Jim Corbett Museum where scheduled sightseeing permits.", nights: 2, highlights: ["Jim Corbett Museum"] },
    { day: 5, title: "Mussoorie", state: "Uttarakhand", desc: "Explore Mussoorie, the Queen of Hills, and visit Kempty Falls and Gun Hill by ropeway.", highlights: ["Mussoorie Queen of Hills", "Kempty Falls", "Gun Hill Ropeway"] },
    { day: 6, title: "Mussoorie · Rishikesh · Haridwar", state: "Uttarakhand", desc: "Travel via Rishikesh, visiting Prati Badri Kedarnath Temple, Lakshman Mandir and Lakshman Jhula. Continue to Haridwar for an overnight stay and experience Ganga Aarti at Har Ki Pauri.", nights: 1, highlights: ["Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White Water Rafting Rishikesh", "Ganga Aarti Har Ki Pauri"] },
    { day: 7, title: "Haridwar · Delhi · Departure", state: "Delhi", desc: "Travel from Haridwar to Delhi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart from Delhi independently.", highlights: ["Delhi"] },
  ],
});WORLD_TOURS.push({
  slug: "coorg-mysore-bengaluru-kamg",
  title: "Coorg Mysore Bengaluru",
  scope: "world",
  image: "/assets/media/wiki-coorg.jpg",
  gallery: ["/assets/media/wiki-coorg.jpg", "/assets/media/wiki-mysore.jpg"],
  code: "KAMG",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Karnataka",
  zone: "South India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 49000,
  joiningLeavingPrice: 37000,
  emiPerMonth: 4765,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Karnataka", stops: ["Mysore (2N)", "Coorg (2N)", "Bengaluru (1N)"] }],
  highlights: ["Brindavan Gardens", "Mysore Palace", "Mysore Sand Sculpture Museum", "Shri Chamundeshwari Temple", "Tibetan Monastery and Tibetan Market", "The Hanging Bridge at Cauvery Nisargdhama", "Dubare Elephant Camp", "Abbey Waterfalls", "Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bengaluru (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Bengaluru · Mysore", state: "Karnataka", desc: "Arrive in Bengaluru and travel to Mysore for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at Bengaluru Airport.", nights: 2 },
    { day: 2, title: "Mysore", state: "Karnataka", desc: "Visit Mysore Palace, Mysore Sand Sculpture Museum and Shri Chamundeshwari Temple, then enjoy the gardens at Brindavan.", highlights: ["Brindavan Gardens", "Mysore Palace", "Mysore Sand Sculpture Museum", "Shri Chamundeshwari Temple"] },
    { day: 3, title: "Mysore · Coorg", state: "Karnataka", desc: "Travel from Mysore to Coorg and check in for a two-night stay. Visit Tipu Sultan’s Summer Palace en route as scheduled.", nights: 2, highlights: ["Tipu Sultan’s Summer Palace"] },
    { day: 4, title: "Coorg", state: "Karnataka", desc: "Explore Coorg’s Tibetan Monastery and Market, walk across the Hanging Bridge at Cauvery Nisargadhama, visit Dubare Elephant Camp and see Abbey Waterfalls.", highlights: ["Tibetan Monastery and Tibetan Market", "The Hanging Bridge at Cauvery Nisargdhama", "Dubare Elephant Camp", "Abbey Waterfalls"] },
    { day: 5, title: "Coorg · Bengaluru", state: "Karnataka", desc: "Travel to Bengaluru and check in for an overnight stay.", nights: 1 },
    { day: 6, title: "Bengaluru · Departure", state: "Karnataka", desc: "Visit Lalbagh Botanical Gardens before your onward departure. Scheduled guests fly back to Mumbai; joining/leaving guests depart from Bengaluru independently.", highlights: ["Lalbagh Botanical Gardens"] },
  ],
});WORLD_TOURS.push({
  slug: "jaipur-udaipur-kumbhalgarh-rjuk",
  title: "Jaipur Udaipur Kumbhalgarh",
  scope: "world",
  image: "/assets/media/wiki-jaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-chittorgarh.jpg", "/assets/media/wiki-pushkar.jpg"],
  code: "RJUK",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Rajasthan",
  zone: "India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 49000,
  joiningLeavingPrice: 37000,
  emiPerMonth: 4771,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Jaipur (2N)", "Udaipur (2N)", "Nathdwara", "Kumbhalgarh (2N)"] }],
  highlights: ["Amer Fort", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Moti Magri", "City Palace Udaipur", "Boat Ride to Jag Mandir", "Traditional Music and Dance Show", "Shrinathji Temple", "Statue of Belief", "Kumbhalgarh Fort", "Ranakpur Jain Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jaipur (Joining)", "Udaipur (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur", state: "Rajasthan", desc: "Arrive in Jaipur and check in. Scheduled guests fly from Mumbai; joining guests meet the group in Jaipur.", nights: 2 },
    { day: 2, title: "Jaipur", state: "Rajasthan", desc: "Explore Jaipur’s heritage at Amer Fort, Hawa Mahal, Jantar Mantar and City Palace, with a stop at Panna Meena ka Kund.", highlights: ["Amer Fort", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund"] },
    { day: 3, title: "Jaipur · Udaipur", state: "Rajasthan", desc: "Travel from Jaipur to Udaipur and settle in for a two-night stay.", nights: 2 },
    { day: 4, title: "Udaipur", state: "Rajasthan", desc: "Visit Moti Magri and City Palace Udaipur, take a boat ride to Jag Mandir and enjoy a traditional music and dance show.", highlights: ["Moti Magri", "City Palace Udaipur", "Boat Ride to Jag Mandir", "Traditional Music and Dance Show"] },
    { day: 5, title: "Udaipur · Nathdwara · Kumbhalgarh", state: "Rajasthan", desc: "Visit Shrinathji Temple and the Statue of Belief at Nathdwara, then continue to Kumbhalgarh for a two-night stay.", nights: 2, highlights: ["Shrinathji Temple", "Statue of Belief"] },
    { day: 6, title: "Kumbhalgarh", state: "Rajasthan", desc: "Explore the historic Kumbhalgarh Fort and visit Ranakpur Jain Temple.", highlights: ["Kumbhalgarh Fort", "Ranakpur Jain Temple"] },
    { day: 7, title: "Kumbhalgarh · Udaipur · Departure", state: "Rajasthan", desc: "Travel to Udaipur for your onward departure. Scheduled guests fly to Mumbai; joining/leaving guests depart independently.", highlights: ["Udaipur"] },
  ],
});WORLD_TOURS.push({
  slug: "nainital-mussoorie-haridwar-nimn",
  title: "Nainital Mussoorie Haridwar",
  scope: "world",
  image: "/assets/media/wiki-nainital.jpg",
  gallery: ["/assets/media/wiki-nainital.jpg", "/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-rishikesh.jpg", "/assets/media/wiki-haridwar-aarti.jpg"],
  code: "NIMN",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 6,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Nature & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 48000,
  joiningLeavingPrice: 36000,
  emiPerMonth: 4668,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Delhi", stops: ["Delhi (1N)"] },
    { state: "Uttarakhand", stops: ["Bhimtal / Nainital (2N)", "Mussoorie (2N)", "Rishikesh", "Haridwar (1N)"] },
  ],
  highlights: ["Kainchi Dham Ashram", "Cable Car Ride", "Nainadevi Temple", "Naini Lake Boating", "Jim Corbett Museum", "Kempty Falls", "Gun Hill Ropeway", "Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula Photo Stop", "White Water Rafting", "Ganga Aarti Har Ki Pauri"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and check in for an overnight stay before travelling to Uttarakhand. Scheduled guests fly from Mumbai; joining guests meet the group in Delhi.", nights: 1 },
    { day: 2, title: "Delhi · Bhimtal", state: "Uttarakhand", desc: "Travel from Delhi to Bhimtal and settle in for a two-night stay in the Nainital region.", nights: 2 },
    { day: 3, title: "Bhimtal · Nainital · Bhimtal", state: "Uttarakhand", desc: "Explore Nainital, visit Kainchi Dham, take a cable car ride and see Nainadevi Temple. Enjoy boating on Naini Lake.", highlights: ["Kainchi Dham Ashram", "Cable Car Ride", "Nainadevi Temple", "Naini Lake Boating"] },
    { day: 4, title: "Nainital · Mussoorie", state: "Uttarakhand", desc: "Travel from Nainital to Mussoorie for a two-night stay. Visit the Jim Corbett Museum as scheduled en route.", nights: 2, highlights: ["Jim Corbett Museum"] },
    { day: 5, title: "Mussoorie", state: "Uttarakhand", desc: "Enjoy Mussoorie sightseeing, including Kempty Falls and the Gun Hill Ropeway.", highlights: ["Kempty Falls", "Gun Hill Ropeway"] },
    { day: 6, title: "Mussoorie · Rishikesh · Haridwar", state: "Uttarakhand", desc: "Visit Rishikesh landmarks including Prati Badri Kedarnath Temple, Lakshman Mandir and Lakshman Jhula, with white water rafting. Continue to Haridwar for an overnight stay and Ganga Aarti at Har Ki Pauri.", nights: 1, highlights: ["Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula Photo Stop", "White Water Rafting", "Ganga Aarti Har Ki Pauri"] },
    { day: 7, title: "Haridwar · Delhi · Departure", state: "Delhi", desc: "Travel from Haridwar to Delhi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart from Delhi independently.", highlights: ["Delhi"] },
  ],
});WORLD_TOURS.push({
  slug: "jaipur-udaipur-rjju",
  title: "Jaipur Udaipur",
  scope: "world",
  image: "/assets/media/wiki-jaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-pushkar.jpg"],
  code: "RJJU",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Rajasthan",
  zone: "India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 37000,
  joiningLeavingPrice: 27000,
  emiPerMonth: 3600,
  rating: 5,
  reviewsCount: 9,
  route: [{ state: "Rajasthan", stops: ["Jaipur (2N)", "Udaipur (2N)"] }],
  highlights: ["Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Amer Fort", "Sound and Light Show", "Bapu Market Shopping", "Udaipur City", "Moti Magri", "Fateh Sagar Lake", "Udaipur City Palace", "Boat Ride", "Jag Mandir", "Lake Pichola", "Traditional Music Show", "Traditional Dance Show", "Palatial Architecture", "Cultural Heritage", "Rajput-Mughal Influence", "Local Shopping"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jaipur (Joining)", "Udaipur (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur", state: "Rajasthan", desc: "Arrive in Jaipur and settle in for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Jaipur.", nights: 2 },
    { day: 2, title: "Jaipur", state: "Rajasthan", desc: "Explore Jaipur’s highlights, including Hawa Mahal, Jantar Mantar, City Palace, Panna Meena ka Kund and Amer Fort. Enjoy the Sound and Light Show and time for shopping at Bapu Market.", highlights: ["Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Amer Fort", "Sound and Light Show", "Bapu Market Shopping"] },
    { day: 3, title: "Jaipur · Udaipur", state: "Rajasthan", desc: "Travel from Jaipur to Udaipur and check in for a two-night stay.", nights: 2 },
    { day: 4, title: "Udaipur", state: "Rajasthan", desc: "Discover Udaipur city, Moti Magri, Fateh Sagar Lake and Udaipur City Palace. Enjoy a boat ride to Jag Mandir on Lake Pichola and a traditional music and dance show.", highlights: ["Udaipur City", "Moti Magri", "Fateh Sagar Lake", "Udaipur City Palace", "Boat Ride", "Jag Mandir", "Lake Pichola", "Traditional Music Show", "Traditional Dance Show"] },
    { day: 5, title: "Udaipur · Departure", state: "Rajasthan", desc: "Depart from Udaipur for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Udaipur"] },
  ],
});WORLD_TOURS.push({
  slug: "rajasthan-marwad-rjtsm",
  title: "Rajasthan Marwad",
  scope: "world",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-mandawa.jpg", "/assets/media/wiki-rann-kutch.jpg"],
  code: "RJTSM",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 6,
  region: "Rajasthan",
  zone: "India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 53000,
  joiningLeavingPrice: 37000,
  emiPerMonth: 5161,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Mandawa (2N)", "Bikaner (1N)", "Jaisalmer (2N)", "Jodhpur (2N)"] }],
  highlights: ["Mandawa Fort", "Podar Haveli Museum", "Morarka Haveli", "Karani Mata Temple", "Junagarh Fort", "Anup Mahal", "Gaj Mandir", "Sheesh Mahal", "Prachina Museum", "Sadual Museum", "Camel Research Farm", "Gadisar Lake", "Puppet Show", "Golden Fort (Jaisalmer Fort)", "Jaisalmer Fort Palace", "Patwon Ki Haveli", "Kuldhara Village", "Sam Sand Dunes", "Dune Bashing", "Camel Ride", "Rajasthani Folk Dance", "Jaisalmer War Museum", "Bishnoi Village Safari", "Umaid Bhawan Palace Museum", "Mehrangarh Fort", "Moti Mahal", "Phool Mahal", "Silah Khana", "Daulat Khana", "Jaswant Thada", "Sanganeri Block Prints", "Shopping in Jodhpur"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jaipur (Joining)", "Jodhpur (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur · Mandawa", state: "Rajasthan", desc: "Arrive in Jaipur and travel to Mandawa for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Jaipur.", nights: 2 },
    { day: 2, title: "Mandawa · Nawalgarh · Mandawa", state: "Rajasthan", desc: "Explore Mandawa Fort, Podar Haveli Museum and Morarka Haveli, and visit Nawalgarh.", highlights: ["Mandawa Fort", "Podar Haveli Museum", "Morarka Haveli", "Nawalgarh"] },
    { day: 3, title: "Mandawa · Bikaner", state: "Rajasthan", desc: "Travel to Bikaner for an overnight stay. Visit Karani Mata Temple, Junagarh Fort, Anup Mahal, Gaj Mandir, Sheesh Mahal, Prachina Museum and Sadual Museum as scheduled.", nights: 1, highlights: ["Karani Mata Temple", "Junagarh Fort", "Anup Mahal", "Gaj Mandir", "Sheesh Mahal", "Prachina Museum", "Sadual Museum"] },
    { day: 4, title: "Bikaner · Jaisalmer", state: "Rajasthan", desc: "Visit the Camel Research Farm and continue to Jaisalmer for a two-night stay.", nights: 2, highlights: ["Camel Research Farm"] },
    { day: 5, title: "Jaisalmer", state: "Rajasthan", desc: "Enjoy a Gadisar Lake visit and puppet show, explore Jaisalmer Fort, its heritage centre and Patwon Ki Haveli, and visit Kuldhara. Experience the Sam Sand Dunes with dune bashing, a camel ride and Rajasthani folk dance.", highlights: ["Gadisar Lake", "Puppet Show", "Golden Fort (Jaisalmer Fort)", "Jaisalmer Fort Palace", "Patwon Ki Haveli", "Kuldhara Village", "Sam Sand Dunes", "Dune Bashing", "Camel Ride", "Rajasthani Folk Dance", "Jaisalmer War Museum"] },
    { day: 6, title: "Jaisalmer · Jodhpur", state: "Rajasthan", desc: "Travel from Jaisalmer to Jodhpur for a two-night stay.", nights: 2 },
    { day: 7, title: "Jodhpur", state: "Rajasthan", desc: "Explore Jodhpur with a Bishnoi Village Safari, Umaid Bhawan Palace Museum, Mehrangarh Fort and its palaces. Visit Jaswant Thada, see Sanganeri block printing and enjoy time for shopping.", highlights: ["Bishnoi Village Safari", "Umaid Bhawan Palace Museum", "Mehrangarh Fort", "Moti Mahal", "Phool Mahal", "Silah Khana", "Daulat Khana", "Jaswant Thada", "Sanganeri Block Prints", "Shopping in Jodhpur"] },
    { day: 8, title: "Jodhpur · Departure", state: "Rajasthan", desc: "Depart from Jodhpur for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Jodhpur"] },
  ],
});WORLD_TOURS.push({
  slug: "rajasthan-mewad-rjsp",
  title: "Rajasthan Mewad",
  scope: "world",
  image: "/assets/media/wiki-udaipur.jpg",
  gallery: ["/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-chittorgarh.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-ranthambore.jpg", "/assets/media/wiki-jaipur.jpg"],
  code: "RJSP",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 7,
  region: "Rajasthan",
  zone: "India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 53000,
  joiningLeavingPrice: 37000,
  emiPerMonth: 5161,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Gujarat", stops: ["Ahmedabad"] },
    { state: "Rajasthan", stops: ["Mount Abu (1N)", "Udaipur (2N)", "Pushkar (1N)", "Ranthambore (1N)", "Jaipur (2N)"] },
  ],
  highlights: ["Mount Abu Hill Station", "Gurushikhar Peak", "Dilwara Temple Carvings", "Nakki Lake", "Udaipur City Palace", "Fateh Sagar Lake", "Moti Magri", "Lake Pichola Boat Ride", "Jag Mandir Palace", "Shopping in Udaipur", "Traditional Music and Dance Show", "Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini’s Palace", "Pushkar Brahma Mandir", "Pushkar Tirth", "Kishangarh", "Ranthambore National Park Safari", "Birla Temple Jaipur", "Amer Fort Sound and Light Show", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Amer Fort", "Bapu Market Jaipur"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining)", "Jaipur (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Ahmedabad · Mount Abu", state: "Rajasthan", desc: "Arrive in Ahmedabad and travel to Mount Abu for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Ahmedabad Airport.", nights: 1 },
    { day: 2, title: "Mount Abu · Udaipur", state: "Rajasthan", desc: "Explore Mount Abu, including Gurushikhar, Dilwara Temple and Nakki Lake, then continue to Udaipur for a two-night stay.", nights: 2, highlights: ["Mount Abu Hill Station", "Gurushikhar Peak", "Dilwara Temple Carvings", "Nakki Lake"] },
    { day: 3, title: "Udaipur", state: "Rajasthan", desc: "Visit Udaipur City Palace, Fateh Sagar Lake and Moti Magri. Enjoy a Lake Pichola boat ride to Jag Mandir, shopping and a traditional music and dance show.", highlights: ["Udaipur City Palace", "Fateh Sagar Lake", "Moti Magri", "Lake Pichola Boat Ride", "Jag Mandir Palace", "Shopping in Udaipur", "Traditional Music and Dance Show"] },
    { day: 4, title: "Udaipur · Chittorgarh · Pushkar", state: "Rajasthan", desc: "Travel via Chittorgarh Fort and its historic palaces and temples, then continue to Pushkar for an overnight stay.", nights: 1, highlights: ["Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini’s Palace"] },
    { day: 5, title: "Pushkar · Ranthambore", state: "Rajasthan", desc: "Visit Brahma Mandir and Pushkar Tirth, stop at Kishangarh and continue to Ranthambore for an overnight stay.", nights: 1, highlights: ["Pushkar Brahma Mandir", "Pushkar Tirth", "Kishangarh"] },
    { day: 6, title: "Ranthambore · Jaipur", state: "Rajasthan", desc: "Enjoy a safari at Ranthambore National Park, then travel to Jaipur for a two-night stay.", nights: 2, highlights: ["Ranthambore National Park Safari"] },
    { day: 7, title: "Jaipur", state: "Rajasthan", desc: "Explore Jaipur’s Birla Temple, Amer Fort, Hawa Mahal, Jantar Mantar and City Palace. Enjoy the Amer Fort Sound and Light Show and time at Bapu Market.", highlights: ["Birla Temple Jaipur", "Amer Fort Sound and Light Show", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Amer Fort", "Bapu Market Jaipur"] },
    { day: 8, title: "Jaipur · Departure", state: "Rajasthan", desc: "Depart from Jaipur for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Jaipur"] },
  ],
});WORLD_TOURS.push({
  slug: "womens-special-dalhousie-dharamshala-amritsar-hpwd",
  title: "Women's Special Dalhousie Dharamshala Amritsar",
  scope: "world",
  image: "/assets/media/wiki-dalhousie.jpg",
  gallery: [],
  code: "HPWD",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Himachal Pradesh & Punjab",
  zone: "North India",
  interest: "Nature & Culture",
  packageType: "Group Tour",
  startingPrice: 54000,
  joiningLeavingPrice: 40000,
  emiPerMonth: 5258,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Punjab", stops: ["Amritsar (3N)"] },
    { state: "Himachal Pradesh", stops: ["Dalhousie (2N)", "Khajjiar", "Chamba", "Dharamshala (2N)"] },
  ],
  highlights: ["Golden Temple", "Akal Takht", "Jallianwala Bagh", "Partition Museum", "Punjab State War Heroes Memorial", "Traditional Punjabi Village Museum", "Kangra Fort", "Chinmaya Tapovan", "Meditation Hall", "Dalhousie Town", "Khajjiar (Mini Switzerland)", "Khajjiar Sanctuary", "Chamera Dam Boating", "Dharamshala Cricket Stadium", "Dharamshala Skyway Ropeway", "McLeod Ganj", "Tibetan Bazar", "Dalai Lama Monastery", "Saint John's Church", "Bhagsu Naag Temple", "Attari Wagah Border Ceremony"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Amritsar (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Amritsar", state: "Punjab", desc: "Arrive in Amritsar and check in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Amritsar Airport.", nights: 1 },
    { day: 2, title: "Amritsar · Dalhousie", state: "Himachal Pradesh", desc: "Travel from Amritsar to Dalhousie and settle in for a two-night stay.", nights: 2 },
    { day: 3, title: "Dalhousie · Khajjiar · Chamba · Dalhousie", state: "Himachal Pradesh", desc: "Explore Dalhousie, visit scenic Khajjiar and its sanctuary, continue to Chamba and enjoy boating at Chamera Dam.", highlights: ["Dalhousie Town", "Khajjiar (Mini Switzerland)", "Khajjiar Sanctuary", "Chamera Dam Boating"] },
    { day: 4, title: "Dalhousie · Dharamshala", state: "Himachal Pradesh", desc: "Travel to Dharamshala and check in for a two-night stay. Visit Kangra Fort and Chinmaya Tapovan, including the meditation hall.", nights: 2, highlights: ["Kangra Fort", "Chinmaya Tapovan", "Meditation Hall"] },
    { day: 5, title: "Dharamshala", state: "Himachal Pradesh", desc: "Explore Dharamshala, including the cricket stadium and Skyway ropeway, McLeod Ganj, Tibetan Bazar, Dalai Lama Monastery, Saint John's Church and Bhagsu Naag Temple.", highlights: ["Dharamshala Cricket Stadium", "Dharamshala Skyway Ropeway", "McLeod Ganj", "Tibetan Bazar", "Dalai Lama Monastery", "Saint John's Church", "Bhagsu Naag Temple"] },
    { day: 6, title: "Dharamshala · Amritsar", state: "Punjab", desc: "Travel back to Amritsar and check in for a two-night stay.", nights: 2 },
    { day: 7, title: "Amritsar", state: "Punjab", desc: "Visit the Golden Temple, Akal Takht, Jallianwala Bagh, Partition Museum and Punjab State War Heroes Memorial. Experience a traditional Punjabi village museum and attend the Attari Wagah Border ceremony.", highlights: ["Golden Temple", "Akal Takht", "Jallianwala Bagh", "Partition Museum", "Punjab State War Heroes Memorial", "Traditional Punjabi Village Museum", "Attari Wagah Border Ceremony"] },
    { day: 8, title: "Amritsar · Departure", state: "Punjab", desc: "Depart from Amritsar for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Amritsar"] },
  ],
});WORLD_TOURS.push({
  slug: "seniors-special-dalhousie-dharamshala-amritsar-hpzd",
  title: "Seniors' Special Dalhousie Dharamshala Amritsar",
  scope: "world",
  image: "/assets/media/wiki-dalhousie.jpg",
  gallery: [],
  code: "HPZD",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Himachal Pradesh & Punjab",
  zone: "North India",
  interest: "Nature & Culture",
  packageType: "Group Tour",
  startingPrice: 55000,
  joiningLeavingPrice: 41000,
  emiPerMonth: 5356,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Punjab", stops: ["Amritsar (3N)"] },
    { state: "Himachal Pradesh", stops: ["Dalhousie (2N)", "Khajjiar", "Chamba", "Dharamshala (2N)"] },
  ],
  highlights: ["Golden Temple", "Akal Takht", "Jallianwala Bagh", "Partition Museum", "Punjab State War Heroes Memorial", "Traditional Punjabi Village Museum", "Kangra Fort", "Chinmaya Tapovan", "Meditation Hall", "Dalhousie Town", "Khajjiar (Mini Switzerland)", "Khajjiar Sanctuary", "Chamera Dam Boating", "Dharamshala Cricket Stadium", "Dharamshala Skyway Ropeway", "McLeod Ganj", "Tibetan Bazar", "Dalai Lama Monastery", "Saint John's Church", "Bhagsu Naag Temple", "Attari Wagah Border Ceremony"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Amritsar (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Amritsar", state: "Punjab", desc: "Arrive in Amritsar and check in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Amritsar Airport.", nights: 1 },
    { day: 2, title: "Amritsar · Dalhousie", state: "Himachal Pradesh", desc: "Travel from Amritsar to Dalhousie and settle in for a two-night stay.", nights: 2 },
    { day: 3, title: "Dalhousie · Khajjiar · Chamba · Dalhousie", state: "Himachal Pradesh", desc: "Explore Dalhousie, visit scenic Khajjiar and its sanctuary, continue to Chamba and enjoy boating at Chamera Dam.", highlights: ["Dalhousie Town", "Khajjiar (Mini Switzerland)", "Khajjiar Sanctuary", "Chamera Dam Boating"] },
    { day: 4, title: "Dalhousie · Dharamshala", state: "Himachal Pradesh", desc: "Travel to Dharamshala and check in for a two-night stay. Visit Kangra Fort and Chinmaya Tapovan, including the meditation hall.", nights: 2, highlights: ["Kangra Fort", "Chinmaya Tapovan", "Meditation Hall"] },
    { day: 5, title: "Dharamshala", state: "Himachal Pradesh", desc: "Explore Dharamshala, including the cricket stadium and Skyway ropeway, McLeod Ganj, Tibetan Bazar, Dalai Lama Monastery, Saint John's Church and Bhagsu Naag Temple.", highlights: ["Dharamshala Cricket Stadium", "Dharamshala Skyway Ropeway", "McLeod Ganj", "Tibetan Bazar", "Dalai Lama Monastery", "Saint John's Church", "Bhagsu Naag Temple"] },
    { day: 6, title: "Dharamshala · Amritsar", state: "Punjab", desc: "Travel back to Amritsar and check in for a two-night stay.", nights: 2 },
    { day: 7, title: "Amritsar", state: "Punjab", desc: "Visit the Golden Temple, Akal Takht, Jallianwala Bagh, Partition Museum and Punjab State War Heroes Memorial. Experience a traditional Punjabi village museum and attend the Attari Wagah Border ceremony.", highlights: ["Golden Temple", "Akal Takht", "Jallianwala Bagh", "Partition Museum", "Punjab State War Heroes Memorial", "Traditional Punjabi Village Museum", "Attari Wagah Border Ceremony"] },
    { day: 8, title: "Amritsar · Departure", state: "Punjab", desc: "Depart from Amritsar for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Amritsar"] },
  ],
});WORLD_TOURS.push({
  slug: "dwarka-somnath-girnar-gtgd",
  title: "Dwarka Somnath Girnar",
  scope: "world",
  image: "/assets/media/wiki-dwarka.jpg",
  gallery: ["/assets/media/wiki-somnath.jpg", "/assets/media/wiki-gir.jpg"],
  code: "GTGD",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Gujarat",
  zone: "West & Central India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 55000,
  emiPerMonth: 5356,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Gujarat", stops: ["Ahmedabad (1N)", "Dwarka (2N)", "Porbandar", "Somnath (1N)", "Sasan Gir (2N)", "Junagadh", "Ahmedabad (1N)"] },
  ],
  highlights: ["Dwarkadhish Temple", "Rukmini Temple", "Nageshwar Jyotirlinga Temple", "Sudarshan Setu", "Somnath Temple", "Triveni Sangam", "Geeta Mandir", "Somnath Sound and Light Show", "Kirti Mandir (Porbandar)", "Sudama Temple", "Sasan Gir Interpretation Zone", "Girnar", "Adalaj Stepwell", "Sabarmati Ashram", "Vision in Dark Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Ahmedabad", state: "Gujarat", desc: "Arrive in Ahmedabad and check in for an overnight stay. Mumbai departure guests fly to Ahmedabad; joining guests meet the group at the airport.", nights: 1 },
    { day: 2, title: "Ahmedabad · Dwarka", state: "Gujarat", desc: "Travel from Ahmedabad to Dwarka and check in for a two-night stay.", nights: 2 },
    { day: 3, title: "Dwarka", state: "Gujarat", desc: "Visit Dwarkadhish Temple, Rukmini Temple, Nageshwar Jyotirlinga Temple and Sudarshan Setu.", highlights: ["Dwarkadhish Temple", "Rukmini Temple", "Nageshwar Jyotirlinga Temple", "Sudarshan Setu"] },
    { day: 4, title: "Dwarka · Porbandar · Somnath", state: "Gujarat", desc: "Travel via Porbandar, visiting Kirti Mandir and Sudama Temple, then continue to Somnath for an overnight stay.", nights: 1, highlights: ["Kirti Mandir (Porbandar)", "Sudama Temple"] },
    { day: 5, title: "Somnath · Sasan Gir · Junagadh", state: "Gujarat", desc: "Visit Somnath Temple and Triveni Sangam before continuing to Sasan Gir and Junagadh for a two-night stay.", nights: 2, highlights: ["Somnath Temple", "Triveni Sangam", "Geeta Mandir", "Somnath Sound and Light Show", "Sasan Gir Interpretation Zone"] },
    { day: 6, title: "Junagadh · Girnar · Junagadh", state: "Gujarat", desc: "Explore Junagadh and visit Girnar before returning to Junagadh.", highlights: ["Girnar"] },
    { day: 7, title: "Junagadh · Ahmedabad", state: "Gujarat", desc: "Travel back to Ahmedabad and visit Adalaj Stepwell, Sabarmati Ashram and the Vision in Dark Museum. Stay overnight in Ahmedabad.", nights: 1, highlights: ["Adalaj Stepwell", "Sabarmati Ashram", "Vision in Dark Museum"] },
    { day: 8, title: "Ahmedabad · Departure", state: "Gujarat", desc: "Depart from Ahmedabad for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Ahmedabad"] },
  ],
});WORLD_TOURS.push({
  slug: "bhubaneswar-puri-konark-chilika-odpb",
  title: "Bhubaneswar Puri Konark Chilika",
  scope: "world",
  image: "/assets/media/wiki-puri.jpg",
  gallery: ["/assets/media/wiki-puri.jpg", "/assets/media/wiki-konark.jpg", "/assets/media/wiki-chilika.jpg"],
  code: "ODPB",
  tourType: "GROUP TOUR",
  speciality: "Short Trips",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Odisha",
  zone: "East India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 54000,
  emiPerMonth: 5258,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Odisha", stops: ["Bhubaneswar (2N)", "Puri (3N)"] },
  ],
  highlights: ["Lingaraj Temple", "Udayagiri Caves", "Khandagiri Caves", "Nandankanan Zoo", "Dhauli Shanti Stupa", "Pipli Applique Village", "Puri Beach Sunset", "Chilika Lake", "Sea Mouth Island", "Odia Folk Dance Show", "Jagannath Temple", "Chandrabhaga Beach", "Sand Art Museum", "Konark Sun Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bhubaneswar (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Bhubaneswar", state: "Odisha", desc: "Arrive in Bhubaneswar and check in for a two-night stay. Mumbai departure guests fly to Bhubaneswar; joining guests meet the group at the airport.", nights: 2 },
    { day: 2, title: "Bhubaneswar", state: "Odisha", desc: "Explore Bhubaneswar's temples and heritage, including Lingaraj Temple, Udayagiri and Khandagiri Caves, Nandankanan Zoo and Dhauli Shanti Stupa. Stop at Pipli's applique village.", highlights: ["Lingaraj Temple", "Udayagiri Caves", "Khandagiri Caves", "Nandankanan Zoo", "Dhauli Shanti Stupa", "Pipli Applique Village"] },
    { day: 3, title: "Bhubaneswar · Puri", state: "Odisha", desc: "Travel from Bhubaneswar to Puri and check in for a three-night stay. Enjoy the Puri Beach sunset.", nights: 3, highlights: ["Puri Beach Sunset"] },
    { day: 4, title: "Puri", state: "Odisha", desc: "Visit Jagannath Temple and enjoy Puri's coastal atmosphere, with an Odia folk dance performance.", highlights: ["Jagannath Temple", "Odia Folk Dance Show"] },
    { day: 5, title: "Puri · Chilika · Konark · Puri", state: "Odisha", desc: "Explore Chilika Lake and Sea Mouth Island, then visit Chandrabhaga Beach, the Sand Art Museum and the Konark Sun Temple.", highlights: ["Chilika Lake", "Sea Mouth Island", "Chandrabhaga Beach", "Sand Art Museum", "Konark Sun Temple"] },
    { day: 6, title: "Puri · Bhubaneswar · Departure", state: "Odisha", desc: "Travel from Puri to Bhubaneswar for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Bhubaneswar"] },
  ],
});WORLD_TOURS.push({
  slug: "pondicherry-mahabalipuram-stpm",
  title: "Pondicherry Mahabalipuram",
  scope: "world",
  image: "/assets/media/wiki-pondicherry.jpg",
  gallery: [],
  code: "STPM",
  tourType: "GROUP TOUR",
  speciality: "Short Trips",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Tamil Nadu & Puducherry",
  zone: "South India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 55000,
  emiPerMonth: 5356,
  rating: 5,
  reviewsCount: 30,
  route: [
    { state: "Tamil Nadu", stops: ["Kanchipuram (1N)", "Mahabalipuram"] },
    { state: "Puducherry", stops: ["Pondicherry (3N)", "Chidambaram", "Pichavaram"] },
  ],
  highlights: ["Vishnukanchi Temple", "Krishna's Butter Ball", "Sri Aurobindo Ashram", "Pondicherry Museum", "Promenade Beach Walk", "Chidambaram Nataraja Temple", "Pichavaram Mangrove Forest"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Chennai (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Chennai · Kanchipuram", state: "Tamil Nadu", desc: "Arrive in Chennai and travel to Kanchipuram. Visit Vishnukanchi Temple and stay overnight in Kanchipuram.", nights: 1, highlights: ["Vishnukanchi Temple"] },
    { day: 2, title: "Kanchipuram · Mahabalipuram · Pondicherry", state: "Puducherry", desc: "Explore Mahabalipuram, including Krishna's Butter Ball, then continue to Pondicherry for a three-night stay.", nights: 3, highlights: ["Krishna's Butter Ball"] },
    { day: 3, title: "Pondicherry", state: "Puducherry", desc: "Discover Pondicherry's heritage with a visit to Sri Aurobindo Ashram, Pondicherry Museum and a walk along Promenade Beach.", highlights: ["Sri Aurobindo Ashram", "Pondicherry Museum", "Promenade Beach Walk"] },
    { day: 4, title: "Pondicherry · Chidambaram · Pichavaram · Pondicherry", state: "Puducherry", desc: "Visit Chidambaram Nataraja Temple and explore the Pichavaram mangrove forest before returning to Pondicherry.", highlights: ["Chidambaram Nataraja Temple", "Pichavaram Mangrove Forest"] },
    { day: 5, title: "Pondicherry · Chennai · Departure", state: "Tamil Nadu", desc: "Travel from Pondicherry to Chennai for your onward journey. Mumbai departure guests fly back; joining/leaving guests depart independently.", highlights: ["Chennai"] },
  ],
});WORLD_TOURS.push({
  slug: "womens-special-bhubaneswar-puri-konark-chilika-odwb",
  title: "Women's Special Bhubaneswar Puri Konark Chilika",
  scope: "world",
  image: "/assets/media/wiki-puri.jpg",
  gallery: ["/assets/media/wiki-puri.jpg", "/assets/media/wiki-konark.jpg", "/assets/media/wiki-chilika.jpg"],
  code: "ODWB",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Odisha",
  zone: "East India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 57000,
  emiPerMonth: 5545,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Odisha", stops: ["Bhubaneswar (2N)", "Puri (3N)"] },
  ],
  highlights: ["Lingaraj Temple", "Udayagiri & Khandagiri Caves", "Nandankanan Zoo", "Dhauli Shanti Stupa", "Pipli Village", "Chilika Lake", "Sea Mouth Island", "Odia Folk Dance", "Jagannath Temple", "Konark Sun Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bhubaneswar (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: "optional", sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Bhubaneswar", state: "Odisha", desc: "Arrive in Bhubaneswar and check in for a two-night stay. Mumbai departure guests fly to Bhubaneswar; joining guests meet the group at the airport.", nights: 2 },
    { day: 2, title: "Bhubaneswar", state: "Odisha", desc: "Explore Bhubaneswar's heritage, including Lingaraj Temple, Udayagiri and Khandagiri Caves, Nandankanan Zoo and Dhauli Shanti Stupa. Visit Pipli Village.", highlights: ["Lingaraj Temple", "Udayagiri & Khandagiri Caves", "Nandankanan Zoo", "Dhauli Shanti Stupa", "Pipli Village"] },
    { day: 3, title: "Bhubaneswar · Puri", state: "Odisha", desc: "Travel from Bhubaneswar to Puri and check in for a three-night stay.", nights: 3 },
    { day: 4, title: "Puri", state: "Odisha", desc: "Visit Jagannath Temple and enjoy time in Puri, with an Odia folk dance performance.", highlights: ["Jagannath Temple", "Odia Folk Dance"] },
    { day: 5, title: "Puri · Chilika · Konark · Puri", state: "Odisha", desc: "Explore Chilika Lake and Sea Mouth Island, then visit Konark Sun Temple and nearby attractions before returning to Puri.", highlights: ["Chilika Lake", "Sea Mouth Island", "Konark Sun Temple"] },
    { day: 6, title: "Puri · Bhubaneswar · Departure", state: "Odisha", desc: "Travel from Puri to Bhubaneswar for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Bhubaneswar"] },
  ],
});WORLD_TOURS.push({
  slug: "womens-special-rajasthan-marwad-rjwb",
  title: "Women's Special Rajasthan Marwad",
  scope: "world",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-mandawa.jpg", "/assets/media/wiki-rann-kutch.jpg"],
  code: "RJWB",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 6,
  region: "Rajasthan",
  zone: "North India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 59000,
  emiPerMonth: 5740,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Mandawa (2N)", "Bikaner (1N)", "Jaisalmer (2N)", "Jodhpur (2N)"] }],
  highlights: ["Mandawa Fort", "Podar Haveli", "Morarka Haveli", "Junagarh Fort", "Gaj Mandir", "Sheesh Mahal", "Prachina Museum", "Sadual Museum", "Karani Mata Temple", "Camel Research Farm", "Gadisar Lake", "Jaisalmer Fort", "Patwon Ki Haveli", "Kuldhara Village", "Sam Sand Dunes", "Dune Bashing", "Camel Ride", "Rajasthani Folk Dance", "Jaisalmer War Museum", "Bishnoi Village", "Umaid Bhawan Palace", "Mehrangarh Fort", "Moti Mahal", "Phool Mahal", "Jaswant Thada", "Sanganeri Block Printing", "Shopping in Jodhpur"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jaipur (Joining)", "Jodhpur (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur · Mandawa", state: "Rajasthan", desc: "Arrive in Jaipur and travel to Mandawa for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Jaipur.", nights: 2 },
    { day: 2, title: "Mandawa · Nawalgarh · Mandawa", state: "Rajasthan", desc: "Explore Mandawa Fort, Podar Haveli and Morarka Haveli, and visit Nawalgarh.", highlights: ["Mandawa Fort", "Podar Haveli", "Morarka Haveli"] },
    { day: 3, title: "Mandawa · Bikaner", state: "Rajasthan", desc: "Travel to Bikaner for an overnight stay. Visit Karani Mata Temple, Junagarh Fort, Gaj Mandir, Sheesh Mahal, Prachina Museum and Sadual Museum as scheduled.", nights: 1, highlights: ["Karani Mata Temple", "Junagarh Fort", "Gaj Mandir", "Sheesh Mahal", "Prachina Museum", "Sadual Museum"] },
    { day: 4, title: "Bikaner · Jaisalmer", state: "Rajasthan", desc: "Visit the Camel Research Farm and continue to Jaisalmer for a two-night stay.", nights: 2, highlights: ["Camel Research Farm"] },
    { day: 5, title: "Jaisalmer", state: "Rajasthan", desc: "Explore Gadisar Lake, Jaisalmer Fort, Patwon Ki Haveli and Kuldhara. Experience the Sam Sand Dunes with dune bashing, a camel ride and Rajasthani folk dance.", highlights: ["Gadisar Lake", "Jaisalmer Fort", "Patwon Ki Haveli", "Kuldhara Village", "Sam Sand Dunes", "Dune Bashing", "Camel Ride", "Rajasthani Folk Dance", "Jaisalmer War Museum"] },
    { day: 6, title: "Jaisalmer · Jodhpur", state: "Rajasthan", desc: "Travel from Jaisalmer to Jodhpur for a two-night stay.", nights: 2 },
    { day: 7, title: "Jodhpur", state: "Rajasthan", desc: "Explore Jodhpur, including Umaid Bhawan Palace, Mehrangarh Fort and Jaswant Thada. See Sanganeri block printing and enjoy time for shopping.", highlights: ["Bishnoi Village", "Umaid Bhawan Palace", "Mehrangarh Fort", "Moti Mahal", "Phool Mahal", "Jaswant Thada", "Sanganeri Block Printing", "Shopping in Jodhpur"] },
    { day: 8, title: "Jodhpur · Departure", state: "Rajasthan", desc: "Depart from Jodhpur for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Jodhpur"] },
  ],
});WORLD_TOURS.push({
  slug: "rajasthan-marwad-rjts",
  title: "Rajasthan Marwad",
  scope: "world",
  image: "/assets/media/wiki-jodhpur.jpg",
  gallery: ["/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-mandawa.jpg"],
  code: "RJTS",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 6,
  region: "Rajasthan",
  zone: "North India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 49000,
  emiPerMonth: 4772,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Jodhpur (2N)", "Jaisalmer (2N)", "Bikaner (1N)", "Mandawa (2N)"] }],
  highlights: ["Umaid Bhawan Palace Museum", "Mehrangarh Fort", "Moti Mahal", "Phool Mahal", "Sheesh Mahal", "Silah Khana", "Daulat Khana", "Jaswant Thada", "Sanganeri Block Prints Demonstration", "Bishnoi Village Safari", "Jaisalmer Fort", "Jaisalmer Fort Palace", "Patwon Ki Haveli Museum", "Gadisar Lake Boat Ride", "Puppet Show", "Kuldhara Abandoned Village", "Sam Sand Dunes", "Camel Ride", "Rajasthani Folk Dance", "Jaisalmer War Museum", "Camel Research Farm", "Karani Mata Temple", "Junagarh Fort", "Anup Mahal", "Gaj Mandir", "Prachina Museum", "Sadual Museum", "Mandawa Fort", "Podar Haveli and Museum", "Morarka Haveli"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jodhpur (Joining)", "Jaipur (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jodhpur", state: "Rajasthan", desc: "Arrive in Jodhpur and check in for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at Jodhpur Airport.", nights: 2 },
    { day: 2, title: "Jodhpur", state: "Rajasthan", desc: "Explore Jodhpur, visiting Umaid Bhawan Palace Museum, Mehrangarh Fort and its palaces, Jaswant Thada and a Bishnoi village. See Sanganeri block printing as scheduled.", highlights: ["Umaid Bhawan Palace Museum", "Mehrangarh Fort", "Moti Mahal", "Phool Mahal", "Sheesh Mahal", "Silah Khana", "Daulat Khana", "Jaswant Thada", "Sanganeri Block Prints Demonstration", "Bishnoi Village Safari"] },
    { day: 3, title: "Jodhpur · Jaisalmer", state: "Rajasthan", desc: "Travel from Jodhpur to Jaisalmer and settle in for a two-night stay.", nights: 2 },
    { day: 4, title: "Jaisalmer", state: "Rajasthan", desc: "Explore Jaisalmer Fort and Patwon Ki Haveli, visit Gadisar Lake and Kuldhara, and enjoy the Sam Sand Dunes with a camel ride and Rajasthani folk dance.", highlights: ["Jaisalmer Fort", "Jaisalmer Fort Palace", "Patwon Ki Haveli Museum", "Gadisar Lake Boat Ride", "Puppet Show", "Kuldhara Abandoned Village", "Sam Sand Dunes", "Camel Ride", "Rajasthani Folk Dance", "Jaisalmer War Museum"] },
    { day: 5, title: "Jaisalmer · Bikaner", state: "Rajasthan", desc: "Visit the Camel Research Farm and Karani Mata Temple before continuing to Bikaner for an overnight stay.", nights: 1, highlights: ["Camel Research Farm", "Karani Mata Temple"] },
    { day: 6, title: "Bikaner · Mandawa", state: "Rajasthan", desc: "Explore Junagarh Fort and its palaces and museums, then travel to Mandawa for a two-night stay.", nights: 2, highlights: ["Junagarh Fort", "Anup Mahal", "Gaj Mandir", "Prachina Museum", "Sadual Museum"] },
    { day: 7, title: "Mandawa · Nawalgarh · Mandawa", state: "Rajasthan", desc: "Discover Mandawa Fort, Podar Haveli and Museum, and Morarka Haveli. Visit Nawalgarh before returning to Mandawa.", highlights: ["Mandawa Fort", "Podar Haveli and Museum", "Morarka Haveli"] },
    { day: 8, title: "Mandawa · Jaipur · Departure", state: "Rajasthan", desc: "Travel from Mandawa to Jaipur for your onward journey. Scheduled guests continue to Jaipur Airport for their flight; joining/leaving guests depart independently.", highlights: ["Jaipur"] },
  ],
});WORLD_TOURS.push({
  slug: "womens-special-pondicherry-mahabalipuram-stwd",
  title: "Women's Special Pondicherry Mahabalipuram",
  scope: "world",
  image: "/assets/media/wiki-pondicherry.jpg",
  gallery: [],
  code: "STWD",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Tamil Nadu & Puducherry",
  zone: "South India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 58000,
  emiPerMonth: 5643,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Tamil Nadu", stops: ["Kanchipuram (1N)", "Mahabalipuram", "Chennai"] },
    { state: "Puducherry", stops: ["Pondicherry (3N)"] },
  ],
  highlights: ["Kanchipuram City Tour", "Vishnukanchi Temple", "Mahabalipuram Shore Temple", "Panch Rathas", "Varaha Caves", "Arjuna's Penance", "Krishna's Butter Ball", "Pondicherry City Sights", "Auroville", "Sri Aurobindo Ashram", "Serenity Beach Sunset", "Paradise Beach", "French Town Tour", "Pondicherry Museum", "Ayee Mandapam", "Vinayagar Temple", "French War Memorial", "Notre Dame des Anges Church", "Heritage Walk", "Promenade Beach", "Chennai Shopping"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Chennai (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Chennai · Kanchipuram", state: "Tamil Nadu", desc: "Arrive in Chennai and travel to Kanchipuram. Explore the city and visit Vishnukanchi Temple before an overnight stay.", nights: 1, highlights: ["Kanchipuram City Tour", "Vishnukanchi Temple"] },
    { day: 2, title: "Kanchipuram · Mahabalipuram · Pondicherry", state: "Puducherry", desc: "Visit Mahabalipuram's Shore Temple, Panch Rathas, Varaha Caves, Arjuna's Penance and Krishna's Butter Ball, then continue to Pondicherry for a three-night stay.", nights: 3, highlights: ["Mahabalipuram Shore Temple", "Panch Rathas", "Varaha Caves", "Arjuna's Penance", "Krishna's Butter Ball"] },
    { day: 3, title: "Pondicherry", state: "Puducherry", desc: "Explore Auroville, Sri Aurobindo Ashram, Serenity Beach and Paradise Beach, and discover Pondicherry's French Quarter and heritage sights.", highlights: ["Pondicherry City Sights", "Auroville", "Sri Aurobindo Ashram", "Serenity Beach Sunset", "Paradise Beach", "French Town Tour"] },
    { day: 4, title: "Pondicherry", state: "Puducherry", desc: "Visit Pondicherry Museum, Ayee Mandapam and Vinayagar Temple. See the French War Memorial and Notre Dame des Anges Church, enjoy a heritage walk and stroll along Promenade Beach.", highlights: ["Pondicherry Museum", "Ayee Mandapam", "Vinayagar Temple", "French War Memorial", "Notre Dame des Anges Church", "Heritage Walk", "Promenade Beach"] },
    { day: 5, title: "Pondicherry · Chennai · Departure", state: "Tamil Nadu", desc: "Travel from Pondicherry to Chennai for your onward journey, with time for shopping. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Chennai Shopping"] },
  ],
});WORLD_TOURS.push({
  slug: "seniors-special-kashmir-jkzl",
  title: "Seniors' Special Kashmir",
  scope: "world",
  image: "/assets/media/wiki-dal-lake.jpg",
  gallery: [],
  code: "JKZL",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Kashmir",
  zone: "North India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 64000,
  emiPerMonth: 6232,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Jammu & Kashmir", stops: ["Srinagar (4N)", "Pahalgam (1N)"] }],
  highlights: ["Kashmiri Houseboat Stay", "Sonmarg Excursion", "Fishing Point", "Sarbal Village Walk", "Sarva Dharma Sambhav Temple", "Saffron Fields at Pampore", "Apple Valley", "Betaab Valley Walk", "Avantipur Ruins", "Kashmiri Cricket Bat Factory", "Gulmarg Excursion", "Gondola Ride to Apharwat", "Shankaracharya Hill Trek", "Dal Lake Shikara Ride", "Nehru Park", "Shalimar Bagh", "Nishat Bagh"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Srinagar (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Srinagar", state: "Jammu & Kashmir", desc: "Arrive in Srinagar and settle into a traditional Kashmiri houseboat. Scheduled guests fly from Mumbai; joining guests meet the group in Srinagar.", nights: 1, highlights: ["Kashmiri Houseboat Stay"] },
    { day: 2, title: "Srinagar", state: "Jammu & Kashmir", desc: "Enjoy a Shikara ride on Dal Lake and visit Nehru Park, Shankaracharya Hill and Srinagar's celebrated Mughal gardens.", nights: 2, highlights: ["Dal Lake Shikara Ride", "Nehru Park", "Shankaracharya Hill Trek", "Shalimar Bagh", "Nishat Bagh"] },
    { day: 3, title: "Srinagar · Sonmarg · Srinagar", state: "Jammu & Kashmir", desc: "Take an excursion to Sonmarg and visit the fishing point and Sarbal village before returning to Srinagar.", highlights: ["Sonmarg Excursion", "Fishing Point", "Sarbal Village Walk", "Sarva Dharma Sambhav Temple"] },
    { day: 4, title: "Srinagar · Pampore · Pahalgam", state: "Jammu & Kashmir", desc: "Travel toward Pahalgam, stopping at Pampore's saffron fields, Apple Valley, Avantipur ruins and a Kashmiri cricket bat factory. Check in for an overnight stay.", nights: 1, highlights: ["Saffron Fields at Pampore", "Apple Valley", "Avantipur Ruins", "Kashmiri Cricket Bat Factory"] },
    { day: 5, title: "Pahalgam · Gulmarg · Srinagar", state: "Jammu & Kashmir", desc: "Enjoy a walk in Betaab Valley, then visit Gulmarg for a gondola ride toward Apharwat before returning to Srinagar for the night.", nights: 1, highlights: ["Betaab Valley Walk", "Gulmarg Excursion", "Gondola Ride to Apharwat"] },
    { day: 6, title: "Srinagar · Departure", state: "Jammu & Kashmir", desc: "Depart Srinagar for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});WORLD_TOURS.push({
  slug: "womens-special-kashmir-jkwk",
  title: "Women's Special Kashmir",
  scope: "world",
  image: "/assets/media/wiki-dal-lake.jpg",
  gallery: [],
  code: "JKWK",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Kashmir",
  zone: "North India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 59000,
  emiPerMonth: 5740,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Jammu & Kashmir", stops: ["Srinagar (4N)", "Pahalgam (1N)"] }],
  highlights: ["Kashmiri Houseboat Stay", "Sonmarg Excursion", "Fishing Point", "Sarbal Village Walk", "Sarva Dharma Sambhav Temple", "Saffron Fields at Pampore", "Apple Valley Photo Stop", "Betaab Valley Walk", "Avantipur Ruins", "Kashmiri Cricket Bat Factory", "Gulmarg Excursion", "Gondola Ride", "Apharwat Point", "Shankaracharya Hill", "Dal Lake Shikara Ride", "Nehru Park", "Shalimar Bagh", "Nishat Bagh"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Srinagar (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Srinagar", state: "Jammu & Kashmir", desc: "Arrive in Srinagar and settle into a traditional Kashmiri houseboat. Scheduled guests fly from Mumbai; joining guests meet the group in Srinagar.", nights: 1, highlights: ["Kashmiri Houseboat Stay"] },
    { day: 2, title: "Srinagar", state: "Jammu & Kashmir", desc: "Enjoy a Shikara ride on Dal Lake and visit Nehru Park, Shankaracharya Hill and Srinagar's celebrated Mughal gardens.", nights: 2, highlights: ["Dal Lake Shikara Ride", "Nehru Park", "Shankaracharya Hill", "Shalimar Bagh", "Nishat Bagh"] },
    { day: 3, title: "Srinagar · Sonmarg · Srinagar", state: "Jammu & Kashmir", desc: "Take an excursion to Sonmarg and visit the fishing point and Sarbal village before returning to Srinagar.", highlights: ["Sonmarg Excursion", "Fishing Point", "Sarbal Village Walk", "Sarva Dharma Sambhav Temple"] },
    { day: 4, title: "Srinagar · Pampore · Pahalgam", state: "Jammu & Kashmir", desc: "Travel toward Pahalgam, stopping at Pampore's saffron fields, Apple Valley, Avantipur ruins and a Kashmiri cricket bat factory. Check in for an overnight stay.", nights: 1, highlights: ["Saffron Fields at Pampore", "Apple Valley Photo Stop", "Avantipur Ruins", "Kashmiri Cricket Bat Factory"] },
    { day: 5, title: "Pahalgam · Gulmarg · Srinagar", state: "Jammu & Kashmir", desc: "Enjoy a walk in Betaab Valley, then visit Gulmarg for a gondola ride toward Apharwat before returning to Srinagar for the night.", nights: 1, highlights: ["Betaab Valley Walk", "Gulmarg Excursion", "Gondola Ride", "Apharwat Point"] },
    { day: 6, title: "Srinagar · Departure", state: "Jammu & Kashmir", desc: "Depart Srinagar for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});WORLD_TOURS.push({
  slug: "womens-special-rameshwaram-madurai-thanjavur-tnwm",
  title: "Women's Special Rameshwaram Madurai Thanjavur",
  scope: "world",
  image: "/assets/media/wiki-rameshwaram.jpg",
  gallery: ["/assets/media/wiki-madurai.jpg", "/assets/media/wiki-rameshwaram.jpg"],
  code: "TNWM",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Tamil Nadu",
  zone: "South India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 59000,
  emiPerMonth: 5740,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Tamil Nadu", stops: ["Madurai (1N)", "Rameswaram (2N)", "Thanjavur (2N)"] }],
  highlights: ["Meenakshi Amman Temple", "Ranganatha Swamy Temple", "Mahalakshmi Temple", "Rooftop Temple Viewpoint", "Rockfort Temple", "Thanjavur Town", "Brihadeeswara Temple", "Maratha Palace", "Chettinad Mansion", "Chettinad Palace Photo Stop", "Pamban Bridge Drive", "Ramanathaswamy Temple", "22 Theerthams", "Shopping Time", "Panchamukhi Hanuman Temple", "Shri Natraj Mandir", "Dhanushkodi Beach Walk", "Dr. APJ Abdul Kalam Memorial"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Madurai (Joining/leaving)", "Chennai (Joining/leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Madurai", state: "Tamil Nadu", desc: "Arrive in Madurai and visit Meenakshi Amman Temple. Scheduled guests fly from Mumbai; joining guests meet the group in Madurai.", nights: 1, highlights: ["Meenakshi Amman Temple"] },
    { day: 2, title: "Madurai · Rameswaram", state: "Tamil Nadu", desc: "Travel to Rameswaram, crossing the scenic Pamban Bridge. Visit Ramanathaswamy Temple and its sacred 22 theerthams.", nights: 2, highlights: ["Pamban Bridge Drive", "Ramanathaswamy Temple", "22 Theerthams"] },
    { day: 3, title: "Rameswaram · Dhanushkodi", state: "Tamil Nadu", desc: "Explore Rameswaram, including Panchamukhi Hanuman Temple, Shri Natraj Mandir and the Dr. APJ Abdul Kalam Memorial. Take a walk along Dhanushkodi Beach.", highlights: ["Panchamukhi Hanuman Temple", "Shri Natraj Mandir", "Dhanushkodi Beach Walk", "Dr. APJ Abdul Kalam Memorial"] },
    { day: 4, title: "Rameswaram · Chettinad · Thanjavur", state: "Tamil Nadu", desc: "Continue to Thanjavur, stopping in Chettinad to see its mansion and palace architecture. Check in for a two-night stay.", nights: 2, highlights: ["Chettinad Mansion", "Chettinad Palace Photo Stop"] },
    { day: 5, title: "Thanjavur · Trichy · Thanjavur", state: "Tamil Nadu", desc: "Discover Thanjavur town and Brihadeeswara Temple, then visit Maratha Palace. Explore Trichy's Rockfort Temple and the Ranganatha Swamy and Mahalakshmi temples, with time for shopping.", highlights: ["Brihadeeswara Temple", "Maratha Palace", "Rockfort Temple", "Ranganatha Swamy Temple", "Mahalakshmi Temple", "Rooftop Temple Viewpoint", "Shopping Time"] },
    { day: 6, title: "Thanjavur · Departure", state: "Tamil Nadu", desc: "Depart for your onward journey. Scheduled guests return to Mumbai; joining/leaving guests depart independently." },
  ],
});const INDIA_REGION_NAMES = new Set([
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi", "Jammu & Kashmir", "Jammu And Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
  "Delhi & Uttar Pradesh", "Himachal Pradesh & Punjab", "Tamil Nadu & Puducherry",
  "Kashmir", "Leh Ladakh", "North India", "North East",
]);
export const TOURS = [
  ...INDIA_TOURS.map((t) => ({ scope: "india", ...t })),
  ...WORLD_TOURS.map((tour) => ({ ...tour, scope: INDIA_REGION_NAMES.has(tour.region) ? "india" : tour.scope })),
];

export const getTourBySlug = (slug) => TOURS.find((t) => t.slug === slug);
export const getToursByScope = (scope) => TOURS.filter((t) => t.scope === scope);

export const formatINR = (n) =>
  n == null ? "Price on request" : "₹" + Number(n).toLocaleString("en-IN");

TOURS.push({
  slug: "wonders-of-kerala-kllt", title: "Wonders of Kerala", scope: "india",
  image: "/assets/media/wiki-munnar.jpg", gallery: ["/assets/media/wiki-munnar.jpg"], code: "KLLT",
  tourType: "GROUP TOUR", speciality: "Family", allInclusive: true, popularToday: true,
  days: 9, nights: 8, countriesCount: 1, statesCount: 2, citiesCount: 6,
  region: "Kerala", zone: "South India", interest: "Culture & Nature", packageType: "Group Tour",
  startingPrice: 59000, emiPerMonth: 5740, rating: null, reviewsCount: 0,
  route: [{ state: "Kerala", stops: ["Thiruvananthapuram (3N)", "Alleppey (1N)", "Periyar (1N)", "Munnar (2N)", "Cochin (1N)"] }],
  highlights: ["Swami Vivekananda Rock", "Thiruvalluvar Statue", "Kanyakumari Mandir", "Tri Samudra Milan", "Gandhi Mandapam", "Kerala Backwaters", "Kumily Spice Village", "Kalaripayattu Show", "Kathakali Show", "Periyar Wildlife Sanctuary", "Periyar Lake Boat Ride", "Tea Plantations", "Speed Boat Mattupetty", "Echo Point", "Eravikulam National Park"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Thiruvananthapuram (Joining)", "Cochin (Leaving)"], dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Thiruvananthapuram", state: "Kerala", desc: "Arrive in Thiruvananthapuram and settle in for a three-night stay.", nights: 3 },
    { day: 2, title: "Thiruvananthapuram", state: "Kerala", desc: "Explore the capital and its cultural sights." },
    { day: 3, title: "Thiruvananthapuram · Kanyakumari · Thiruvananthapuram", state: "Kerala", desc: "Visit Vivekananda Rock Memorial, Thiruvalluvar Statue, Kanyakumari Mandir, Tri Samudra Milan and Gandhi Mandapam." },
    { day: 4, title: "Thiruvananthapuram · Jatayu Earth Centre · Alleppey", state: "Kerala", desc: "Visit Jatayu Earth Centre en route to Alleppey and enjoy an overnight stay near the backwaters.", nights: 1 },
    { day: 5, title: "Alleppey · Periyar", state: "Kerala", desc: "Travel to Periyar, visit Kumily Spice Village and enjoy a Kalaripayattu performance.", nights: 1 },
    { day: 6, title: "Periyar · Munnar", state: "Kerala", desc: "Take a boat ride on Periyar Lake, then drive through the hills to Munnar.", nights: 2 },
    { day: 7, title: "Munnar", state: "Kerala", desc: "See tea plantations, Mattupetty Dam, Echo Point and Eravikulam National Park, and enjoy a Kathakali show." },
    { day: 8, title: "Munnar · Cochin", state: "Kerala", desc: "Travel to Cochin and explore its historic waterfront and heritage sights.", nights: 1 },
    { day: 9, title: "Cochin · Departure", state: "Kerala", desc: "Depart from Cochin for your onward journey." },
  ],
}, {
  slug: "seniors-special-rajasthan-mewad-rjza", title: "Seniors' Special Rajasthan Mewad", scope: "india",
  image: "/assets/media/wiki-udaipur.jpg", gallery: ["/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-ranthambore.jpg", "/assets/media/wiki-jaipur.jpg"], code: "RJZA",
  tourType: "GROUP TOUR", speciality: "Seniors' Special", allInclusive: true, popularToday: true,
  days: 8, nights: 7, countriesCount: 1, statesCount: 1, citiesCount: 7,
  region: "Rajasthan", zone: "West India", interest: "Culture & Heritage", packageType: "Group Tour",
  startingPrice: 59000, emiPerMonth: 5740, rating: null, reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Mount Abu (1N)", "Udaipur (2N)", "Pushkar (1N)", "Ranthambore (1N)", "Jaipur (2N)"] }],
  highlights: ["Gurushikhar", "Dilwara Temple", "Nakki Lake", "Moti Magri", "Udaipur City Palace", "Fateh Sagar Lake", "Boat Ride", "Jag Mandir", "Traditional Music & Dance Show", "Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace", "Brahma Mandir", "Pushkar Tirth", "Kishangarh", "Ranthambore National Park", "Jungle Safari", "Birla Temple", "Amer Fort", "Sound and Light Show", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Bapu Market"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Ahmedabad (Joining)", "Jaipur (Leaving)"], dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Ahmedabad · Mount Abu", state: "Rajasthan", desc: "Arrive in Ahmedabad and travel to Mount Abu for an overnight stay.", nights: 1 },
    { day: 2, title: "Mount Abu · Udaipur", state: "Rajasthan", desc: "Visit Gurushikhar, Dilwara Temple and Nakki Lake before continuing to Udaipur.", nights: 2 },
    { day: 3, title: "Udaipur", state: "Rajasthan", desc: "Explore Moti Magri, Udaipur City Palace and Fateh Sagar Lake, take a boat ride to Jag Mandir and enjoy traditional music and dance." },
    { day: 4, title: "Udaipur · Chittorgarh · Pushkar", state: "Rajasthan", desc: "Visit Chittorgarh Fort and its historic landmarks before continuing to Pushkar.", nights: 1 },
    { day: 5, title: "Pushkar · Ranthambore", state: "Rajasthan", desc: "Visit Pushkar Tirth and Brahma Mandir, stop at Kishangarh and continue to Ranthambore.", nights: 1 },
    { day: 6, title: "Ranthambore · Jaipur", state: "Rajasthan", desc: "Enjoy a jungle safari at Ranthambore National Park before travelling to Jaipur.", nights: 2 },
    { day: 7, title: "Jaipur", state: "Rajasthan", desc: "Visit Amer Fort, Hawa Mahal, Jantar Mantar, City Palace and Panna Meena ka Kund, with time at Bapu Market." },
    { day: 8, title: "Jaipur · Departure", state: "Rajasthan", desc: "Depart from Jaipur for your onward journey." },
  ],
});
TOURS.push({
  slug: "varanasi-ayodhya-lucknow-uplv",
  title: "Varanasi Ayodhya Lucknow",
  scope: "india",
  image: "/assets/media/wiki-varanasi-ghat.jpg",
  gallery: ["/assets/media/wiki-lucknow.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-prayagraj.jpg", "/assets/media/wiki-varanasi-aarti.jpg"],
  code: "UPLV",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 59000,
  emiPerMonth: 5740,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Lucknow (1N)", "Ayodhya (2N)", "Prayagraj (1N)", "Varanasi (3N)"] }],
  highlights: ["Ambedkar Park", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency", "Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Laying Hanuman Temple", "Triveni Sangam Boat Ride", "Anand Bhavan", "Swarved Mahamandir", "Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Assi Ghat Sunrise", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana Weavers' Village"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Lucknow (Joining)", "Varanasi (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Lucknow", state: "Uttar Pradesh", desc: "Arrive in Lucknow and begin exploring the city's landmarks. Scheduled guests fly from Mumbai; joining guests meet the group in Lucknow.", nights: 1, highlights: ["Ambedkar Park"] },
    { day: 2, title: "Lucknow · Ayodhya", state: "Uttar Pradesh", desc: "Discover Lucknow's historic gateways, clock tower, Imambaras and British Residency, then travel to Ayodhya for a two-night stay.", nights: 2, highlights: ["Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency"] },
    { day: 3, title: "Ayodhya", state: "Uttar Pradesh", desc: "Visit Shri Ram Janmabhoomi Mandir, Hanuman Garhi, Dashrath Mahal, Kanak Bhavan, Sita Rasoi and Laying Hanuman Temple.", highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Laying Hanuman Temple"] },
    { day: 4, title: "Ayodhya · Prayagraj", state: "Uttar Pradesh", desc: "Travel to Prayagraj and experience a boat ride at Triveni Sangam. Visit Anand Bhavan before an overnight stay.", nights: 1, highlights: ["Triveni Sangam Boat Ride", "Anand Bhavan"] },
    { day: 5, title: "Prayagraj · Varanasi", state: "Uttar Pradesh", desc: "Continue to Varanasi and visit Swarved Mahamandir. Settle in for a three-night stay.", nights: 3, highlights: ["Swarved Mahamandir"] },
    { day: 6, title: "Varanasi", state: "Uttar Pradesh", desc: "Visit Kaal Bhairav Temple, Kashi Vishwanath Temple, Banaras Hindu University and Birla Mandir. See the evening ceremony at Dashashwamedh Ghat.", highlights: ["Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat"] },
    { day: 7, title: "Varanasi · Sarnath · Varanasi", state: "Uttar Pradesh", desc: "Watch sunrise at Assi Ghat, then explore Sarnath's Dhamek Stupa and Archaeological Museum, and visit Sarai Mohana Weavers' Village.", highlights: ["Assi Ghat Sunrise", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana Weavers' Village"] },
    { day: 8, title: "Varanasi · Departure", state: "Uttar Pradesh", desc: "Depart from Varanasi for your onward journey. Scheduled guests return to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "best-of-madhya-pradesh-mpbh",
  title: "Best of Madhya Pradesh",
  scope: "india",
  image: "/assets/media/wiki-badami.jpg",
  gallery: ["/assets/media/wiki-badami.jpg"],
  code: "MPBH",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 6,
  region: "Madhya Pradesh",
  zone: "Central India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 60000,
  emiPerMonth: 5840,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Madhya Pradesh", stops: ["Jabalpur (2N)", "Khajuraho (2N)", "Jhansi (1N)", "Gwalior (2N)"] }],
  highlights: ["Bhedaghat Boat Ride", "Marble Village Walk", "Dhuandhar Falls Ropeway", "Gwarighat Narmada Aarti", "Panna National Park Safari", "Khajuraho Temples Tour", "Kandariya Mahadeo Temple", "Jain Temple", "Chitragupta Temple", "Folk Dance Show", "Sound & Light Show", "Orchha Cenotaphs", "Orchha Fort", "Jhansi Fort", "Jai Vilas Palace", "Gwalior Fort"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jabalpur (Joining)", "Gwalior (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jabalpur", state: "Madhya Pradesh", desc: "Arrive in Jabalpur and settle in for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Jabalpur.", nights: 2 },
    { day: 2, title: "Jabalpur", state: "Madhya Pradesh", desc: "Explore Bhedaghat, walk through the marble village, enjoy a boat ride on the Narmada and take the ropeway to Dhuandhar Falls. Attend the Narmada Aarti at Gwarighat.", highlights: ["Bhedaghat Boat Ride", "Marble Village Walk", "Dhuandhar Falls Ropeway", "Gwarighat Narmada Aarti"] },
    { day: 3, title: "Jabalpur · Panna National Park · Khajuraho", state: "Madhya Pradesh", desc: "Visit Panna National Park and continue to Khajuraho for a two-night stay.", nights: 2, highlights: ["Panna National Park Safari"] },
    { day: 4, title: "Khajuraho", state: "Madhya Pradesh", desc: "Discover the celebrated temples of Khajuraho, including Kandariya Mahadeo, Jain and Chitragupta temples. Enjoy a folk dance and sound and light show.", highlights: ["Khajuraho Temples Tour", "Kandariya Mahadeo Temple", "Jain Temple", "Chitragupta Temple", "Folk Dance Show", "Sound & Light Show"] },
    { day: 5, title: "Khajuraho · Orchha · Jhansi", state: "Madhya Pradesh", desc: "Travel via Orchha to explore its cenotaphs and fort, then continue to Jhansi for an overnight stay.", nights: 1, highlights: ["Orchha Cenotaphs", "Orchha Fort"] },
    { day: 6, title: "Jhansi · Gwalior", state: "Madhya Pradesh", desc: "Visit Jhansi Fort and continue to Gwalior for a two-night stay.", nights: 2, highlights: ["Jhansi Fort"] },
    { day: 7, title: "Gwalior", state: "Madhya Pradesh", desc: "Explore Jai Vilas Palace and the historic Gwalior Fort.", highlights: ["Jai Vilas Palace", "Gwalior Fort"] },
    { day: 8, title: "Gwalior · Departure", state: "Madhya Pradesh", desc: "Depart from Gwalior for your onward journey. Scheduled guests return to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "delhi-agra-haridwar-rishikesh-nidr",
  title: "Delhi Agra Haridwar Rishikesh",
  scope: "india",
  image: "/assets/media/wiki-taj-mahal.jpg",
  gallery: ["/assets/media/wiki-delhi.jpg", "/assets/media/wiki-taj-mahal.jpg", "/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg"],
  code: "NIDR",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 3,
  citiesCount: 8,
  region: "Delhi, Uttar Pradesh & Uttarakhand",
  zone: "North India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 68000,
  emiPerMonth: 6617,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Delhi", stops: ["Delhi (2N)"] },
    { state: "Uttar Pradesh", stops: ["Mathura", "Vrindavan", "Agra (2N)", "Fatehpur Sikri"] },
    { state: "Uttarakhand", stops: ["Haridwar (1N)", "Rishikesh (2N)"] },
  ],
  highlights: ["Fatehpur Sikri", "Taj Mahal", "Mehtab Bagh", "Agra Fort", "Inlay Work Display", "Mathura and Vrindavan Temples", "Akshardham Temple", "India Gate", "Rashtrapati Bhavan", "Parliament House", "Bahai Temple", "Qutub Minar", "Red Fort", "Ugrasen ki Baoli", "Ganga Aarti at Har Ki Pauri", "Mansa Devi Temple by Rope Way", "Prati Badri Kedarnath Temple", "Lakshman Jhula", "White Water Rafting"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining)", "Rishikesh (Joining)", "Agra (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and settle in for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Delhi.", nights: 2 },
    { day: 2, title: "Delhi", state: "Delhi", desc: "Explore the capital, including India Gate, Rashtrapati Bhavan, Parliament House, Bahai Temple, Qutub Minar, Red Fort, Ugrasen ki Baoli and Akshardham Temple.", highlights: ["Akshardham Temple", "India Gate", "Rashtrapati Bhavan", "Parliament House", "Bahai Temple", "Qutub Minar", "Red Fort", "Ugrasen ki Baoli"] },
    { day: 3, title: "Delhi · Mathura · Vrindavan · Agra", state: "Uttar Pradesh", desc: "Visit temples in Mathura and Vrindavan before continuing to Agra for a two-night stay.", nights: 2, highlights: ["Mathura and Vrindavan Temples"] },
    { day: 4, title: "Agra · Fatehpur Sikri · Agra", state: "Uttar Pradesh", desc: "Visit the Taj Mahal, Agra Fort and Mehtab Bagh, and explore Fatehpur Sikri. See a demonstration of traditional inlay work.", highlights: ["Taj Mahal", "Agra Fort", "Mehtab Bagh", "Fatehpur Sikri", "Inlay Work Display"] },
    { day: 5, title: "Agra · Haridwar", state: "Uttarakhand", desc: "Travel to Haridwar and experience the evening Ganga Aarti at Har Ki Pauri.", nights: 1, highlights: ["Ganga Aarti at Har Ki Pauri"] },
    { day: 6, title: "Haridwar · Rishikesh", state: "Uttarakhand", desc: "Visit Mansa Devi Temple by ropeway and Prati Badri Kedarnath Temple, then continue to Rishikesh for a two-night stay.", nights: 2, highlights: ["Mansa Devi Temple by Rope Way", "Prati Badri Kedarnath Temple"] },
    { day: 7, title: "Rishikesh", state: "Uttarakhand", desc: "Discover Rishikesh, walk across Lakshman Jhula and enjoy an opportunity for white water rafting.", highlights: ["Lakshman Jhula", "White Water Rafting"] },
    { day: 8, title: "Rishikesh · Departure", state: "Uttarakhand", desc: "Depart for your onward journey. Scheduled guests travel to the airport for their return flight; joining/leaving guests make their own arrangements." },
  ],
});
TOURS.push({
  slug: "womens-special-rajasthan-mewad-rjwa",
  title: "Women's Special Rajasthan Mewad",
  scope: "india",
  image: "/assets/media/wiki-udaipur.jpg",
  gallery: ["/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-ranthambore.jpg", "/assets/media/wiki-jaipur.jpg"],
  code: "RJWA",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Rajasthan",
  zone: "West India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 55000,
  emiPerMonth: 5350,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Mount Abu (1N)", "Udaipur (2N)", "Pushkar (1N)", "Ranthambore (1N)", "Jaipur (2N)"] }],
  highlights: ["Udaipur City Palace", "Gurushikhar", "Dilwara Temple", "Nakki Lake", "Moti Magri", "Fateh Sagar Lake", "Jag Mandir Boat Ride", "Traditional Music & Dance Show", "Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace", "Brahma Mandir", "Pushkar Tirth", "Kishangarh", "Ranthambore Jungle Safari", "Birla Temple", "Amer Fort Sound & Light Show", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Bapu Market Shopping"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining)", "Jaipur (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Ahmedabad · Mount Abu", state: "Rajasthan", desc: "Arrive in Ahmedabad and travel to Mount Abu for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group in Ahmedabad.", nights: 1 },
    { day: 2, title: "Mount Abu · Udaipur", state: "Rajasthan", desc: "Visit Gurushikhar, Dilwara Temple and Nakki Lake before continuing to Udaipur for a two-night stay.", nights: 2, highlights: ["Gurushikhar", "Dilwara Temple", "Nakki Lake"] },
    { day: 3, title: "Udaipur", state: "Rajasthan", desc: "Explore Udaipur City Palace, Moti Magri and Fateh Sagar Lake. Enjoy the Jag Mandir boat ride and a traditional music and dance show.", highlights: ["Udaipur City Palace", "Moti Magri", "Fateh Sagar Lake", "Jag Mandir Boat Ride", "Traditional Music & Dance Show"] },
    { day: 4, title: "Udaipur · Chittorgarh · Pushkar", state: "Rajasthan", desc: "Visit Chittorgarh Fort and its historic landmarks before continuing to Pushkar for an overnight stay.", nights: 1, highlights: ["Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace"] },
    { day: 5, title: "Pushkar · Ranthambore", state: "Rajasthan", desc: "Visit Brahma Mandir and Pushkar Tirth, stop at Kishangarh and continue to Ranthambore for an overnight stay.", nights: 1, highlights: ["Brahma Mandir", "Pushkar Tirth", "Kishangarh"] },
    { day: 6, title: "Ranthambore · Jaipur", state: "Rajasthan", desc: "Enjoy a jungle safari at Ranthambore National Park, visit Birla Temple and continue to Jaipur for a two-night stay.", nights: 2, highlights: ["Ranthambore Jungle Safari", "Birla Temple"] },
    { day: 7, title: "Jaipur", state: "Rajasthan", desc: "Visit Amer Fort and its sound and light show, Hawa Mahal, Jantar Mantar, City Palace and Panna Meena ka Kund. Browse Bapu Market.", highlights: ["Amer Fort Sound & Light Show", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Bapu Market Shopping"] },
    { day: 8, title: "Jaipur · Departure", state: "Rajasthan", desc: "Depart from Jaipur for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own arrangements." },
  ],
});
TOURS.push({
  slug: "seniors-special-kerala-klzlt",
  title: "Seniors' Special Kerala",
  scope: "india",
  image: "/assets/media/wiki-munnar.jpg",
  gallery: ["/assets/media/wiki-kovalam.jpg", "/assets/media/wiki-alleppey.jpg", "/assets/media/wiki-munnar.jpg"],
  code: "KLZLT",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 6,
  region: "Kerala",
  zone: "South India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 60000,
  emiPerMonth: 5840,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Kerala", stops: ["Thiruvananthapuram (3N)", "Alleppey (1N)", "Periyar (1N)", "Munnar (2N)", "Cochin (1N)"] }],
  highlights: ["Padmanabh Swami Temple", "Raja Ravi Varma Art Gallery", "Napier Museum", "Kovalam Beach", "Kanyakumari Mandir", "Swami Vivekananda Rock Memorial", "Thiruvalluvar Statue", "Tri Samudra Milan", "Gandhi Mandapam", "Jatayu Earth Centre", "Jatayu Sculpture", "Alleppey Backwaters", "Kumily Spice Village", "Kalaripayattu Show", "Kathakali Show", "Periyar Wildlife Sanctuary", "Periyar Lake Boat Ride", "Munnar Tea Plantations", "Mattupetty Dam", "Echo Point", "Eravikulam National Park", "Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue", "Dutch Palace"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Thiruvananthapuram (Joining)", "Cochin (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Thiruvananthapuram", state: "Kerala", desc: "Arrive in Thiruvananthapuram and settle in for a three-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at the airport.", nights: 3 },
    { day: 2, title: "Thiruvananthapuram", state: "Kerala", desc: "Visit Padmanabh Swami Temple, Raja Ravi Varma Art Gallery, Napier Museum and Kovalam Beach.", highlights: ["Padmanabh Swami Temple", "Raja Ravi Varma Art Gallery", "Napier Museum", "Kovalam Beach"] },
    { day: 3, title: "Thiruvananthapuram · Kanyakumari · Thiruvananthapuram", state: "Kerala", desc: "Visit Kanyakumari Mandir, Swami Vivekananda Rock Memorial, Thiruvalluvar Statue, Tri Samudra Milan and Gandhi Mandapam." },
    { day: 4, title: "Thiruvananthapuram · Jatayu Earth Centre · Alleppey", state: "Kerala", desc: "Visit Jatayu Earth Centre and the Jatayu Sculpture en route to Alleppey for an overnight stay.", nights: 1, highlights: ["Jatayu Earth Centre", "Jatayu Sculpture"] },
    { day: 5, title: "Alleppey · Periyar", state: "Kerala", desc: "Enjoy the Alleppey backwaters and continue to Periyar. Visit Kumily Spice Village and watch a Kalaripayattu performance.", nights: 1, highlights: ["Alleppey Backwaters", "Kumily Spice Village", "Kalaripayattu Show"] },
    { day: 6, title: "Periyar · Munnar", state: "Kerala", desc: "Take a boat ride on Periyar Lake to explore the wildlife sanctuary, then travel to Munnar for a two-night stay.", nights: 2, highlights: ["Periyar Wildlife Sanctuary", "Periyar Lake Boat Ride"] },
    { day: 7, title: "Munnar", state: "Kerala", desc: "Explore Munnar's tea plantations, Mattupetty Dam, Echo Point and Eravikulam National Park. Enjoy a Kathakali performance.", highlights: ["Munnar Tea Plantations", "Mattupetty Dam", "Echo Point", "Eravikulam National Park", "Kathakali Show"] },
    { day: 8, title: "Munnar · Cochin", state: "Kerala", desc: "Travel to Cochin and see Chinese Fishing Nets, St. Francis Church, the Jewish Synagogue and Dutch Palace.", nights: 1, highlights: ["Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue", "Dutch Palace"] },
    { day: 9, title: "Cochin · Departure", state: "Kerala", desc: "Depart from Cochin for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "varanasi-ayodhya-lucknow-pune-uplvp",
  title: "Varanasi Ayodhya Lucknow - Pune",
  scope: "india",
  image: "/assets/media/wiki-varanasi-ghat.jpg",
  gallery: ["/assets/media/wiki-lucknow.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-prayagraj.jpg", "/assets/media/wiki-varanasi-aarti.jpg"],
  code: "UPLVP",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 62000,
  emiPerMonth: 6035,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Lucknow (1N)", "Ayodhya (2N)", "Prayagraj (1N)", "Varanasi (3N)"] }],
  highlights: ["Ambedkar Park", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency", "Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Laying Hanuman Temple", "Triveni Sangam Boat Ride", "Anand Bhavan", "Swarved Mahamandir", "Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Assi Ghat Sunrise", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana Weavers' Village"],
  departureCity: "Pune",
  departureCities: ["Pune", "Lucknow (Joining)", "Varanasi (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Lucknow", state: "Uttar Pradesh", desc: "Arrive in Lucknow and begin exploring the city. Scheduled guests fly from Pune; joining guests meet the group in Lucknow.", nights: 1, highlights: ["Ambedkar Park"] },
    { day: 2, title: "Lucknow · Ayodhya", state: "Uttar Pradesh", desc: "Visit Lucknow's Rumi Darwaja, Clock Tower, Chota and Bada Imambara and British Residency, then travel to Ayodhya.", nights: 2, highlights: ["Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency"] },
    { day: 3, title: "Ayodhya", state: "Uttar Pradesh", desc: "Visit Shri Ram Janmabhoomi Mandir, Hanuman Garhi, Dashrath Mahal, Kanak Bhavan, Sita Rasoi and Laying Hanuman Temple.", highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Laying Hanuman Temple"] },
    { day: 4, title: "Ayodhya · Prayagraj", state: "Uttar Pradesh", desc: "Travel to Prayagraj, take a boat ride at Triveni Sangam and visit Anand Bhavan.", nights: 1, highlights: ["Triveni Sangam Boat Ride", "Anand Bhavan"] },
    { day: 5, title: "Prayagraj · Varanasi", state: "Uttar Pradesh", desc: "Continue to Varanasi and visit Swarved Mahamandir. Settle in for a three-night stay.", nights: 3, highlights: ["Swarved Mahamandir"] },
    { day: 6, title: "Varanasi", state: "Uttar Pradesh", desc: "Visit Kaal Bhairav Temple, Kashi Vishwanath Temple, Banaras Hindu University and Birla Mandir, and attend the evening Ganga Aarti at Dashashwamedh Ghat.", highlights: ["Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat"] },
    { day: 7, title: "Varanasi · Sarnath · Varanasi", state: "Uttar Pradesh", desc: "Watch sunrise at Assi Ghat, explore Dhamek Stupa and Sarnath Archaeological Museum, and visit Sarai Mohana Weavers' Village.", highlights: ["Assi Ghat Sunrise", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana Weavers' Village"] },
    { day: 8, title: "Varanasi · Departure", state: "Uttar Pradesh", desc: "Depart from Varanasi for your onward journey. Scheduled guests fly back to Pune; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "rajasthan-mewad-rjme",
  title: "Rajasthan Mewad",
  scope: "india",
  image: "/assets/media/wiki-udaipur.jpg",
  gallery: ["/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-ranthambore.jpg", "/assets/media/wiki-jaipur.jpg"],
  code: "RJME",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 10,
  nights: 9,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 9,
  region: "Rajasthan",
  zone: "West India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 63000,
  emiPerMonth: 6135,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Mount Abu (1N)", "Kumbhalgarh (2N)", "Udaipur (2N)", "Pushkar (1N)", "Ranthambore (1N)", "Jaipur (2N)"] }],
  highlights: ["Gurushikhar", "Dilwara Temple", "Nakki Lake", "Kumbhalgarh Fort", "Ranakpur Jain Temple", "Shrinathji Temple", "Statue of Belief", "Udaipur City", "Moti Magri", "Udaipur City Palace", "Jag Mandir", "Fateh Sagar Lake", "Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace", "Brahma Mandir", "Pushkar Tirth", "Kishangarh", "Ranthambore National Park", "Jungle Safari", "Birla Temple", "Amer Fort", "Sound and Light Show", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Bapu Market"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining)", "Jaipur (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Ahmedabad · Mount Abu", state: "Rajasthan", desc: "Arrive in Ahmedabad and travel to Mount Abu for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group in Ahmedabad.", nights: 1 },
    { day: 2, title: "Mount Abu · Kumbhalgarh", state: "Rajasthan", desc: "Visit Gurushikhar, Dilwara Temple and Nakki Lake, then continue to Kumbhalgarh for a two-night stay.", nights: 2, highlights: ["Gurushikhar", "Dilwara Temple", "Nakki Lake"] },
    { day: 3, title: "Kumbhalgarh", state: "Rajasthan", desc: "Explore the grand Kumbhalgarh Fort and the surrounding Mewar countryside.", highlights: ["Kumbhalgarh Fort", "Ranakpur Jain Temple"] },
    { day: 4, title: "Kumbhalgarh · Nathdwara · Udaipur", state: "Rajasthan", desc: "Visit Nathdwara's Shrinathji Temple and the Statue of Belief en route to Udaipur for a two-night stay.", nights: 2, highlights: ["Shrinathji Temple", "Statue of Belief"] },
    { day: 5, title: "Udaipur", state: "Rajasthan", desc: "Discover Moti Magri, Udaipur City Palace, Fateh Sagar Lake and Jag Mandir.", highlights: ["Moti Magri", "Udaipur City Palace", "Fateh Sagar Lake", "Jag Mandir"] },
    { day: 6, title: "Udaipur · Chittorgarh · Pushkar", state: "Rajasthan", desc: "Explore Chittorgarh Fort and its historic landmarks, then continue to Pushkar for an overnight stay.", nights: 1, highlights: ["Chittorgarh Fort", "Ranakumbha Palace", "Meera Mandir", "Vijay Stambha", "Queen Padmini's Palace"] },
    { day: 7, title: "Pushkar · Ranthambore", state: "Rajasthan", desc: "Visit Brahma Mandir and Pushkar Tirth, with a scenic stop at Kishangarh, before continuing to Ranthambore.", nights: 1, highlights: ["Brahma Mandir", "Pushkar Tirth", "Kishangarh"] },
    { day: 8, title: "Ranthambore · Jaipur", state: "Rajasthan", desc: "Enjoy a safari at Ranthambore National Park and continue to Jaipur for a two-night stay.", nights: 2, highlights: ["Ranthambore National Park", "Jungle Safari", "Birla Temple"] },
    { day: 9, title: "Jaipur", state: "Rajasthan", desc: "Visit Amer Fort, Hawa Mahal, Jantar Mantar, City Palace and Panna Meena ka Kund, with time to shop at Bapu Market.", highlights: ["Amer Fort", "Sound and Light Show", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Bapu Market"] },
    { day: 10, title: "Jaipur · Departure", state: "Rajasthan", desc: "Depart from Jaipur for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "womens-special-varanasi-ayodhya-lucknow-upwl",
  title: "Women's Special Varanasi Ayodhya Lucknow",
  scope: "india",
  image: "/assets/media/wiki-varanasi-ghat.jpg",
  gallery: ["/assets/media/wiki-lucknow.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-prayagraj.jpg", "/assets/media/wiki-varanasi-aarti.jpg"],
  code: "UPWL",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 60000,
  emiPerMonth: 5840,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Lucknow (1N)", "Ayodhya (2N)", "Prayagraj (1N)", "Varanasi (3N)"] }],
  highlights: ["Ambedkar Park", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency", "Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Laying Hanuman Temple", "Triveni Sangam Boat Ride", "Anand Bhavan", "Swarved Mahamandir", "Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Assi Ghat Sunrise", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana Weavers' Village"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Lucknow (Joining)", "Varanasi (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Lucknow", state: "Uttar Pradesh", desc: "Arrive in Lucknow and settle in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group in Lucknow.", nights: 1, highlights: ["Ambedkar Park"] },
    { day: 2, title: "Lucknow · Ayodhya", state: "Uttar Pradesh", desc: "Explore Lucknow's Rumi Darwaja, Clock Tower, Chota and Bada Imambara and British Residency, then travel to Ayodhya for a two-night stay.", nights: 2, highlights: ["Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency"] },
    { day: 3, title: "Ayodhya", state: "Uttar Pradesh", desc: "Visit Shri Ram Janmabhoomi Mandir, Hanuman Garhi, Dashrath Mahal, Kanak Bhavan, Sita Rasoi and Laying Hanuman Temple.", highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Laying Hanuman Temple"] },
    { day: 4, title: "Ayodhya · Prayagraj", state: "Uttar Pradesh", desc: "Travel to Prayagraj, take a boat ride at Triveni Sangam and visit Anand Bhavan before an overnight stay.", nights: 1, highlights: ["Triveni Sangam Boat Ride", "Anand Bhavan"] },
    { day: 5, title: "Prayagraj · Varanasi", state: "Uttar Pradesh", desc: "Continue to Varanasi and visit Swarved Mahamandir. Settle in for a three-night stay.", nights: 3, highlights: ["Swarved Mahamandir"] },
    { day: 6, title: "Varanasi", state: "Uttar Pradesh", desc: "Visit Kaal Bhairav Temple, Kashi Vishwanath Temple, Banaras Hindu University and Birla Mandir, and attend the evening Ganga Aarti at Dashashwamedh Ghat.", highlights: ["Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat"] },
    { day: 7, title: "Varanasi · Sarnath · Varanasi", state: "Uttar Pradesh", desc: "Watch sunrise at Assi Ghat, explore Dhamek Stupa and Sarnath Archaeological Museum, and visit Sarai Mohana Weavers' Village.", highlights: ["Assi Ghat Sunrise", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana Weavers' Village"] },
    { day: 8, title: "Varanasi · Departure", state: "Uttar Pradesh", desc: "Depart from Varanasi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "womens-special-ayodhya-varanasi-mathura-vrindavan-upwvm",
  title: "Women's Special Ayodhya Varanasi Mathura Vrindavan",
  scope: "india",
  image: "/assets/media/wiki-prem-mandir.jpg",
  gallery: ["/assets/media/wiki-prem-mandir.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-varanasi-ghat.jpg", "/assets/media/wiki-lucknow.jpg"],
  code: "UPWVM",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 11,
  nights: 10,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 9,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 65000,
  joiningLeavingPrice: 54000,
  emiPerMonth: 6329,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Mathura (3N)", "Lucknow (1N)", "Ayodhya (2N)", "Prayagraj (1N)", "Varanasi (3N)"] }],
  highlights: ["Govardhan Hill Visit", "Barsana Cable Car", "Radha Rani Temple", "Bramhand Ghat", "Chintaharan Mahadev", "Chaurasi Khamba", "Raman Reti", "Krishna Janmabhoomi", "Banke Bihari Temple", "Prem Mandir", "Chandra Uday Temple", "ISKCON Vrindavan", "Ambedkar Park", "Rumi Darwaja", "Chota & Bada Imambara", "British Residency", "Shri Ram Janmabhoomi", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Surya Kund Light Show", "Swarved Mahamandir", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Ganga Aarti", "Dhamek Stupa", "Sarnath Museum", "Tibetan Buddhist Monastery"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining)", "Varanasi (Leaving)"],
  dates: [{ date: "Wed Mar 03, 2027", price: 65000, tag: "Lowest Price" }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Delhi · Mathura", state: "Uttar Pradesh", desc: "Arrive in Delhi and continue to Mathura for a three-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at the reporting point.", nights: 3 },
    { day: 2, title: "Mathura · Govardhan · Barsana · Gokul · Mathura", state: "Uttar Pradesh", desc: "Visit Govardhan Hill, take the Barsana cable car to Radha Rani Temple, and explore Bramhand Ghat, Chintaharan Mahadev, Chaurasi Khamba and Raman Reti.", highlights: ["Govardhan Hill Visit", "Barsana Cable Car", "Radha Rani Temple", "Bramhand Ghat", "Chintaharan Mahadev", "Chaurasi Khamba", "Raman Reti"] },
    { day: 3, title: "Mathura · Vrindavan · Mathura", state: "Uttar Pradesh", desc: "Discover Krishna Janmabhoomi and Vrindavan's Banke Bihari Temple, Prem Mandir, Chandra Uday Temple and ISKCON Vrindavan.", highlights: ["Krishna Janmabhoomi", "Banke Bihari Temple", "Prem Mandir", "Chandra Uday Temple", "ISKCON Vrindavan"] },
    { day: 4, title: "Mathura · Lucknow", state: "Uttar Pradesh", desc: "Travel to Lucknow and visit Ambedkar Park, Rumi Darwaja, Chota and Bada Imambara and British Residency. Stay overnight in Lucknow.", nights: 1, highlights: ["Ambedkar Park", "Rumi Darwaja", "Chota & Bada Imambara", "British Residency"] },
    { day: 5, title: "Lucknow · Ayodhya", state: "Uttar Pradesh", desc: "Continue to Ayodhya for a two-night stay and discover the sacred city.", nights: 2 },
    { day: 6, title: "Ayodhya", state: "Uttar Pradesh", desc: "Visit Shri Ram Janmabhoomi, Hanuman Garhi, Dashrath Mahal and Kanak Bhavan, and enjoy the Surya Kund light show.", highlights: ["Shri Ram Janmabhoomi", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Surya Kund Light Show"] },
    { day: 7, title: "Ayodhya · Prayagraj", state: "Uttar Pradesh", desc: "Travel to Prayagraj for an overnight stay.", nights: 1 },
    { day: 8, title: "Prayagraj · Varanasi", state: "Uttar Pradesh", desc: "Continue to Varanasi and settle in for a three-night stay. Visit Swarved Mahamandir en route.", nights: 3, highlights: ["Swarved Mahamandir"] },
    { day: 9, title: "Varanasi", state: "Uttar Pradesh", desc: "Visit Kashi Vishwanath Temple, Banaras Hindu University and Birla Mandir, and attend the evening Ganga Aarti at Dashashwamedh Ghat.", highlights: ["Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Ganga Aarti"] },
    { day: 10, title: "Varanasi · Sarnath · Varanasi", state: "Uttar Pradesh", desc: "Explore Dhamek Stupa, Sarnath Museum and the Tibetan Buddhist Monastery.", highlights: ["Dhamek Stupa", "Sarnath Museum", "Tibetan Buddhist Monastery"] },
    { day: 11, title: "Varanasi · Departure", state: "Uttar Pradesh", desc: "Depart from Varanasi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "best-of-odisha-odbo",
  title: "Best of Odisha",
  scope: "india",
  image: "/assets/media/wiki-puri.jpg",
  gallery: ["/assets/media/wiki-puri.jpg", "/assets/media/wiki-konark.jpg", "/assets/media/wiki-chilika.jpg"],
  code: "ODBO",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Odisha",
  zone: "East India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 65000,
  emiPerMonth: 6329,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Odisha", stops: ["Puri (3N)", "Bhitarkanika National Park (2N)", "Bhubaneswar (2N)"] }],
  highlights: ["Chilika Lake", "Pipli", "Odia Folk Dance Show", "Jagannath Temple", "Konark Sun Temple", "Dhauli Shanti Stupa", "Lingaraj Temple", "Udaygiri & Khandagiri Caves", "Bhitarkanika National Park Boat Ride", "Bhitarkanika Interpretation Centre", "Paradip", "Netaji Subhash Chandra Bose Birthplace Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bhubaneswar (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Bhubaneswar · Puri", state: "Odisha", desc: "Arrive at Bhubaneswar and travel to Puri, where you will stay for three nights. Scheduled guests fly from Mumbai; joining guests meet the group in Bhubaneswar.", nights: 3 },
    { day: 2, title: "Puri", state: "Odisha", desc: "Visit Jagannath Temple, explore Pipli and enjoy an Odia folk dance show.", highlights: ["Jagannath Temple", "Pipli", "Odia Folk Dance Show"] },
    { day: 3, title: "Puri · Chilika Lake · Puri", state: "Odisha", desc: "Visit Chilika Lake and enjoy the scenic lake experience before returning to Puri.", highlights: ["Chilika Lake"] },
    { day: 4, title: "Puri · Bhitarkanika National Park", state: "Odisha", desc: "Travel to Bhitarkanika National Park for a two-night stay.", nights: 2 },
    { day: 5, title: "Bhitarkanika National Park", state: "Odisha", desc: "Take a boat ride through Bhitarkanika National Park and visit its interpretation centre.", highlights: ["Bhitarkanika National Park Boat Ride", "Bhitarkanika Interpretation Centre"] },
    { day: 6, title: "Bhitarkanika · Paradip · Bhubaneswar", state: "Odisha", desc: "Travel via Paradip to Bhubaneswar and settle in for a two-night stay.", nights: 2, highlights: ["Paradip"] },
    { day: 7, title: "Bhubaneswar", state: "Odisha", desc: "Explore Konark Sun Temple, Dhauli Shanti Stupa, Lingaraj Temple and the Udaygiri and Khandagiri Caves. Visit Netaji Subhash Chandra Bose's birthplace museum.", highlights: ["Konark Sun Temple", "Dhauli Shanti Stupa", "Lingaraj Temple", "Udaygiri & Khandagiri Caves", "Netaji Subhash Chandra Bose Birthplace Museum"] },
    { day: 8, title: "Bhubaneswar · Departure", state: "Odisha", desc: "Depart from Bhubaneswar for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "uttar-pradesh-buddhist-circuit-upbt",
  title: "Uttar Pradesh - Buddhist Circuit",
  scope: "india",
  image: "/assets/media/wiki-bodhgaya.jpg",
  gallery: ["/assets/media/wiki-bodhgaya.jpg", "/assets/media/wiki-varanasi-ghat.jpg", "/assets/media/wiki-lucknow.jpg"],
  code: "UPBT",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 2,
  statesCount: 2,
  citiesCount: 7,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 65000,
  emiPerMonth: 6329,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Uttar Pradesh", stops: ["Shravasti (2N)"] },
    { state: "Nepal", stops: ["Lumbini (1N)"] },
    { state: "Uttar Pradesh", stops: ["Kushinagar (1N)", "Bodhgaya (2N)", "Sarnath (1N)"] },
  ],
  highlights: ["Jetavana Monastery", "Angulimala Stupa", "Daen Mahamongkol Temple", "Sacred Garden", "Maya Devi Temple", "Ashoka Pillar", "World Peace Pagoda", "International Monastic Zone", "Ramabhar Stupa", "Mahanirvana Temple", "Mahabodhi Temple", "Great Buddha Statue", "Nippon Japanese Temple", "Dhamek Stupa", "Sarnath Archaeological Museum", "Tibetan Buddhist Monastery"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Lucknow (Joining)", "Varanasi (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Lucknow · Shravasti", state: "Uttar Pradesh", desc: "Arrive in Lucknow and travel to Shravasti for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Lucknow.", nights: 2 },
    { day: 2, title: "Shravasti", state: "Uttar Pradesh", desc: "Explore Jetavana Monastery and visit Angulimala Stupa and Daen Mahamongkol Temple.", highlights: ["Jetavana Monastery", "Angulimala Stupa", "Daen Mahamongkol Temple"] },
    { day: 3, title: "Shravasti · Lumbini", state: "Nepal", desc: "Travel to Lumbini, the birthplace of Gautama Buddha, and stay overnight. Visit the Sacred Garden, Maya Devi Temple, Ashoka Pillar, World Peace Pagoda and International Monastic Zone.", nights: 1, highlights: ["Sacred Garden", "Maya Devi Temple", "Ashoka Pillar", "World Peace Pagoda", "International Monastic Zone"] },
    { day: 4, title: "Lumbini · Kushinagar", state: "Uttar Pradesh", desc: "Continue to Kushinagar for an overnight stay and visit Ramabhar Stupa and Mahaparinirvana Temple.", nights: 1, highlights: ["Ramabhar Stupa", "Mahanirvana Temple"] },
    { day: 5, title: "Kushinagar · Bodhgaya", state: "Uttar Pradesh", desc: "Travel to Bodhgaya and settle in for a two-night stay.", nights: 2 },
    { day: 6, title: "Bodhgaya", state: "Uttar Pradesh", desc: "Visit Mahabodhi Temple, Great Buddha Statue and Nippon Japanese Temple.", highlights: ["Mahabodhi Temple", "Great Buddha Statue", "Nippon Japanese Temple"] },
    { day: 7, title: "Bodhgaya · Sarnath", state: "Uttar Pradesh", desc: "Travel to Sarnath for an overnight stay and explore Dhamek Stupa, the Sarnath Archaeological Museum and Tibetan Buddhist Monastery.", nights: 1, highlights: ["Dhamek Stupa", "Sarnath Archaeological Museum", "Tibetan Buddhist Monastery"] },
    { day: 8, title: "Sarnath · Varanasi · Departure", state: "Uttar Pradesh", desc: "Transfer from Sarnath to Varanasi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "womens-special-kerala-klwlt",
  title: "Women's Special Kerala",
  scope: "india",
  image: "/assets/media/wiki-munnar.jpg",
  gallery: ["/assets/media/wiki-munnar.jpg", "/assets/media/wiki-alleppey.jpg", "/assets/media/wiki-kovalam.jpg", "/assets/media/wiki-kanyakumari.jpg"],
  code: "KLWLT",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 6,
  region: "Kerala",
  zone: "South India",
  interest: "Nature & Culture",
  packageType: "Group Tour",
  startingPrice: 65000,
  emiPerMonth: 6329,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Kerala", stops: ["Thiruvananthapuram (3N)", "Alleppey (1N)", "Periyar (1N)", "Munnar (2N)", "Cochin (1N)"] }],
  highlights: ["Swami Vivekananda Rock Memorial", "Thiruvalluvar Statue", "Kanyakumari Mandir", "Tri Samudra Milan", "Gandhi Mandapam", "Padmanabh Swami Temple", "Raja Ravi Varma Art Gallery", "Napier Museum", "Kovalam Beach", "Jatayu Earth Centre", "Jatayu Sculpture", "Alleppey Backwaters", "Kumily Spice Village Shopping", "Kalaripayattu Show", "Kathakali Show", "Periyar Wildlife Sanctuary", "Periyar Lake Boat Ride", "Munnar Tea Plantations", "Mattupetty Dam Speed Boat", "Echo Point", "Eravikulam National Park", "Tea Museum & Factory", "Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue", "Dutch Palace"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Thiruvananthapuram (Joining)", "Cochin (Leaving)"],
  dates: [{ date: "Sat Nov 28, 2026", price: 65000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Thiruvananthapuram", state: "Kerala", desc: "Arrive at Thiruvananthapuram and settle in for a three-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at the airport.", nights: 3 },
    { day: 2, title: "Thiruvananthapuram", state: "Kerala", desc: "Visit Padmanabh Swami Temple, Raja Ravi Varma Art Gallery, Napier Museum and Kovalam Beach.", highlights: ["Padmanabh Swami Temple", "Raja Ravi Varma Art Gallery", "Napier Museum", "Kovalam Beach"] },
    { day: 3, title: "Thiruvananthapuram · Kanyakumari · Thiruvananthapuram", state: "Tamil Nadu", desc: "Visit Kanyakumari Mandir, Swami Vivekananda Rock Memorial, Thiruvalluvar Statue, Tri Samudra Milan and Gandhi Mandapam before returning to Thiruvananthapuram.", highlights: ["Kanyakumari Mandir", "Swami Vivekananda Rock Memorial", "Thiruvalluvar Statue", "Tri Samudra Milan", "Gandhi Mandapam"] },
    { day: 4, title: "Thiruvananthapuram · Jatayu Earth Centre · Alleppey", state: "Kerala", desc: "Visit Jatayu Earth Centre and its sculpture en route to Alleppey for an overnight stay.", nights: 1, highlights: ["Jatayu Earth Centre", "Jatayu Sculpture"] },
    { day: 5, title: "Alleppey · Periyar", state: "Kerala", desc: "Enjoy the Alleppey backwaters, then continue to Periyar. Visit Kumily Spice Village and watch a Kalaripayattu show.", nights: 1, highlights: ["Alleppey Backwaters", "Kumily Spice Village Shopping", "Kalaripayattu Show"] },
    { day: 6, title: "Periyar · Munnar", state: "Kerala", desc: "Take a boat ride on Periyar Lake in the wildlife sanctuary, then travel to Munnar for a two-night stay.", nights: 2, highlights: ["Periyar Wildlife Sanctuary", "Periyar Lake Boat Ride"] },
    { day: 7, title: "Munnar", state: "Kerala", desc: "Explore Munnar's tea plantations, Mattupetty Dam and Echo Point, and visit Eravikulam National Park and the tea museum. Enjoy a Kathakali show.", highlights: ["Munnar Tea Plantations", "Mattupetty Dam Speed Boat", "Echo Point", "Eravikulam National Park", "Tea Museum & Factory", "Kathakali Show"] },
    { day: 8, title: "Munnar · Cochin", state: "Kerala", desc: "Travel to Cochin and visit the Chinese Fishing Nets, St. Francis Church, Jewish Synagogue and Dutch Palace. Stay overnight in Cochin.", nights: 1, highlights: ["Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue", "Dutch Palace"] },
    { day: 9, title: "Cochin · Departure", state: "Kerala", desc: "Depart from Cochin for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "ayodhya-lucknow-dudhwa-national-park-upad",
  title: "Ayodhya Lucknow Dudhwa National Park",
  scope: "india",
  image: "/assets/media/wiki-ayodhya.jpg",
  gallery: ["/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-lucknow.jpg"],
  code: "UPAD",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Wildlife",
  packageType: "Group Tour",
  startingPrice: 65000,
  emiPerMonth: 6329,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Lucknow (1N)", "Ayodhya (2N)", "Pilibhit (2N)", "Dudhwa National Park (2N)"] }],
  highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Ambedkar Park", "Pilibhit Tiger Reserve", "Dudhwa National Park", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency Ruins"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Lucknow (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Lucknow", state: "Uttar Pradesh", desc: "Arrive in Lucknow and explore Ambedkar Park, Rumi Darwaja, Clock Tower, Chota and Bada Imambara and the British Residency ruins. Scheduled guests fly from Mumbai; joining guests meet the group in Lucknow. Stay overnight in the city.", nights: 1, highlights: ["Ambedkar Park"] },
    { day: 2, title: "Lucknow · Ayodhya", state: "Uttar Pradesh", desc: "Travel to Ayodhya and settle in for a two-night stay.", nights: 2 },
    { day: 3, title: "Ayodhya", state: "Uttar Pradesh", desc: "Visit Shri Ram Janmabhoomi Mandir, Hanuman Garhi, Dashrath Mahal, Kanak Bhavan and Sita Rasoi.", highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi"] },
    { day: 4, title: "Ayodhya · Pilibhit", state: "Uttar Pradesh", desc: "Travel to Pilibhit and stay for two nights near the tiger reserve.", nights: 2 },
    { day: 5, title: "Pilibhit Tiger Reserve", state: "Uttar Pradesh", desc: "Explore Pilibhit Tiger Reserve and its Terai forests and wildlife.", highlights: ["Pilibhit Tiger Reserve"] },
    { day: 6, title: "Pilibhit · Dudhwa National Park", state: "Uttar Pradesh", desc: "Continue to Dudhwa National Park for a two-night stay.", nights: 2 },
    { day: 7, title: "Dudhwa National Park", state: "Uttar Pradesh", desc: "Enjoy a day exploring the wildlife and landscapes of Dudhwa National Park.", highlights: ["Dudhwa National Park"] },
    { day: 8, title: "Dudhwa · Lucknow · Departure", state: "Uttar Pradesh", desc: "Travel from Dudhwa to Lucknow for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "ayodhya-varanasi-mathura-vrindavan-upvm",
  title: "Ayodhya Varanasi Mathura Vrindavan",
  scope: "india",
  image: "/assets/media/wiki-prem-mandir.jpg",
  gallery: ["/assets/media/wiki-prem-mandir.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-varanasi-ghat.jpg", "/assets/media/wiki-lucknow.jpg"],
  code: "UPVM",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 11,
  nights: 10,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 9,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 65000,
  joiningLeavingPrice: 54000,
  emiPerMonth: 6329,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Mathura (3N)", "Lucknow (1N)", "Ayodhya (2N)", "Prayagraj (1N)", "Varanasi (3N)"] }],
  highlights: ["Govardhan Hill Visit", "Barsana Cable Car", "Radha Rani Temple", "Bramhand Ghat", "Chintaharan Mahadev", "Chaurasi Khamba", "Raman Reti", "Krishna Janmabhoomi", "Banke Bihari Temple", "Prem Mandir", "Chandra Uday Temple", "ISKCON Vrindavan", "Ambedkar Park", "Rumi Darwaja", "Chota & Bada Imambara", "British Residency", "Shri Ram Janmabhoomi", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Surya Kund Light Show", "Swarved Mahamandir", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Ganga Aarti", "Dhamek Stupa", "Sarnath Museum", "Tibetan Buddhist Monastery"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining)", "Varanasi (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Delhi · Mathura", state: "Uttar Pradesh", desc: "Arrive in Delhi and continue to Mathura for a three-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at the reporting point.", nights: 3 },
    { day: 2, title: "Mathura · Govardhan · Barsana · Gokul · Mathura", state: "Uttar Pradesh", desc: "Visit Govardhan Hill, take the Barsana cable car to Radha Rani Temple, and explore Bramhand Ghat, Chintaharan Mahadev, Chaurasi Khamba and Raman Reti.", highlights: ["Govardhan Hill Visit", "Barsana Cable Car", "Radha Rani Temple", "Bramhand Ghat", "Chintaharan Mahadev", "Chaurasi Khamba", "Raman Reti"] },
    { day: 3, title: "Mathura · Vrindavan · Mathura", state: "Uttar Pradesh", desc: "Discover Krishna Janmabhoomi and Vrindavan's Banke Bihari Temple, Prem Mandir, Chandra Uday Temple and ISKCON Vrindavan.", highlights: ["Krishna Janmabhoomi", "Banke Bihari Temple", "Prem Mandir", "Chandra Uday Temple", "ISKCON Vrindavan"] },
    { day: 4, title: "Mathura · Lucknow", state: "Uttar Pradesh", desc: "Travel to Lucknow and visit Ambedkar Park, Rumi Darwaja, Chota and Bada Imambara and British Residency. Stay overnight in Lucknow.", nights: 1, highlights: ["Ambedkar Park", "Rumi Darwaja", "Chota & Bada Imambara", "British Residency"] },
    { day: 5, title: "Lucknow · Ayodhya", state: "Uttar Pradesh", desc: "Continue to Ayodhya for a two-night stay and discover the sacred city.", nights: 2 },
    { day: 6, title: "Ayodhya", state: "Uttar Pradesh", desc: "Visit Shri Ram Janmabhoomi, Hanuman Garhi, Dashrath Mahal and Kanak Bhavan, and enjoy the Surya Kund light show.", highlights: ["Shri Ram Janmabhoomi", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Surya Kund Light Show"] },
    { day: 7, title: "Ayodhya · Prayagraj", state: "Uttar Pradesh", desc: "Travel to Prayagraj for an overnight stay.", nights: 1 },
    { day: 8, title: "Prayagraj · Varanasi", state: "Uttar Pradesh", desc: "Continue to Varanasi and settle in for a three-night stay. Visit Swarved Mahamandir en route.", nights: 3, highlights: ["Swarved Mahamandir"] },
    { day: 9, title: "Varanasi", state: "Uttar Pradesh", desc: "Visit Kashi Vishwanath Temple, Banaras Hindu University and Birla Mandir, and attend the evening Ganga Aarti at Dashashwamedh Ghat.", highlights: ["Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Ganga Aarti"] },
    { day: 10, title: "Varanasi · Sarnath · Varanasi", state: "Uttar Pradesh", desc: "Explore Dhamek Stupa, Sarnath Museum and the Tibetan Buddhist Monastery.", highlights: ["Dhamek Stupa", "Sarnath Museum", "Tibetan Buddhist Monastery"] },
    { day: 11, title: "Varanasi · Departure", state: "Uttar Pradesh", desc: "Depart from Varanasi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "nainital-mussoorie-haridwar-rishikesh-corbett-park-nijw",
  title: "Nainital Mussoorie Haridwar Rishikesh Corbett Park",
  scope: "india",
  image: "/assets/media/wiki-nainital.jpg",
  gallery: ["/assets/media/wiki-nainital.jpg", "/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg", "/assets/media/wiki-corbett.jpg"],
  code: "NIJW",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 7,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Nature & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 67000,
  joiningLeavingPrice: 54000,
  emiPerMonth: 6524,
  rating: 5,
  reviewsCount: 509,
  route: [
    { state: "Delhi", stops: ["Delhi (1N)"] },
    { state: "Uttarakhand", stops: ["Haridwar (1N)", "Mussoorie (2N)", "Nainital (2N)", "Corbett Park (2N)"] },
  ],
  highlights: ["Ganga Aarti at Har Ki Pauri", "Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White-water Rafting in Rishikesh", "Mussoorie Hill Station", "Kempty Falls", "Gun Hill Ropeway", "Himalayan Views", "Mall Road Shopping", "Nainital Sightseeing", "Hanumangarhi Temple", "Cable Car to Snow Viewpoint", "Naina Devi Temple", "Boating at Naini Lake", "Kainchi Dham", "Jim Corbett Museum", "Jim Corbett National Park", "Jeep Safari", "Dhangari Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Delhi", state: "Delhi", desc: "Arrive in Delhi and check in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Delhi Airport.", nights: 1 },
    { day: 2, title: "Delhi · Haridwar", state: "Uttarakhand", desc: "Travel from Delhi to Haridwar for an overnight stay and visit Har Ki Pauri.", nights: 1, highlights: ["Har Ki Pauri"] },
    { day: 3, title: "Haridwar · Rishikesh · Mussoorie", state: "Uttarakhand", desc: "Visit Rishikesh's Prati Badri Kedarnath Temple, Lakshman Mandir and Lakshman Jhula, with time for white-water rafting, then continue to Mussoorie for a two-night stay.", nights: 2, highlights: ["Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White-water Rafting"] },
    { day: 4, title: "Mussoorie", state: "Uttarakhand", desc: "Enjoy Mussoorie sightseeing, Kempty Falls, the Gun Hill Ropeway, Himalayan views and time on Mall Road.", highlights: ["Kempty Falls", "Gun Hill Ropeway", "Himalayan Views", "Mall Road Shopping"] },
    { day: 5, title: "Mussoorie · Nainital", state: "Uttarakhand", desc: "Travel to Nainital for a two-night stay, with a visit to the Jim Corbett Museum as scheduled en route.", nights: 2, highlights: ["Jim Corbett Museum"] },
    { day: 6, title: "Nainital", state: "Uttarakhand", desc: "Explore Nainital, visit Hanumangarhi Temple, take the cable car to the snow viewpoint, see Naina Devi Temple and enjoy boating on Naini Lake. Visit Kainchi Dham as scheduled.", highlights: ["Nainital Sightseeing", "Hanumangarhi Temple", "Cable Car to Snow Viewpoint", "Naina Devi Temple", "Boating at Naini Lake", "Kainchi Dham"] },
    { day: 7, title: "Nainital · Corbett Park", state: "Uttarakhand", desc: "Continue to Corbett Park for a two-night stay and visit the Dhangari Museum.", nights: 2, highlights: ["Dhangari Museum"] },
    { day: 8, title: "Corbett Park", state: "Uttarakhand", desc: "Explore Jim Corbett National Park and enjoy a jeep safari through its wildlife habitat.", highlights: ["Jim Corbett National Park", "Jeep Safari"] },
    { day: 9, title: "Corbett Park · Delhi · Departure", state: "Delhi", desc: "Travel to Delhi Airport for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "seniors-special-nainital-mussoorie-haridwar-rishikesh-corbett-park-nizm",
  title: "Seniors' Special Nainital Mussoorie Haridwar Rishikesh Corbett Park",
  scope: "india",
  image: "/assets/media/wiki-nainital.jpg",
  gallery: ["/assets/media/wiki-nainital.jpg", "/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg", "/assets/media/wiki-corbett.jpg"],
  code: "NIZM",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 7,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Nature & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 72000,
  joiningLeavingPrice: 60000,
  emiPerMonth: 7011,
  rating: 5,
  reviewsCount: 28,
  route: [
    { state: "Delhi", stops: ["Delhi (1N)"] },
    { state: "Uttarakhand", stops: ["Haridwar (1N)", "Mussoorie (2N)", "Nainital (2N)", "Corbett Park (2N)"] },
  ],
  highlights: ["Har Ki Pauri Ganga Aarti", "Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White-Water Rafting", "Kempty Falls", "Gun Hill Ropeway", "Nainital Lake Boating", "Hanumangarhi Temple", "Nainadevi Temple", "Cable Car Ride (Nainital)", "Kainchi Dham", "Jim Corbett Museum", "Jim Corbett Jeep Safari", "Wildlife Spotting", "Dhangari Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining/Leaving)"],
  dates: [{ date: "Thu Mar 25, 2027", price: 72000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Delhi", state: "Delhi", desc: "Arrive in Delhi and check in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Delhi Airport.", nights: 1 },
    { day: 2, title: "Delhi · Haridwar", state: "Uttarakhand", desc: "Travel from Delhi to Haridwar for an overnight stay and visit Har Ki Pauri.", nights: 1, highlights: ["Har Ki Pauri Ganga Aarti"] },
    { day: 3, title: "Haridwar · Rishikesh · Mussoorie", state: "Uttarakhand", desc: "Visit Rishikesh's Prati Badri Kedarnath Temple, Lakshman Mandir and Lakshman Jhula, with time for white-water rafting, then continue to Mussoorie for a two-night stay.", nights: 2, highlights: ["Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White-Water Rafting"] },
    { day: 4, title: "Mussoorie", state: "Uttarakhand", desc: "Enjoy Mussoorie sightseeing, Kempty Falls and the Gun Hill Ropeway.", highlights: ["Kempty Falls", "Gun Hill Ropeway"] },
    { day: 5, title: "Mussoorie · Nainital", state: "Uttarakhand", desc: "Travel to Nainital for a two-night stay, with a visit to the Jim Corbett Museum as scheduled.", nights: 2, highlights: ["Jim Corbett Museum"] },
    { day: 6, title: "Nainital", state: "Uttarakhand", desc: "Explore Nainital, visit Hanumangarhi Temple and Nainadevi Temple, enjoy a cable car ride and boating on Naini Lake, and visit Kainchi Dham as scheduled.", highlights: ["Nainital Lake Boating", "Hanumangarhi Temple", "Nainadevi Temple", "Cable Car Ride (Nainital)", "Kainchi Dham"] },
    { day: 7, title: "Nainital · Ranikhet · Corbett Park", state: "Uttarakhand", desc: "Travel via Ranikhet to Corbett Park for a two-night stay and visit the Dhangari Museum.", nights: 2, highlights: ["Dhangari Museum"] },
    { day: 8, title: "Corbett Park", state: "Uttarakhand", desc: "Explore Corbett Park and enjoy a jeep safari with opportunities for wildlife spotting.", highlights: ["Jim Corbett Jeep Safari", "Wildlife Spotting"] },
    { day: 9, title: "Corbett Park · Delhi · Departure", state: "Delhi", desc: "Travel to Delhi Airport for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "womens-special-nainital-mussoorie-haridwar-rishikesh-corbett-park-niwm",
  title: "Women's Special Nainital Mussoorie Haridwar Rishikesh Corbett Park",
  scope: "india",
  image: "/assets/media/wiki-nainital.jpg",
  gallery: ["/assets/media/wiki-nainital.jpg", "/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg", "/assets/media/wiki-corbett.jpg"],
  code: "NIWM",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 7,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Nature & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 72000,
  joiningLeavingPrice: 62000,
  emiPerMonth: 7011,
  rating: 4,
  reviewsCount: 29,
  route: [
    { state: "Delhi", stops: ["Delhi (1N)"] },
    { state: "Uttarakhand", stops: ["Haridwar (1N)", "Mussoorie (2N)", "Nainital (2N)", "Corbett Park (2N)"] },
  ],
  highlights: ["Har Ki Pauri Ganga Aarti", "Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White-Water Rafting", "Mussoorie Hill Station", "Kempty Falls", "Gun Hill Ropeway", "Mall Road Shopping", "Nainital Lake District", "Hanumangarhi Temple", "Nainadevi Temple", "Boating at Naini Lake", "Kainchi Dham Ashram", "Jim Corbett Museum", "Jeep Safari", "Dhangari Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Delhi (Joining/Leaving)"],
  dates: [{ date: "Sat Nov 21, 2026", price: 72000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Delhi", state: "Delhi", desc: "Arrive in Delhi and check in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Delhi Airport.", nights: 1 },
    { day: 2, title: "Delhi · Haridwar", state: "Uttarakhand", desc: "Travel from Delhi to Haridwar for an overnight stay and visit Har Ki Pauri.", nights: 1, highlights: ["Har Ki Pauri Ganga Aarti"] },
    { day: 3, title: "Haridwar · Rishikesh · Mussoorie", state: "Uttarakhand", desc: "Visit Rishikesh's Prati Badri Kedarnath Temple, Lakshman Mandir and Lakshman Jhula, with time for white-water rafting, then continue to Mussoorie for a two-night stay.", nights: 2, highlights: ["Prati Badri Kedarnath Temple", "Lakshman Mandir", "Lakshman Jhula", "White-Water Rafting"] },
    { day: 4, title: "Mussoorie", state: "Uttarakhand", desc: "Enjoy Mussoorie sightseeing, Kempty Falls, the Gun Hill Ropeway and time on Mall Road.", highlights: ["Mussoorie Hill Station", "Kempty Falls", "Gun Hill Ropeway", "Mall Road Shopping"] },
    { day: 5, title: "Mussoorie · Nainital", state: "Uttarakhand", desc: "Travel to Nainital for a two-night stay, with a visit to the Jim Corbett Museum as scheduled.", nights: 2, highlights: ["Jim Corbett Museum"] },
    { day: 6, title: "Nainital", state: "Uttarakhand", desc: "Explore Nainital, visit Hanumangarhi Temple and Nainadevi Temple, enjoy boating on Naini Lake and visit Kainchi Dham as scheduled.", highlights: ["Nainital Lake District", "Hanumangarhi Temple", "Nainadevi Temple", "Boating at Naini Lake", "Kainchi Dham Ashram"] },
    { day: 7, title: "Nainital · Ranikhet · Corbett Park", state: "Uttarakhand", desc: "Travel via Ranikhet to Corbett Park for a two-night stay and visit the Dhangari Museum.", nights: 2, highlights: ["Dhangari Museum"] },
    { day: 8, title: "Corbett Park", state: "Uttarakhand", desc: "Explore Jim Corbett National Park and enjoy a jeep safari through its wildlife habitat.", highlights: ["Jeep Safari"] },
    { day: 9, title: "Corbett Park · Delhi · Departure", state: "Delhi", desc: "Travel to Delhi Airport for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "rajasthan-delhi-agra-rjda",
  title: "Rajasthan Delhi Agra",
  scope: "india",
  image: "/assets/media/wiki-udaipur.jpg",
  gallery: ["/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-chittorgarh.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-taj-mahal.jpg", "/assets/media/wiki-delhi.jpg"],
  code: "RJDA",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 10,
  nights: 9,
  countriesCount: 1,
  statesCount: 3,
  citiesCount: 9,
  region: "Rajasthan",
  zone: "North India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 52000,
  joiningLeavingPrice: 52000,
  emiPerMonth: 5060,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Rajasthan", stops: ["Udaipur (2N)", "Pushkar (1N)", "Jaipur (2N)"] },
    { state: "Uttar Pradesh", stops: ["Agra (2N)", "Mathura", "Vrindavan"] },
    { state: "Delhi", stops: ["Delhi (2N)"] },
  ],
  highlights: ["Moti Magri", "Fateh Sagar Lake", "City Palace Udaipur", "Jag Mandir", "Lake Pichola", "Chittorgarh Fort", "Ranakumbha Palace", "Pushkar Tirth", "Hawa Mahal", "Jantar Mantar", "Jaipur City Palace", "Panna Meena ka Kund", "Amer Fort", "Birla Temple", "Fatehpur Sikri", "Taj Mahal", "Mehtab Bagh", "Agra Fort", "Akshardham Temple", "India Gate", "Rashtrapati Bhavan", "Parliament House", "Raj Ghat", "Qutub Minar", "Red Fort", "Ugrasen ki Baoli"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Udaipur (Joining)", "Delhi (Leaving)"],
  dates: [{ date: "Wed Dec 16, 2026", price: 52000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Ahmedabad · Udaipur", state: "Rajasthan", desc: "Arrive at Ahmedabad and continue to Udaipur for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at Udaipur Airport.", nights: 2 },
    { day: 2, title: "Udaipur", state: "Rajasthan", desc: "Explore Udaipur's Moti Magri, Fateh Sagar Lake and City Palace, and enjoy a boat ride to Jag Mandir on Lake Pichola.", highlights: ["Moti Magri", "Fateh Sagar Lake", "City Palace Udaipur", "Jag Mandir", "Lake Pichola"] },
    { day: 3, title: "Udaipur · Chittorgarh · Pushkar", state: "Rajasthan", desc: "Visit Chittorgarh Fort and Ranakumbha Palace before continuing to Pushkar for an overnight stay. Explore Pushkar Tirth.", nights: 1, highlights: ["Chittorgarh Fort", "Ranakumbha Palace", "Pushkar Tirth"] },
    { day: 4, title: "Pushkar · Jaipur", state: "Rajasthan", desc: "Travel to Jaipur and settle in for a two-night stay.", nights: 2 },
    { day: 5, title: "Jaipur", state: "Rajasthan", desc: "Discover Jaipur's Hawa Mahal, Jantar Mantar, City Palace, Panna Meena ka Kund and Amer Fort. Visit Birla Temple.", highlights: ["Hawa Mahal", "Jantar Mantar", "Jaipur City Palace", "Panna Meena ka Kund", "Amer Fort", "Birla Temple"] },
    { day: 6, title: "Jaipur · Fatehpur Sikri · Agra", state: "Uttar Pradesh", desc: "Travel via Fatehpur Sikri to Agra for a two-night stay.", nights: 2, highlights: ["Fatehpur Sikri"] },
    { day: 7, title: "Agra", state: "Uttar Pradesh", desc: "Visit the Taj Mahal, Mehtab Bagh and Agra Fort.", highlights: ["Taj Mahal", "Mehtab Bagh", "Agra Fort"] },
    { day: 8, title: "Agra · Mathura · Vrindavan · Delhi", state: "Delhi", desc: "Travel via Mathura and Vrindavan to Delhi for a two-night stay.", nights: 2 },
    { day: 9, title: "Delhi", state: "Delhi", desc: "Explore Delhi's Akshardham Temple, India Gate, Rashtrapati Bhavan, Parliament House, Raj Ghat, Qutub Minar, Red Fort and Ugrasen ki Baoli.", highlights: ["Akshardham Temple", "India Gate", "Rashtrapati Bhavan", "Parliament House", "Raj Ghat", "Qutub Minar", "Red Fort", "Ugrasen ki Baoli"] },
    { day: 10, title: "Delhi · Departure", state: "Delhi", desc: "Depart from Delhi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "seniors-special-varanasi-ayodhya-lucknow-upzl",
  title: "Seniors' Special Varanasi Ayodhya Lucknow",
  scope: "india",
  image: "/assets/media/wiki-varanasi-ghat.jpg",
  gallery: ["/assets/media/wiki-lucknow.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-prayagraj.jpg", "/assets/media/wiki-varanasi-aarti.jpg"],
  code: "UPZL",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Spirituality",
  packageType: "Group Tour",
  startingPrice: 64000,
  joiningLeavingPrice: 54000,
  emiPerMonth: 6223,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Lucknow (1N)", "Ayodhya (2N)", "Prayagraj (1N)", "Varanasi (3N)"] }],
  highlights: ["Ambedkar Park", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency", "Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Laying Hanuman Temple", "Triveni Sangam Boat Ride", "Anand Bhavan", "Swarved Mahamandir", "Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat", "Assi Ghat Sunrise", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana Weavers' Village"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Lucknow (Joining)", "Varanasi (Leaving)"],
  dates: [{ date: "Wed Nov 11, 2026", price: 64000 }, { date: "Sun Dec 06, 2026", price: 64000 }, { date: "Wed Jan 27, 2027", price: 64000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Lucknow", state: "Uttar Pradesh", desc: "Arrive in Lucknow and explore Ambedkar Park. Scheduled guests fly from Mumbai; joining guests meet the group in Lucknow. Stay overnight.", nights: 1, highlights: ["Ambedkar Park"] },
    { day: 2, title: "Lucknow · Ayodhya", state: "Uttar Pradesh", desc: "Explore Rumi Darwaja, Clock Tower, Chota and Bada Imambara and British Residency, then travel to Ayodhya for a two-night stay.", nights: 2, highlights: ["Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency"] },
    { day: 3, title: "Ayodhya", state: "Uttar Pradesh", desc: "Visit Shri Ram Janmabhoomi Mandir, Hanuman Garhi, Dashrath Mahal, Kanak Bhavan, Sita Rasoi and Laying Hanuman Temple.", highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Laying Hanuman Temple"] },
    { day: 4, title: "Ayodhya · Prayagraj", state: "Uttar Pradesh", desc: "Travel to Prayagraj, take a boat ride at Triveni Sangam and visit Anand Bhavan before an overnight stay.", nights: 1, highlights: ["Triveni Sangam Boat Ride", "Anand Bhavan"] },
    { day: 5, title: "Prayagraj · Varanasi", state: "Uttar Pradesh", desc: "Continue to Varanasi, visit Swarved Mahamandir and settle in for a three-night stay.", nights: 3, highlights: ["Swarved Mahamandir"] },
    { day: 6, title: "Varanasi", state: "Uttar Pradesh", desc: "Visit Kaal Bhairav Temple, Kashi Vishwanath Temple, Banaras Hindu University and Birla Mandir, and see the evening Ganga Aarti at Dashashwamedh Ghat.", highlights: ["Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Dashashwamedh Ghat"] },
    { day: 7, title: "Varanasi · Sarnath · Varanasi", state: "Uttar Pradesh", desc: "Watch sunrise at Assi Ghat, explore Dhamek Stupa and Sarnath Archaeological Museum, and visit Sarai Mohana Weavers' Village.", highlights: ["Assi Ghat Sunrise", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana Weavers' Village"] },
    { day: 8, title: "Varanasi · Departure", state: "Uttar Pradesh", desc: "Depart from Varanasi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "best-of-gujarat-gtgb",
  title: "Best of Gujarat",
  scope: "india",
  image: "/assets/media/wiki-statue-of-unity.jpg",
  gallery: ["/assets/media/wiki-statue-of-unity.jpg", "/assets/media/wiki-diu.jpg", "/assets/media/wiki-gir.jpg", "/assets/media/wiki-somnath.jpg"],
  code: "GTGB",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Gujarat",
  zone: "West India",
  interest: "Culture & Wildlife",
  packageType: "Group Tour",
  startingPrice: 67000,
  joiningLeavingPrice: 55000,
  emiPerMonth: 6524,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Ahmedabad (1N)", "Kevadia (2N)", "Vadodara (1N)", "Diu (2N)", "Sasan Gir (1N)", "Ahmedabad (1N)"] }],
  highlights: ["Adalaj Stepwell", "Garudeshwar Dutta Mandir", "Champaner World Heritage Site", "Pavagadh Fort", "Kalika Mata Mandir", "Diu", "Gangeshwar Mahadev Temple", "INS Khukri Memorial", "Nagao Beach", "Sasan Gir Interpretation Zone", "Asiatic Lion Sanctuary", "State-of-Art Zoological Park", "Jungle Safari", "Valley of Flowers", "Statue of Unity", "Sabarmati Ashram", "Vision in Dark Museum", "Sabarmati Riverfront"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Ahmedabad", state: "Gujarat", desc: "Arrive in Ahmedabad, visit Adalaj Stepwell and settle in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group in Ahmedabad.", nights: 1, highlights: ["Adalaj Stepwell"] },
    { day: 2, title: "Ahmedabad · Kevadia", state: "Gujarat", desc: "Travel to Kevadia for a two-night stay and visit Garudeshwar Dutta Mandir.", nights: 2, highlights: ["Garudeshwar Dutta Mandir"] },
    { day: 3, title: "Kevadia", state: "Gujarat", desc: "Explore the Statue of Unity complex, including the Valley of Flowers, state-of-the-art Zoological Park, jungle safari and Vision in Dark Museum.", highlights: ["Statue of Unity", "Valley of Flowers", "State-of-Art Zoological Park", "Jungle Safari", "Vision in Dark Museum"] },
    { day: 4, title: "Kevadia · Champaner · Pavagadh · Vadodara", state: "Gujarat", desc: "Visit Champaner World Heritage Site, Pavagadh Fort and Kalika Mata Mandir before continuing to Vadodara for an overnight stay.", nights: 1, highlights: ["Champaner World Heritage Site", "Pavagadh Fort", "Kalika Mata Mandir"] },
    { day: 5, title: "Vadodara · Diu", state: "Gujarat", desc: "Travel from Vadodara to Diu and settle in for a two-night stay.", nights: 2 },
    { day: 6, title: "Diu", state: "Gujarat", desc: "Explore Diu's coastal attractions, including Gangeshwar Mahadev Temple, INS Khukri Memorial and Nagao Beach.", highlights: ["Gangeshwar Mahadev Temple", "INS Khukri Memorial", "Nagao Beach"] },
    { day: 7, title: "Diu · Sasan Gir", state: "Gujarat", desc: "Continue to Sasan Gir for an overnight stay and visit the Gir Interpretation Zone.", nights: 1, highlights: ["Sasan Gir Interpretation Zone"] },
    { day: 8, title: "Sasan Gir · Ahmedabad", state: "Gujarat", desc: "Experience Gir's Asiatic lion habitat and jungle safari, then travel to Ahmedabad for an overnight stay.", nights: 1, highlights: ["Asiatic Lion Sanctuary", "Jungle Safari"] },
    { day: 9, title: "Ahmedabad · Departure", state: "Gujarat", desc: "Visit Sabarmati Ashram and Sabarmati Riverfront before your onward departure. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Sabarmati Ashram", "Sabarmati Riverfront"] },
  ],
});
TOURS.push({
  slug: "womens-special-gujarat-gtwgb",
  title: "Women's Special Gujarat",
  scope: "india",
  image: "/assets/media/wiki-statue-of-unity.jpg",
  gallery: ["/assets/media/wiki-statue-of-unity.jpg", "/assets/media/wiki-diu.jpg", "/assets/media/wiki-gir.jpg", "/assets/media/wiki-somnath.jpg"],
  code: "GTWGB",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Gujarat",
  zone: "West India",
  interest: "Culture & Wildlife",
  packageType: "Group Tour",
  startingPrice: 72000,
  joiningLeavingPrice: 72000,
  emiPerMonth: 7011,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Ahmedabad (1N)", "Kevadia (2N)", "Vadodara (1N)", "Diu (2N)", "Sasan Gir (1N)", "Ahmedabad (1N)"] }],
  highlights: ["Adalaj Stepwell", "Garudeshwar Dutta Mandir", "Miyawaki Garden", "State-of-Art Zoological Park", "Valley of Flowers", "Boating at Nauka Vihar", "Statue of Unity", "Champaner (UNESCO Site)", "Pavagadh", "Diu", "Gangeshwar Mahadev Temple", "INS Khukri Memorial", "Sasan Gir Interpretation Zone", "Sabarmati Ashram", "Vision in Dark Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining/Leaving)"],
  dates: [{ date: "Fri Dec 11, 2026", price: 72000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Ahmedabad", state: "Gujarat", desc: "Arrive in Ahmedabad and settle in for an overnight stay. Scheduled guests travel from Mumbai; joining guests meet the group at Ahmedabad Airport.", nights: 1 },
    { day: 2, title: "Ahmedabad · Kevadia", state: "Gujarat", desc: "Travel to Kevadia for a two-night stay and visit Garudeshwar Dutta Mandir and Miyawaki Garden.", nights: 2, highlights: ["Garudeshwar Dutta Mandir", "Miyawaki Garden"] },
    { day: 3, title: "Kevadia", state: "Gujarat", desc: "Explore the Statue of Unity complex, including the Valley of Flowers, State-of-Art Zoological Park and boating at Nauka Vihar.", highlights: ["Statue of Unity", "Valley of Flowers", "State-of-Art Zoological Park", "Boating at Nauka Vihar"] },
    { day: 4, title: "Kevadia · Champaner · Pavagadh · Vadodara", state: "Gujarat", desc: "Visit the UNESCO site at Champaner and Pavagadh before continuing to Vadodara for an overnight stay.", nights: 1, highlights: ["Champaner (UNESCO Site)", "Pavagadh"] },
    { day: 5, title: "Vadodara · Diu", state: "Gujarat", desc: "Travel from Vadodara to Diu and settle in for a two-night stay.", nights: 2 },
    { day: 6, title: "Diu", state: "Gujarat", desc: "Explore Diu, including Gangeshwar Mahadev Temple and INS Khukri Memorial.", highlights: ["Gangeshwar Mahadev Temple", "INS Khukri Memorial"] },
    { day: 7, title: "Diu · Sasan Gir", state: "Gujarat", desc: "Continue to Sasan Gir for an overnight stay and visit the Sasan Gir Interpretation Zone.", nights: 1, highlights: ["Sasan Gir Interpretation Zone"] },
    { day: 8, title: "Sasan Gir · Ahmedabad", state: "Gujarat", desc: "Travel from Sasan Gir to Ahmedabad for an overnight stay.", nights: 1 },
    { day: 9, title: "Ahmedabad · Departure", state: "Gujarat", desc: "Explore Ahmedabad, including Sabarmati Ashram and Vision in Dark Museum, then depart after lunch. Scheduled guests return to Mumbai; joining/leaving guests make their own onward arrangements.", highlights: ["Sabarmati Ashram", "Vision in Dark Museum"] },
  ],
});
TOURS.push({
  slug: "bundi-alwar-sariska-shekhawati-rjba",
  title: "Bundi Alwar Sariska Shekhawati",
  scope: "india",
  image: "/assets/media/wiki-mandawa.jpg",
  gallery: ["/assets/media/wiki-mandawa.jpg", "/assets/media/wiki-ranthambore.jpg", "/assets/media/wiki-jaipur.jpg"],
  code: "RJBA",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Rajasthan",
  zone: "West India",
  interest: "Culture & Wildlife",
  packageType: "Group Tour",
  startingPrice: 60000,
  joiningLeavingPrice: 50000,
  emiPerMonth: 5840,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Kota (1N)", "Sawai Madhopur (1N)", "Alwar (2N)", "Nawalgarh (1N)", "Jaipur (1N)"] }],
  highlights: ["Seven Wonder Park", "Kota Water Front", "Taragarh Fort", "Raniji ki Baori", "Garadia Mahadev Temple", "Chambal River Gorge", "Sawai Madhopur", "Bhangarh Fort", "Siliserh Lake Boating", "Sariska National Park Safari", "Musi Rani ki Chatri", "Bakteshwar Mahadev Temple", "Jagannath Temple", "Shri Khatu Shyam Ji Temple", "Nawalgarh Havelis", "Mandawa Fort", "Podar Haveli Museum", "Morarka Haveli", "Shekhawati Murals", "Jaipur City"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Jaipur (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Jaipur · Kota", state: "Rajasthan", desc: "Arrive in Jaipur and travel to Kota for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group in Jaipur. Explore Seven Wonder Park and Kota Water Front.", nights: 1, highlights: ["Seven Wonder Park", "Kota Water Front"] },
    { day: 2, title: "Kota · Bundi · Sawai Madhopur", state: "Rajasthan", desc: "Explore Bundi's Taragarh Fort and Raniji ki Baori, and visit Garadia Mahadev Temple overlooking the Chambal River Gorge. Continue to Sawai Madhopur for an overnight stay.", nights: 1, highlights: ["Taragarh Fort", "Raniji ki Baori", "Garadia Mahadev Temple", "Chambal River Gorge"] },
    { day: 3, title: "Sawai Madhopur · Alwar", state: "Rajasthan", desc: "Travel to Alwar via Bhangarh Fort and settle in for a two-night stay.", nights: 2, highlights: ["Sawai Madhopur", "Bhangarh Fort"] },
    { day: 4, title: "Alwar · Sariska · Alwar", state: "Rajasthan", desc: "Enjoy boating at Siliserh Lake and explore Sariska National Park on safari. Visit Musi Rani ki Chatri, Bakteshwar Mahadev Temple and Jagannath Temple.", highlights: ["Siliserh Lake Boating", "Sariska National Park Safari", "Musi Rani ki Chatri", "Bakteshwar Mahadev Temple", "Jagannath Temple"] },
    { day: 5, title: "Alwar · Khatu Shyam Ji · Nawalgarh", state: "Rajasthan", desc: "Visit Shri Khatu Shyam Ji Temple and continue to Nawalgarh for an overnight stay among the Shekhawati havelis.", nights: 1, highlights: ["Shri Khatu Shyam Ji Temple", "Nawalgarh Havelis"] },
    { day: 6, title: "Nawalgarh · Mandawa · Jaipur", state: "Rajasthan", desc: "Explore Mandawa Fort, Podar Haveli Museum, Morarka Haveli and the painted Shekhawati murals before travelling to Jaipur for an overnight stay.", nights: 1, highlights: ["Mandawa Fort", "Podar Haveli Museum", "Morarka Haveli", "Shekhawati Murals"] },
    { day: 7, title: "Jaipur · Departure", state: "Rajasthan", desc: "Enjoy Jaipur city sightseeing before departing for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Jaipur City"] },
  ],
});
TOURS.push({
  slug: "rann-utsav-with-nadabet-gtrs",
  title: "Rann Utsav with Nadabet",
  scope: "india",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-statue-of-unity.jpg", "/assets/media/wiki-diu.jpg"],
  code: "GTRS",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Gujarat",
  zone: "West India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 69000,
  joiningLeavingPrice: 55000,
  emiPerMonth: 6718,
  rating: 5,
  reviewsCount: 39,
  route: [{ state: "Gujarat", stops: ["Ahmedabad (1N)", "Bhuj (2N)", "Dhordo (2N)", "Dasada (1N)", "Ahmedabad (1N)"] }],
  highlights: ["Adalaj Stepwell", "Bhuj", "Aina Mahal", "Prag Mahal", "Swaminarayan Temple", "Mandavi Beach", "Vijay Vilas Palace", "Smritivan Earthquake Memorial", "Dhordo", "White Rann Sunset", "Road to Heaven Drive", "Dholavira", "Nadabet", "MIG 27 Photostop", "Sarhad Gatha Museum", "Zero Point", "Sabarmati Ashram", "Vision in Dark Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining/Leaving)"],
  dates: [{ date: "Sun Nov 29, 2026", price: 69000 }, { date: "Sun Dec 20, 2026", price: 69000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Ahmedabad", state: "Gujarat", desc: "Arrive in Ahmedabad and settle in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Ahmedabad Airport.", nights: 1 },
    { day: 2, title: "Ahmedabad · Anjar · Bhuj", state: "Gujarat", desc: "Travel via Anjar to Bhuj for a two-night stay.", nights: 2 },
    { day: 3, title: "Bhuj", state: "Gujarat", desc: "Explore Bhuj's Aina Mahal, Prag Mahal and Swaminarayan Temple.", highlights: ["Aina Mahal", "Prag Mahal", "Swaminarayan Temple"] },
    { day: 4, title: "Bhuj · Smritivan · Dhordo", state: "Gujarat", desc: "Visit Smritivan Earthquake Memorial and continue to Dhordo for a two-night stay. Explore Mandavi Beach and Vijay Vilas Palace along the way as scheduled.", nights: 2, highlights: ["Smritivan Earthquake Memorial", "Mandavi Beach", "Vijay Vilas Palace"] },
    { day: 5, title: "Dhordo", state: "Gujarat", desc: "Experience the Rann Utsav and watch sunset over the White Rann.", highlights: ["White Rann Sunset", "Dhordo"] },
    { day: 6, title: "Dhordo · Dholavira · Road to Heaven · Dasada", state: "Gujarat", desc: "Travel to Dholavira and drive along the scenic Road to Heaven, continuing to Dasada for an overnight stay.", nights: 1, highlights: ["Dholavira", "Road to Heaven Drive"] },
    { day: 7, title: "Dasada · Nadabet · Ahmedabad", state: "Gujarat", desc: "Visit Nadabet, including the MIG 27 display, Sarhad Gatha Museum and Zero Point, then return to Ahmedabad for an overnight stay.", nights: 1, highlights: ["Nadabet", "MIG 27 Photostop", "Sarhad Gatha Museum", "Zero Point"] },
    { day: 8, title: "Ahmedabad · Departure", state: "Gujarat", desc: "Explore Ahmedabad, including Sabarmati Ashram and Vision in Dark Museum, then depart after lunch. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Sabarmati Ashram", "Vision in Dark Museum"] },
  ],
});
TOURS.push({
  slug: "womens-special-rann-utsav-with-nadabet-gtwrs",
  title: "Women's Special Rann Utsav with Nadabet",
  scope: "india",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-statue-of-unity.jpg", "/assets/media/wiki-diu.jpg"],
  code: "GTWRS",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Gujarat",
  zone: "West India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 73000,
  joiningLeavingPrice: 59000,
  emiPerMonth: 7100,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Ahmedabad (1N)", "Bhuj (2N)", "Dhordo (2N)", "Dasada (1N)", "Ahmedabad (1N)"] }],
  highlights: ["Adalaj Stepwell", "Bhuj", "Aina Mahal", "Prag Mahal", "Swaminarayan Temple", "Mandavi Beach", "Vijay Vilas Palace", "Smritivan Earthquake Memorial", "Dhordo", "White Rann sunset", "Road to Heaven drive", "Dholavira", "Nadabet", "MIG 27 photostop", "Sarhad Gatha Museum", "Zero Point", "Sabarmati Ashram", "Vision in Dark Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Ahmedabad", state: "Gujarat", desc: "Arrive in Ahmedabad and settle in for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Ahmedabad Airport.", nights: 1 },
    { day: 2, title: "Ahmedabad · Anjar · Bhuj", state: "Gujarat", desc: "Travel via Anjar to Bhuj for a two-night stay.", nights: 2 },
    { day: 3, title: "Bhuj", state: "Gujarat", desc: "Explore Bhuj's Aina Mahal, Prag Mahal and Swaminarayan Temple.", highlights: ["Aina Mahal", "Prag Mahal", "Swaminarayan Temple"] },
    { day: 4, title: "Bhuj · Smritivan · Dhordo", state: "Gujarat", desc: "Visit Smritivan Earthquake Memorial and continue to Dhordo for a two-night stay. Explore Mandavi Beach and Vijay Vilas Palace along the way as scheduled.", nights: 2, highlights: ["Smritivan Earthquake Memorial", "Mandavi Beach", "Vijay Vilas Palace"] },
    { day: 5, title: "Dhordo", state: "Gujarat", desc: "Experience the Rann Utsav and watch sunset over the White Rann.", highlights: ["White Rann sunset", "Dhordo"] },
    { day: 6, title: "Dhordo · Dholavira · Road to Heaven · Dasada", state: "Gujarat", desc: "Travel to Dholavira and drive along the scenic Road to Heaven, continuing to Dasada for an overnight stay.", nights: 1, highlights: ["Dholavira", "Road to Heaven drive"] },
    { day: 7, title: "Dasada · Nadabet · Ahmedabad", state: "Gujarat", desc: "Visit Nadabet, including the MIG 27 display, Sarhad Gatha Museum and Zero Point, then return to Ahmedabad for an overnight stay.", nights: 1, highlights: ["Nadabet", "MIG 27 photostop", "Sarhad Gatha Museum", "Zero Point"] },
    { day: 8, title: "Ahmedabad · Departure", state: "Gujarat", desc: "Explore Ahmedabad, including Sabarmati Ashram and Vision in Dark Museum, then depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Sabarmati Ashram", "Vision in Dark Museum"] },
  ],
});
TOURS.push({
  slug: "trivandrum-kanyakumari-rameswaram-madurai-klrm",
  title: "Trivandrum Kanyakumari Rameswaram Madurai",
  scope: "india",
  image: "/assets/media/wiki-kanyakumari.jpg",
  gallery: ["/assets/media/wiki-kanyakumari.jpg", "/assets/media/wiki-rameshwaram.jpg", "/assets/media/wiki-madurai.jpg", "/assets/media/wiki-kovalam.jpg"],
  code: "KLRM",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Tamil Nadu",
  zone: "South India",
  interest: "Culture & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 69000,
  joiningLeavingPrice: 55000,
  emiPerMonth: 6718,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Kerala", stops: ["Thiruvananthapuram (2N)"] }, { state: "Tamil Nadu", stops: ["Kanyakumari (2N)", "Rameswaram (2N)", "Madurai (1N)"] }],
  highlights: ["Padmanabhaswamy Temple", "Napier Museum", "Kovalam Beach", "Vivekananda Rock Memorial", "Thiruvalluvar Statue", "Kanyakumari Devi Temple", "Suchindram Temple", "Ramanathaswamy Temple", "Pamban Bridge", "Dhanushkodi", "Meenakshi Amman Temple", "Thirumalai Nayakkar Palace"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Thiruvananthapuram (Joining)", "Madurai (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Thiruvananthapuram", state: "Kerala", desc: "Arrive in Thiruvananthapuram and meet the tour manager. Scheduled guests fly from Mumbai; joining guests meet the group at the first destination.", nights: 1 },
    { day: 2, title: "Thiruvananthapuram · Kovalam", state: "Kerala", desc: "Explore Thiruvananthapuram's cultural landmarks and enjoy time around Kovalam before continuing the South India journey.", highlights: ["Padmanabhaswamy Temple", "Napier Museum", "Kovalam Beach"] },
    { day: 3, title: "Thiruvananthapuram · Kanyakumari", state: "Tamil Nadu", desc: "Travel to Kanyakumari and visit its celebrated coastal and spiritual landmarks.", nights: 2, highlights: ["Vivekananda Rock Memorial", "Thiruvalluvar Statue", "Kanyakumari Devi Temple"] },
    { day: 4, title: "Kanyakumari", state: "Tamil Nadu", desc: "Explore Kanyakumari and nearby Suchindram, with time to experience the southern tip of India.", highlights: ["Suchindram Temple", "Kanyakumari"] },
    { day: 5, title: "Kanyakumari · Rameswaram", state: "Tamil Nadu", desc: "Travel along the coast to Rameswaram, crossing the Pamban Bridge en route to the island town.", nights: 2, highlights: ["Pamban Bridge"] },
    { day: 6, title: "Rameswaram", state: "Tamil Nadu", desc: "Visit the revered Ramanathaswamy Temple and explore Rameswaram, including a visit to Dhanushkodi as scheduled.", highlights: ["Ramanathaswamy Temple", "Dhanushkodi"] },
    { day: 7, title: "Rameswaram · Madurai", state: "Tamil Nadu", desc: "Continue to Madurai and explore the city's historic temple and palace before an overnight stay.", nights: 1, highlights: ["Meenakshi Amman Temple", "Thirumalai Nayakkar Palace"] },
    { day: 8, title: "Madurai · Departure", state: "Tamil Nadu", desc: "Conclude the tour in Madurai and depart for your onward journey. Scheduled guests return to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "ooty-coorg-mysore-bengaluru-kaoc",
  title: "Ooty Coorg Mysore Bengaluru",
  scope: "india",
  image: "/assets/media/wiki-ooty.jpg",
  gallery: ["/assets/media/wiki-ooty.jpg", "/assets/media/wiki-coorg.jpg", "/assets/media/wiki-mysore.jpg"],
  code: "KAOC",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Karnataka",
  zone: "South India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 69000,
  joiningLeavingPrice: 55000,
  emiPerMonth: 6718,
  rating: 5,
  reviewsCount: 161,
  route: [{ state: "Karnataka", stops: ["Mysore (2N)"] }, { state: "Tamil Nadu", stops: ["Ooty (2N)"] }, { state: "Karnataka", stops: ["Coorg (2N)", "Bengaluru (1N)"] }],
  highlights: ["Brindavan Gardens", "Mysore Palace", "Mysore Zoo", "Mysore Sand Sculpture Museum", "Shri Chamundeshwari Temple", "Boat ride in Ooty Lake", "Dolphin’s Nose Viewpoint", "Doddabetta Peak", "Sim's Park", "Tibetan Monastery and Market", "Cauvery Nisargadhama Hanging Bridge", "Dubare Elephant Camp", "White Water Rafting at Dubare Camp", "Channapatna", "Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bengaluru (Joining/Leaving)"],
  dates: [{ date: "Sat Nov 14, 2026", price: 69000 }, { date: "Sat Nov 28, 2026", price: 69000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Bengaluru · Mysore", state: "Karnataka", desc: "Arrive in Bengaluru and travel to Mysore for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at Bengaluru Airport.", nights: 2 },
    { day: 2, title: "Mysore", state: "Karnataka", desc: "Explore Mysore's royal heritage, gardens and cultural attractions.", highlights: ["Mysore Palace", "Mysore Zoo", "Mysore Sand Sculpture Museum", "Shri Chamundeshwari Temple", "Brindavan Gardens"] },
    { day: 3, title: "Mysore · Ooty", state: "Tamil Nadu", desc: "Travel through the Nilgiri hills to Ooty for a two-night stay.", nights: 2 },
    { day: 4, title: "Ooty · Coonoor · Ooty", state: "Tamil Nadu", desc: "Enjoy Ooty and Coonoor sightseeing, including scenic viewpoints and a boat ride on Ooty Lake.", highlights: ["Ooty Lake Boat Ride", "Dolphin’s Nose Viewpoint", "Doddabetta Peak", "Sim's Park"] },
    { day: 5, title: "Ooty · Coorg", state: "Karnataka", desc: "Travel to Coorg and settle in for a two-night stay. Visit the Tibetan Monastery and Market en route as scheduled.", nights: 2, highlights: ["Tibetan Monastery and Market"] },
    { day: 6, title: "Coorg", state: "Karnataka", desc: "Explore Coorg's natural and cultural attractions, including the Cauvery Nisargadhama and Dubare Elephant Camp. White water rafting is subject to availability and conditions.", highlights: ["Cauvery Nisargadhama Hanging Bridge", "Dubare Elephant Camp", "White Water Rafting at Dubare Camp"] },
    { day: 7, title: "Coorg · Bengaluru", state: "Karnataka", desc: "Travel to Bengaluru via Channapatna and visit Tipu Sultan's Summer Palace and Lalbagh Botanical Gardens. Overnight in Bengaluru.", nights: 1, highlights: ["Channapatna", "Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"] },
    { day: 8, title: "Bengaluru · Departure", state: "Karnataka", desc: "Conclude the tour in Bengaluru and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "honeymoon-special-ooty-coorg-mysore-bengaluru-kahc",
  title: "Honeymoon Special Ooty Coorg Mysore Bengaluru",
  scope: "india",
  image: "/assets/media/wiki-ooty.jpg",
  gallery: ["/assets/media/wiki-ooty.jpg", "/assets/media/wiki-coorg.jpg", "/assets/media/wiki-mysore.jpg"],
  code: "KAHC",
  tourType: "GROUP TOUR",
  speciality: "Honeymoon Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Karnataka",
  zone: "South India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 74000,
  joiningLeavingPrice: 60000,
  emiPerMonth: 7206,
  rating: 5,
  reviewsCount: 3,
  route: [{ state: "Karnataka", stops: ["Mysore (2N)"] }, { state: "Tamil Nadu", stops: ["Ooty (2N)"] }, { state: "Karnataka", stops: ["Coorg (2N)", "Bengaluru (1N)"] }],
  highlights: ["Brindavan Gardens", "Mysore Palace", "Mysore Zoo", "Chamundeshwari Temple", "Mysore Palace Illumination", "Ooty Lake Boating", "Dolphin’s Nose Viewpoint", "Sim’s Park", "Doddabetta Peak", "Government Botanical Gardens", "Bylekuppe Tibetan Monastery", "Cauvery Nisargadhama", "Dubare Elephant Camp", "Abbey Waterfalls", "Channapatna Toy Workshops", "Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bengaluru (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Bengaluru · Mysore", state: "Karnataka", desc: "Arrive in Bengaluru and travel to Mysore for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at Bengaluru Airport.", nights: 2 },
    { day: 2, title: "Mysore", state: "Karnataka", desc: "Explore Mysore's royal heritage, including the Mysore Palace, Mysore Zoo and Chamundeshwari Temple. See the palace illumination as scheduled.", highlights: ["Brindavan Gardens", "Mysore Palace", "Mysore Zoo", "Chamundeshwari Temple", "Mysore Palace Illumination"] },
    { day: 3, title: "Mysore · Ooty", state: "Tamil Nadu", desc: "Travel through the Nilgiri hills to Ooty for a two-night stay.", nights: 2 },
    { day: 4, title: "Ooty · Coonoor · Ooty", state: "Tamil Nadu", desc: "Enjoy Ooty and Coonoor sightseeing, including Ooty Lake, Dolphin's Nose, Sim's Park, Doddabetta Peak and the Government Botanical Gardens.", highlights: ["Ooty Lake Boating", "Dolphin’s Nose Viewpoint", "Sim’s Park", "Doddabetta Peak", "Government Botanical Gardens"] },
    { day: 5, title: "Ooty · Coorg", state: "Karnataka", desc: "Travel to Coorg for a two-night stay and visit the Bylekuppe Tibetan Monastery as scheduled.", nights: 2, highlights: ["Bylekuppe Tibetan Monastery"] },
    { day: 6, title: "Coorg", state: "Karnataka", desc: "Explore Coorg's natural attractions, including Cauvery Nisargadhama, Dubare Elephant Camp and Abbey Waterfalls. Activities may depend on local conditions.", highlights: ["Cauvery Nisargadhama", "Dubare Elephant Camp", "Abbey Waterfalls"] },
    { day: 7, title: "Coorg · Bengaluru", state: "Karnataka", desc: "Travel to Bengaluru via Channapatna and visit Tipu Sultan's Summer Palace and Lalbagh Botanical Gardens. Overnight in Bengaluru.", nights: 1, highlights: ["Channapatna Toy Workshops", "Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"] },
    { day: 8, title: "Bengaluru · Departure", state: "Karnataka", desc: "Conclude the tour in Bengaluru and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "womens-special-ooty-coorg-mysore-bengaluru-kawoc",
  title: "Women's Special Ooty Coorg Mysore Bengaluru",
  scope: "india",
  image: "/assets/media/wiki-ooty.jpg",
  gallery: ["/assets/media/wiki-ooty.jpg", "/assets/media/wiki-coorg.jpg", "/assets/media/wiki-mysore.jpg"],
  code: "KAWOC",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Karnataka",
  zone: "South India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 72000,
  joiningLeavingPrice: 58000,
  emiPerMonth: 7000,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Karnataka", stops: ["Mysore (2N)"] }, { state: "Tamil Nadu", stops: ["Ooty (2N)"] }, { state: "Karnataka", stops: ["Coorg (2N)", "Bengaluru (1N)"] }],
  highlights: ["Brindavan Gardens", "Mysore Palace", "Mysore Zoo", "Mysore Sand Sculpture Museum", "Shri Chamundeshwari Temple", "Boat ride in Ooty Lake", "Dolphin’s Nose Viewpoint", "Doddabetta Peak", "Sim's Park", "Tibetan Monastery and Market", "Cauvery Nisargadhama Hanging Bridge", "Dubare Elephant Camp", "White Water Rafting at Dubare Camp", "Channapatna", "Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bengaluru (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Bengaluru · Mysore", state: "Karnataka", desc: "Arrive in Bengaluru and travel to Mysore for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group at Bengaluru Airport.", nights: 2 },
    { day: 2, title: "Mysore", state: "Karnataka", desc: "Explore Mysore's royal heritage, gardens and cultural attractions.", highlights: ["Mysore Palace", "Mysore Zoo", "Mysore Sand Sculpture Museum", "Shri Chamundeshwari Temple", "Brindavan Gardens"] },
    { day: 3, title: "Mysore · Ooty", state: "Tamil Nadu", desc: "Travel through the Nilgiri hills to Ooty for a two-night stay.", nights: 2 },
    { day: 4, title: "Ooty · Coonoor · Ooty", state: "Tamil Nadu", desc: "Enjoy Ooty and Coonoor sightseeing, including scenic viewpoints and a boat ride on Ooty Lake.", highlights: ["Ooty Lake Boat Ride", "Dolphin’s Nose Viewpoint", "Doddabetta Peak", "Sim's Park"] },
    { day: 5, title: "Ooty · Coorg", state: "Karnataka", desc: "Travel to Coorg and settle in for a two-night stay. Visit the Tibetan Monastery and Market en route as scheduled.", nights: 2, highlights: ["Tibetan Monastery and Market"] },
    { day: 6, title: "Coorg", state: "Karnataka", desc: "Explore Coorg's natural and cultural attractions, including the Cauvery Nisargadhama and Dubare Elephant Camp. White water rafting is subject to availability and conditions.", highlights: ["Cauvery Nisargadhama Hanging Bridge", "Dubare Elephant Camp", "White Water Rafting at Dubare Camp"] },
    { day: 7, title: "Coorg · Bengaluru", state: "Karnataka", desc: "Travel to Bengaluru via Channapatna and visit Tipu Sultan's Summer Palace and Lalbagh Botanical Gardens. Overnight in Bengaluru.", nights: 1, highlights: ["Channapatna", "Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"] },
    { day: 8, title: "Bengaluru · Departure", state: "Karnataka", desc: "Conclude the tour in Bengaluru and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});TOURS.push({
  slug: "seniors-special-rann-utsav-with-nadabet-gtzrs",
  title: "Seniors' Special Rann Utsav with Nadabet",
  scope: "india",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-rann-kutch.jpg"],
  code: "GTZRS",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 7,
  region: "Gujarat",
  zone: "West India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 70000,
  joiningLeavingPrice: 56000,
  emiPerMonth: 6816,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Ahmedabad (1N)", "Bhuj (2N)", "Dhordo (2N)", "Dasada (1N)", "Ahmedabad (1N)"] }],
  highlights: ["Adalaj Stepwell", "Bhuj", "Aina Mahal", "Prag Mahal", "Swaminarayan Temple", "Mandavi Beach", "Vijay Vilas Palace", "Smritivan Earthquake Memorial", "Dhordo", "White Rann Sunset", "Road to Heaven Drive", "Dholavira", "Nadabet", "MIG 27 Photostop", "Sarhad Gatha Museum", "Zero Point", "Sabarmati Ashram", "Vision in Dark Museum"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Ahmedabad", state: "Gujarat", desc: "Arrive in Ahmedabad and meet the tour manager. Scheduled guests fly from Mumbai; joining guests meet the group at Ahmedabad Airport.", nights: 1 },
    { day: 2, title: "Ahmedabad · Anjar · Bhuj", state: "Gujarat", desc: "Travel via Anjar to Bhuj for a two-night stay.", nights: 2 },
    { day: 3, title: "Bhuj", state: "Gujarat", desc: "Explore Bhuj's historic palaces and Swaminarayan Temple.", highlights: ["Aina Mahal", "Prag Mahal", "Swaminarayan Temple"] },
    { day: 4, title: "Bhuj · Smritivan · Dhordo", state: "Gujarat", desc: "Visit Smritivan Earthquake Memorial and continue to Dhordo for a two-night stay. Explore Mandavi Beach and Vijay Vilas Palace as scheduled.", nights: 2, highlights: ["Smritivan Earthquake Memorial", "Mandavi Beach", "Vijay Vilas Palace"] },
    { day: 5, title: "Dhordo", state: "Gujarat", desc: "Experience the Rann Utsav and watch sunset over the White Rann.", highlights: ["White Rann Sunset", "Dhordo"] },
    { day: 6, title: "Dhordo · Dholavira · Road to Heaven · Dasada", state: "Gujarat", desc: "Visit Dholavira and drive along the Road to Heaven, continuing to Dasada for an overnight stay.", nights: 1, highlights: ["Dholavira", "Road to Heaven Drive"] },
    { day: 7, title: "Dasada · Nadabet · Ahmedabad", state: "Gujarat", desc: "Visit Nadabet, including the MIG 27 display, Sarhad Gatha Museum and Zero Point, then return to Ahmedabad for an overnight stay.", nights: 1, highlights: ["Nadabet", "MIG 27 Photostop", "Sarhad Gatha Museum", "Zero Point"] },
    { day: 8, title: "Ahmedabad · Departure", state: "Gujarat", desc: "Explore Ahmedabad, including Sabarmati Ashram and Vision in Dark Museum, before departing for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Sabarmati Ashram", "Vision in Dark Museum"] },
  ],
});
TOURS.push({
  slug: "kedarnath-badrinath-nikb",
  title: "Kedarnath Badrinath",
  scope: "india",
  image: "/assets/media/wiki-kedarnath.jpg",
  gallery: ["/assets/media/wiki-kedarnath.jpg", "/assets/media/wiki-badrinath.jpg", "/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg"],
  code: "NIKB",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 8,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Pilgrimage & Nature",
  packageType: "Group Tour",
  startingPrice: 70000,
  joiningLeavingPrice: 56000,
  emiPerMonth: 6816,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Delhi", stops: ["Delhi (Arrival/Departure)"] }, { state: "Uttarakhand", stops: ["Haridwar (2N)", "Guptakashi (2N)", "Kedarnath (1N)", "Badrinath (2N)", "Rudraprayag (1N)"] }],
  highlights: ["Ganga Aarti at Har Ki Pauri", "Kedarnath Ji Temple", "Adi Shankaracharya Samadhi", "Bhairon Nath Temple", "Ardh Narishwar (Vishwanath) Temple", "Badrinath Temple", "Veda Vyasa Gufa", "Adi Shankaracharya Ashram", "Narsimha Temple", "Devprayag Sangam", "Dhari Devi", "Ganga Aarti at Triveni Ghat"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Pune", "Aurangabad", "Delhi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Delhi · Haridwar", state: "Uttarakhand", desc: "Arrive in Delhi and travel to Haridwar for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the tour at Delhi Airport.", nights: 1 },
    { day: 2, title: "Haridwar · Guptakashi", state: "Uttarakhand", desc: "Travel through the Himalayan foothills to Guptakashi for an overnight stay.", nights: 1 },
    { day: 3, title: "Guptakashi · Kedarnath", state: "Uttarakhand", desc: "Proceed to Kedarnath and visit the sacred Kedarnath Ji Temple. The trek or other access arrangements are subject to the tour's operational plan and local conditions.", nights: 1, highlights: ["Kedarnath Ji Temple"] },
    { day: 4, title: "Kedarnath · Guptakashi", state: "Uttarakhand", desc: "Return from Kedarnath to Guptakashi for an overnight stay.", nights: 1, highlights: ["Adi Shankaracharya Samadhi", "Bhairon Nath Temple"] },
    { day: 5, title: "Guptakashi · Joshimath · Badrinath", state: "Uttarakhand", desc: "Travel via Joshimath to Badrinath for a two-night stay.", nights: 2 },
    { day: 6, title: "Badrinath", state: "Uttarakhand", desc: "Visit Badrinath Temple and nearby spiritual landmarks, including Veda Vyasa Gufa and the Adi Shankaracharya Ashram.", highlights: ["Badrinath Temple", "Veda Vyasa Gufa", "Adi Shankaracharya Ashram", "Narsimha Temple"] },
    { day: 7, title: "Badrinath · Rudraprayag", state: "Uttarakhand", desc: "Travel to Rudraprayag for an overnight stay, visiting Dhari Devi en route as scheduled.", nights: 1, highlights: ["Dhari Devi"] },
    { day: 8, title: "Rudraprayag · Rishikesh · Haridwar", state: "Uttarakhand", desc: "Continue to Haridwar via Rishikesh and attend Ganga Aarti at Triveni Ghat as scheduled. Overnight in Haridwar.", nights: 1, highlights: ["Devprayag Sangam", "Ganga Aarti at Triveni Ghat"] },
    { day: 9, title: "Haridwar · Delhi · Departure", state: "Uttarakhand", desc: "Travel to Delhi for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently.", highlights: ["Ganga Aarti at Har Ki Pauri"] },
  ],
});
TOURS.push({
  slug: "ayodhya-varanasi-lucknow-bodh-gaya-upgb",
  title: "Ayodhya Varanasi Lucknow Bodh Gaya",
  scope: "india",
  image: "/assets/media/wiki-ayodhya.jpg",
  gallery: ["/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-lucknow.jpg", "/assets/media/wiki-varanasi-ghat.jpg", "/assets/media/wiki-bodhgaya.jpg", "/assets/media/wiki-prayagraj.jpg"],
  code: "UPGB",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 10,
  nights: 9,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 8,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 70000,
  joiningLeavingPrice: 56000,
  emiPerMonth: 6816,
  rating: 5,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Lucknow (1N)", "Ayodhya (2N)", "Prayagraj (1N)", "Varanasi (3N)"] }, { state: "Bihar", stops: ["Bodh Gaya (2N)"] }],
  highlights: ["Vishnupad Temple", "Mahabodhi Temple", "Great Buddha Statue", "Thai Monastery", "Japanese Monastery", "Tibetan Monastery", "Bodhi Tree", "Boat Ride at Dashashwamedh Ghat", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Kaal Bhairav Temple", "Dhamek Stupa", "Sarnath Archaeological Museum", "Tibetan Buddhist Monastery", "Anand Bhavan", "Laying Hanuman Temple", "Boat Ride at Triveni Sangam", "Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Ram Darbar", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency", "Ambedkar Park"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Lucknow (Joining)", "Gaya (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Lucknow", state: "Uttar Pradesh", desc: "Arrive in Lucknow and meet the tour manager. Explore the city's heritage landmarks before an overnight stay.", nights: 1, highlights: ["Ambedkar Park", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency"] },
    { day: 2, title: "Lucknow · Ayodhya", state: "Uttar Pradesh", desc: "Travel to Ayodhya and settle in for a two-night stay.", nights: 2 },
    { day: 3, title: "Ayodhya", state: "Uttar Pradesh", desc: "Visit Ayodhya's revered temples and landmarks, including Shri Ram Janmabhoomi Mandir.", highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Ram Darbar"] },
    { day: 4, title: "Ayodhya · Prayagraj", state: "Uttar Pradesh", desc: "Travel to Prayagraj for an overnight stay and explore the city's historic sites.", nights: 1, highlights: ["Anand Bhavan", "Laying Hanuman Temple"] },
    { day: 5, title: "Prayagraj · Varanasi", state: "Uttar Pradesh", desc: "Visit Triveni Sangam and continue to Varanasi for a three-night stay.", nights: 3, highlights: ["Triveni Sangam Boat Ride"] },
    { day: 6, title: "Varanasi", state: "Uttar Pradesh", desc: "Explore Varanasi's temples and ghats, with a boat ride at Dashashwamedh Ghat as scheduled.", highlights: ["Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Kaal Bhairav Temple", "Dashashwamedh Ghat Boat Ride"] },
    { day: 7, title: "Varanasi · Sarnath · Varanasi", state: "Uttar Pradesh", desc: "Visit Sarnath's Buddhist heritage sites and return to Varanasi. Enjoy the Assi Ghat sunrise or other sightseeing as scheduled.", highlights: ["Dhamek Stupa", "Sarnath Archaeological Museum", "Tibetan Buddhist Monastery"] },
    { day: 8, title: "Varanasi · Bodh Gaya", state: "Bihar", desc: "Travel to Bodh Gaya and check in for a two-night stay.", nights: 2 },
    { day: 9, title: "Bodh Gaya", state: "Bihar", desc: "Explore Bodh Gaya's Buddhist pilgrimage landmarks and monasteries.", highlights: ["Mahabodhi Temple", "Bodhi Tree", "Great Buddha Statue", "Thai Monastery", "Japanese Monastery", "Tibetan Monastery", "Vishnupad Temple"] },
    { day: 10, title: "Bodh Gaya · Departure", state: "Bihar", desc: "Conclude the tour and depart for your onward journey from Gaya. Scheduled guests continue to their departure airport as arranged." },
  ],
});
TOURS.push({
  slug: "sikkim-darjeeling-gangtok-sdsd",
  title: "Sikkim Darjeeling Gangtok",
  scope: "india",
  image: "/assets/media/wiki-darjeeling-tea.jpg",
  gallery: ["/assets/media/wiki-darjeeling-tea.jpg", "/assets/media/wiki-gangtok.jpg"],
  code: "SDSD",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 6,
  region: "Sikkim Darjeeling",
  zone: "East India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 70000,
  joiningLeavingPrice: 55000,
  emiPerMonth: 6816,
  rating: 5,
  reviewsCount: 411,
  route: [{ state: "West Bengal", stops: ["Darjeeling (2N)", "Siliguri (1N)"] }, { state: "Sikkim", stops: ["Gangtok (3N)"] }],
  highlights: ["Tiger Hill Sunrise", "Batasia Loop", "Himalayan Mountaineering Institute", "Zoological Park", "Himalayan Tibet Museum", "Tenzing Rock", "Namchi Chardham Temple", "Samdruptse Monastery", "Gangtok Ropeway Ride", "Ranka Monastery", "Banjhakri Waterfall", "Namgyal Institute of Tibetology", "Dordul Chorten Stupa", "Flower Exhibition Centre", "Hanuman Tok", "Ganesh Tok", "Tashi View Point", "Folk Dance", "Baba Harbhajan Singh Mandir", "Tsomgo Lake", "White Water Rafting"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bagdogra (Joining/Leaving)"],
  dates: [{ date: "Sat Nov 07, 2026", price: 70000 }, { date: "Sat Nov 28, 2026", price: 70000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Bagdogra · Darjeeling", state: "West Bengal", desc: "Arrive at Bagdogra and travel to Darjeeling for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the tour at Bagdogra Airport.", nights: 2 },
    { day: 2, title: "Darjeeling", state: "West Bengal", desc: "Enjoy Darjeeling sightseeing, including the sunrise from Tiger Hill and the town's Himalayan heritage attractions.", highlights: ["Tiger Hill Sunrise", "Batasia Loop", "Himalayan Mountaineering Institute", "Zoological Park", "Himalayan Tibet Museum", "Tenzing Rock"] },
    { day: 3, title: "Darjeeling · Namchi · Gangtok", state: "Sikkim", desc: "Travel via Namchi to Gangtok for a three-night stay, visiting its Chardham complex and Samdruptse Monastery as scheduled.", nights: 3, highlights: ["Namchi Chardham Temple", "Samdruptse Monastery"] },
    { day: 4, title: "Gangtok · Tsomgo Lake · Gangtok", state: "Sikkim", desc: "Take an excursion to Tsomgo Lake and visit Baba Harbhajan Singh Mandir. Sightseeing is subject to permits and weather conditions.", highlights: ["Tsomgo Lake", "Baba Harbhajan Singh Mandir"] },
    { day: 5, title: "Gangtok", state: "Sikkim", desc: "Explore Gangtok's monasteries, viewpoints, cultural institutions and local attractions.", highlights: ["Gangtok Ropeway Ride", "Ranka Monastery", "Banjhakri Waterfall", "Namgyal Institute of Tibetology", "Dordul Chorten Stupa", "Flower Exhibition Centre", "Hanuman Tok", "Ganesh Tok", "Tashi View Point", "Folk Dance"] },
    { day: 6, title: "Gangtok · Teesta River Rafting · Siliguri", state: "West Bengal", desc: "Travel to Siliguri via the Teesta River rafting area. Rafting is optional and subject to seasonal availability and local conditions. Overnight in Siliguri.", nights: 1, highlights: ["White Water Rafting"] },
    { day: 7, title: "Siliguri · Bagdogra · Departure", state: "West Bengal", desc: "Transfer to Bagdogra Airport for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "seniors-special-sikkim-darjeeling-gangtok-sdzb",
  title: "Senior's Special Sikkim Darjeeling Gangtok",
  scope: "india",
  image: "/assets/media/wiki-darjeeling-tea.jpg",
  gallery: ["/assets/media/wiki-darjeeling-tea.jpg", "/assets/media/wiki-gangtok.jpg"],
  code: "SDZB",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Sikkim Darjeeling",
  zone: "East India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 74000,
  joiningLeavingPrice: 57500,
  emiPerMonth: 7206,
  rating: 5,
  reviewsCount: 1,
  route: [{ state: "West Bengal", stops: ["Darjeeling (2N)", "Siliguri (1N)"] }, { state: "Sikkim", stops: ["Gangtok (3N)"] }],
  highlights: ["Baba Harbhajan Singh Mandir", "Tsomgo Lake", "Local Folk Dance", "Ranka Monastery", "Banjhakri Waterfall", "Gangtok Ropeway Ride", "Namgyal Institute of Tibetology", "Do-Drul Chorten Stupa", "Hanuman Tok", "Ganesh Tok", "Orchidarium", "Gangtok Shopping", "Chardham Temple (Namchi)", "Samdruptse Monastery", "White Water Rafting (Teesta River)", "Tiger Hill Sunrise", "Batasia Loop", "Himalayan Mountaineering Institute", "Zoological Park", "Himalayan Tibet Museum", "Tenzing Rock"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bagdogra (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Bagdogra · Darjeeling", state: "West Bengal", desc: "Arrive at Bagdogra and travel to Darjeeling for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the tour at Bagdogra Airport.", nights: 2 },
    { day: 2, title: "Darjeeling", state: "West Bengal", desc: "Enjoy Darjeeling sightseeing, including the sunrise from Tiger Hill, Batasia Loop and the town's Himalayan heritage attractions.", highlights: ["Tiger Hill Sunrise", "Batasia Loop", "Himalayan Mountaineering Institute", "Zoological Park", "Himalayan Tibet Museum", "Tenzing Rock"] },
    { day: 3, title: "Darjeeling · Namchi · Gangtok", state: "Sikkim", desc: "Travel via Namchi to Gangtok for a three-night stay, visiting Chardham Temple and Samdruptse Monastery as scheduled.", nights: 3, highlights: ["Chardham Temple (Namchi)", "Samdruptse Monastery"] },
    { day: 4, title: "Gangtok · Tsomgo Lake · Gangtok", state: "Sikkim", desc: "Take an excursion to Tsomgo Lake and visit Baba Harbhajan Singh Mandir. Sightseeing is subject to permits and weather conditions.", highlights: ["Tsomgo Lake", "Baba Harbhajan Singh Mandir"] },
    { day: 5, title: "Gangtok", state: "Sikkim", desc: "Explore Gangtok's monasteries, cultural institutions and viewpoints, with time for shopping and a local folk dance.", highlights: ["Gangtok Ropeway Ride", "Ranka Monastery", "Banjhakri Waterfall", "Namgyal Institute of Tibetology", "Do-Drul Chorten Stupa", "Hanuman Tok", "Ganesh Tok", "Orchidarium", "Gangtok Shopping", "Local Folk Dance"] },
    { day: 6, title: "Gangtok · Teesta River Rafting · Siliguri", state: "West Bengal", desc: "Travel to Siliguri via the Teesta River rafting area. Rafting is optional and subject to seasonal availability and local conditions. Overnight in Siliguri.", nights: 1, highlights: ["White Water Rafting (Teesta River)"] },
    { day: 7, title: "Siliguri · Bagdogra · Departure", state: "West Bengal", desc: "Transfer to Bagdogra Airport for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "hampi-badami-chikmagalur-kabh",
  title: "Hampi Badami Chikmagalur",
  scope: "india",
  image: "/assets/media/wiki-hampi.jpg",
  gallery: ["/assets/media/wiki-hampi.jpg", "/assets/media/wiki-badami.jpg"],
  code: "KABH",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 9,
  region: "Karnataka",
  zone: "South India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 70000,
  joiningLeavingPrice: 55000,
  emiPerMonth: 6816,
  rating: 5,
  reviewsCount: 9,
  route: [{ state: "Karnataka", stops: ["Bengaluru (1N)", "Hassan (1N)", "Chikmagalur (2N)", "Hampi (2N)", "Badami (2N)"] }],
  highlights: ["Statue of Lord Bahubali (Gomteshwara)", "Chennakeshava Temple", "Hoysaleswara Temple", "Virupaksha Temple", "Lakshmi Narasimha Temple", "Coracle Ride", "Pattadakal Group of Monuments", "Badami Cave Temples", "Bhutanatha Temple Complex", "Chitradurga Fort", "Mullayanagiri Peak", "Coffee Plantations", "Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bengaluru (Joining/Leaving)"],
  dates: [{ date: "Sun Nov 29, 2026", price: 70000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Bengaluru · Hassan", state: "Karnataka", desc: "Arrive in Bengaluru and travel to Hassan, visiting Shravanabelagola and the Gomateshwara statue en route. Overnight in Hassan.", nights: 1, highlights: ["Statue of Lord Bahubali (Gomteshwara)"] },
    { day: 2, title: "Hassan · Belur · Halebidu · Chikmagalur", state: "Karnataka", desc: "Visit the celebrated Hoysala temples at Belur and Halebidu before continuing to Chikmagalur for a two-night stay.", nights: 2, highlights: ["Chennakeshava Temple", "Hoysaleswara Temple"] },
    { day: 3, title: "Chikmagalur", state: "Karnataka", desc: "Enjoy Chikmagalur's mountain scenery, coffee plantations and Mullayanagiri Peak.", highlights: ["Mullayanagiri Peak", "Coffee Plantations"] },
    { day: 4, title: "Chikmagalur · Chitradurga · Hampi", state: "Karnataka", desc: "Travel towards Hampi, stopping at Chitradurga Fort as scheduled. Settle in for a two-night stay.", nights: 2, highlights: ["Chitradurga Fort"] },
    { day: 5, title: "Hampi", state: "Karnataka", desc: "Explore Hampi's historic temples and Vijayanagara heritage, including Virupaksha Temple and the Vittala Temple Complex.", highlights: ["Virupaksha Temple", "Vittala Temple Complex", "Lakshmi Narasimha Temple", "Coracle Ride"] },
    { day: 6, title: "Hampi · Badami", state: "Karnataka", desc: "Continue to Badami via the Pattadakal Group of Monuments for a two-night stay.", nights: 2, highlights: ["Pattadakal Group of Monuments"] },
    { day: 7, title: "Badami", state: "Karnataka", desc: "Visit the Badami Cave Temples and the lakeside Bhutanatha Temple Complex.", highlights: ["Badami Cave Temples", "Bhutanatha Temple Complex"] },
    { day: 8, title: "Badami · Bengaluru", state: "Karnataka", desc: "Travel back to Bengaluru, visiting Tipu Sultan's Summer Palace and Lalbagh Botanical Gardens as scheduled. Overnight in Bengaluru.", nights: 1, highlights: ["Tipu Sultan’s Summer Palace", "Lalbagh Botanical Gardens"] },
    { day: 9, title: "Bengaluru · Departure", state: "Karnataka", desc: "Conclude the tour in Bengaluru and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "womens-special-coastal-karnataka-kawk",
  title: "Women's Special Coastal Karnataka",
  scope: "india",
  image: "/assets/media/wiki-gokarna.jpg",
  gallery: ["/assets/media/wiki-gokarna.jpg", "/assets/media/wiki-dandeli.jpg", "/assets/media/wiki-goa.jpg"],
  code: "KAWK",
  tourType: "GROUP TOUR",
  speciality: "Women's Special",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 9,
  region: "Karnataka",
  zone: "South India",
  interest: "Coast & Nature",
  packageType: "Group Tour",
  startingPrice: 70000,
  joiningLeavingPrice: 64200,
  emiPerMonth: 6816,
  rating: 5,
  reviewsCount: 1,
  route: [{ state: "Karnataka", stops: ["Udupi (1N)", "Gokarna (3N)", "Dandeli (2N)"] }, { state: "Goa", stops: ["Goa (1N)"] }],
  highlights: ["Sri Krishna Math", "Murdeshwar Temple", "Gopuram", "Kandla Mangrove Board", "Sharavati River Backwaters Ride", "Om Beach", "Mahabaleshwar Temple", "Gokarna Beach", "Yana Rocks", "Cave Temple", "Sahastralinga", "Rock Garden", "Jeep Safari at Dandeli Wildlife Sanctuary", "Shanta Durga Temple", "Shree Mangueshi Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Mangalore (Joining)", "Goa (Leaving)"],
  dates: [{ date: "Sat Dec 05, 2026", price: 70000 }, { date: "Sat Mar 06, 2027", price: 70000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Mangalore · Udupi", state: "Karnataka", desc: "Arrive at Mangalore and travel to Udupi for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Mangalore Airport.", nights: 1, highlights: ["Sri Krishna Math"] },
    { day: 2, title: "Udupi · Murdeshwar · Honavar · Gokarna", state: "Karnataka", desc: "Travel along the coast via Murdeshwar and Honavar to Gokarna for a three-night stay.", nights: 3, highlights: ["Murdeshwar Temple", "Gopuram", "Kandla Mangrove Board", "Sharavati River Backwaters Ride"] },
    { day: 3, title: "Gokarna", state: "Karnataka", desc: "Explore Gokarna's coastal landmarks and beaches.", highlights: ["Om Beach", "Mahabaleshwar Temple", "Gokarna Beach"] },
    { day: 4, title: "Gokarna · Yana · Gokarna", state: "Karnataka", desc: "Take an excursion to Yana's striking rock formations and nearby cave temples, returning to Gokarna.", highlights: ["Yana Rocks", "Cave Temple"] },
    { day: 5, title: "Gokarna · Karwar · Dandeli", state: "Karnataka", desc: "Travel via Karwar to Dandeli for a two-night stay, with a visit to the rock garden and Sahastralinga as scheduled.", nights: 2, highlights: ["Sahastralinga", "Rock Garden"] },
    { day: 6, title: "Dandeli", state: "Karnataka", desc: "Enjoy a jeep safari in Dandeli Wildlife Sanctuary and time to experience the area's forest scenery.", highlights: ["Jeep Safari at Dandeli Wildlife Sanctuary"] },
    { day: 7, title: "Dandeli · Goa", state: "Goa", desc: "Travel to Goa for an overnight stay, with visits to Shanta Durga and Shree Mangueshi temples as scheduled.", nights: 1, highlights: ["Shanta Durga Temple", "Shree Mangueshi Temple"] },
    { day: 8, title: "Goa · Departure", state: "Goa", desc: "Conclude the tour in Goa and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "coastal-karnataka-kakc",
  title: "Coastal Karnataka",
  scope: "india",
  image: "/assets/media/wiki-gokarna.jpg",
  gallery: ["/assets/media/wiki-gokarna.jpg", "/assets/media/wiki-dandeli.jpg", "/assets/media/wiki-goa.jpg"],
  code: "KAKC",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 9,
  region: "Karnataka",
  zone: "South India",
  interest: "Coast & Nature",
  packageType: "Group Tour",
  startingPrice: 65000,
  joiningLeavingPrice: 50000,
  emiPerMonth: 6323,
  rating: 5,
  reviewsCount: 0,
  route: [{ state: "Karnataka", stops: ["Udupi (1N)", "Gokarna (3N)", "Dandeli (2N)"] }, { state: "Goa", stops: ["Goa (1N)"] }],
  highlights: ["Sri Krishna Math", "Malpe Beach", "Murdeshwar Temple", "Gopuram", "Kandla Mangrove Board", "Sharavati River Backwaters Ride", "Om Beach", "Mahabaleshwar Temple", "Gokarna Beach", "Yana Rocks", "Cave Temple", "Sahastralinga", "Rock Garden", "Jeep Safari at Dandeli Wildlife Sanctuary", "Shanta Durga Temple", "Shree Mangueshi Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Mangalore (Joining)", "Goa (Leaving)"],
  dates: [{ date: "Sat Nov 07, 2026", price: 65000 }, { date: "Sat Nov 14, 2026", price: 65000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Mangalore · Udupi", state: "Karnataka", desc: "Arrive at Mangalore and travel to Udupi for an overnight stay. Scheduled guests fly from Mumbai; joining guests meet the group at Mangalore Airport.", nights: 1, highlights: ["Sri Krishna Math"] },
    { day: 2, title: "Udupi · Murdeshwar · Honavar · Gokarna", state: "Karnataka", desc: "Travel along the coast via Murdeshwar and Honavar to Gokarna for a three-night stay.", nights: 3, highlights: ["Malpe Beach", "Murdeshwar Temple", "Gopuram", "Kandla Mangrove Board", "Sharavati River Backwaters Ride"] },
    { day: 3, title: "Gokarna", state: "Karnataka", desc: "Explore Gokarna's beaches and spiritual landmarks.", highlights: ["Om Beach", "Mahabaleshwar Temple", "Gokarna Beach"] },
    { day: 4, title: "Gokarna · Yana · Gokarna", state: "Karnataka", desc: "Take an excursion to Yana's striking rock formations and cave temple, returning to Gokarna.", highlights: ["Yana Rocks", "Cave Temple"] },
    { day: 5, title: "Gokarna · Karwar · Dandeli", state: "Karnataka", desc: "Travel via Karwar to Dandeli for a two-night stay, with visits to Sahastralinga and the rock garden as scheduled.", nights: 2, highlights: ["Sahastralinga", "Rock Garden"] },
    { day: 6, title: "Dandeli", state: "Karnataka", desc: "Enjoy a jeep safari at Dandeli Wildlife Sanctuary and experience the surrounding forest landscape.", highlights: ["Jeep Safari at Dandeli Wildlife Sanctuary"] },
    { day: 7, title: "Dandeli · Goa", state: "Goa", desc: "Travel to Goa for an overnight stay, visiting Shanta Durga and Shree Mangueshi temples as scheduled.", nights: 1, highlights: ["Shanta Durga Temple", "Shree Mangueshi Temple"] },
    { day: 8, title: "Goa · Departure", state: "Goa", desc: "Conclude the tour in Goa and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "temples-of-tamil-nadu-tntt",
  title: "Temples of Tamil Nadu",
  scope: "india",
  image: "/assets/media/wiki-madurai.jpg",
  gallery: ["/assets/media/wiki-madurai.jpg", "/assets/media/wiki-rameshwaram.jpg"],
  code: "TNTT",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Tamil Nadu",
  zone: "South India",
  interest: "Culture & Pilgrimage",
  packageType: "Group Tour",
  startingPrice: 69000,
  joiningLeavingPrice: 52000,
  emiPerMonth: 6718,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Tamil Nadu", stops: ["Madurai (1N)", "Thanjavur (2N)", "Rameswaram (2N)"] }],
  highlights: ["Meenakshi Amman Temple", "Ranganatha Swamy Temple", "Brihadeeswara Temple", "Maratha Palace", "Sivagangai Fort", "Chettinad Palace", "Ramanathaswamy Temple", "Dhanushkodi Beach"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Madurai (Joining/Leaving)"],
  dates: [{ date: "Sun Nov 22, 2026", price: 69000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Madurai", state: "Tamil Nadu", desc: "Arrive in Madurai and meet the tour manager. Visit Meenakshi Amman Temple and settle in for an overnight stay.", nights: 1, highlights: ["Meenakshi Amman Temple"] },
    { day: 2, title: "Madurai · Trichy · Thanjavur", state: "Tamil Nadu", desc: "Travel via Trichy, visiting Ranganatha Swamy Temple, and continue to Thanjavur for a two-night stay.", nights: 2, highlights: ["Ranganatha Swamy Temple"] },
    { day: 3, title: "Thanjavur", state: "Tamil Nadu", desc: "Explore Thanjavur's great temple and royal heritage, including Brihadeeswara Temple and Maratha Palace.", highlights: ["Brihadeeswara Temple", "Maratha Palace", "Sivagangai Fort"] },
    { day: 4, title: "Thanjavur · Chettinad · Rameswaram", state: "Tamil Nadu", desc: "Travel through the Chettinad region, visiting Chettinad Palace as scheduled, before reaching Rameswaram for a two-night stay.", nights: 2, highlights: ["Chettinad Palace"] },
    { day: 5, title: "Rameswaram", state: "Tamil Nadu", desc: "Visit Ramanathaswamy Temple and explore Dhanushkodi Beach.", highlights: ["Ramanathaswamy Temple", "Dhanushkodi Beach"] },
    { day: 6, title: "Rameswaram · Madurai · Departure", state: "Tamil Nadu", desc: "Return to Madurai and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});

TOURS.push({
  slug: "best-of-andaman-anex",
  title: "Best of Andaman",
  scope: "india",
  image: "/assets/media/wiki-goa.jpg",
  gallery: ["/assets/media/wiki-goa.jpg", "/assets/media/wiki-kovalam.jpg", "/assets/media/wiki-alleppey.jpg"],
  code: "ANEX",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Andaman and Nicobar Islands",
  zone: "South India",
  interest: "Beaches & Nature",
  packageType: "Group Tour",
  startingPrice: 74000,
  joiningLeavingPrice: 56000,
  emiPerMonth: 7206,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Andaman and Nicobar Islands", stops: ["Port Blair (1N)", "Havelock (2N)", "Neil Island (1N)", "Port Blair (2N)"] }],
  highlights: ["Cellular Museum", "Cellular Jail", "Veer Savarkar Smarak", "Light and Sound Show", "Netaji Subhash Chandra Bose Island", "Ross Island", "Havelock (Swaraj Dweep)", "Elephant Beach", "Radhanagar Beach", "Neil Island (Shaheed Dweep)", "Bharatpur Beach", "Baratang Island", "Mangrove Boat Ride", "Mud Volcano", "Limestone Caves"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Port Blair (Joining/Leaving)"],
  dates: [{ date: "Fri Mar 12, 2027", price: 74000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Port Blair", state: "Andaman and Nicobar Islands", desc: "Arrive at Port Blair, visit the Cellular Museum and Cellular Jail, and attend the Light and Sound Show at Veer Savarkar Smarak. Overnight in Port Blair.", nights: 1, highlights: ["Cellular Museum", "Cellular Jail", "Veer Savarkar Smarak", "Light and Sound Show"] },
    { day: 2, title: "Port Blair · Ross Island · Havelock", state: "Andaman and Nicobar Islands", desc: "Visit Netaji Subhash Chandra Bose Island (Ross Island), then ferry to Havelock (Swaraj Dweep) for a two-night stay.", nights: 2, highlights: ["Netaji Subhash Chandra Bose Island", "Ross Island"] },
    { day: 3, title: "Havelock", state: "Andaman and Nicobar Islands", desc: "Enjoy Havelock Island, including Elephant Beach and Radhanagar Beach as scheduled.", highlights: ["Elephant Beach", "Radhanagar Beach"] },
    { day: 4, title: "Havelock · Neil Island", state: "Andaman and Nicobar Islands", desc: "Travel by ferry to Neil Island (Shaheed Dweep) and explore Bharatpur Beach. Overnight on the island.", nights: 1, highlights: ["Neil Island (Shaheed Dweep)", "Bharatpur Beach"] },
    { day: 5, title: "Neil Island · Port Blair", state: "Andaman and Nicobar Islands", desc: "Return by ferry to Port Blair for a two-night stay.", nights: 2 },
    { day: 6, title: "Port Blair · Baratang · Port Blair", state: "Andaman and Nicobar Islands", desc: "Take an excursion to Baratang Island, with a mangrove boat ride to the limestone caves and a visit to the mud volcano as scheduled.", highlights: ["Baratang Island", "Mangrove Boat Ride", "Mud Volcano", "Limestone Caves"] },
    { day: 7, title: "Port Blair · Departure", state: "Andaman and Nicobar Islands", desc: "Conclude the tour and depart from Port Blair for your onward journey. Scheduled guests connect through Chennai to Mumbai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "best-of-kerala-klkv",
  title: "Best of Kerala",
  scope: "india",
  image: "/assets/media/wiki-munnar.jpg",
  gallery: ["/assets/media/wiki-munnar.jpg", "/assets/media/wiki-alleppey.jpg", "/assets/media/wiki-kovalam.jpg", "/assets/media/wiki-kanyakumari.jpg"],
  code: "KLKV",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 11,
  nights: 10,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 7,
  region: "Kerala",
  zone: "South India",
  interest: "Nature & Culture",
  packageType: "Group Tour",
  startingPrice: 76000,
  joiningLeavingPrice: 71000,
  emiPerMonth: 7390,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Kerala", stops: ["Cochin (1N)", "Munnar (2N)", "Periyar (1N)", "Alleppey Houseboat (1N)", "Varkala (2N)"] }, { state: "Tamil Nadu", stops: ["Kanyakumari (1N)"] }, { state: "Kerala", stops: ["Thiruvananthapuram (2N)"] }],
  highlights: ["Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue", "Dutch Palace", "Munnar Tea Plantations", "Mattupetty Dam Boat Ride", "Echo Point", "Eravikulam National Park", "Kumily Spice Village", "Periyar Wildlife Sanctuary", "Periyar Lake Boat Safari", "Kalaripayattu Show", "Kathakali Show", "Alleppey Houseboat Stay", "Jatayu Earth Centre", "Varkala Cliff", "Mangrove Backwater Safari", "Kanyakumari Sunset", "Vivekananda Rock Memorial", "Thiruvalluvar Statue", "Triveni Sangam", "Kanyakumari Mandir", "Padmanabh Swami Temple", "Raja Ravi Varma Art Gallery", "Napier Museum", "Kovalam Beach"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Cochin (Joining)", "Thiruvananthapuram (Leaving)"],
  dates: [{ date: "Fri Nov 06, 2026", price: 76000 }, { date: "Tue Nov 10, 2026", price: 76000 }, { date: "Sat Nov 14, 2026", price: 76000 }, { date: "Fri Nov 20, 2026", price: 76000 }, { date: "Fri Nov 27, 2026", price: 76000 }, { date: "Fri Dec 04, 2026", price: 76000 }, { date: "Fri Dec 18, 2026", price: 76000 }, { date: "Fri Jan 08, 2027", price: 76000 }, { date: "Fri Feb 05, 2027", price: 76000 }, { date: "Fri Mar 19, 2027", price: 76000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Cochin", state: "Kerala", desc: "Arrive in Cochin and explore its historic waterfront, including the Chinese Fishing Nets, St. Francis Church, Jewish Synagogue and Dutch Palace. Overnight in Cochin.", nights: 1, highlights: ["Chinese Fishing Nets", "St. Francis Church", "Jewish Synagogue", "Dutch Palace"] },
    { day: 2, title: "Cochin · Munnar", state: "Kerala", desc: "Travel to Munnar through Kerala's scenic tea country for a two-night stay.", nights: 2 },
    { day: 3, title: "Munnar", state: "Kerala", desc: "Explore Munnar's tea plantations, Mattupetty Dam and Echo Point, with a visit to Eravikulam National Park as scheduled.", highlights: ["Munnar Tea Plantations", "Mattupetty Dam Boat Ride", "Echo Point", "Eravikulam National Park"] },
    { day: 4, title: "Munnar · Periyar", state: "Kerala", desc: "Travel to Periyar and visit Kumily Spice Village. Stay overnight near the wildlife sanctuary.", nights: 1, highlights: ["Kumily Spice Village"] },
    { day: 5, title: "Periyar · Alleppey Houseboat", state: "Kerala", desc: "Enjoy Periyar Wildlife Sanctuary and a boat safari on Periyar Lake, with Kalaripayattu and Kathakali performances as scheduled. Continue to Alleppey for a houseboat stay.", nights: 1, highlights: ["Periyar Wildlife Sanctuary", "Periyar Lake Boat Safari", "Kalaripayattu Show", "Kathakali Show", "Alleppey Houseboat Stay"] },
    { day: 6, title: "Alleppey Houseboat · Jatayu · Varkala", state: "Kerala", desc: "Disembark and visit Jatayu Earth Centre before continuing to Varkala for a two-night stay.", nights: 2, highlights: ["Jatayu Earth Centre", "Varkala Cliff"] },
    { day: 7, title: "Varkala", state: "Kerala", desc: "Explore Varkala's coastal scenery and enjoy a mangrove backwater safari as scheduled.", highlights: ["Varkala Cliff", "Mangrove Backwater Safari"] },
    { day: 8, title: "Varkala · Kanyakumari", state: "Tamil Nadu", desc: "Travel to Kanyakumari, arriving in time to enjoy the sunset. Overnight in Kanyakumari.", nights: 1, highlights: ["Kanyakumari Sunset"] },
    { day: 9, title: "Kanyakumari · Thiruvananthapuram", state: "Kerala", desc: "Visit Vivekananda Rock Memorial, Thiruvalluvar Statue, Triveni Sangam and Kanyakumari Mandir, then continue to Thiruvananthapuram for a two-night stay.", nights: 2, highlights: ["Vivekananda Rock Memorial", "Thiruvalluvar Statue", "Triveni Sangam", "Kanyakumari Mandir"] },
    { day: 10, title: "Thiruvananthapuram", state: "Kerala", desc: "Explore Padmanabha Swamy Temple, Raja Ravi Varma Art Gallery, Napier Museum and Kovalam Beach.", highlights: ["Padmanabh Swami Temple", "Raja Ravi Varma Art Gallery", "Napier Museum", "Kovalam Beach"] },
    { day: 11, title: "Thiruvananthapuram · Departure", state: "Kerala", desc: "Conclude the tour in Thiruvananthapuram and depart for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests make their own arrangements." },
  ],
});
TOURS.push({
  slug: "best-of-rajasthan-rjbr",
  title: "Best of Rajasthan",
  scope: "india",
  image: "/assets/media/wiki-udaipur.jpg",
  gallery: ["/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-ranthambore.jpg", "/assets/media/wiki-chittorgarh.jpg"],
  code: "RJBR",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 13,
  nights: 12,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 8,
  region: "Rajasthan",
  zone: "North India",
  interest: "Culture & Wildlife",
  packageType: "Group Tour",
  startingPrice: 77000,
  joiningLeavingPrice: 72000,
  emiPerMonth: 7494,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Udaipur (2N)", "Kumbhalgarh (1N)", "Jodhpur (2N)", "Jaisalmer (2N)", "Jaipur (3N)", "Ranthambore (2N)"] }],
  highlights: ["Jaisalmer War Museum", "Gadisar Lake Boat Ride", "Puppet Show", "Golden Fort (Jaisalmer Fort)", "Jaisalmer Fort Palace and Museum", "Patwon Ki Haveli Museum", "Kuldhara Village", "Sam Sand Dunes", "Dune Bashing", "Camel Ride at Sunset", "Rajasthani Folk Dance", "Bishnoi Village Safari", "Sanganeri Block Prints", "Umaid Bhawan Palace Museum", "Mehrangarh Fort", "Jaswant Thada", "Sound and Light Show (Amer Fort)", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Amer Fort", "Bapu Market Shopping", "Ranthambore Jungle Safari", "Kumbhalgarh Fort", "Ranakpur Jain Temple", "Shrinathji Temple", "Statue of Belief", "Chittorgarh Fort", "Ranakumbha Palace", "Vijay Stambha", "Queen Padmini’s Palace", "Moti Magri", "Udaipur City Palace", "Jag Mandir", "Traditional Music & Dance Show"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Udaipur (Joining)", "Jaipur (Leaving)"],
  dates: [{ date: "Thu Nov 19, 2026", price: 77000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Udaipur", state: "Rajasthan", desc: "Arrive in Udaipur, meet the tour manager and settle in for a two-night stay. Scheduled guests fly from Mumbai; joining guests meet the group in Udaipur.", nights: 2 },
    { day: 2, title: "Udaipur", state: "Rajasthan", desc: "Explore Udaipur's Moti Magri, City Palace and Jag Mandir, and enjoy traditional music and dance as scheduled.", highlights: ["Moti Magri", "Udaipur City Palace", "Jag Mandir", "Traditional Music & Dance Show"] },
    { day: 3, title: "Udaipur · Chittorgarh · Kumbhalgarh", state: "Rajasthan", desc: "Visit Chittorgarh Fort and its historic palaces and monuments, then continue to Kumbhalgarh for an overnight stay.", nights: 1, highlights: ["Chittorgarh Fort", "Ranakumbha Palace", "Vijay Stambha", "Queen Padmini’s Palace"] },
    { day: 4, title: "Kumbhalgarh · Ranakpur · Jodhpur", state: "Rajasthan", desc: "Explore Kumbhalgarh Fort and Ranakpur Jain Temple before travelling to Jodhpur for a two-night stay.", nights: 2, highlights: ["Kumbhalgarh Fort", "Ranakpur Jain Temple"] },
    { day: 5, title: "Jodhpur", state: "Rajasthan", desc: "Visit Umaid Bhawan Palace Museum, Mehrangarh Fort and Jaswant Thada, with a Bishnoi Village Safari and block-print demonstration as scheduled.", highlights: ["Umaid Bhawan Palace Museum", "Mehrangarh Fort", "Jaswant Thada", "Bishnoi Village Safari", "Sanganeri Block Prints"] },
    { day: 6, title: "Jodhpur · Jaisalmer", state: "Rajasthan", desc: "Travel to Jaisalmer for a two-night stay.", nights: 2 },
    { day: 7, title: "Jaisalmer", state: "Rajasthan", desc: "Explore Jaisalmer Fort, its heritage museum and Patwon Ki Haveli, visit Gadisar Lake and Kuldhara, and enjoy the Sam Sand Dunes with a camel ride, dune bashing and folk performance.", highlights: ["Jaisalmer War Museum", "Gadisar Lake Boat Ride", "Puppet Show", "Golden Fort (Jaisalmer Fort)", "Jaisalmer Fort Palace and Museum", "Patwon Ki Haveli Museum", "Kuldhara Village", "Sam Sand Dunes", "Dune Bashing", "Camel Ride at Sunset", "Rajasthani Folk Dance"] },
    { day: 8, title: "Jaisalmer · Jaipur", state: "Rajasthan", desc: "Travel to Jaipur and settle in for a three-night stay.", nights: 3 },
    { day: 9, title: "Jaipur", state: "Rajasthan", desc: "Explore Jaipur's Amer Fort, Hawa Mahal, Jantar Mantar and City Palace, with time for Panna Meena ka Kund and Bapu Market.", highlights: ["Sound and Light Show (Amer Fort)", "Hawa Mahal", "Jantar Mantar", "City Palace Jaipur", "Panna Meena ka Kund", "Amer Fort", "Bapu Market Shopping"] },
    { day: 10, title: "Jaipur · Shrinathji · Nathdwara · Jaipur", state: "Rajasthan", desc: "Visit Shrinathji Temple and the Statue of Belief as scheduled, returning to Jaipur for the night.", highlights: ["Shrinathji Temple", "Statue of Belief"] },
    { day: 11, title: "Jaipur · Ranthambore", state: "Rajasthan", desc: "Travel to Ranthambore for a two-night stay and enjoy a jungle safari as scheduled.", nights: 2, highlights: ["Ranthambore Jungle Safari"] },
    { day: 12, title: "Ranthambore", state: "Rajasthan", desc: "Discover Ranthambore National Park and its wildlife on a safari, subject to park permits and availability.", highlights: ["Ranthambore Jungle Safari"] },
    { day: 13, title: "Ranthambore · Jaipur · Departure", state: "Rajasthan", desc: "Return to Jaipur for your onward journey. Scheduled guests fly back to Mumbai; joining/leaving guests depart independently." },
  ],
});TOURS.push({
  slug: "seniors-special-andaman-anza",
  title: "Seniors' Special Andaman",
  scope: "india",
  image: "/assets/media/wiki-goa.jpg",
  gallery: ["/assets/media/wiki-goa.jpg", "/assets/media/wiki-kovalam.jpg", "/assets/media/wiki-alleppey.jpg"],
  code: "ANZA",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Andaman and Nicobar Islands",
  zone: "South India",
  interest: "Beaches & Nature",
  packageType: "Group Tour",
  startingPrice: 79000,
  joiningLeavingPrice: 52000,
  emiPerMonth: 7680,
  rating: 5,
  reviewsCount: 14,
  route: [{ state: "Andaman and Nicobar Islands", stops: ["Port Blair (1N)", "Havelock (2N)", "Neil Island (1N)", "Port Blair (2N)"] }],
  highlights: ["Cellular Museum", "Cellular Jail", "Veer Savarkar Smarak", "Light and Sound Show", "Netaji Subhash Chandra Bose Island", "Ross Island", "Havelock (Swaraj Dweep)", "Elephant Beach", "Radhanagar Beach", "Neil Island (Shaheed Dweep)", "Bharatpur Beach", "Baratang Island", "Mangrove Boat Ride", "Mud Volcano", "Limestone Caves"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Port Blair (Joining/Leaving)"],
  dates: [{ date: "Sun Dec 06, 2026", price: 79000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Port Blair", state: "Andaman and Nicobar Islands", desc: "Arrive in Port Blair and meet the tour manager. Visit the Cellular Museum and Cellular Jail, with the Light and Sound Show as scheduled. Overnight in Port Blair.", nights: 1, highlights: ["Cellular Museum", "Cellular Jail", "Veer Savarkar Smarak", "Light and Sound Show"] },
    { day: 2, title: "Port Blair · Ross Island · Havelock", state: "Andaman and Nicobar Islands", desc: "Visit Netaji Subhash Chandra Bose Island (Ross Island) before taking the ferry to Havelock (Swaraj Dweep) for a two-night stay.", nights: 2, highlights: ["Netaji Subhash Chandra Bose Island", "Ross Island"] },
    { day: 3, title: "Havelock", state: "Andaman and Nicobar Islands", desc: "Enjoy Havelock Island, including Elephant Beach and Radhanagar Beach as scheduled.", highlights: ["Havelock (Swaraj Dweep)", "Elephant Beach", "Radhanagar Beach"] },
    { day: 4, title: "Havelock · Neil Island", state: "Andaman and Nicobar Islands", desc: "Travel by ferry to Neil Island (Shaheed Dweep), explore Bharatpur Beach and stay overnight.", nights: 1, highlights: ["Neil Island (Shaheed Dweep)", "Bharatpur Beach"] },
    { day: 5, title: "Neil Island · Port Blair", state: "Andaman and Nicobar Islands", desc: "Return by ferry to Port Blair for a two-night stay.", nights: 2 },
    { day: 6, title: "Port Blair · Baratang · Port Blair", state: "Andaman and Nicobar Islands", desc: "Take an excursion to Baratang Island, including a mangrove boat ride, limestone caves and mud volcano visit as scheduled.", highlights: ["Baratang Island", "Mangrove Boat Ride", "Mud Volcano", "Limestone Caves"] },
    { day: 7, title: "Port Blair · Departure", state: "Andaman and Nicobar Islands", desc: "Conclude the tour and depart from Port Blair. Scheduled guests return to Mumbai via Chennai; joining/leaving guests make their own onward arrangements." },
  ],
});
TOURS.push({
  slug: "wonders-of-madhya-pradesh-mpjm",
  title: "Wonders of Madhya Pradesh",
  scope: "india", image: "/assets/media/wiki-madurai.jpg", gallery: ["/assets/media/wiki-madurai.jpg", "/assets/media/wiki-chittorgarh.jpg", "/assets/media/wiki-badami.jpg"],
  code: "MPJM", tourType: "GROUP TOUR", speciality: "Family", allInclusive: true, popularToday: true,
  days: 13, nights: 12, countriesCount: 1, statesCount: 1, citiesCount: 13, region: "Madhya Pradesh", zone: "West & Central India", interest: "Culture & Wildlife", packageType: "Group Tour",
  startingPrice: 76000, joiningLeavingPrice: 70000, emiPerMonth: 7400, rating: 5, reviewsCount: 9,
  route: [{ state: "Madhya Pradesh", stops: ["Indore (4N)", "Bhopal (2N)", "Jabalpur (1N)", "Khajuraho (2N)", "Jhansi (1N)", "Gwalior (2N)"] }],
  highlights: ["Pitra Parvat", "Rajwada Palace", "Chappan Dukan", "Omkareshwar", "Maheshwar", "Royal Ahilya Fort", "Mhow", "Jahaz Mahal", "Sarafa Bazar", "Lalbaug Palace", "Mahakaleshwar Temple", "Harsiddhi Mata Temple", "Sanchi Stupa", "Bhimbetka Cave", "Bhojpur Temple", "Marble Village Walking Tour", "Panna National Park", "Kandariya Mahadeo Temple", "Jain Temple", "Chitragupta Temple", "Orchha Fort", "Jhansi Fort", "Jai Vilas Palace", "Gwalior Fort"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Indore (Joining)", "Gwalior (Leaving)"], dates: [{ date: "Mon Mar 08, 2027", price: 99000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Indore", state: "Madhya Pradesh", desc: "Arrive in Indore and settle in for a four-night stay.", nights: 4 },
    { day: 2, title: "Indore · Mandu · Indore", state: "Madhya Pradesh", desc: "Explore the historic monuments of Mandu, including Jahaz Mahal, before returning to Indore.", highlights: ["Jahaz Mahal"] },
    { day: 3, title: "Indore · Omkareshwar · Maheshwar · Indore", state: "Madhya Pradesh", desc: "Visit Omkareshwar and Maheshwar, including Royal Ahilya Fort, and return to Indore.", highlights: ["Omkareshwar", "Maheshwar", "Royal Ahilya Fort"] },
    { day: 4, title: "Indore · Ujjain · Indore", state: "Madhya Pradesh", desc: "Visit Mahakaleshwar Temple and Harsiddhi Mata Temple in Ujjain.", highlights: ["Mahakaleshwar Temple", "Harsiddhi Mata Temple"] },
    { day: 5, title: "Indore · Bhopal", state: "Madhya Pradesh", desc: "Continue to Bhopal for a two-night stay.", nights: 2 },
    { day: 6, title: "Bhopal · Sanchi · Bhopal", state: "Madhya Pradesh", desc: "Explore Sanchi Stupa and return to Bhopal.", highlights: ["Sanchi Stupa"] },
    { day: 7, title: "Bhopal · Bhedaghat · Jabalpur", state: "Madhya Pradesh", desc: "Visit the marble landscapes at Bhedaghat and continue to Jabalpur for an overnight stay.", nights: 1 },
    { day: 8, title: "Jabalpur · Panna · Khajuraho", state: "Madhya Pradesh", desc: "Visit Panna National Park en route to Khajuraho for a two-night stay.", nights: 2, highlights: ["Panna National Park"] },
    { day: 9, title: "Khajuraho", state: "Madhya Pradesh", desc: "Explore the celebrated temples of Khajuraho, including Kandariya Mahadeo, Jain and Chitragupta temples.", highlights: ["Kandariya Mahadeo Temple", "Jain Temple", "Chitragupta Temple"] },
    { day: 10, title: "Khajuraho · Orchha · Jhansi", state: "Madhya Pradesh", desc: "Visit Orchha Fort and continue to Jhansi for an overnight stay.", nights: 1, highlights: ["Orchha Fort"] },
    { day: 11, title: "Jhansi · Gwalior", state: "Madhya Pradesh", desc: "Visit Jhansi Fort before continuing to Gwalior for a two-night stay.", nights: 2, highlights: ["Jhansi Fort"] },
    { day: 12, title: "Gwalior", state: "Madhya Pradesh", desc: "Explore Jai Vilas Palace and Gwalior Fort.", highlights: ["Jai Vilas Palace", "Gwalior Fort"] },
    { day: 13, title: "Gwalior · Departure", state: "Madhya Pradesh", desc: "Conclude the tour in Gwalior and depart for your onward journey." },
  ],
});
TOURS.push({
  slug: "womens-special-andaman-anwa", title: "Women's Special Andaman", scope: "india",
  image: "/assets/media/wiki-goa.jpg", gallery: ["/assets/media/wiki-goa.jpg", "/assets/media/wiki-kovalam.jpg", "/assets/media/wiki-alleppey.jpg"],
  code: "ANWA", tourType: "GROUP TOUR", speciality: "Women's Special", allInclusive: true, popularToday: true,
  days: 7, nights: 6, countriesCount: 1, statesCount: 1, citiesCount: 4, region: "Andaman and Nicobar Islands", zone: "South India", interest: "Beaches & Nature", packageType: "Group Tour",
  startingPrice: 80000, joiningLeavingPrice: 60000, emiPerMonth: 7800, rating: null, reviewsCount: 0,
  route: [{ state: "Andaman and Nicobar Islands", stops: ["Port Blair (1N)", "Havelock (2N)", "Neil Island (1N)", "Port Blair (2N)"] }],
  highlights: ["Cellular Museum", "Cellular Jail", "Veer Savarkar Smarak", "Light and Sound Show", "Netaji Subhash Chandra Bose Island", "Ross Island", "Havelock (Swaraj Dweep)", "Elephant Beach", "Radhanagar Beach", "Neil Island (Shaheed Dweep)", "Bharatpur Beach", "Baratang Island", "Mangrove Boat Ride", "Mud Volcano", "Limestone Caves"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Port Blair (Joining/Leaving)"], dates: [], inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Port Blair", state: "Andaman and Nicobar Islands", desc: "Arrive in Port Blair and visit the Cellular Museum and Cellular Jail. Attend the Light and Sound Show as scheduled.", nights: 1, highlights: ["Cellular Museum", "Cellular Jail", "Light and Sound Show"] },
    { day: 2, title: "Port Blair · Ross Island · Havelock", state: "Andaman and Nicobar Islands", desc: "Visit Netaji Subhash Chandra Bose Island (Ross Island) before travelling by ferry to Havelock for a two-night stay.", nights: 2, highlights: ["Netaji Subhash Chandra Bose Island", "Ross Island"] },
    { day: 3, title: "Havelock", state: "Andaman and Nicobar Islands", desc: "Enjoy Havelock Island, including Elephant Beach and Radhanagar Beach as scheduled.", highlights: ["Elephant Beach", "Radhanagar Beach"] },
    { day: 4, title: "Havelock · Neil Island", state: "Andaman and Nicobar Islands", desc: "Ferry to Neil Island and explore Bharatpur Beach. Overnight on the island.", nights: 1, highlights: ["Neil Island (Shaheed Dweep)", "Bharatpur Beach"] },
    { day: 5, title: "Neil Island · Port Blair", state: "Andaman and Nicobar Islands", desc: "Return by ferry to Port Blair for a two-night stay.", nights: 2 },
    { day: 6, title: "Port Blair · Baratang · Port Blair", state: "Andaman and Nicobar Islands", desc: "Excursion to Baratang Island for the mangrove boat ride, limestone caves and mud volcano as scheduled.", highlights: ["Baratang Island", "Mangrove Boat Ride", "Limestone Caves", "Mud Volcano"] },
    { day: 7, title: "Port Blair · Departure", state: "Andaman and Nicobar Islands", desc: "Conclude the tour and depart from Port Blair." },
  ],
});
TOURS.push({
  slug: "sikkim-darjeeling-gangtok-pelling-sdgp", title: "Sikkim Darjeeling Gangtok Pelling", scope: "india",
  image: "/assets/media/wiki-darjeeling-tea.jpg", gallery: ["/assets/media/wiki-darjeeling-tea.jpg", "/assets/media/wiki-gangtok.jpg", "/assets/media/wiki-gangtok.jpg"],
  code: "SDGP", tourType: "GROUP TOUR", speciality: "Family", allInclusive: true, popularToday: true,
  days: 9, nights: 8, countriesCount: 1, statesCount: 2, citiesCount: 8, region: "Sikkim and Darjeeling", zone: "East & North East India", interest: "Nature & Culture", packageType: "Group Tour",
  startingPrice: 76000, joiningLeavingPrice: 70000, emiPerMonth: 7400, rating: null, reviewsCount: 0,
  route: [{ state: "West Bengal", stops: ["Darjeeling (2N)", "Siliguri (1N)"] }, { state: "Sikkim", stops: ["Namchi", "Pelling (2N)", "Ravangla", "Gangtok (3N)", "Tsomgo Lake"] }],
  highlights: ["Tiger Hill Sunrise", "Batasia Loop", "Himalayan Mountaineering Institute", "Zoological Park", "Himalayan Tibet Museum", "Tenzing Rock", "Darjeeling Tea Estate", "Chardham Temple", "Samdruptse Monastery", "Glass Skywalk", "Chenrezig Statue", "Khecheopalri Lake", "Pemayangtse Monastery", "Buddha Park Ravangla", "Tsomgo Lake", "Baba Harbhajan Singh Mandir", "Ranka Monastery", "Banjhakri Waterfall", "Namgyal Institute of Tibetology", "White Water Rafting"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Bagdogra (Joining/Leaving)"], dates: [{ date: "Fri Nov 06, 2026", price: 76000 }], inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Bagdogra · Darjeeling", state: "West Bengal", desc: "Arrive at Bagdogra and drive to Darjeeling for a two-night stay.", nights: 2 },
    { day: 2, title: "Darjeeling", state: "West Bengal", desc: "Visit Tiger Hill, Batasia Loop and Darjeeling's Himalayan heritage attractions as scheduled.", highlights: ["Tiger Hill Sunrise", "Batasia Loop", "Himalayan Mountaineering Institute", "Zoological Park"] },
    { day: 3, title: "Darjeeling · Namchi · Pelling", state: "Sikkim", desc: "Visit Namchi and continue to Pelling for a two-night stay.", nights: 2, highlights: ["Chardham Temple", "Samdruptse Monastery"] },
    { day: 4, title: "Pelling", state: "Sikkim", desc: "Explore Pelling's monasteries, viewpoints and Glass Skywalk as scheduled.", highlights: ["Glass Skywalk", "Chenrezig Statue", "Khecheopalri Lake", "Pemayangtse Monastery"] },
    { day: 5, title: "Pelling · Ravangla · Gangtok", state: "Sikkim", desc: "Visit Buddha Park at Ravangla en route to Gangtok for a three-night stay.", nights: 3, highlights: ["Buddha Park Ravangla"] },
    { day: 6, title: "Gangtok · Tsomgo Lake · Gangtok", state: "Sikkim", desc: "Excursion to Tsomgo Lake and Baba Harbhajan Singh Mandir, subject to permits and weather.", highlights: ["Tsomgo Lake", "Baba Harbhajan Singh Mandir"] },
    { day: 7, title: "Gangtok", state: "Sikkim", desc: "Explore Gangtok, including Ranka Monastery and Banjhakri Waterfall as scheduled.", highlights: ["Ranka Monastery", "Banjhakri Waterfall", "Namgyal Institute of Tibetology"] },
    { day: 8, title: "Gangtok · Siliguri", state: "West Bengal", desc: "Enjoy Tista River rafting as scheduled and continue to Siliguri for an overnight stay.", nights: 1, highlights: ["White Water Rafting"] },
    { day: 9, title: "Siliguri · Bagdogra · Departure", state: "West Bengal", desc: "Transfer to Bagdogra Airport for your onward journey." },
  ],
});
TOURS.push({
  slug: "best-of-kumaon-nibk", title: "Best of Kumaon", scope: "india",
  image: "/assets/media/wiki-nainital.jpg", gallery: ["/assets/media/wiki-nainital.jpg", "/assets/media/wiki-nainital.jpg", "/assets/media/wiki-mussoorie.jpg"],
  code: "NIBK", tourType: "GROUP TOUR", speciality: "Family", allInclusive: true, popularToday: true,
  days: 11, nights: 10, countriesCount: 1, statesCount: 1, citiesCount: 8, region: "Kumaon", zone: "North India", interest: "Nature & Wildlife", packageType: "Group Tour",
  startingPrice: 99000, joiningLeavingPrice: 90000, emiPerMonth: 9600, rating: null, reviewsCount: 0,
  route: [{ state: "Uttarakhand", stops: ["Delhi", "Nainital", "Ranikhet", "Kausani", "Almora", "Binsar", "Mukteshwar", "Jim Corbett National Park"] }],
  highlights: ["Naini Lake", "Naina Devi Temple", "Bhimtal", "Sattal", "Naukuchiatal", "Ranikhet", "Kausani Tea Estate", "Binsar Wildlife Sanctuary", "Jageshwar Temples", "Mukteshwar Temple", "Jim Corbett National Park"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Delhi (Joining/Leaving)"], dates: [{ date: "Tue Nov 10, 2026", price: 99000 }], inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Delhi · Nainital", state: "Uttarakhand", desc: "Meet the group and travel to Nainital for a multi-night stay.", nights: 3 },
    { day: 2, title: "Nainital", state: "Uttarakhand", desc: "Explore Nainital, Naini Lake and Naina Devi Temple as scheduled.", highlights: ["Naini Lake", "Naina Devi Temple"] },
    { day: 3, title: "Nainital Lake Circuit", state: "Uttarakhand", desc: "Visit the scenic lakes of Bhimtal, Sattal and Naukuchiatal.", highlights: ["Bhimtal", "Sattal", "Naukuchiatal"] },
    { day: 4, title: "Nainital · Ranikhet", state: "Uttarakhand", desc: "Continue to Ranikhet and explore the hill town.", nights: 1, highlights: ["Ranikhet"] },
    { day: 5, title: "Ranikhet · Kausani", state: "Uttarakhand", desc: "Travel to Kausani for an overnight stay and visit its tea estate.", nights: 1, highlights: ["Kausani Tea Estate"] },
    { day: 6, title: "Kausani · Binsar", state: "Uttarakhand", desc: "Continue to Binsar for an overnight stay near the wildlife sanctuary.", nights: 1, highlights: ["Binsar Wildlife Sanctuary"] },
    { day: 7, title: "Binsar · Almora", state: "Uttarakhand", desc: "Explore Almora and visit the Jageshwar temple complex as scheduled.", nights: 1, highlights: ["Jageshwar Temples"] },
    { day: 8, title: "Almora · Mukteshwar", state: "Uttarakhand", desc: "Travel to Mukteshwar and visit Mukteshwar Temple.", nights: 1, highlights: ["Mukteshwar Temple"] },
    { day: 9, title: "Mukteshwar · Jim Corbett", state: "Uttarakhand", desc: "Continue to Jim Corbett National Park for a two-night stay.", nights: 2 },
    { day: 10, title: "Jim Corbett National Park", state: "Uttarakhand", desc: "Enjoy the park and safari activities as scheduled, subject to permits and availability.", highlights: ["Jim Corbett National Park"] },
    { day: 11, title: "Jim Corbett · Delhi · Departure", state: "Uttarakhand", desc: "Return to Delhi and depart for your onward journey." },
  ],
});
TOURS.push({
  slug: "womens-special-sikkim-darjeeling-gangtok-pelling-sdwp", title: "Women's Special Sikkim Darjeeling Gangtok Pelling", scope: "india",
  image: "/assets/media/wiki-darjeeling-tea.jpg", gallery: ["/assets/media/wiki-darjeeling-tea.jpg", "/assets/media/wiki-gangtok.jpg", "/assets/media/wiki-gangtok.jpg"],
  code: "SDWP", tourType: "GROUP TOUR", speciality: "Women's Special", allInclusive: true, popularToday: true,
  days: 9, nights: 8, countriesCount: 1, statesCount: 2, citiesCount: 8, region: "Sikkim and Darjeeling", zone: "East & North East India", interest: "Nature & Culture", packageType: "Group Tour",
  startingPrice: 87000, joiningLeavingPrice: 80000, emiPerMonth: 8500, rating: null, reviewsCount: 0,
  route: [{ state: "West Bengal", stops: ["Darjeeling (2N)", "Siliguri (1N)"] }, { state: "Sikkim", stops: ["Namchi", "Pelling (2N)", "Ravangla", "Gangtok (3N)", "Tsomgo Lake"] }],
  highlights: ["Batasia Loop", "Himalayan Mountaineering Institute", "Zoological Park", "Himalayan Tibet Museum", "Tenzing Rock", "Tea Estate", "Chardham Temple", "Samdruptse Monastery", "Glass Skywalk", "Chenrezig Statue", "Buddha Park", "Ranka Monastery", "Banjhakri Waterfall", "Namgyal Institute of Tibetology", "Dordul Chorten Stupa", "Baba Harbhajan Singh Mandir", "White Water Rafting in Tista River"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Bagdogra (Joining/Leaving)"], dates: [], inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Bagdogra · Darjeeling", state: "West Bengal", desc: "Arrive at Bagdogra and drive to Darjeeling for a two-night stay.", nights: 2 },
    { day: 2, title: "Darjeeling", state: "West Bengal", desc: "Explore Batasia Loop, the Himalayan Mountaineering Institute, Zoological Park, Tenzing Rock and tea country as scheduled.", highlights: ["Batasia Loop", "Himalayan Mountaineering Institute", "Zoological Park", "Tenzing Rock", "Tea Estate"] },
    { day: 3, title: "Darjeeling · Namchi · Pelling", state: "Sikkim", desc: "Visit Chardham Temple and Samdruptse Monastery at Namchi before continuing to Pelling for a two-night stay.", nights: 2, highlights: ["Chardham Temple", "Samdruptse Monastery"] },
    { day: 4, title: "Pelling", state: "Sikkim", desc: "Discover Pelling's Glass Skywalk, Chenrezig statue and monasteries as scheduled.", highlights: ["Glass Skywalk", "Chenrezig Statue"] },
    { day: 5, title: "Pelling · Ravangla · Gangtok", state: "Sikkim", desc: "Visit Buddha Park at Ravangla and continue to Gangtok for a three-night stay.", nights: 3, highlights: ["Buddha Park"] },
    { day: 6, title: "Gangtok · Tsomgo Lake · Gangtok", state: "Sikkim", desc: "Excursion to Tsomgo Lake and Baba Harbhajan Singh Mandir as scheduled.", highlights: ["Baba Harbhajan Singh Mandir"] },
    { day: 7, title: "Gangtok", state: "Sikkim", desc: "Visit Ranka Monastery, Banjhakri Waterfall and local cultural attractions as scheduled.", highlights: ["Ranka Monastery", "Banjhakri Waterfall", "Namgyal Institute of Tibetology"] },
    { day: 8, title: "Gangtok · Siliguri", state: "West Bengal", desc: "Enjoy Tista River rafting as scheduled and stay overnight in Siliguri.", nights: 1, highlights: ["White Water Rafting in Tista River"] },
    { day: 9, title: "Siliguri · Bagdogra · Departure", state: "West Bengal", desc: "Transfer to Bagdogra Airport for the onward journey." },
  ],
});
TOURS.push({
  slug: "assam-meghalaya-nema", title: "Assam Meghalaya", scope: "india",
  image: "/assets/media/wiki-corbett.jpg", gallery: ["/assets/media/wiki-corbett.jpg", "/assets/media/wiki-munnar.jpg", "/assets/media/wiki-rishikesh.jpg"],
  code: "NEMA", tourType: "GROUP TOUR", speciality: "Family", allInclusive: true, popularToday: true,
  days: 7, nights: 6, countriesCount: 1, statesCount: 2, citiesCount: 5, region: "Assam and Meghalaya", zone: "East & North East India", interest: "Nature & Wildlife", packageType: "Group Tour",
  startingPrice: 85000, joiningLeavingPrice: 78000, emiPerMonth: 8300, rating: 5, reviewsCount: 120,
  route: [{ state: "Assam", stops: ["Guwahati (1N)", "Kaziranga (2N)"] }, { state: "Meghalaya", stops: ["Shillong (3N)"] }],
  highlights: ["Maha Mrityunjai Temple", "Jeep Safari at Kaziranga National Park", "Orchid Park", "Bihu Dance", "Umiam Lake", "Mawlynnong Village", "Balancing Rock", "Living Root Bridge", "Ram Krishna Mission", "Elephant Falls", "Nohkalikai Fall", "Ropeway over the Brahmaputra River", "River Cruise in Brahmaputra River", "Kamakhya Temple"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Guwahati (Joining/Leaving)"], dates: [{ date: "Sun Oct 18, 2026", price: 85000 }], inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Guwahati · Kaziranga", state: "Assam", desc: "Arrive in Guwahati and drive to Kaziranga for a two-night stay.", nights: 2 },
    { day: 2, title: "Kaziranga", state: "Assam", desc: "Enjoy a jeep safari in Kaziranga National Park and visit Orchid Park as scheduled.", highlights: ["Jeep Safari at Kaziranga National Park", "Orchid Park", "Bihu Dance"] },
    { day: 3, title: "Kaziranga · Shillong", state: "Meghalaya", desc: "Travel to Shillong for a three-night stay, with a visit to Maha Mrityunjai Temple en route.", nights: 3, highlights: ["Maha Mrityunjai Temple"] },
    { day: 4, title: "Shillong · Mawlynnong · Shillong", state: "Meghalaya", desc: "Visit Mawlynnong village, Balancing Rock, Living Root Bridge and Ram Krishna Mission.", highlights: ["Mawlynnong Village", "Balancing Rock", "Living Root Bridge", "Ram Krishna Mission"] },
    { day: 5, title: "Shillong · Cherrapunjee · Shillong", state: "Meghalaya", desc: "Explore Cherrapunjee's waterfalls and scenic sites, including Nohkalikai Fall and Elephant Falls as scheduled.", highlights: ["Nohkalikai Fall", "Elephant Falls"] },
    { day: 6, title: "Shillong · Guwahati", state: "Assam", desc: "Return to Guwahati for an overnight stay. Enjoy the Brahmaputra ropeway and river cruise as scheduled.", nights: 1, highlights: ["Ropeway over the Brahmaputra River", "River Cruise in Brahmaputra River"] },
    { day: 7, title: "Guwahati · Departure", state: "Assam", desc: "Visit Kamakhya Temple as scheduled and depart from Guwahati.", highlights: ["Kamakhya Temple"] },
  ],
});
TOURS.push({
  slug: "womens-special-assam-meghalaya-newma", title: "Women's Special Assam Meghalaya", scope: "india",
  image: "/assets/media/wiki-corbett.jpg", gallery: ["/assets/media/wiki-corbett.jpg", "/assets/media/wiki-munnar.jpg", "/assets/media/wiki-rishikesh.jpg"],
  code: "NEWMA", tourType: "GROUP TOUR", speciality: "Women's Special", allInclusive: true, popularToday: true,
  days: 7, nights: 6, countriesCount: 1, statesCount: 2, citiesCount: 5, region: "Assam and Meghalaya", zone: "East & North East India", interest: "Nature & Wildlife", packageType: "Group Tour",
  startingPrice: 89000, joiningLeavingPrice: 82000, emiPerMonth: 8700, rating: null, reviewsCount: 0,
  route: [{ state: "Assam", stops: ["Guwahati (1N)", "Kaziranga (2N)"] }, { state: "Meghalaya", stops: ["Shillong (3N)"] }],
  highlights: ["Maha Mrityunjai Temple", "Jeep Safari at Kaziranga National Park", "Orchid Park", "Bihu Dance", "Umiam Lake", "Mawlynnong Village", "Balancing Rock", "Living Root Bridge", "Ram Krishna Mission", "Elephant Falls", "Nohkalikai Fall", "Ropeway over the Brahmaputra River", "River Cruise in Brahmaputra River", "Kamakhya Temple"],
  departureCity: "Mumbai", departureCities: ["Mumbai", "Guwahati (Joining/Leaving)"], dates: [], inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Guwahati · Kaziranga", state: "Assam", desc: "Arrive in Guwahati and drive to Kaziranga for a two-night stay.", nights: 2 },
    { day: 2, title: "Kaziranga", state: "Assam", desc: "Enjoy the jeep safari in Kaziranga National Park and visit Orchid Park as scheduled.", highlights: ["Jeep Safari at Kaziranga National Park", "Orchid Park", "Bihu Dance"] },
    { day: 3, title: "Kaziranga · Shillong", state: "Meghalaya", desc: "Travel to Shillong for a three-night stay, with Maha Mrityunjai Temple en route.", nights: 3, highlights: ["Maha Mrityunjai Temple"] },
    { day: 4, title: "Shillong · Mawlynnong · Shillong", state: "Meghalaya", desc: "Explore Mawlynnong village, Balancing Rock, Living Root Bridge and Ram Krishna Mission.", highlights: ["Mawlynnong Village", "Balancing Rock", "Living Root Bridge", "Ram Krishna Mission"] },
    { day: 5, title: "Shillong · Cherrapunjee · Shillong", state: "Meghalaya", desc: "See the waterfalls and landscapes around Cherrapunjee, including Nohkalikai Fall as scheduled.", highlights: ["Elephant Falls", "Nohkalikai Fall"] },
    { day: 6, title: "Shillong · Guwahati", state: "Assam", desc: "Return to Guwahati and enjoy the Brahmaputra ropeway and river cruise as scheduled.", nights: 1, highlights: ["Ropeway over the Brahmaputra River", "River Cruise in Brahmaputra River"] },
    { day: 7, title: "Guwahati · Departure", state: "Assam", desc: "Visit Kamakhya Temple as scheduled and depart from Guwahati.", highlights: ["Kamakhya Temple"] },
  ],
});
TOURS.push({
  slug: "seniors-special-assam-meghalaya-nezma",
  title: "Seniors' Special Assam Meghalaya",
  scope: "india",
  image: "/assets/media/wiki-corbett.jpg",
  gallery: ["/assets/media/wiki-corbett.jpg", "/assets/media/wiki-darjeeling-tea.jpg", "/assets/media/wiki-gangtok.jpg"],
  code: "NEZMA",
  tourType: "GROUP TOUR",
  speciality: "Seniors' Special",
  allInclusive: true,
  popularToday: true,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 5,
  region: "Assam and Meghalaya",
  zone: "East & North East India",
  interest: "Nature & Wildlife",
  packageType: "Group Tour",
  startingPrice: 92000,
  joiningLeavingPrice: 66000,
  emiPerMonth: 8958,
  rating: 5,
  reviewsCount: 52,
  route: [{ state: "Assam", stops: ["Guwahati", "Kaziranga (2N)"] }, { state: "Meghalaya", stops: ["Shillong (3N)"] }, { state: "Assam", stops: ["Guwahati (1N)"] }],
  highlights: ["Maha Mrityunjai Temple", "Jeep Safari at Kaziranga National Park", "Orchid Park", "Bihu Dance", "Umiam Lake", "Mawlynnong Village", "Balancing Rock", "Living Root Bridge", "Ram Krishna Mission", "Elephant Falls", "Nohkalikai Fall", "Ropeway over the Brahmaputra River", "River Cruise in Brahmaputra River", "Kamakhya Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Guwahati (Joining/Leaving)"],
  dates: [{ date: "Thu Nov 19, 2026", price: 92000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Guwahati · Kaziranga", state: "Assam", desc: "Arrive in Guwahati and travel to Kaziranga for a two-night stay.", nights: 2 },
    { day: 2, title: "Kaziranga", state: "Assam", desc: "Enjoy a jeep safari at Kaziranga National Park and visit Orchid Park. Bihu dance as scheduled.", highlights: ["Jeep Safari at Kaziranga National Park", "Orchid Park", "Bihu Dance"] },
    { day: 3, title: "Kaziranga · Shillong", state: "Meghalaya", desc: "Visit Maha Mrityunjai Temple and continue to Shillong for a three-night stay.", nights: 3, highlights: ["Maha Mrityunjai Temple"] },
    { day: 4, title: "Shillong · Mawlynnong · Shillong", state: "Meghalaya", desc: "Explore Mawlynnong village, Balancing Rock, Living Root Bridge and Ram Krishna Mission.", highlights: ["Mawlynnong Village", "Balancing Rock", "Living Root Bridge", "Ram Krishna Mission"] },
    { day: 5, title: "Shillong · Cherrapunjee · Shillong", state: "Meghalaya", desc: "Discover the waterfalls and scenery around Cherrapunjee, including Nohkalikai Fall and Elephant Falls as scheduled.", highlights: ["Nohkalikai Fall", "Elephant Falls", "Umiam Lake"] },
    { day: 6, title: "Shillong · Guwahati", state: "Assam", desc: "Return to Guwahati for an overnight stay. Enjoy the Brahmaputra ropeway and river cruise as scheduled.", nights: 1, highlights: ["Ropeway over the Brahmaputra River", "River Cruise in Brahmaputra River"] },
    { day: 7, title: "Guwahati · Departure", state: "Assam", desc: "Visit Kamakhya Temple as scheduled and depart from Guwahati.", highlights: ["Kamakhya Temple"] },
  ],
});
TOURS.push({
  slug: "best-of-arunachal-neba",
  title: "Best of Arunachal",
  scope: "india",
  image: "/assets/media/wiki-gangtok.jpg",
  gallery: ["/assets/media/wiki-gangtok.jpg", "/assets/media/wiki-darjeeling-tea.jpg", "/assets/media/wiki-mussoorie.jpg"],
  code: "NEBA",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 10,
  nights: 9,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 7,
  region: "Arunachal Pradesh",
  zone: "East & North East India",
  interest: "Nature & Culture",
  packageType: "Group Tour",
  startingPrice: 94000,
  joiningLeavingPrice: 70000,
  emiPerMonth: 9200,
  rating: 5,
  reviewsCount: 2,
  route: [{ state: "Assam", stops: ["Guwahati", "Tezpur (1N)"] }, { state: "Arunachal Pradesh", stops: ["Dirang (1N)", "Tawang (3N)", "Bomdila (1N)", "Itanagar (2N)"] }, { state: "Assam", stops: ["Guwahati (1N)"] }],
  highlights: ["Maha Mrityunjaya Temple", "Mahabhairab Temple", "Bomdila Monastery", "Sela Pass", "Sela Lake", "Jaswant Garh Indo-China War Memorial", "Bum La Pass", "P.T. Tso Lake", "Shungatser (Madhuri) Lake", "Tawang War Memorial", "Tawang Monastery", "Ani Gompa", "Nuranang Falls", "Potin Dam", "Ziro Valley", "Apatani Villages", "Samiran Tea Garden", "Nagshankar Temple", "Kamakhya Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Guwahati (Joining)", "Itanagar (Leaving)"],
  dates: [{ date: "Fri Mar 12, 2027", price: 94000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Guwahati · Tezpur", state: "Assam", desc: "Arrive in Guwahati, visit Kamakhya Temple as scheduled, and continue to Tezpur for an overnight stay.", nights: 1, highlights: ["Kamakhya Temple"] },
    { day: 2, title: "Tezpur · Dirang", state: "Arunachal Pradesh", desc: "Visit Mahabhairab Temple and travel to Dirang for an overnight stay.", nights: 1, highlights: ["Mahabhairab Temple"] },
    { day: 3, title: "Dirang · Bomdila · Tawang", state: "Arunachal Pradesh", desc: "Visit Bomdila Monastery and cross Sela Pass and Sela Lake en route to Tawang for a three-night stay.", nights: 3, highlights: ["Bomdila Monastery", "Sela Pass", "Sela Lake", "Jaswant Garh Indo-China War Memorial"] },
    { day: 4, title: "Tawang · Bum La Pass · Tawang", state: "Arunachal Pradesh", desc: "Excursion to Bum La Pass, P.T. Tso Lake and Shungatser (Madhuri) Lake, subject to permits and weather.", highlights: ["Bum La Pass", "P.T. Tso Lake", "Shungatser (Madhuri) Lake"] },
    { day: 5, title: "Tawang", state: "Arunachal Pradesh", desc: "Explore Tawang Monastery, Tawang War Memorial, Ani Gompa and Nuranang Falls as scheduled.", highlights: ["Tawang War Memorial", "Tawang Monastery", "Ani Gompa", "Nuranang Falls"] },
    { day: 6, title: "Tawang · Bomdila", state: "Arunachal Pradesh", desc: "Travel back toward Bomdila for an overnight stay.", nights: 1 },
    { day: 7, title: "Bomdila · Itanagar", state: "Arunachal Pradesh", desc: "Continue to Itanagar for a two-night stay, visiting Potin Dam en route as scheduled.", nights: 2, highlights: ["Potin Dam"] },
    { day: 8, title: "Itanagar · Ziro · Itanagar", state: "Arunachal Pradesh", desc: "Explore Ziro Valley and the Apatani villages before returning to Itanagar.", highlights: ["Ziro Valley", "Apatani Villages", "Samiran Tea Garden"] },
    { day: 9, title: "Itanagar · Guwahati", state: "Assam", desc: "Travel to Guwahati for an overnight stay.", nights: 1 },
    { day: 10, title: "Guwahati · Departure", state: "Assam", desc: "Conclude the tour and depart for your onward journey." },
  ],
});
TOURS.push({
  slug: "all-of-uttar-pradesh-upau",
  title: "All of Uttar Pradesh",
  scope: "india",
  image: "/assets/media/wiki-lucknow.jpg",
  gallery: ["/assets/media/wiki-lucknow.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-varanasi-aarti.jpg", "/assets/media/wiki-taj-mahal.jpg"],
  code: "UPAU",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 15,
  nights: 14,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 12,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Wildlife",
  packageType: "Group Tour",
  startingPrice: 95000,
  joiningLeavingPrice: 80000,
  emiPerMonth: 9200,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Lucknow", "Pilibhit Tiger Reserve", "Dudhwa National Park", "Ayodhya", "Varanasi", "Sarnath", "Prayagraj", "Mathura", "Vrindavan", "Govardhan", "Agra", "Fatehpur Sikri"] }],
  highlights: ["Ambedkar Park", "Pilibhit Tiger Reserve", "Tiger Safari", "Dudhwa National Park", "Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi", "Swarved Mahamandir", "Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Boat Ride at Dashashwamedh Ghat", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana", "Anand Bhavan", "Laying Hanuman Temple", "Triveni Sangam Boat Ride", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency", "Shri Krishna Janmabhoomi", "Bramhand Ghat", "Raman Reti", "Govardhan Hill", "Radha Rani Temple", "Banke Bihari Temple", "Prem Mandir", "Taj Mahal", "Mehtab Bagh", "Agra Fort", "Fatehpur Sikri"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Lucknow (Joining)", "Agra (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Lucknow", state: "Uttar Pradesh", desc: "Arrive in Lucknow and settle in for a two-night stay.", nights: 2 },
    { day: 2, title: "Lucknow", state: "Uttar Pradesh", desc: "Explore Lucknow's heritage, including Ambedkar Park, Rumi Darwaja, Clock Tower, Chota and Bada Imambara and the British Residency.", highlights: ["Ambedkar Park", "Rumi Darwaja", "Clock Tower", "Chota Imambara", "Bada Imambara", "British Residency"] },
    { day: 3, title: "Lucknow · Pilibhit", state: "Uttar Pradesh", desc: "Travel to Pilibhit and visit the tiger reserve as scheduled.", nights: 1, highlights: ["Pilibhit Tiger Reserve", "Tiger Safari"] },
    { day: 4, title: "Pilibhit · Dudhwa", state: "Uttar Pradesh", desc: "Continue to Dudhwa National Park for a two-night stay.", nights: 2, highlights: ["Dudhwa National Park"] },
    { day: 5, title: "Dudhwa National Park", state: "Uttar Pradesh", desc: "Explore Dudhwa and enjoy a tiger safari as scheduled, subject to park permits and availability.", highlights: ["Tiger Safari"] },
    { day: 6, title: "Dudhwa · Ayodhya", state: "Uttar Pradesh", desc: "Travel to Ayodhya for an overnight stay.", nights: 1 },
    { day: 7, title: "Ayodhya · Varanasi", state: "Uttar Pradesh", desc: "Visit Shri Ram Janmabhoomi Mandir, Hanuman Garhi, Dashrath Mahal, Kanak Bhavan and Sita Rasoi, then continue to Varanasi for a two-night stay.", nights: 2, highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Dashrath Mahal", "Kanak Bhavan", "Sita Rasoi"] },
    { day: 8, title: "Varanasi · Sarnath", state: "Uttar Pradesh", desc: "Explore Varanasi's temples and ghats, with a Dashashwamedh Ghat boat ride, and visit Sarnath as scheduled.", highlights: ["Swarved Mahamandir", "Kaal Bhairav Temple", "Kashi Vishwanath Temple", "Banaras Hindu University", "Birla Mandir", "Boat Ride at Dashashwamedh Ghat", "Dhamek Stupa", "Sarnath Archaeological Museum", "Sarai Mohana"] },
    { day: 9, title: "Varanasi · Prayagraj", state: "Uttar Pradesh", desc: "Continue to Prayagraj for an overnight stay and visit Anand Bhavan and Triveni Sangam as scheduled.", nights: 1, highlights: ["Anand Bhavan", "Laying Hanuman Temple", "Triveni Sangam Boat Ride"] },
    { day: 10, title: "Prayagraj · Lucknow", state: "Uttar Pradesh", desc: "Travel back to Lucknow for an overnight stay.", nights: 1 },
    { day: 11, title: "Lucknow · Mathura · Vrindavan", state: "Uttar Pradesh", desc: "Continue to the Mathura and Vrindavan region for an overnight stay.", nights: 1, highlights: ["Shri Krishna Janmabhoomi", "Bramhand Ghat", "Raman Reti", "Banke Bihari Temple", "Prem Mandir"] },
    { day: 12, title: "Mathura · Govardhan · Agra", state: "Uttar Pradesh", desc: "Visit Govardhan and Barsana before continuing to Agra for a three-night stay.", nights: 3, highlights: ["Govardhan Hill", "Radha Rani Temple"] },
    { day: 13, title: "Agra", state: "Uttar Pradesh", desc: "Explore Agra Fort and the Taj Mahal, including Mehtab Bagh as scheduled.", highlights: ["Taj Mahal", "Mehtab Bagh", "Agra Fort"] },
    { day: 14, title: "Agra · Fatehpur Sikri · Agra", state: "Uttar Pradesh", desc: "Visit the historic city of Fatehpur Sikri and return to Agra.", highlights: ["Fatehpur Sikri"] },
    { day: 15, title: "Agra · Departure", state: "Uttar Pradesh", desc: "Conclude the tour and depart from Agra for your onward journey." },
  ],
});
TOURS.push({
  slug: "all-of-karnataka-kaak",
  title: "All of Karnataka",
  scope: "india",
  image: "/assets/media/wiki-hampi.jpg",
  gallery: ["/assets/media/wiki-hampi.jpg", "/assets/media/wiki-coorg.jpg", "/assets/media/wiki-mysore.jpg", "/assets/media/wiki-gokarna.jpg"],
  code: "KAAK",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 15,
  nights: 14,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 16,
  region: "Karnataka",
  zone: "South India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 95000,
  emiPerMonth: 9250,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Karnataka", stops: ["Bengaluru", "Mysuru", "Coorg (2N)", "Hampi (2N)", "Badami", "Aihole", "Pattadakal", "Dandeli (2N)", "Gokarna (2N)", "Yana", "Murudeshwar", "Udupi", "Belur", "Shravanabelagola"] }],
  highlights: ["Explore Hampi", "Coracle ride", "Badami Caves", "Bhutnatha Group of Temples", "Aihole temples", "River rafting and zipline", "Jeep safari at Dandeli Wildlife Sanctuary", "Om Beach", "Kudle Beach", "Mahabaleshwar Temple", "Yana Rocks", "Sahastralinga", "Murdeshwar Temple", "Sri Krishna Math", "Chennakeshava Temple", "Shravanabelagola", "Tibetan Monastery and Market at Bylakuppe", "Dubare Elephant Camp", "Cauvery Nisargadhama", "Brindavan Gardens", "Mysore Palace", "Lalbagh Botanical Gardens"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bengaluru (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Bengaluru · Mysuru", state: "Karnataka", desc: "Arrive in Bengaluru and continue to Mysuru. Visit Lalbagh Botanical Gardens as scheduled.", nights: 1, highlights: ["Lalbagh Botanical Gardens"] },
    { day: 2, title: "Mysuru", state: "Karnataka", desc: "Explore Mysore Palace and Brindavan Gardens as scheduled.", nights: 1, highlights: ["Mysore Palace", "Brindavan Gardens"] },
    { day: 3, title: "Mysuru · Coorg", state: "Karnataka", desc: "Travel to Coorg and settle in for a two-night stay.", nights: 2 },
    { day: 4, title: "Coorg", state: "Karnataka", desc: "Visit Dubare Elephant Camp, Cauvery Nisargadhama and the Tibetan Monastery and Market at Bylakuppe as scheduled.", highlights: ["Dubare Elephant Camp", "Cauvery Nisargadhama", "Tibetan Monastery and Market at Bylakuppe"] },
    { day: 5, title: "Coorg · Hassan", state: "Karnataka", desc: "Travel toward Hassan, with a visit to Shravanabelagola as scheduled.", nights: 1, highlights: ["Shravanabelagola"] },
    { day: 6, title: "Hassan · Hampi", state: "Karnataka", desc: "Visit Chennakeshava Temple and continue to Hampi for a two-night stay.", nights: 2, highlights: ["Chennakeshava Temple"] },
    { day: 7, title: "Hampi", state: "Karnataka", desc: "Explore the historic ruins of Hampi and enjoy a coracle ride as scheduled.", highlights: ["Explore Hampi", "Coracle ride"] },
    { day: 8, title: "Hampi · Badami", state: "Karnataka", desc: "Continue to Badami to see the cave temples and Bhutnatha group of temples.", nights: 1, highlights: ["Badami Caves", "Bhutnatha Group of Temples"] },
    { day: 9, title: "Badami · Aihole · Pattadakal · Dandeli", state: "Karnataka", desc: "Visit the temple sites at Aihole and Pattadakal before continuing to Dandeli for a two-night stay.", nights: 2, highlights: ["Aihole temples", "Pattadakal"] },
    { day: 10, title: "Dandeli", state: "Karnataka", desc: "Enjoy a jeep safari at Dandeli Wildlife Sanctuary. River rafting and zipline activities are subject to availability and schedule.", highlights: ["Jeep safari at Dandeli Wildlife Sanctuary", "River rafting and zipline"] },
    { day: 11, title: "Dandeli · Gokarna", state: "Karnataka", desc: "Travel to the coast and check in at Gokarna for a two-night stay.", nights: 2 },
    { day: 12, title: "Gokarna · Yana", state: "Karnataka", desc: "Discover Om Beach, Kudle Beach, Mahabaleshwar Temple and Yana Rocks as scheduled.", highlights: ["Om Beach", "Kudle Beach", "Mahabaleshwar Temple", "Yana Rocks"] },
    { day: 13, title: "Gokarna · Murudeshwar · Udupi", state: "Karnataka", desc: "Visit Murdeshwar Temple en route to Udupi. See Sahastralinga as scheduled.", nights: 1, highlights: ["Murdeshwar Temple", "Sahastralinga"] },
    { day: 14, title: "Udupi · Bengaluru", state: "Karnataka", desc: "Visit Sri Krishna Math and return to Bengaluru for an overnight stay.", nights: 1, highlights: ["Sri Krishna Math"] },
    { day: 15, title: "Bengaluru · Departure", state: "Karnataka", desc: "Conclude the Karnataka tour and depart for your onward journey." },
  ],
});
TOURS.push({
  slug: "all-of-rajasthan-rjar",
  title: "All of Rajasthan",
  scope: "india",
  image: "/assets/media/wiki-jaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-ranthambore.jpg", "/assets/media/wiki-chittorgarh.jpg"],
  code: "RJAR",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 17,
  nights: 16,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 14,
  region: "Rajasthan",
  zone: "West & Central India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 95000,
  emiPerMonth: 9250,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Rajasthan", stops: ["Mount Abu (1N)", "Udaipur (2N)", "Chittorgarh", "Kumbhalgarh", "Ranakpur", "Jodhpur (2N)", "Jaisalmer (2N)", "Bikaner (1N)", "Mandawa (1N)", "Pushkar (1N)", "Ranthambore (2N)", "Jaipur (3N)"] },
  ],
  highlights: ["Gurushikhar Viewpoint", "Dilwara Jain Temple", "Nakki Lake", "Udaipur City Palace", "Fateh Sagar Lake", "Jag Mandir Boat Ride", "Moti Magri", "Traditional Music & Dance", "Chittorgarh Fort", "Ranakumbha Palace", "Vijay Stambha", "Queen Padmini Palace", "Shrinathji Temple", "Statue of Belief", "Kumbhalgarh Fort", "Ranakpur Jain Temple", "Bishnoi Village Safari", "Umaid Bhavan Palace", "Mehrangarh Fort", "Jaswant Thada", "Sanganeri Block Print Demo", "Jaisalmer War Museum", "Gadisar Lake", "Sam Sand Dunes", "Camel Ride & Folk Dance", "Patwon Ki Haveli", "Kuldhara Village", "Junagarh Fort", "Mandawa Fort", "Podar Haveli", "Pushkar Tirth", "Brahma Mandir", "Ranthambore Safari", "Birla Temple Jaipur", "Hawa Mahal", "Amer Fort", "Jantar Mantar", "Bapu Market Shopping"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining)", "Jodhpur (Joining)", "Jaipur (Joining/Leaving)"],
  dates: [{ date: "Mon Nov 23, 2026", price: 95000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival · Mount Abu", state: "Rajasthan", desc: "Arrive and travel to Mount Abu for an overnight stay. Scheduled flight and joining arrangements depend on the selected departure.", nights: 1 },
    { day: 2, title: "Mount Abu · Udaipur", state: "Rajasthan", desc: "Visit Gurushikhar Viewpoint, Dilwara Jain Temple and Nakki Lake before continuing to Udaipur for a two-night stay.", nights: 2, highlights: ["Gurushikhar Viewpoint", "Dilwara Jain Temple", "Nakki Lake"] },
    { day: 3, title: "Udaipur", state: "Rajasthan", desc: "Explore Udaipur City Palace, Fateh Sagar Lake and Moti Magri. Enjoy the Jag Mandir boat ride and traditional music and dance as scheduled.", highlights: ["Udaipur City Palace", "Fateh Sagar Lake", "Jag Mandir Boat Ride", "Moti Magri", "Traditional Music & Dance"] },
    { day: 4, title: "Udaipur · Shrinathji · Kumbhalgarh", state: "Rajasthan", desc: "Visit Shrinathji Temple and the Statue of Belief, with Kumbhalgarh Fort and Ranakpur Jain Temple as scheduled.", nights: 1, highlights: ["Shrinathji Temple", "Statue of Belief", "Kumbhalgarh Fort", "Ranakpur Jain Temple"] },
    { day: 5, title: "Kumbhalgarh · Jodhpur", state: "Rajasthan", desc: "Continue to Jodhpur and settle in for a two-night stay.", nights: 2 },
    { day: 6, title: "Jodhpur", state: "Rajasthan", desc: "Visit Umaid Bhavan Palace, Mehrangarh Fort and Jaswant Thada. Experience a Bishnoi Village Safari as scheduled.", highlights: ["Bishnoi Village Safari", "Umaid Bhavan Palace", "Mehrangarh Fort", "Jaswant Thada"] },
    { day: 7, title: "Jodhpur · Jaisalmer", state: "Rajasthan", desc: "Travel to Jaisalmer for a two-night stay.", nights: 2 },
    { day: 8, title: "Jaisalmer", state: "Rajasthan", desc: "Explore Jaisalmer War Museum, Gadisar Lake, Patwon Ki Haveli and Kuldhara. Enjoy the Sam Sand Dunes, camel ride and folk dance as scheduled.", highlights: ["Jaisalmer War Museum", "Gadisar Lake", "Sam Sand Dunes", "Camel Ride & Folk Dance", "Patwon Ki Haveli", "Kuldhara Village"] },
    { day: 9, title: "Jaisalmer · Bikaner", state: "Rajasthan", desc: "Continue to Bikaner for an overnight stay.", nights: 1 },
    { day: 10, title: "Bikaner", state: "Rajasthan", desc: "Discover Junagarh Fort and the local sights as scheduled.", highlights: ["Junagarh Fort"] },
    { day: 11, title: "Bikaner · Mandawa", state: "Rajasthan", desc: "Travel to the Shekhawati region and check in at Mandawa for an overnight stay.", nights: 1 },
    { day: 12, title: "Mandawa · Pushkar", state: "Rajasthan", desc: "Visit Mandawa Fort and Podar Haveli, then continue to Pushkar for an overnight stay. Enjoy a Sanganeri block print demonstration as scheduled.", nights: 1, highlights: ["Mandawa Fort", "Podar Haveli", "Sanganeri Block Print Demo"] },
    { day: 13, title: "Pushkar · Ranthambore", state: "Rajasthan", desc: "Visit Pushkar Tirth and Brahma Mandir before travelling to Ranthambore for a two-night stay.", nights: 2, highlights: ["Pushkar Tirth", "Brahma Mandir"] },
    { day: 14, title: "Ranthambore", state: "Rajasthan", desc: "Enjoy a safari at Ranthambore National Park as scheduled, subject to park permits and availability.", highlights: ["Ranthambore Safari"] },
    { day: 15, title: "Ranthambore · Jaipur", state: "Rajasthan", desc: "Continue to Jaipur and check in for a three-night stay.", nights: 3 },
    { day: 16, title: "Jaipur", state: "Rajasthan", desc: "Explore Birla Temple, Hawa Mahal, Amer Fort and Jantar Mantar. Visit Bapu Market as scheduled.", highlights: ["Birla Temple Jaipur", "Hawa Mahal", "Amer Fort", "Jantar Mantar", "Bapu Market Shopping"] },
    { day: 17, title: "Jaipur · Departure", state: "Rajasthan", desc: "Conclude the tour and depart from Jaipur for your onward journey." },
  ],
});
TOURS.push({
  slug: "all-of-gujarat-with-rann-utsav-gtag",
  title: "All of Gujarat with Rann Utsav",
  scope: "india",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-statue-of-unity.jpg", "/assets/media/wiki-somnath.jpg", "/assets/media/wiki-gir.jpg"],
  code: "GTAG",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 18,
  nights: 17,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 16,
  region: "Gujarat",
  zone: "West & Central India",
  interest: "Culture, Heritage & Wildlife",
  packageType: "Group Tour",
  startingPrice: 99000,
  emiPerMonth: 9650,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Gujarat", stops: ["Ahmedabad (2N)", "Kevadia (1N)", "Vadodara", "Diu (2N)", "Somnath (1N)", "Sasan Gir (2N)", "Dwarka (2N)", "Bhuj (2N)", "Dholavira (1N)", "Nadabet (1N)", "Patan (1N)", "Ahmedabad (1N)"] },
  ],
  highlights: ["Adalaj Stepwell", "Sabarmati Ashram", "Vision in Dark Museum", "Rani Ki Vav", "Modhera Sun Temple", "BAPS Akshardham Temple", "Miyawaki Garden", "State-of-Art Zoological Park", "Jungle Safari", "Valley of Flowers", "Statue of Unity", "Champaner (UNESCO Site)", "Pavagadh", "Diu", "Gangeshwar Mahadev Temple", "INS Khukri Memorial", "Somnath Temple", "Sasan Gir Interpretation Zone", "Gir National Park Safari", "Dwarka", "Nageshwar Jyotirlinga", "Junagadh", "Girnar", "Bhuj", "Aina Mahal", "Prag Mahal", "Swaminarayan Temple", "Mandvi Beach", "Vijay Vilas Palace", "Smritivan Earthquake Memorial", "Dhordo", "White Rann Sunset", "Road to Heaven Drive", "Dholavira", "Nadabet", "MIG-27 Photo Stop", "Sarhad Gatha Museum", "Zero Point"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Ahmedabad (Joining/Leaving)"],
  dates: [{ date: "Mon Nov 23, 2026", price: 99000 }],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Ahmedabad", state: "Gujarat", desc: "Arrive in Ahmedabad and settle in for a two-night stay. Scheduled flights and joining arrangements depend on the selected departure.", nights: 2 },
    { day: 2, title: "Ahmedabad", state: "Gujarat", desc: "Explore Sabarmati Ashram, Adalaj Stepwell, Vision in Dark Museum and BAPS Akshardham Temple as scheduled.", highlights: ["Sabarmati Ashram", "Adalaj Stepwell", "Vision in Dark Museum", "BAPS Akshardham Temple"] },
    { day: 3, title: "Ahmedabad · Kevadia", state: "Gujarat", desc: "Travel to Kevadia for an overnight stay and explore the Statue of Unity complex as scheduled.", nights: 1, highlights: ["Statue of Unity", "Valley of Flowers", "Miyawaki Garden"] },
    { day: 4, title: "Kevadia · Vadodara · Diu", state: "Gujarat", desc: "Continue across Gujarat toward Diu. Visit the State-of-Art Zoological Park and Champaner–Pavagadh as scheduled.", nights: 2, highlights: ["State-of-Art Zoological Park", "Champaner (UNESCO Site)", "Pavagadh"] },
    { day: 5, title: "Diu", state: "Gujarat", desc: "Discover Diu, including Gangeshwar Mahadev Temple and INS Khukri Memorial as scheduled.", highlights: ["Diu", "Gangeshwar Mahadev Temple", "INS Khukri Memorial"] },
    { day: 6, title: "Diu · Somnath", state: "Gujarat", desc: "Travel to Somnath for an overnight stay and visit Somnath Temple as scheduled.", nights: 1, highlights: ["Somnath Temple"] },
    { day: 7, title: "Somnath · Sasan Gir", state: "Gujarat", desc: "Continue to Sasan Gir for a two-night stay. Visit the Gir Interpretation Zone as scheduled.", nights: 2, highlights: ["Sasan Gir Interpretation Zone"] },
    { day: 8, title: "Gir National Park", state: "Gujarat", desc: "Enjoy a jeep safari at Gir National Park as scheduled, subject to permits and park availability.", highlights: ["Gir National Park Safari"] },
    { day: 9, title: "Sasan Gir · Junagadh · Dwarka", state: "Gujarat", desc: "Travel via Junagadh and Girnar toward Dwarka for a two-night stay.", nights: 2, highlights: ["Junagadh", "Girnar"] },
    { day: 10, title: "Dwarka", state: "Gujarat", desc: "Explore Dwarka and Nageshwar Jyotirlinga as scheduled.", highlights: ["Dwarka", "Nageshwar Jyotirlinga"] },
    { day: 11, title: "Dwarka · Bhuj", state: "Gujarat", desc: "Travel to Bhuj and check in for a two-night stay.", nights: 2 },
    { day: 12, title: "Bhuj", state: "Gujarat", desc: "Visit Aina Mahal, Prag Mahal, Swaminarayan Temple, Mandvi Beach, Vijay Vilas Palace and Smritivan as scheduled.", highlights: ["Aina Mahal", "Prag Mahal", "Swaminarayan Temple", "Mandvi Beach", "Vijay Vilas Palace", "Smritivan Earthquake Memorial"] },
    { day: 13, title: "Bhuj · Dholavira", state: "Gujarat", desc: "Travel to Dholavira for an overnight stay and explore the archaeological site as scheduled.", nights: 1, highlights: ["Dholavira"] },
    { day: 14, title: "Dholavira · Dhordo · White Rann", state: "Gujarat", desc: "Continue to the Rann of Kutch area for an overnight stay. Visit Dhordo and experience the White Rann sunset as scheduled.", nights: 1, highlights: ["Dhordo", "White Rann Sunset"] },
    { day: 15, title: "White Rann · Nadabet", state: "Gujarat", desc: "Enjoy the Road to Heaven drive and continue to Nadabet for an overnight stay.", nights: 1, highlights: ["Road to Heaven Drive", "Nadabet", "MIG-27 Photo Stop", "Sarhad Gatha Museum", "Zero Point"] },
    { day: 16, title: "Nadabet · Patan", state: "Gujarat", desc: "Travel to Patan for an overnight stay. Visit Rani Ki Vav as scheduled.", nights: 1, highlights: ["Rani Ki Vav"] },
    { day: 17, title: "Patan · Modhera · Ahmedabad", state: "Gujarat", desc: "Visit Modhera Sun Temple and return to Ahmedabad for an overnight stay.", nights: 1, highlights: ["Modhera Sun Temple"] },
    { day: 18, title: "Ahmedabad · Departure", state: "Gujarat", desc: "Conclude the Gujarat tour and depart from Ahmedabad for your onward journey." },
  ],
});
TOURS.push({
  slug: "odisha-with-kolkata-and-sundarbans-odsb",
  title: "Odisha with Kolkata and Sundarbans",
  scope: "india",
  image: "/assets/media/wiki-puri.jpg",
  gallery: ["/assets/media/wiki-puri.jpg", "/assets/media/wiki-konark.jpg", "/assets/media/wiki-chilika.jpg"],
  code: "ODSB",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 12,
  nights: 11,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 4,
  region: "Odisha & West Bengal",
  zone: "East & North East India",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 101000,
  emiPerMonth: 9850,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Odisha", stops: ["Bhubaneswar (2N)", "Puri (3N)"] },
    { state: "West Bengal", stops: ["Kolkata (3N)", "Sundarbans (3N)"] },
  ],
  highlights: ["Pipli Applique Village", "Chilika Lake", "Sea Mouth Island", "Odia Folk Dance", "Jagannath Temple", "Chandrabhaga Beach", "Sand Art Museum", "Konark Sun Temple", "Arka Khetra Interpretation", "Dhauli Shanti Stupa", "Lingaraj Temple", "Udaygiri & Khandagiri Caves", "Nandankanan Zoo", "Kolkata City", "Sundarban Tiger Reserve", "Sunset Cruise", "Sajnekhali Watch Tower", "Mangrove Boat Ride", "Sudhanyakhali Watch Tower", "Howrah Bridge", "Belur Math", "Dakshineswar Kali Temple", "Princep Ghat", "BBD Bagh Walk", "British Colonial Landmarks", "Eden Gardens", "Parshwanath Jain Temple", "Rabindranath Tagore House", "Tram Ride Experience", "Netaji Subhash Chandra House", "Victoria Memorial", "St. Paul's Cathedral", "Shopping in Kolkata"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Bhubaneswar (Joining)", "Kolkata (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Bhubaneswar", state: "Odisha", desc: "Arrive in Bhubaneswar and settle in for a two-night stay. Scheduled flight and joining arrangements depend on the selected departure.", nights: 2 },
    { day: 2, title: "Bhubaneswar", state: "Odisha", desc: "Visit Dhauli Shanti Stupa, Lingaraj Temple, Udaygiri and Khandagiri Caves, and Nandankanan Zoo as scheduled.", highlights: ["Dhauli Shanti Stupa", "Lingaraj Temple", "Udaygiri & Khandagiri Caves", "Nandankanan Zoo"] },
    { day: 3, title: "Bhubaneswar · Pipli · Puri", state: "Odisha", desc: "Visit Pipli Applique Village and continue to Puri for a three-night stay.", nights: 3, highlights: ["Pipli Applique Village"] },
    { day: 4, title: "Puri · Chilika Lake", state: "Odisha", desc: "Explore Chilika Lake and Sea Mouth Island as scheduled. Enjoy an Odia folk dance experience when arranged.", highlights: ["Chilika Lake", "Sea Mouth Island", "Odia Folk Dance"] },
    { day: 5, title: "Puri · Konark", state: "Odisha", desc: "Visit Jagannath Temple, Chandrabhaga Beach, Sand Art Museum, Konark Sun Temple and Arka Khetra Interpretation as scheduled.", highlights: ["Jagannath Temple", "Chandrabhaga Beach", "Sand Art Museum", "Konark Sun Temple", "Arka Khetra Interpretation"] },
    { day: 6, title: "Puri · Kolkata", state: "West Bengal", desc: "Travel to Kolkata and check in for a three-night stay.", nights: 3 },
    { day: 7, title: "Kolkata", state: "West Bengal", desc: "Explore Kolkata’s heritage and riverfront, including Howrah Bridge, Belur Math, Dakshineswar Kali Temple and Princep Ghat as scheduled.", highlights: ["Howrah Bridge", "Belur Math", "Dakshineswar Kali Temple", "Princep Ghat", "BBD Bagh Walk", "British Colonial Landmarks", "Eden Gardens"] },
    { day: 8, title: "Kolkata", state: "West Bengal", desc: "Discover the city's cultural landmarks, memorials and local experiences as scheduled.", highlights: ["Parshwanath Jain Temple", "Rabindranath Tagore House", "Tram Ride Experience", "Netaji Subhash Chandra House", "Victoria Memorial", "St. Paul's Cathedral", "Shopping in Kolkata"] },
    { day: 9, title: "Kolkata · Sundarbans", state: "West Bengal", desc: "Continue to the Sundarbans for a three-night stay.", nights: 3 },
    { day: 10, title: "Sundarbans", state: "West Bengal", desc: "Explore Sundarban Tiger Reserve by boat, including a mangrove cruise and Sajnekhali Watch Tower as scheduled.", highlights: ["Sundarban Tiger Reserve", "Sunset Cruise", "Sajnekhali Watch Tower", "Mangrove Boat Ride"] },
    { day: 11, title: "Sundarbans", state: "West Bengal", desc: "Continue exploring the Sundarbans waterways and visit Sudhanyakhali Watch Tower as scheduled.", highlights: ["Sudhanyakhali Watch Tower"] },
    { day: 12, title: "Sundarbans · Kolkata · Departure", state: "West Bengal", desc: "Return to Kolkata and depart for your onward journey. Transfer and flight arrangements depend on the selected departure." },
  ],
});
TOURS.push({
  slug: "char-dham-yatra-kedarnath-badrinath-gangotri-yamunotri-nicd",
  title: "Char Dham Yatra - Kedarnath Badrinath Gangotri Yamunotri",
  scope: "india",
  image: "/assets/media/wiki-kedarnath.jpg",
  gallery: ["/assets/media/wiki-kedarnath.jpg", "/assets/media/wiki-badrinath.jpg", "/assets/media/wiki-haridwar-aarti.jpg", "/assets/media/wiki-rishikesh.jpg"],
  code: "NICD",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 13,
  nights: 12,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 13,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Pilgrimage & Nature",
  packageType: "Group Tour",
  startingPrice: 100000,
  emiPerMonth: 9750,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Delhi", stops: ["Delhi (Arrival/Departure)"] },
    { state: "Uttarakhand", stops: ["Haridwar (1N)", "Barkot (2N)", "Uttarkashi (2N)", "Guptkashi (2N)", "Kedarnath (1N)", "Badrinath (2N)", "Rudraprayag (1N)", "Rishikesh / Haridwar (1N)"] },
  ],
  highlights: ["Ganga Aarti at Har Ki Pauri", "Prakateshwar Cave", "Vishwanath Temple", "Gangotri Temple", "Yamunotri Temple", "Kedarnath ji Temple", "Adi Shankaracharya Samadhi", "Bhairon Nath Temple", "Ardh Narishwar (Vishwanath) Temple", "Badrinath ji Temple", "Veda Vyasa Gufa", "Adi Sankaracharya Ashram", "Narsimha Temple", "Devprayag Sangam", "Dhari Devi", "Prati Badri Kedarnath Temple", "Ganga Aarti at Triveni Ghat"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Pune", "Aurangabad", "Delhi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Delhi · Haridwar", state: "Uttarakhand", desc: "Arrive in Delhi and travel to Haridwar for an overnight stay. Scheduled flight and joining arrangements depend on the selected departure.", nights: 1 },
    { day: 2, title: "Haridwar · Barkot", state: "Uttarakhand", desc: "Attend Ganga Aarti at Har Ki Pauri as scheduled, then travel to Barkot for a two-night stay.", nights: 2, highlights: ["Ganga Aarti at Har Ki Pauri"] },
    { day: 3, title: "Barkot · Yamunotri · Barkot", state: "Uttarakhand", desc: "Visit Yamunotri Temple. Trekking and local transport arrangements are subject to the tour plan and weather conditions.", highlights: ["Yamunotri Temple"] },
    { day: 4, title: "Barkot · Uttarkashi", state: "Uttarakhand", desc: "Travel to Uttarkashi for a two-night stay. Visit Prakateshwar Cave as scheduled.", nights: 2, highlights: ["Prakateshwar Cave"] },
    { day: 5, title: "Uttarkashi · Gangotri · Uttarkashi", state: "Uttarakhand", desc: "Visit Gangotri Temple and Vishwanath Temple, returning to Uttarkashi for the night. Access is subject to local conditions.", highlights: ["Gangotri Temple", "Vishwanath Temple"] },
    { day: 6, title: "Uttarkashi · Guptkashi", state: "Uttarakhand", desc: "Continue through the Garhwal region to Guptkashi for an overnight stay.", nights: 1 },
    { day: 7, title: "Guptkashi · Kedarnath", state: "Uttarakhand", desc: "Proceed to Kedarnath and visit Kedarnath ji Temple. Trek or other access arrangements depend on the tour plan, permits and local conditions.", nights: 1, highlights: ["Kedarnath ji Temple", "Adi Shankaracharya Samadhi", "Bhairon Nath Temple"] },
    { day: 8, title: "Kedarnath · Guptkashi", state: "Uttarakhand", desc: "Return to Guptkashi for an overnight stay. Visit Prati Badri Kedarnath Temple as scheduled.", nights: 1, highlights: ["Prati Badri Kedarnath Temple"] },
    { day: 9, title: "Guptkashi · Badrinath", state: "Uttarakhand", desc: "Travel to Badrinath for a two-night stay, visiting Dhari Devi en route as scheduled.", nights: 2, highlights: ["Dhari Devi"] },
    { day: 10, title: "Badrinath", state: "Uttarakhand", desc: "Visit Badrinath ji Temple, Veda Vyasa Gufa, Adi Sankaracharya Ashram and Narsimha Temple as scheduled.", highlights: ["Badrinath ji Temple", "Veda Vyasa Gufa", "Adi Sankaracharya Ashram", "Narsimha Temple"] },
    { day: 11, title: "Badrinath · Rudraprayag", state: "Uttarakhand", desc: "Travel toward Rudraprayag, with Ardh Narishwar (Vishwanath) Temple as scheduled.", nights: 1, highlights: ["Ardh Narishwar (Vishwanath) Temple"] },
    { day: 12, title: "Rudraprayag · Devprayag · Rishikesh · Haridwar", state: "Uttarakhand", desc: "Continue via Devprayag to Rishikesh and Haridwar for an overnight stay. Attend Ganga Aarti at Triveni Ghat as scheduled.", nights: 1, highlights: ["Devprayag Sangam", "Ganga Aarti at Triveni Ghat"] },
    { day: 13, title: "Haridwar · Delhi · Departure", state: "Delhi", desc: "Travel to Delhi for your onward journey. Scheduled guests return by flight; joining/leaving guests depart independently." },
  ],
});
TOURS.push({
  slug: "cultural-tamil-nadu-tntr",
  title: "Cultural Tamil Nadu",
  scope: "india",
  image: "/assets/media/wiki-madurai.jpg",
  gallery: ["/assets/media/wiki-madurai.jpg", "/assets/media/wiki-rameshwaram.jpg"],
  code: "TNTR",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: false,
  days: 12,
  nights: 11,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 11,
  region: "Tamil Nadu",
  zone: "South India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 105000,
  emiPerMonth: 10240,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Tamil Nadu", stops: ["Chennai & Kanchipuram", "Pondicherry", "Chidambaram", "Vellankani", "Thanjavur", "Chettinad", "Rameswaram", "Madurai", "Trichy"] },
  ],
  highlights: ["Vishnukanchi Temple", "Rockfort Temple", "Ranganatha Swamy Temple", "Chettinad Palace", "Meenakshi Amman Temple", "APJ Abdul Kalam Memorial", "Ramanathaswamy Temple", "Dhanushkodi Beach", "Pamban Bridge", "Church of Vellankani", "Brihadeeswara Temple", "Maratha Palace", "Chidambaram Nataraja Temple", "Pichavaram Mangrove Forest", "Sri Aurobindo Ashram", "Promenade Beach", "Krishna's Butter Ball"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Chennai (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival in Chennai · Kanchipuram", state: "Tamil Nadu", desc: "Arrive in Chennai and continue to Kanchipuram. Visit Vishnukanchi Temple as scheduled, then settle in for the first overnight stay.", nights: 1, highlights: ["Vishnukanchi Temple"] },
    { day: 2, title: "Kanchipuram · Mahabalipuram · Pondicherry", state: "Tamil Nadu", desc: "Travel south toward Pondicherry, with a visit to Krishna's Butter Ball at Mahabalipuram as scheduled.", nights: 1, highlights: ["Krishna's Butter Ball"] },
    { day: 3, title: "Pondicherry", state: "Tamil Nadu", desc: "Explore Pondicherry's spiritual and seaside landmarks, including Sri Aurobindo Ashram and Promenade Beach as scheduled.", highlights: ["Sri Aurobindo Ashram", "Promenade Beach"] },
    { day: 4, title: "Pondicherry · Chidambaram · Pichavaram", state: "Tamil Nadu", desc: "Visit Chidambaram Nataraja Temple and the Pichavaram mangrove forest before continuing south.", nights: 1, highlights: ["Chidambaram Nataraja Temple", "Pichavaram Mangrove Forest"] },
    { day: 5, title: "Vellankani", state: "Tamil Nadu", desc: "Visit the Church of Vellankani and enjoy time for prayer and sightseeing as scheduled.", nights: 1, highlights: ["Church of Vellankani"] },
    { day: 6, title: "Vellankani · Thanjavur", state: "Tamil Nadu", desc: "Continue to Thanjavur and visit Brihadeeswara Temple and Maratha Palace as scheduled.", nights: 2, highlights: ["Brihadeeswara Temple", "Maratha Palace"] },
    { day: 7, title: "Thanjavur", state: "Tamil Nadu", desc: "Explore Thanjavur and its cultural heritage at a comfortable pace. Sightseeing follows the confirmed tour schedule." },
    { day: 8, title: "Thanjavur · Chettinad", state: "Tamil Nadu", desc: "Travel through the region to Chettinad and visit Chettinad Palace as scheduled.", nights: 1, highlights: ["Chettinad Palace"] },
    { day: 9, title: "Chettinad · Rameswaram", state: "Tamil Nadu", desc: "Continue to Rameswaram for a two-night stay and visit Ramanathaswamy Temple as scheduled.", nights: 2, highlights: ["Ramanathaswamy Temple"] },
    { day: 10, title: "Rameswaram · Dhanushkodi", state: "Tamil Nadu", desc: "Visit APJ Abdul Kalam Memorial and explore Dhanushkodi Beach. Drive across Pamban Bridge as scheduled.", highlights: ["APJ Abdul Kalam Memorial", "Dhanushkodi Beach", "Pamban Bridge"] },
    { day: 11, title: "Rameswaram · Madurai", state: "Tamil Nadu", desc: "Travel to Madurai and visit Meenakshi Amman Temple as scheduled.", nights: 2, highlights: ["Meenakshi Amman Temple"] },
    { day: 12, title: "Madurai · Trichy · Departure", state: "Tamil Nadu", desc: "Continue to Trichy for Rockfort Temple and Ranganatha Swamy Temple before your onward journey. Departure and transfer details depend on the selected tour arrangement.", highlights: ["Rockfort Temple", "Ranganatha Swamy Temple"] },
  ],
});
TOURS.push({
  slug: "mizoram-tripura-kolkata-nemk",
  title: "Mizoram Tripura Kolkata",
  scope: "india",
  image: "/assets/media/wiki-gangtok.jpg",
  gallery: ["/assets/media/wiki-gangtok.jpg", "/assets/media/wiki-darjeeling-tea.jpg"],
  code: "NEMK",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: false,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 3,
  citiesCount: 4,
  region: "Mizoram, Tripura & West Bengal",
  zone: "East & North East India",
  interest: "Culture & Heritage",
  packageType: "Group Tour",
  startingPrice: 105000,
  emiPerMonth: 10240,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Tripura", stops: ["Agartala (2N)"] },
    { state: "Mizoram", stops: ["Aizawl (2N)"] },
    { state: "West Bengal", stops: ["Kolkata (3N)", "Gangasagar (1N)"] },
  ],
  highlights: ["Ujjayanta Palace", "Neermahal Palace", "Tripura Sundari Temple", "India–Bangladesh Border Flag Down Ceremony", "Unakoti", "Aizawl Sky Bridge", "Mizoram State Museum", "Solomon's Temple", "Kalighat Temple", "Victoria Memorial", "Mother Teresa House", "Belur Math", "Dakshineswar Temple", "Gangasagar", "Kapil Muni Ashram"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Agartala (Joining)", "Kolkata (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival in Agartala", state: "Tripura", desc: "Arrive in Agartala and settle in for a two-night stay. Transfer arrangements depend on the selected departure.", nights: 2 },
    { day: 2, title: "Agartala · Tripura", state: "Tripura", desc: "Explore Tripura's royal and spiritual heritage, including Ujjayanta Palace, Neermahal Palace and Tripura Sundari Temple as scheduled.", highlights: ["Ujjayanta Palace", "Neermahal Palace", "Tripura Sundari Temple"] },
    { day: 3, title: "Tripura · Aizawl", state: "Mizoram", desc: "Continue to Aizawl for a two-night stay. The India–Bangladesh border flag down ceremony and Unakoti visit are included as scheduled, subject to the confirmed route and local timings.", nights: 2, highlights: ["India–Bangladesh Border Flag Down Ceremony", "Unakoti"] },
    { day: 4, title: "Aizawl", state: "Mizoram", desc: "Discover Aizawl's city viewpoints and cultural landmarks, including Aizawl Sky Bridge and Mizoram State Museum as scheduled.", highlights: ["Aizawl Sky Bridge", "Mizoram State Museum", "Solomon's Temple"] },
    { day: 5, title: "Aizawl · Kolkata", state: "West Bengal", desc: "Fly or travel onward to Kolkata and check in for a three-night stay. Final transfer arrangements follow the selected departure plan.", nights: 3 },
    { day: 6, title: "Kolkata", state: "West Bengal", desc: "Visit Kolkata's cultural and historic landmarks, including Victoria Memorial, Mother Teresa House and Kalighat Temple as scheduled.", highlights: ["Victoria Memorial", "Mother Teresa House", "Kalighat Temple"] },
    { day: 7, title: "Kolkata", state: "West Bengal", desc: "Explore the city's riverfront and religious landmarks, including Belur Math and Dakshineswar Temple as scheduled.", highlights: ["Belur Math", "Dakshineswar Temple"] },
    { day: 8, title: "Kolkata · Gangasagar", state: "West Bengal", desc: "Travel to Gangasagar for an overnight stay and visit Kapil Muni Ashram as scheduled.", nights: 1, highlights: ["Gangasagar", "Kapil Muni Ashram"] },
    { day: 9, title: "Gangasagar · Kolkata · Departure", state: "West Bengal", desc: "Return toward Kolkata for your onward journey. Transfers and departure timing depend on the selected tour arrangement." },
  ],
});
TOURS.push({
  slug: "all-of-meghalaya-nems",
  title: "All of Meghalaya",
  scope: "india",
  image: "/assets/media/wiki-gangtok.jpg",
  gallery: ["/assets/media/wiki-gangtok.jpg", "/assets/media/wiki-darjeeling-tea.jpg", "/assets/media/wiki-corbett.jpg"],
  code: "NEMS",
  tourType: "GROUP TOUR",
  speciality: "Family",
  allInclusive: true,
  popularToday: true,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 6,
  region: "Meghalaya",
  zone: "East & North East India",
  interest: "Nature & Culture",
  packageType: "Group Tour",
  startingPrice: 103000,
  emiPerMonth: 10040,
  rating: 5,
  reviewsCount: 14,
  route: [
    { state: "Assam", stops: ["Guwahati (Arrival/Departure)"] },
    { state: "Meghalaya", stops: ["Shillong (2N)", "Jowai (2N)", "Cherrapunjee (2N)"] },
    { state: "Assam", stops: ["Guwahati (1N)"] },
  ],
  highlights: ["Elephant Falls", "Krang Suri Waterfall", "Boating in Dawki River", "Indo-Bangladesh Border at Tamabil", "Living Root Bridge", "Nongriat Trek", "Double Decker Root Bridge", "Cherrapunjee", "Mawsmai Caves", "Seven Sisters Falls", "Nohkalikai Falls", "Kamakhya Temple"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "Guwahati (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival at Guwahati · Shillong", state: "Meghalaya", desc: "Arrive in Guwahati and travel to Shillong for a two-night stay. To-and-fro flight arrangements depend on the selected departure.", nights: 2 },
    { day: 2, title: "Shillong", state: "Meghalaya", desc: "Explore Shillong and visit Elephant Falls as scheduled.", highlights: ["Elephant Falls"] },
    { day: 3, title: "Shillong · Jowai", state: "Meghalaya", desc: "Travel to Jowai for a two-night stay, enjoying the changing landscapes of Meghalaya en route.", nights: 2 },
    { day: 4, title: "Jowai · Krang Suri · Jowai", state: "Meghalaya", desc: "Visit the scenic Krang Suri Waterfall and return to Jowai.", highlights: ["Krang Suri Waterfall"] },
    { day: 5, title: "Jowai · Dawki · Mawlynnong · Cherrapunjee", state: "Meghalaya", desc: "Visit Dawki for a boat ride on the river and see the India–Bangladesh border at Tamabil. Continue through Mawlynnong to Cherrapunjee for a two-night stay.", nights: 2, highlights: ["Boating in Dawki River", "Indo-Bangladesh Border at Tamabil"] },
    { day: 6, title: "Cherrapunjee", state: "Meghalaya", desc: "Discover Cherrapunjee's waterfalls and caves. The Living Root Bridge and Nongriat trek, including the Double Decker Root Bridge, are subject to the confirmed schedule and trek conditions.", highlights: ["Living Root Bridge", "Nongriat Trek", "Double Decker Root Bridge", "Mawsmai Caves", "Seven Sisters Falls", "Nohkalikai Falls"] },
    { day: 7, title: "Cherrapunjee · Guwahati", state: "Assam", desc: "Travel back to Guwahati for an overnight stay. Visit Kamakhya Temple as scheduled.", nights: 1, highlights: ["Kamakhya Temple"] },
    { day: 8, title: "Guwahati · Departure", state: "Assam", desc: "Conclude the tour and depart from Guwahati. Flight and drop-off arrangements follow the selected departure city." },
  ],
});
TOURS.push({
  slug: "amritsar-escape-shpb1",
  title: "Amritsar Escape",
  scope: "india",
  image: "/assets/media/wiki-delhi.jpg",
  gallery: ["/assets/media/wiki-delhi.jpg", "/assets/media/wiki-varanasi-ghat.jpg", "/assets/media/wiki-jaipur.jpg"],
  code: "SHPB1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Punjab",
  zone: "North India",
  interest: "Culture & Pilgrimage",
  packageType: "Customized Holiday",
  startingPrice: 15000,
  emiPerMonth: 1463,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Punjab", stops: ["Amritsar (2N)"] },
  ],
  highlights: ["Golden Temple", "Jallianwala Bagh", "Partition Museum", "Attari Wagah Border Ceremony"],
  departureCity: "Amritsar",
  departureCities: ["Amritsar (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: false, flight: false, sightseeing: false, transport: false, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Amritsar", state: "Punjab", desc: "Arrive in Amritsar and check in for a two-night stay. Since this is a customized holiday, arrival transfers and activities depend on the options selected." , nights: 2 },
    { day: 2, title: "Amritsar at your pace", state: "Punjab", desc: "Plan your day around Amritsar's key attractions. The Golden Temple, Jallianwala Bagh, Partition Museum and Attari Wagah Border Ceremony are popular options; visits and transport are subject to your customized plan.", highlights: ["Golden Temple", "Jallianwala Bagh", "Partition Museum", "Attari Wagah Border Ceremony"] },
    { day: 3, title: "Departure from Amritsar", state: "Punjab", desc: "Check out and depart from Amritsar. Departure transfers and any additional sightseeing depend on the customized arrangements." },
  ],
});
TOURS.push({
  slug: "goa-with-pride-sun-village-resort-and-spa-shga2",
  title: "Goa with Pride Sun Village Resort and Spa",
  scope: "india",
  image: "/assets/media/wiki-goa.jpg",
  gallery: ["/assets/media/wiki-goa.jpg", "/assets/media/wiki-gokarna.jpg", "/assets/media/wiki-kovalam.jpg"],
  code: "SHGA2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Goa",
  zone: "West India",
  interest: "Beach & Leisure",
  packageType: "Customized Holiday",
  startingPrice: 15000,
  emiPerMonth: 1463,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Goa", stops: ["Goa (3N)"] }],
  highlights: ["Three nights at Pride Sun Village Resort and Spa or similar", "North Goa sightseeing by shared coach", "Leisure day in Goa", "Shared airport or railway station transfers"],
  departureCity: "Goa",
  departureCities: ["Goa (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Goa · Hotel", state: "Goa", desc: "Arrive in Goa and transfer by shared hotel vehicle from Dabolim Airport, Karmali or Thivim station. Check in for a three-night stay at Pride Sun Village Resort and Spa or a similar category hotel.", nights: 3 },
    { day: 2, title: "North Goa sightseeing", state: "Goa", desc: "Enjoy North Goa sightseeing by shared coach and hotel vehicle. Sightseeing operates at fixed timings; the confirmed pickup schedule applies." , highlights: ["North Goa sightseeing"] },
    { day: 3, title: "Goa · Day at leisure", state: "Goa", desc: "Spend the day at leisure. Optional activities and additional transport can be arranged separately, subject to availability." },
    { day: 4, title: "Goa · Departure", state: "Goa", desc: "Check out and transfer to the airport or railway station using the included shared hotel vehicle service. Airfare or railway fare is not included." },
  ],
});
TOURS.push({
  slug: "goa-hard-rock-hotel-shga32",
  title: "Goa - Hard Rock Hotel",
  scope: "india",
  image: "/assets/media/wiki-goa.jpg",
  gallery: ["/assets/media/wiki-goa.jpg", "/assets/media/wiki-gokarna.jpg", "/assets/media/wiki-kovalam.jpg"],
  code: "SHGA32",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Goa",
  zone: "West India",
  interest: "Beach & Leisure",
  packageType: "Customized Holiday",
  startingPrice: 15000,
  emiPerMonth: 1463,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Goa", stops: ["Goa (3N)"] }],
  highlights: ["Three nights at Hard Rock Hotel Goa", "Half-day North Goa sightseeing on a private basis", "Day at leisure", "Private airport or railway station transfers"],
  departureCity: "Goa",
  departureCities: ["Goa (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrival in Goa · Hard Rock Hotel", state: "Goa", desc: "Arrive in Goa and transfer by private vehicle to Hard Rock Hotel Goa for a three-night stay. Arrival transfer arrangements depend on the selected airport or railway station.", nights: 3 },
    { day: 2, title: "North Goa sightseeing", state: "Goa", desc: "Enjoy half-day North Goa sightseeing by private vehicle. Sightseeing timings and pickup details follow the confirmed arrangements.", highlights: ["Half-day North Goa sightseeing"] },
    { day: 3, title: "Goa · Day at leisure", state: "Goa", desc: "Enjoy a day at leisure. Additional sightseeing, meals and transport beyond the stated inclusions can be arranged separately." },
    { day: 4, title: "Goa · Departure", state: "Goa", desc: "Check out and transfer by private vehicle to the airport or railway station. Airfare or railway fare is not included." },
  ],
});
TOURS.push({
  slug: "solapur-tuljapur-akkalkot-gangapur-pandharpur-shmh37",
  title: "Solapur Tuljapur Akkalkot Gangapur Pandharpur",
  scope: "india",
  image: "/assets/media/wiki-somnath.jpg",
  gallery: ["/assets/media/wiki-somnath.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-varanasi-aarti.jpg"],
  code: "SHMH37",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 1,
  region: "Maharashtra",
  zone: "West India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 16000,
  emiPerMonth: 1560,
  rating: 5,
  reviewsCount: 5,
  route: [{ state: "Maharashtra", stops: ["Solapur region (2N)"] }],
  highlights: ["Solapur", "Tuljapur", "Akkalkot", "Gangapur", "Pandharpur", "Tulja Bhavani Temple", "Shri Swami Samarth Temple", "Shri Dattatreya Temple", "Vitthal-Rukmini Temple"],
  departureCity: "Solapur",
  departureCities: ["Solapur (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: false, flight: false, sightseeing: false, transport: false, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Solapur", state: "Maharashtra", desc: "Arrive in the Solapur region and check in for a two-night stay. Tuljapur and Solapur-area temple visits can be arranged as part of your customized plan; confirm the selected inclusions and transfers when booking.", nights: 2, highlights: ["Solapur", "Tuljapur", "Tulja Bhavani Temple"] },
    { day: 2, title: "Akkalkot · Gangapur", state: "Maharashtra and Karnataka", desc: "Use the day for the pilgrimage visits to Akkalkot and Gangapur. These visits and the route between them are subject to your customized arrangements.", highlights: ["Akkalkot", "Shri Swami Samarth Temple", "Gangapur", "Shri Dattatreya Temple"] },
    { day: 3, title: "Pandharpur · Departure", state: "Maharashtra", desc: "Visit Pandharpur and the Vitthal-Rukmini Temple as planned, then depart. Sightseeing, transport and departure transfers depend on the final customized package.", highlights: ["Pandharpur", "Vitthal-Rukmini Temple"] },
  ],
});
TOURS.push({
  slug: "ayodhya-getaway-shup15",
  title: "Ayodhya Getaway",
  scope: "india",
  image: "/assets/media/wiki-ayodhya.jpg",
  gallery: ["/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-varanasi-ghat.jpg", "/assets/media/wiki-prem-mandir.jpg"],
  code: "SHUP15",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 17000,
  emiPerMonth: 1658,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Ayodhya (2N)"] }],
  highlights: ["Ram Janmabhoomi", "Hanuman Garhi", "Kanak Bhawan", "Sarayu riverfront"],
  departureCity: "Ayodhya",
  departureCities: ["Ayodhya (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: false, flight: false, sightseeing: false, transport: false, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Ayodhya", state: "Uttar Pradesh", desc: "Arrive in Ayodhya and check in for a two-night stay. Transfers and sightseeing depend on the customized arrangements selected for your holiday.", nights: 2 },
    { day: 2, title: "Ayodhya at your pace", state: "Uttar Pradesh", desc: "Plan time for Ayodhya's spiritual landmarks, such as Ram Janmabhoomi, Hanuman Garhi, Kanak Bhawan and the Sarayu riverfront. Visits and transport are subject to your confirmed itinerary.", highlights: ["Ram Janmabhoomi", "Hanuman Garhi", "Kanak Bhawan", "Sarayu riverfront"] },
    { day: 3, title: "Depart from Ayodhya", state: "Uttar Pradesh", desc: "Check out and depart from Ayodhya. Departure transfers and any additional arrangements depend on the customized package selected." },
  ],
});
TOURS.push({
  slug: "evoke-dholavira-shgj16",
  title: "Evoke Dholavira",
  scope: "india",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-statue-of-unity.jpg", "/assets/media/wiki-rann-kutch.jpg"],
  code: "SHGJ16",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Gujarat",
  zone: "West India",
  interest: "History & Culture",
  packageType: "Customized Holiday",
  startingPrice: 15000,
  emiPerMonth: 1463,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Dholavira (2N)"] }],
  highlights: ["Stay at Evoke Dholavira", "Dholavira archaeological site", "Harappan heritage", "Kutch landscape"],
  departureCity: "Dholavira",
  departureCities: ["Dholavira (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: false, flight: false, sightseeing: false, transport: false, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Dholavira · Evoke", state: "Gujarat", desc: "Arrive in Dholavira and check in for a two-night stay at Evoke Dholavira. Transfers and meals depend on the customized package selected.", nights: 2 },
    { day: 2, title: "Explore Dholavira", state: "Gujarat", desc: "Spend the day discovering Dholavira's archaeological heritage and the surrounding Kutch landscape. Sightseeing and transport are subject to your confirmed arrangements.", highlights: ["Dholavira archaeological site", "Harappan heritage"] },
    { day: 3, title: "Dholavira · Departure", state: "Gujarat", desc: "Check out and depart from Dholavira. Confirm your onward transfer and any additional services when customizing the holiday." },
  ],
});
TOURS.push({
  slug: "statue-of-unity-tent-city-1-shgj18",
  title: "Statue of Unity Tent City 1",
  scope: "india",
  image: "/assets/media/wiki-statue-of-unity.jpg",
  gallery: ["/assets/media/wiki-statue-of-unity.jpg", "/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-statue-of-unity.jpg"],
  code: "SHGJ18",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Gujarat",
  zone: "West India",
  interest: "Nature & Culture",
  packageType: "Customized Holiday",
  startingPrice: 16500,
  emiPerMonth: 1609,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Statue of Unity / Kevadia (2N)"] }],
  highlights: ["Stay at Tent City 1", "Statue of Unity", "Valley of Flowers", "Sardar Sarovar Dam"],
  departureCity: "Kevadia",
  departureCities: ["Kevadia (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: false, flight: false, sightseeing: false, transport: false, visa: false },
  itinerary: [
    { day: 1, title: "Arrive at Statue of Unity · Tent City 1", state: "Gujarat", desc: "Arrive in Kevadia and check in at Tent City 1 for a two-night stay. Transfers and any included services depend on the customized arrangements selected for your holiday.", nights: 2 },
    { day: 2, title: "Explore the Statue of Unity area", state: "Gujarat", desc: "Plan time for the Statue of Unity, Valley of Flowers and Sardar Sarovar Dam. Entry tickets, local transport and sightseeing are subject to your confirmed customized itinerary.", highlights: ["Statue of Unity", "Valley of Flowers", "Sardar Sarovar Dam"] },
    { day: 3, title: "Depart from Kevadia", state: "Gujarat", desc: "Check out from Tent City 1 and depart from Kevadia. Confirm your onward transfer and any additional services when customizing the holiday." },
  ],
});
TOURS.push({
  slug: "goa-kyriad-prestige-calangute-shga1",
  title: "Goa Kyriad Prestige Calangute",
  scope: "india",
  image: "/assets/media/wiki-goa.jpg",
  gallery: ["/assets/media/wiki-goa.jpg", "/assets/media/wiki-gokarna.jpg", "/assets/media/wiki-kovalam.jpg"],
  code: "SHGA1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Goa",
  zone: "West India",
  interest: "Beach & Leisure",
  packageType: "Customized Holiday",
  startingPrice: 17000,
  emiPerMonth: 1658,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Goa", stops: ["Calangute (3N)"] }],
  highlights: ["Three-night stay at Kyriad Prestige Calangute", "Explore Calangute and North Goa", "Time at leisure", "Customize your Goa holiday"],
  departureCity: "Goa",
  departureCities: ["Goa (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: false, flight: false, sightseeing: false, transport: false, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Goa · Kyriad Prestige Calangute", state: "Goa", desc: "Arrive in Goa and check in at Kyriad Prestige Calangute for a three-night stay. Airport or railway station transfers depend on the customized arrangements selected for your holiday.", nights: 3 },
    { day: 2, title: "Calangute · North Goa", state: "Goa", desc: "Enjoy Calangute and explore North Goa at your own pace. Sightseeing, meals and local transport depend on the confirmed customized itinerary.", highlights: ["Calangute", "North Goa"] },
    { day: 3, title: "Goa · Day at leisure", state: "Goa", desc: "Spend the day at leisure or add activities and excursions to your customized plan, subject to availability." },
    { day: 4, title: "Goa · Departure", state: "Goa", desc: "Check out and depart from Goa. Confirm your onward transfer and any additional services when customizing the holiday." },
  ],
});
TOURS.push({
  slug: "ashtavinayak-shmh18",
  title: "Ashtavinayak",
  scope: "india",
  image: "/assets/media/wiki-somnath.jpg",
  gallery: ["/assets/media/wiki-somnath.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-haridwar-aarti.jpg"],
  code: "SHMH18",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Maharashtra",
  zone: "West India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 18000,
  emiPerMonth: 1753,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Maharashtra", stops: ["Mumbai", "Pune (2N)"] }],
  highlights: ["Moreshwar Temple, Morgaon", "Siddhivinayak Temple, Siddhatek", "Chintamani Temple, Theur", "Mahaganpati Temple, Ranjangaon", "Vighneshwar Temple, Ozar", "Girijatmaj Temple, Lenyadri", "Ballaleshwar Temple, Pali", "Varadvinayak Temple, Mahad"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Mumbai · Morgaon · Siddhatek · Theur · Pune", state: "Maharashtra", desc: "Depart Mumbai by private vehicle and visit Moreshwar at Morgaon, Siddhivinayak at Siddhatek and Chintamani at Theur. Continue to Pune for a two-night hotel stay. Breakfast and private vehicle travel are included as stated; temple entry fees and guide charges are extra.", nights: 2, highlights: ["Morgaon", "Siddhatek", "Theur"] },
    { day: 2, title: "Pune · Ranjangaon · Ozar · Lenyadri · Pune", state: "Maharashtra", desc: "Visit Mahaganpati Temple at Ranjangaon, Vighneshwar Temple at Ozar and Girijatmaj Temple at Lenyadri, then return to Pune. Sightseeing follows the confirmed private-vehicle itinerary; entry fees and guide charges are not included.", highlights: ["Ranjangaon", "Ozar", "Lenyadri"] },
    { day: 3, title: "Pune · Pali · Mahad · Mumbai", state: "Maharashtra", desc: "Visit Ballaleshwar Temple at Pali and Varadvinayak Temple at Mahad before continuing to Mumbai. The itinerary includes breakfast and private vehicle travel; airfare or railway fare, temple entry fees and guide charges are excluded.", highlights: ["Pali", "Mahad"] },
  ],
});
TOURS.push({
  slug: "rann-utsav-dhordo-evoke-shgj17",
  title: "Rann Utsav Dhordo - Evoke",
  scope: "india",
  image: "/assets/media/wiki-rann-kutch.jpg",
  gallery: ["/assets/media/wiki-rann-kutch.jpg", "/assets/media/wiki-statue-of-unity.jpg", "/assets/media/wiki-rann-kutch.jpg"],
  code: "SHGJ17",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Gujarat",
  zone: "West India",
  interest: "Nature & Culture",
  packageType: "Customized Holiday",
  startingPrice: 18500,
  emiPerMonth: 1804,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Dhordo (2N)"] }],
  highlights: ["Two-night stay at Rann Utsav Dhordo", "White Rann sunset", "Kutch cultural performances", "Desert activities and local experiences"],
  departureCity: "Bhuj",
  departureCities: ["Bhuj (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Bhuj · Dhordo", state: "Gujarat", desc: "Transfer from Bhuj to Rann Utsav Dhordo on the scheduled shared service and check in for a two-night stay. Enjoy the White Rann sunset, dinner and Kutch cultural activities as arranged by the camp.", nights: 2, highlights: ["Dhordo", "White Rann sunset", "Kutch cultural activities"] },
    { day: 2, title: "Experience Rann Utsav", state: "Gujarat", desc: "Spend the day enjoying the White Rann and the camp's scheduled activities, meals and cultural programme. Optional excursions and activities depend on the package and availability.", highlights: ["White Rann", "Desert activities", "Cultural programme"] },
    { day: 3, title: "Dhordo · Bhuj departure", state: "Gujarat", desc: "Check out and transfer from Dhordo to Bhuj using the scheduled shared departure service. Confirm your transfer timing and any additional excursions with the final booking details." },
  ],
});
TOURS.push({
  slug: "tirupati-escape-shap2",
  title: "Tirupati Escape",
  scope: "india",
  image: "/assets/media/wiki-tirupati.jpg",
  gallery: ["/assets/media/wiki-madurai.jpg", "/assets/media/wiki-varanasi-ghat.jpg"],
  code: "SHAP2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 2,
  region: "Andhra Pradesh",
  zone: "South India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 17000,
  emiPerMonth: 1658,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Tamil Nadu", stops: ["Chennai"] }, { state: "Andhra Pradesh", stops: ["Tirupati (2N)"] }],
  highlights: ["Drive from Chennai to Tirupati", "Sri Venkateswara Temple darshan", "Two-night hotel stay", "Breakfast and dinner"],
  departureCity: "Chennai",
  departureCities: ["Chennai (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Chennai · Tirupati", state: "Andhra Pradesh", desc: "Travel by private vehicle from Chennai to Tirupati, approximately 150 km or around three hours by road. Check in at your hotel for a two-night stay. Breakfast and dinner are included as noted in the itinerary; darshan booking and availability must be confirmed separately.", nights: 2, highlights: ["Chennai to Tirupati drive"] },
    { day: 2, title: "Tirupati · Darshan", state: "Andhra Pradesh", desc: "Keep the day for Tirupati and the Sri Venkateswara Temple darshan as planned. Local sightseeing or additional visits depend on your confirmed itinerary. Carry the required passport-size photo for darshan booking; temple tickets and any other exclusions should be checked at booking.", highlights: ["Tirupati", "Sri Venkateswara Temple"] },
    { day: 3, title: "Tirupati · Chennai · Hometown", state: "Tamil Nadu", desc: "Travel from Tirupati to Chennai by private vehicle and continue to your onward journey. Breakfast is included as indicated in the itinerary; airfare or railway fare is not included." },
  ],
});
TOURS.push({
  slug: "udaipur-fixed-date-holiday-fdrj1",
  title: "Udaipur Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-udaipur.jpg",
  gallery: ["/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-chittorgarh.jpg"],
  code: "FDRJ1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Rajasthan",
  zone: "West India",
  interest: "Culture & Heritage",
  packageType: "Fixed Date Holiday",
  startingPrice: 19000,
  emiPerMonth: 1853,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Udaipur (3N)"] }],
  highlights: ["Three-night stay in Udaipur", "City Palace", "Lake Pichola", "Fateh Sagar Lake", "Udaipur heritage and lakeside sights"],
  departureCity: "Udaipur",
  departureCities: ["Udaipur (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Udaipur", state: "Rajasthan", desc: "Arrive in Udaipur and check in for a three-night stay. Your fixed-date holiday sightseeing and transfer schedule will follow the confirmed departure itinerary.", nights: 3 },
    { day: 2, title: "Udaipur city sightseeing", state: "Rajasthan", desc: "Explore Udaipur's heritage sights, including the City Palace and the lakeside precinct around Lake Pichola. Sightseeing, meals and transfers are subject to the confirmed fixed-date itinerary.", highlights: ["City Palace", "Lake Pichola"] },
    { day: 3, title: "Udaipur · Lakes and local sights", state: "Rajasthan", desc: "Continue exploring Udaipur, with time for Fateh Sagar Lake and other included sights as listed for your selected departure. Optional activities and entry fees depend on the confirmed package details.", highlights: ["Fateh Sagar Lake", "Udaipur"] },
    { day: 4, title: "Udaipur · Departure", state: "Rajasthan", desc: "Check out and depart from Udaipur. Confirm your pickup, meals and onward travel arrangements against the selected departure itinerary." },
  ],
});
TOURS.push({
  slug: "munnar-alleppey-fixed-date-holiday-fdkl1",
  title: "Munnar Alleppey Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-munnar.jpg",
  gallery: ["/assets/media/wiki-munnar.jpg", "/assets/media/wiki-alleppey.jpg", "/assets/media/wiki-munnar.jpg"],
  code: "FDKL1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Kerala",
  zone: "South India",
  interest: "Nature & Backwaters",
  packageType: "Fixed Date Holiday",
  startingPrice: 19000,
  emiPerMonth: 1853,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Kerala", stops: ["Munnar (2N)", "Alleppey (1N)"] }],
  highlights: ["Munnar hill station", "Kerala backwaters in Alleppey", "Three nights' accommodation", "Breakfast and dinner"],
  departureCity: "Cochin",
  departureCities: ["Cochin Airport (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Cochin Airport · Munnar", state: "Kerala", desc: "Meet at Cochin Airport and travel by shared vehicle to Munnar. Check in for a two-night stay. Dinner is included as listed in the itinerary; sightseeing and transfers follow the fixed-date schedule.", nights: 2 },
    { day: 2, title: "Explore Munnar", state: "Kerala", desc: "Enjoy the scheduled Munnar sightseeing and the region's tea-growing landscapes. Breakfast and dinner are included; entrance fees and guide charges are extra.", highlights: ["Munnar", "Tea-growing landscapes"] },
    { day: 3, title: "Munnar · Alleppey", state: "Kerala", desc: "Travel from Munnar to Alleppey and check in for one night. Sightseeing is as mentioned in the confirmed itinerary; optional activities and entrance fees are not included unless specified.", nights: 1, highlights: ["Alleppey", "Kerala backwaters"] },
    { day: 4, title: "Alleppey · Cochin Airport", state: "Kerala", desc: "Travel from Alleppey to Cochin Airport for your onward journey. Breakfast and shared transport are included as listed; airfare or railway fare is not included." },
  ],
});
TOURS.push({
  slug: "indore-ujjain-omkareshwar-fixed-date-holiday-fdmp1",
  title: "Indore Ujjain Omkareshwar Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-somnath.jpg",
  gallery: ["/assets/media/wiki-somnath.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-haridwar-aarti.jpg"],
  code: "FDMP1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Madhya Pradesh",
  zone: "West & Central India",
  interest: "Pilgrimage & Culture",
  packageType: "Fixed Date Holiday",
  startingPrice: 19000,
  emiPerMonth: 1853,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Madhya Pradesh", stops: ["Indore (3N)"] }],
  highlights: ["Indore", "Mahakaleshwar Jyotirlinga", "Shri Mahakal Lok Corridor", "Omkareshwar Jyotirlinga", "Ujjain temple visits"],
  departureCity: "Indore",
  departureCities: ["Indore (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Indore", state: "Madhya Pradesh", desc: "Arrive in Indore and check in for a three-night stay. Confirm the fixed-date departure schedule for transfers, sightseeing and meals included in the package.", nights: 3 },
    { day: 2, title: "Indore · Ujjain", state: "Madhya Pradesh", desc: "Travel to Ujjain for the scheduled temple visits, including Mahakaleshwar Jyotirlinga and Shri Mahakal Lok Corridor, then return to Indore. Temple darshan timing and entry arrangements follow the confirmed itinerary.", highlights: ["Ujjain", "Mahakaleshwar Jyotirlinga", "Shri Mahakal Lok Corridor"] },
    { day: 3, title: "Indore · Omkareshwar", state: "Madhya Pradesh", desc: "Visit Omkareshwar Jyotirlinga on the planned excursion from Indore and return to the hotel. Any boat rides, guide services or entry fees are subject to the confirmed package inclusions.", highlights: ["Omkareshwar Jyotirlinga"] },
    { day: 4, title: "Indore · Departure", state: "Madhya Pradesh", desc: "Check out and depart from Indore. Confirm your pickup, meal and onward travel details against the selected fixed-date itinerary." },
  ],
});
TOURS.push({
  slug: "jaipur-fixed-date-holiday-fdrj2",
  title: "Jaipur Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-jaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-udaipur.jpg", "/assets/media/wiki-mandawa.jpg"],
  code: "FDRJ2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Rajasthan",
  zone: "West India",
  interest: "Culture & Heritage",
  packageType: "Fixed Date Holiday",
  startingPrice: 19000,
  emiPerMonth: 1853,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Jaipur (3N)"] }],
  highlights: ["Three-night stay in Jaipur", "Amber Fort", "Hawa Mahal", "City Palace", "Jantar Mantar"],
  departureCity: "Jaipur",
  departureCities: ["Jaipur (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur", state: "Rajasthan", desc: "Arrive in Jaipur and check in for a three-night stay. Your fixed-date holiday sightseeing, transfers and meals will follow the confirmed departure itinerary.", nights: 3 },
    { day: 2, title: "Explore Jaipur", state: "Rajasthan", desc: "Discover Jaipur's heritage landmarks, such as Amber Fort, Hawa Mahal, City Palace and Jantar Mantar, as scheduled for your selected departure. Entry tickets, guide services and transport follow the confirmed package inclusions.", highlights: ["Amber Fort", "Hawa Mahal", "City Palace", "Jantar Mantar"] },
    { day: 3, title: "Jaipur · Local sights and markets", state: "Rajasthan", desc: "Continue exploring Jaipur and its local bazaars, with sightseeing and included meals as listed for your fixed-date departure. Optional activities and entrance fees depend on the confirmed package details.", highlights: ["Jaipur local sights", "Pink City markets"] },
    { day: 4, title: "Jaipur · Departure", state: "Rajasthan", desc: "Check out and depart from Jaipur. Confirm your pickup, meals and onward travel details against the selected departure itinerary." },
  ],
});
TOURS.push({
  slug: "dwarka-somnath-fixed-date-holiday-fdgj1",
  title: "Dwarka Somnath Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-somnath.jpg",
  gallery: ["/assets/media/wiki-somnath.jpg", "/assets/media/wiki-diu.jpg", "/assets/media/wiki-gir.jpg"],
  code: "FDGJ1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Gujarat",
  zone: "West India",
  interest: "Pilgrimage & Culture",
  packageType: "Fixed Date Holiday",
  startingPrice: 19000,
  emiPerMonth: 1853,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Dwarka", "Somnath", "Diu"] }],
  highlights: ["Dwarkadhish Temple", "Rukmini Temple", "Nageshwar Jyotirlinga", "Porbandar", "Somnath Temple", "Diu"],
  departureCity: "Ahmedabad",
  departureCities: ["Ahmedabad (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Ahmedabad · Dwarka", state: "Gujarat", desc: "Meet at Ahmedabad and travel toward Dwarka as per the fixed-date itinerary. Check in to the hotel on arrival; the confirmed schedule will specify meals, transport and overnight arrangements.", highlights: ["Dwarka"] },
    { day: 2, title: "Dwarka · Temple visits", state: "Gujarat", desc: "Explore Dwarka's sacred sites, including Dwarkadhish Temple, Rukmini Temple and Nageshwar Jyotirlinga, as scheduled for your departure. Darshan arrangements, entry fees and guide services follow the confirmed package details.", highlights: ["Dwarkadhish Temple", "Rukmini Temple", "Nageshwar Jyotirlinga"] },
    { day: 3, title: "Dwarka · Porbandar · Somnath", state: "Gujarat", desc: "Travel onward toward Somnath, with sightseeing at Porbandar if included in your confirmed itinerary. Check in at the hotel as scheduled.", highlights: ["Porbandar", "Somnath"] },
    { day: 4, title: "Somnath · Diu", state: "Gujarat", desc: "Visit Somnath Temple and continue to Diu as per the fixed-date itinerary. Sightseeing, transport and meals are included only as listed for your selected departure.", highlights: ["Somnath Temple", "Diu"] },
    { day: 5, title: "Diu · Ahmedabad departure", state: "Gujarat", desc: "Complete the planned sightseeing and travel onward to Ahmedabad for departure. Confirm timings, transfer arrangements and included services against the final itinerary." },
  ],
});
TOURS.push({
  slug: "kolhapur-and-jyotiba-darshan-shmh43",
  title: "Kolhapur and Jyotiba Darshan",
  scope: "india",
  image: "/assets/media/wiki-somnath.jpg",
  gallery: ["/assets/media/wiki-somnath.jpg", "/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-haridwar-aarti.jpg"],
  code: "SHMH43",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 3,
  nights: 2,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Maharashtra",
  zone: "West India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 19000,
  emiPerMonth: 1853,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Maharashtra", stops: ["Kolhapur (2N)"] }],
  highlights: ["Kolhapur", "Shri Mahalaxmi Ambabai Temple", "Jyotiba Temple", "Wadi Ratnagiri"],
  departureCity: "Kolhapur",
  departureCities: ["Kolhapur (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Kolhapur", state: "Maharashtra", desc: "Arrive in Kolhapur and check in for your two-night stay. Explore the city and its spiritual heritage according to your customized holiday plan.", nights: 2, highlights: ["Kolhapur"] },
    { day: 2, title: "Kolhapur · Jyotiba Darshan", state: "Maharashtra", desc: "Visit Jyotiba Temple at Wadi Ratnagiri and continue your Kolhapur sightseeing as arranged in your customized itinerary. Darshan timing, transfers, meals and entry arrangements should be confirmed with the final holiday plan.", highlights: ["Jyotiba Temple", "Wadi Ratnagiri", "Kolhapur"] },
    { day: 3, title: "Kolhapur · Departure", state: "Maharashtra", desc: "Complete any remaining planned sightseeing, check out, and depart from Kolhapur. Confirm transfer and meal arrangements in your final customized itinerary." },
  ],
});
TOURS.push({
  slug: "munnar-alleppey-shkl5",
  title: "Munnar Alleppey",
  scope: "india",
  image: "/assets/media/wiki-munnar.jpg",
  gallery: ["/assets/media/wiki-munnar.jpg", "/assets/media/wiki-alleppey.jpg"],
  code: "SHKL5",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Kerala",
  zone: "South India",
  interest: "Nature & Backwaters",
  packageType: "Customized Holiday",
  startingPrice: 21000,
  emiPerMonth: 2048,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Kerala", stops: ["Cochin", "Munnar (2N)", "Alleppey (1N)"] }],
  highlights: ["Munnar tea gardens", "Eravikulam National Park", "Mattupetty Dam", "Alleppey backwaters", "Kerala houseboat experience"],
  departureCity: "Cochin",
  departureCities: ["Cochin (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Cochin · Munnar", state: "Kerala", desc: "Arrive in Cochin and travel to Munnar. Check in for a two-night stay; en-route sightseeing and included meals depend on your customized holiday plan.", nights: 2, highlights: ["Munnar"] },
    { day: 2, title: "Explore Munnar", state: "Kerala", desc: "Enjoy Munnar's tea-growing landscapes and scheduled local sightseeing. Places such as Mattupetty Dam and Eravikulam National Park may be included in the confirmed itinerary; entry fees and activities depend on your package details.", highlights: ["Tea gardens", "Mattupetty Dam", "Eravikulam National Park"] },
    { day: 3, title: "Munnar · Alleppey", state: "Kerala", desc: "Travel from Munnar to Alleppey and check in for an overnight stay. Backwater or houseboat arrangements and meals are as specified in your customized itinerary.", nights: 1, highlights: ["Alleppey", "Kerala backwaters"] },
    { day: 4, title: "Alleppey · Cochin departure", state: "Kerala", desc: "Check out and travel to Cochin for your onward journey. Confirm transfer timings and meal arrangements in the final holiday plan." },
  ],
});
TOURS.push({
  slug: "goa-with-grand-continent-anjuna-shga30",
  title: "Goa with Grand Continent Anjuna",
  scope: "india",
  image: "/assets/media/wiki-goa.jpg",
  gallery: ["/assets/media/wiki-goa.jpg", "/assets/media/wiki-alleppey.jpg", "/assets/media/wiki-diu.jpg"],
  code: "SHGA30",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Goa",
  zone: "West India",
  interest: "Beaches & Leisure",
  packageType: "Customized Holiday",
  startingPrice: 22000,
  emiPerMonth: 2145,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Goa", stops: ["Anjuna (3N)"] }],
  highlights: ["Three-night stay at Grand Continent Anjuna", "Anjuna Beach", "North Goa beaches", "Goa sightseeing at your own pace"],
  departureCity: "Goa",
  departureCities: ["Goa (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Goa · Anjuna", state: "Goa", desc: "Arrive in Goa and check in at Grand Continent Anjuna for a three-night stay. Transfers, meals and check-in arrangements follow your customized holiday confirmation.", nights: 3, highlights: ["Anjuna"] },
    { day: 2, title: "Explore North Goa", state: "Goa", desc: "Spend the day enjoying Anjuna and nearby North Goa beaches. Sightseeing, transport, meals and optional water activities are based on the services selected for your confirmed package.", highlights: ["Anjuna Beach", "North Goa"] },
    { day: 3, title: "Goa at leisure", state: "Goa", desc: "Enjoy a flexible day in Goa for beach time or additional sightseeing. Optional experiences and any transfer arrangements should be confirmed in your customized itinerary.", highlights: ["Goa"] },
    { day: 4, title: "Goa · Departure", state: "Goa", desc: "Check out and depart from Goa. Confirm your pickup time and any included transfer or meal arrangements with your final holiday details." },
  ],
});
TOURS.push({
  slug: "pondicherry-getaway-shtn4",
  title: "Pondicherry Getaway",
  scope: "india",
  image: "/assets/media/wiki-alleppey.jpg",
  gallery: ["/assets/media/wiki-alleppey.jpg", "/assets/media/wiki-kovalam.jpg", "/assets/media/wiki-konark.jpg"],
  code: "SHTN4",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 3,
  region: "Puducherry & Tamil Nadu",
  zone: "South India",
  interest: "Culture & Beaches",
  packageType: "Customized Holiday",
  startingPrice: 27000,
  emiPerMonth: 2633,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Tamil Nadu", stops: ["Chennai", "Mahabalipuram"] }, { state: "Puducherry", stops: ["Pondicherry (3N)"] }],
  highlights: ["Pondicherry French Quarter", "Promenade Beach", "Sri Aurobindo Ashram", "Auroville", "Mahabalipuram heritage sights"],
  departureCity: "Chennai",
  departureCities: ["Chennai (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Chennai · Pondicherry", state: "Puducherry", desc: "Arrive in Chennai and travel to Pondicherry. Check in for your three-night stay; transfers, meals and sightseeing are as arranged in your customized holiday plan.", nights: 3, highlights: ["Pondicherry"] },
    { day: 2, title: "Discover Pondicherry", state: "Puducherry", desc: "Explore Pondicherry's French Quarter and coastal promenade. Visits to Sri Aurobindo Ashram, Auroville or other local sights depend on the selections in your confirmed itinerary.", highlights: ["French Quarter", "Promenade Beach", "Sri Aurobindo Ashram", "Auroville"] },
    { day: 3, title: "Pondicherry · Mahabalipuram", state: "Tamil Nadu", desc: "Enjoy the planned excursion toward Mahabalipuram and its heritage landmarks, then return as scheduled. Transport, entry tickets and guide services follow your customized package details.", highlights: ["Mahabalipuram", "Shore Temple"] },
    { day: 4, title: "Pondicherry · Chennai departure", state: "Tamil Nadu", desc: "Check out and travel to Chennai for your onward journey. Confirm transfer timings and any included meals in your final holiday plan." },
  ],
});
TOURS.push({
  slug: "port-blair-getaway-shan10",
  title: "Port Blair Getaway",
  scope: "india",
  image: "/assets/media/wiki-goa.jpg",
  gallery: ["/assets/media/wiki-goa.jpg", "/assets/media/wiki-chilika.jpg", "/assets/media/wiki-diu.jpg"],
  code: "SHAN10",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Andaman and Nicobar Islands",
  zone: "South India",
  interest: "Islands & Beaches",
  packageType: "Customized Holiday",
  startingPrice: 27000,
  emiPerMonth: 2633,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Andaman and Nicobar Islands", stops: ["Port Blair (3N)"] }],
  highlights: ["Port Blair", "Cellular Jail", "Netaji Subhash Chandra Bose Island (Ross Island)", "Andaman island scenery", "Coastal leisure"],
  departureCity: "Port Blair",
  departureCities: ["Port Blair (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Port Blair", state: "Andaman and Nicobar Islands", desc: "Arrive in Port Blair and check in for a three-night stay. Transfers, meals and any arrival-day sightseeing follow your confirmed customized holiday plan.", nights: 3, highlights: ["Port Blair"] },
    { day: 2, title: "Explore Port Blair", state: "Andaman and Nicobar Islands", desc: "Discover Port Blair's history and coastal sights. Cellular Jail and the light and sound show may be included as arranged in your final itinerary; timings and entry arrangements are subject to confirmation.", highlights: ["Cellular Jail", "Port Blair"] },
    { day: 3, title: "Port Blair island excursion", state: "Andaman and Nicobar Islands", desc: "Enjoy the island excursion or leisure activities selected for your customized holiday. Boat transfers, entry fees and optional activities depend on the confirmed package details.", highlights: ["Andaman islands", "Coastal scenery"] },
    { day: 4, title: "Port Blair · Departure", state: "Andaman and Nicobar Islands", desc: "Check out and depart from Port Blair. Confirm your pickup time, transfer arrangements and any included meals against your final itinerary." },
  ],
});
TOURS.push({
  slug: "delhi-agra-shni2",
  title: "Delhi Agra",
  scope: "india",
  image: "/assets/media/wiki-taj-mahal.jpg",
  gallery: ["/assets/media/wiki-delhi.jpg", "/assets/media/wiki-taj-mahal.jpg", "/assets/media/wiki-lucknow.jpg"],
  code: "SHNI2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 2,
  region: "Delhi & Uttar Pradesh",
  zone: "North India",
  interest: "Culture & Heritage",
  packageType: "Customized Holiday",
  startingPrice: 27000,
  emiPerMonth: 2633,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Delhi", stops: ["Delhi (2N)"] }, { state: "Uttar Pradesh", stops: ["Agra (2N)"] }],
  highlights: ["Delhi", "Qutub Minar", "Red Fort", "Taj Mahal", "Agra Fort", "Mehtab Bagh"],
  departureCity: "Delhi",
  departureCities: ["Delhi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and check in to your hotel. The rest of the day is at leisure or follows the sightseeing and transfer plan chosen for your customized holiday.", nights: 2, highlights: ["Delhi"] },
    { day: 2, title: "Explore Delhi", state: "Delhi", desc: "Explore the capital's historic landmarks, with sights such as Qutub Minar and the Red Fort scheduled according to your confirmed itinerary. Entry fees and guide services are as specified in your package.", highlights: ["Qutub Minar", "Red Fort", "Delhi"] },
    { day: 3, title: "Delhi · Agra", state: "Uttar Pradesh", desc: "Travel from Delhi to Agra and check in for a two-night stay. Transfers and sightseeing are arranged as outlined in your customized holiday confirmation.", nights: 2, highlights: ["Agra"] },
    { day: 4, title: "Explore Agra", state: "Uttar Pradesh", desc: "Visit Agra's celebrated heritage sights, including the Taj Mahal and Agra Fort, as scheduled in your selected plan. Mehtab Bagh or other visits depend on the confirmed itinerary.", highlights: ["Taj Mahal", "Agra Fort", "Mehtab Bagh"] },
    { day: 5, title: "Agra · Departure", state: "Uttar Pradesh", desc: "Check out and depart from Agra or return to Delhi according to the transfer plan selected for your customized holiday." },
  ],
});
TOURS.push({
  slug: "dwarka-somnath-girnar-shgj19",
  title: "Dwarka Somnath Girnar",
  scope: "india",
  image: "/assets/media/wiki-somnath.jpg",
  gallery: ["/assets/media/wiki-somnath.jpg", "/assets/media/wiki-gir.jpg", "/assets/media/wiki-diu.jpg"],
  code: "SHGJ19",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Gujarat",
  zone: "West India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 27000,
  emiPerMonth: 2633,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Gujarat", stops: ["Dwarka", "Somnath", "Junagadh / Girnar"] }],
  highlights: ["Dwarkadhish Temple", "Nageshwar Jyotirlinga", "Somnath Temple", "Girnar Hill", "Junagadh"],
  departureCity: "Dwarka",
  departureCities: ["Dwarka (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Dwarka", state: "Gujarat", desc: "Arrive in Dwarka and check in to your hotel. Explore the sacred town according to your selected customized itinerary.", nights: 2, highlights: ["Dwarka"] },
    { day: 2, title: "Dwarka temple visits", state: "Gujarat", desc: "Visit Dwarkadhish Temple and other local sacred sites, such as Rukmini Temple and Nageshwar Jyotirlinga, as scheduled in your holiday plan. Darshan timing and transport are subject to the confirmed arrangements.", highlights: ["Dwarkadhish Temple", "Rukmini Temple", "Nageshwar Jyotirlinga"] },
    { day: 3, title: "Dwarka · Somnath", state: "Gujarat", desc: "Travel from Dwarka toward Somnath and check in as arranged. Stopovers and sightseeing on the way depend on the itinerary selected for your holiday.", nights: 1, highlights: ["Somnath"] },
    { day: 4, title: "Somnath · Junagadh · Girnar", state: "Gujarat", desc: "Visit Somnath Temple and continue toward Junagadh and Girnar as included in your plan. Local transfers, temple visits and any ropeway or activity arrangements should be confirmed in your final itinerary.", nights: 1, highlights: ["Somnath Temple", "Junagadh", "Girnar Hill"] },
    { day: 5, title: "Girnar · Departure", state: "Gujarat", desc: "Complete any remaining planned sightseeing and depart according to your confirmed transfer arrangements." },
  ],
});
TOURS.push({
  slug: "varanasi-ayodhya-shup10",
  title: "Varanasi Ayodhya",
  scope: "india",
  image: "/assets/media/wiki-varanasi-ghat.jpg",
  gallery: ["/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-varanasi-aarti.jpg", "/assets/media/wiki-prayagraj.jpg"],
  code: "SHUP10",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 29000,
  emiPerMonth: 2830,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Varanasi", "Sarnath", "Ayodhya"] }],
  highlights: ["Kashi Vishwanath Temple", "Dashashwamedh Ghat", "Sarnath", "Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Kanak Bhavan"],
  departureCity: "Varanasi",
  departureCities: ["Varanasi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Varanasi", state: "Uttar Pradesh", desc: "Arrive in Varanasi and check in to your hotel. Any arrival-day sightseeing, transfers and meals follow your selected customized holiday plan.", nights: 2, highlights: ["Varanasi"] },
    { day: 2, title: "Varanasi · Sarnath", state: "Uttar Pradesh", desc: "Explore Varanasi's sacred ghats and temples, with a visit to Sarnath as arranged in your confirmed itinerary. Boat rides, entry tickets and guide services depend on the package details.", highlights: ["Kashi Vishwanath Temple", "Dashashwamedh Ghat", "Sarnath"] },
    { day: 3, title: "Varanasi · Ayodhya", state: "Uttar Pradesh", desc: "Travel from Varanasi to Ayodhya and check in for your stay. Sightseeing and transfer arrangements are as outlined in your customized itinerary.", nights: 2, highlights: ["Ayodhya"] },
    { day: 4, title: "Explore Ayodhya", state: "Uttar Pradesh", desc: "Visit Ayodhya's revered sites, which may include Shri Ram Janmabhoomi Mandir, Hanuman Garhi and Kanak Bhavan, according to your confirmed plan. Darshan arrangements and timings are subject to local conditions.", highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Kanak Bhavan"] },
    { day: 5, title: "Ayodhya · Departure", state: "Uttar Pradesh", desc: "Check out and depart as per the transfer arrangements in your customized holiday confirmation." },
  ],
});
TOURS.push({
  slug: "dalhousie-dharamshala-shhp11",
  title: "Dalhousie Dharamshala",
  scope: "india",
  image: "/assets/media/wiki-mussoorie.jpg",
  gallery: ["/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-darjeeling-tea.jpg", "/assets/media/wiki-nainital.jpg"],
  code: "SHHP11",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Himachal Pradesh",
  zone: "North India",
  interest: "Mountains & Culture",
  packageType: "Customized Holiday",
  startingPrice: 27000,
  emiPerMonth: 2633,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Himachal Pradesh", stops: ["Dalhousie (2N)", "Khajjiar", "Dharamshala (2N)", "McLeod Ganj"] }],
  highlights: ["Dalhousie hill town", "Khajjiar", "Dharamshala", "McLeod Ganj", "Himalayan scenery"],
  departureCity: "Amritsar",
  departureCities: ["Amritsar (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive · Dalhousie", state: "Himachal Pradesh", desc: "Arrive at the designated joining point and travel to Dalhousie. Check in for a two-night stay; transfers and meals are arranged as specified in your customized holiday plan.", nights: 2, highlights: ["Dalhousie"] },
    { day: 2, title: "Dalhousie · Khajjiar", state: "Himachal Pradesh", desc: "Explore Dalhousie and the nearby landscapes of Khajjiar as scheduled. Sightseeing stops, entrance fees and optional activities are subject to your final itinerary.", highlights: ["Dalhousie", "Khajjiar"] },
    { day: 3, title: "Dalhousie · Dharamshala", state: "Himachal Pradesh", desc: "Travel to Dharamshala and check in for a two-night stay. Any sightseeing en route follows the confirmed customized plan.", nights: 2, highlights: ["Dharamshala"] },
    { day: 4, title: "Dharamshala · McLeod Ganj", state: "Himachal Pradesh", desc: "Explore Dharamshala and McLeod Ganj, with local sights and activities according to your selected itinerary. Transfers, entry fees and guide services are included only where confirmed.", highlights: ["Dharamshala", "McLeod Ganj"] },
    { day: 5, title: "Dharamshala · Departure", state: "Himachal Pradesh", desc: "Check out and transfer to the designated departure point as arranged in your confirmed holiday plan." },
  ],
});
TOURS.push({
  slug: "khatu-shyam-ji-salasar-balaji-devotional-escape-shrj63",
  title: "Khatu Shyam Ji – Salasar Balaji Devotional Escape",
  scope: "india",
  image: "/assets/media/wiki-jaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-mandawa.jpg", "/assets/media/wiki-pushkar.jpg"],
  code: "SHRJ63",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Rajasthan",
  zone: "West India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 28000,
  emiPerMonth: 2730,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Jaipur", "Khatu Shyam Ji", "Salasar Balaji"] }],
  highlights: ["Jaipur", "Shri Khatu Shyam Ji Temple", "Salasar Balaji Temple", "Rajasthan devotional circuit"],
  departureCity: "Jaipur",
  departureCities: ["Jaipur (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur", state: "Rajasthan", desc: "Arrive in Jaipur and check in to your hotel. Review the confirmed schedule for your temple visits, transfers and included services.", nights: 1, highlights: ["Jaipur"] },
    { day: 2, title: "Jaipur · Khatu Shyam Ji", state: "Rajasthan", desc: "Travel from Jaipur to Khatu Shyam Ji for darshan at Shri Khatu Shyam Ji Temple. Transfer timing and darshan arrangements follow your customized holiday plan and local conditions.", nights: 1, highlights: ["Shri Khatu Shyam Ji Temple"] },
    { day: 3, title: "Khatu Shyam Ji · Salasar Balaji", state: "Rajasthan", desc: "Continue to Salasar Balaji for darshan at the revered temple. Overnight arrangements and local transfers are according to your final itinerary.", nights: 1, highlights: ["Salasar Balaji Temple"] },
    { day: 4, title: "Salasar · Jaipur", state: "Rajasthan", desc: "Return toward Jaipur and enjoy the remainder of the day as arranged in your customized holiday plan.", nights: 1, highlights: ["Jaipur"] },
    { day: 5, title: "Jaipur · Departure", state: "Rajasthan", desc: "Check out and depart from Jaipur. Confirm your pickup time and onward travel arrangements against the final itinerary." },
  ],
});
TOURS.push({
  slug: "varanasi-ayodhya-lucknow-shup9",
  title: "Varanasi Ayodhya Lucknow",
  scope: "india",
  image: "/assets/media/wiki-varanasi-aarti.jpg",
  gallery: ["/assets/media/wiki-ayodhya.jpg", "/assets/media/wiki-lucknow.jpg", "/assets/media/wiki-varanasi-ghat.jpg"],
  code: "SHUP9",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Uttar Pradesh",
  zone: "North India",
  interest: "Pilgrimage & Culture",
  packageType: "Customized Holiday",
  startingPrice: 29000,
  emiPerMonth: 2830,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttar Pradesh", stops: ["Varanasi (2N)", "Ayodhya (1N)", "Lucknow (1N)"] }],
  highlights: ["Kashi Vishwanath Temple", "Dashashwamedh Ghat", "Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Bada Imambara", "Rumi Darwaza"],
  departureCity: "Varanasi",
  departureCities: ["Varanasi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Varanasi", state: "Uttar Pradesh", desc: "Arrive in Varanasi and check in to your hotel for a two-night stay. Any arrival-day sightseeing and included services follow your customized holiday plan.", nights: 2, highlights: ["Varanasi"] },
    { day: 2, title: "Explore Varanasi", state: "Uttar Pradesh", desc: "Discover Varanasi's sacred sites and riverfront, with visits such as Kashi Vishwanath Temple and Dashashwamedh Ghat as arranged in your confirmed itinerary. Boat rides, entry fees and guide services depend on your package details.", highlights: ["Kashi Vishwanath Temple", "Dashashwamedh Ghat", "Varanasi ghats"] },
    { day: 3, title: "Varanasi · Ayodhya", state: "Uttar Pradesh", desc: "Travel to Ayodhya and check in for an overnight stay. Transfer timings and temple visits follow your selected customized holiday plan.", nights: 1, highlights: ["Ayodhya"] },
    { day: 4, title: "Ayodhya · Lucknow", state: "Uttar Pradesh", desc: "Visit Ayodhya's sacred landmarks, such as Shri Ram Janmabhoomi Mandir and Hanuman Garhi, then continue to Lucknow for an overnight stay as scheduled. Darshan arrangements are subject to local conditions.", nights: 1, highlights: ["Shri Ram Janmabhoomi Mandir", "Hanuman Garhi", "Lucknow"] },
    { day: 5, title: "Explore Lucknow · Departure", state: "Uttar Pradesh", desc: "Enjoy planned Lucknow sightseeing, which may include Bada Imambara and Rumi Darwaza, before departure according to your final transfer plan.", highlights: ["Bada Imambara", "Rumi Darwaza"] },
  ],
});
TOURS.push({
  slug: "kashmir-fixed-date-holiday-fdjk1",
  title: "Kashmir Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-mussoorie.jpg",
  gallery: ["/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-nainital.jpg", "/assets/media/wiki-darjeeling-tea.jpg"],
  code: "FDJK1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Jammu & Kashmir",
  zone: "North India",
  interest: "Mountains & Nature",
  packageType: "Fixed Date Holiday",
  startingPrice: 29000,
  emiPerMonth: 2830,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Jammu & Kashmir", stops: ["Srinagar (4N)", "Pahalgam"] }],
  highlights: ["Srinagar houseboat stay", "Dal Lake Shikara ride", "Srinagar sightseeing", "Pahalgam excursion", "Gulmarg excursion", "Gondola ride (subject to availability)"],
  departureCity: "Srinagar",
  departureCities: ["Srinagar (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Srinagar Airport · Srinagar houseboat", state: "Jammu & Kashmir", desc: "Arrive at Srinagar Airport and transfer to your houseboat for the night. A Shikara ride on Dal Lake and other included services follow the fixed-date itinerary.", nights: 1, highlights: ["Srinagar", "Dal Lake", "Houseboat stay"] },
    { day: 2, title: "Srinagar sightseeing", state: "Jammu & Kashmir", desc: "Enjoy scheduled Srinagar sightseeing after breakfast. The confirmed itinerary includes listed sightseeing and meals; entrance fees and guide charges are excluded unless specified.", nights: 1, highlights: ["Srinagar", "Dal Lake"] },
    { day: 3, title: "Srinagar · Pahalgam · Srinagar", state: "Jammu & Kashmir", desc: "Take the planned excursion from Srinagar to Pahalgam and return to Srinagar. Local sightseeing, transport and any optional activities follow the fixed-date schedule.", nights: 1, highlights: ["Pahalgam"] },
    { day: 4, title: "Srinagar · Gulmarg · Srinagar", state: "Jammu & Kashmir", desc: "Visit Gulmarg on the scheduled excursion and return to Srinagar. Gondola rides are subject to availability; local conditions may affect the order or operation of activities.", nights: 1, highlights: ["Gulmarg", "Gondola ride"] },
    { day: 5, title: "Srinagar · Departure", state: "Jammu & Kashmir", desc: "Check out and transfer to Srinagar Airport for your onward journey. Confirm departure timing and included transfers against your selected date." },
  ],
});
TOURS.push({
  slug: "jaipur-pushkar-udaipur-fixed-date-holiday-fdrj3",
  title: "Jaipur Pushkar Udaipur Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-jaipur.jpg",
  gallery: ["/assets/media/wiki-jaipur.jpg", "/assets/media/wiki-pushkar.jpg", "/assets/media/wiki-udaipur.jpg"],
  code: "FDRJ3",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Rajasthan",
  zone: "West India",
  interest: "Culture & Heritage",
  packageType: "Fixed Date Holiday",
  startingPrice: 29000,
  emiPerMonth: 2830,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Rajasthan", stops: ["Jaipur (2N)", "Pushkar (1N)", "Udaipur (2N)"] }],
  highlights: ["Jaipur heritage sights", "Pushkar Brahma Temple", "Pushkar Lake", "Chittorgarh Fort", "Udaipur City Palace", "Lake Pichola"],
  departureCity: "Jaipur",
  departureCities: ["Jaipur (Joining)", "Udaipur (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Jaipur", state: "Rajasthan", desc: "Arrive in Jaipur and check in for a two-night stay. Your fixed-date holiday sightseeing, transfers and meals follow the confirmed departure itinerary.", nights: 2, highlights: ["Jaipur"] },
    { day: 2, title: "Explore Jaipur", state: "Rajasthan", desc: "Discover Jaipur's heritage landmarks and local sights as scheduled for your selected departure. Sightseeing, entry tickets and guide services follow the confirmed package details.", highlights: ["Jaipur heritage sights"] },
    { day: 3, title: "Jaipur · Pushkar", state: "Rajasthan", desc: "Travel to Pushkar for an overnight stay. Visit Pushkar's sacred sites, such as Brahma Temple and Pushkar Lake, as included in your fixed-date itinerary.", nights: 1, highlights: ["Brahma Temple", "Pushkar Lake"] },
    { day: 4, title: "Pushkar · Chittorgarh · Udaipur", state: "Rajasthan", desc: "Continue toward Udaipur, with a scheduled visit to Chittorgarh en route. Sightseeing and transfer timings depend on the confirmed departure plan.", nights: 2, highlights: ["Chittorgarh Fort"] },
    { day: 5, title: "Explore Udaipur", state: "Rajasthan", desc: "Enjoy Udaipur sightseeing, which may include City Palace and Lake Pichola, according to the confirmed fixed-date schedule. Optional activities and entry fees depend on package inclusions.", highlights: ["Udaipur City Palace", "Lake Pichola"] },
    { day: 6, title: "Udaipur · Departure", state: "Rajasthan", desc: "Check out and depart from Udaipur. Confirm your pickup time, included transfers and onward travel arrangements against your selected departure itinerary." },
  ],
});
TOURS.push({
  slug: "munnar-thekkady-alleppey-fixed-date-holiday-fdkl2",
  title: "Munnar Thekkady Alleppey Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-munnar.jpg",
  gallery: ["/assets/media/wiki-munnar.jpg", "/assets/media/wiki-alleppey.jpg", "/assets/media/wiki-munnar.jpg"],
  code: "FDKL2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Kerala",
  zone: "South India",
  interest: "Nature & Backwaters",
  packageType: "Fixed Date Holiday",
  startingPrice: 29000,
  emiPerMonth: 2830,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Kerala", stops: ["Munnar (2N)", "Thekkady (2N)", "Alleppey (1N)"] }],
  highlights: ["Munnar tea-growing landscapes", "Thekkady and Periyar Wildlife Sanctuary", "Alleppey backwaters", "Five-night Kerala stay"],
  departureCity: "Cochin",
  departureCities: ["Cochin Airport (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Cochin Airport · Munnar", state: "Kerala", desc: "Meet at Cochin Airport and travel to Munnar by shared vehicle. Check in for a two-night stay; sightseeing and included meals follow the confirmed fixed-date itinerary.", nights: 2, highlights: ["Munnar"] },
    { day: 2, title: "Explore Munnar", state: "Kerala", desc: "Enjoy scheduled sightseeing among Munnar's tea-growing landscapes and hill country. Entry fees and guide charges follow the package inclusions for your departure.", highlights: ["Munnar tea-growing landscapes"] },
    { day: 3, title: "Munnar · Thekkady", state: "Kerala", desc: "Travel from Munnar to Thekkady and check in for a two-night stay. The transfer and any en-route sightseeing follow the fixed-date schedule.", nights: 2, highlights: ["Thekkady"] },
    { day: 4, title: "Explore Thekkady", state: "Kerala", desc: "Spend the day in Thekkady, with planned experiences around Periyar Wildlife Sanctuary as listed for your selected departure. Wildlife sightings and optional activities are subject to availability and local conditions.", highlights: ["Periyar Wildlife Sanctuary"] },
    { day: 5, title: "Thekkady · Alleppey", state: "Kerala", desc: "Continue to Alleppey for an overnight stay. Enjoy the backwater region and any included activities as specified in the confirmed itinerary.", nights: 1, highlights: ["Alleppey backwaters"] },
    { day: 6, title: "Alleppey · Cochin Airport", state: "Kerala", desc: "Travel from Alleppey to Cochin Airport for your onward journey. Confirm the transfer timing and included services against your selected departure." },
  ],
});
TOURS.push({
  slug: "delhi-agra-vrindavan-fixed-date-holiday-fdni1",
  title: "Delhi Agra Vrindavan Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-delhi.jpg",
  gallery: ["/assets/media/wiki-delhi.jpg", "/assets/media/wiki-delhi.jpg", "/assets/media/wiki-delhi.jpg"],
  code: "FDNI1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 3,
  region: "North India",
  zone: "North India",
  interest: "Culture & Heritage",
  packageType: "Fixed Date Holiday",
  startingPrice: 29000,
  emiPerMonth: 2824,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Delhi", stops: ["Delhi (2N)"] }, { state: "Uttar Pradesh", stops: ["Vrindavan (1N)", "Agra (2N)"] }],
  highlights: ["Delhi landmarks", "Vrindavan temples", "Taj Mahal", "Agra Fort", "Five-night North India stay"],
  departureCity: "Delhi",
  departureCities: ["Delhi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Delhi", state: "Delhi", desc: "Arrive in Delhi and check in for a two-night stay. Your sightseeing, transfers and meals follow the confirmed fixed-date itinerary.", nights: 2, highlights: ["Delhi"] },
    { day: 2, title: "Explore Delhi", state: "Delhi", desc: "Enjoy scheduled sightseeing in Delhi. The included landmarks and services depend on the selected departure itinerary.", highlights: ["Delhi landmarks"] },
    { day: 3, title: "Delhi · Vrindavan", state: "Uttar Pradesh", desc: "Travel to Vrindavan for an overnight stay. Visit the temples and local sights listed in the confirmed fixed-date itinerary.", nights: 1, highlights: ["Vrindavan temples"] },
    { day: 4, title: "Vrindavan · Mathura · Agra", state: "Uttar Pradesh", desc: "Continue through the Mathura region to Agra and check in for a two-night stay. Sightseeing and transfer timings follow the departure schedule.", nights: 2, highlights: ["Mathura", "Agra"] },
    { day: 5, title: "Explore Agra", state: "Uttar Pradesh", desc: "Explore Agra's heritage sights, which may include the Taj Mahal and Agra Fort as listed for your selected departure. Entry fees and guide charges are subject to package inclusions.", highlights: ["Taj Mahal", "Agra Fort"] },
    { day: 6, title: "Agra · Delhi · Departure", state: "Delhi", desc: "Travel back to Delhi for your onward journey. Confirm transfer timings and departure arrangements against the fixed-date itinerary." },
  ],
});
TOURS.push({
  slug: "andaman-fixed-date-holiday-fdan1",
  title: "Andaman Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/017-images-unsplash-com-photo-1514282401047-d79a71a590e8.jpg",
  gallery: ["/assets/media/017-images-unsplash-com-photo-1514282401047-d79a71a590e8.jpg", "/assets/media/017-images-unsplash-com-photo-1514282401047-d79a71a590e8.jpg", "/assets/media/017-images-unsplash-com-photo-1514282401047-d79a71a590e8.jpg"],
  code: "FDAN1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Andaman and Nicobar Islands",
  zone: "South India",
  interest: "Beaches & Nature",
  packageType: "Fixed Date Holiday",
  startingPrice: 29000,
  emiPerMonth: 2824,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Andaman and Nicobar Islands", stops: ["Port Blair (1N + 1N)", "Havelock (3N)"] }],
  highlights: ["Port Blair", "Havelock (Swaraj Dweep)", "Radhanagar Beach", "Andaman Island scenery", "Five-night island stay"],
  departureCity: "Port Blair",
  departureCities: ["Port Blair (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Port Blair", state: "Andaman and Nicobar Islands", desc: "Arrive at Port Blair and check in for your stay. The fixed-date holiday schedule and included transfers follow the confirmed departure itinerary.", nights: 1, highlights: ["Port Blair"] },
    { day: 2, title: "Port Blair · Havelock", state: "Andaman and Nicobar Islands", desc: "Take the scheduled ferry from Port Blair to Havelock (Swaraj Dweep) and check in for a three-night stay. Ferry timings are subject to the confirmed schedule and sea conditions.", nights: 3, highlights: ["Havelock (Swaraj Dweep)"] },
    { day: 3, title: "Explore Havelock", state: "Andaman and Nicobar Islands", desc: "Enjoy the island's scheduled sightseeing, which may include Radhanagar Beach. Optional water activities and entry charges depend on the package inclusions and local conditions.", highlights: ["Radhanagar Beach"] },
    { day: 4, title: "Havelock island day", state: "Andaman and Nicobar Islands", desc: "Continue your Havelock stay with experiences arranged for your selected departure. Boat trips and water activities are subject to availability and sea conditions.", highlights: ["Havelock (Swaraj Dweep)"] },
    { day: 5, title: "Havelock · Port Blair", state: "Andaman and Nicobar Islands", desc: "Return by scheduled ferry to Port Blair and stay overnight. Confirm ferry departure and transfer details against the fixed-date itinerary.", nights: 1, highlights: ["Port Blair"] },
    { day: 6, title: "Port Blair · Departure", state: "Andaman and Nicobar Islands", desc: "Check out and transfer for your onward journey from Port Blair. Confirm pickup time and included services for your selected departure." },
  ],
});

TOURS.push({
  slug: "shimla-manali-fixed-date-holiday-fdhp2",
  title: "Shimla Manali Fixed Date Holiday",
  scope: "india",
  image: U("1626621341517-bbf3d9990a23"),
  gallery: [U("1544634076-a90160ddf44c"), U("1626621341517-bbf3d9990a23"), U("1602216056096-3b40cc0c9944")],
  code: "FDHP2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Himachal Pradesh",
  zone: "North India",
  interest: "Mountains & Nature",
  packageType: "Fixed Date Holiday",
  startingPrice: 29000,
  emiPerMonth: 2824,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Himachal Pradesh", stops: ["Chandigarh", "Shimla (1N)", "Manali (3N)", "Chandigarh (1N)"] }],
  highlights: ["Shimla", "Manali", "Solang Valley", "Rohtang Pass snow point", "Solang Valley Ropeway ride"],
  departureCity: "Chandigarh",
  departureCities: ["Chandigarh (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Chandigarh · Shimla", state: "Himachal Pradesh", desc: "Arrive in Chandigarh and travel to Shimla. Check in for an overnight stay; shared transport and meals follow the fixed-date itinerary.", nights: 1, highlights: ["Shimla"] },
    { day: 2, title: "Shimla · Manali", state: "Himachal Pradesh", desc: "Travel from Shimla to Manali and check in for a three-night stay. Transfer timings and en-route services follow the selected departure schedule.", nights: 3, highlights: ["Manali"] },
    { day: 3, title: "Explore Manali", state: "Himachal Pradesh", desc: "Enjoy the scheduled Manali sightseeing. Entrance fees and guide charges are not included unless specified in your package details.", highlights: ["Manali"] },
    { day: 4, title: "Manali · Solang Valley", state: "Himachal Pradesh", desc: "Visit Solang Valley and enjoy the included ropeway ride. A local union vehicle day trip to Rohtang Pass snow point is included; operation and access depend on local conditions.", highlights: ["Solang Valley", "Solang Valley Ropeway ride", "Rohtang Pass snow point"] },
    { day: 5, title: "Manali · Chandigarh", state: "Himachal Pradesh", desc: "Travel from Manali to Chandigarh and check in for an overnight stay. Shared transport and meals follow the confirmed schedule.", nights: 1, highlights: ["Chandigarh"] },
    { day: 6, title: "Chandigarh · Departure", state: "Chandigarh", desc: "Check out and depart from Chandigarh for your hometown. Confirm pickup time and onward travel arrangements against the selected fixed-date itinerary." },
  ],
});
TOURS.push({
  slug: "nainital-mussoorie-delhi-fixed-date-holiday-fdut1",
  title: "Nainital Mussoorie Delhi Fixed Date Holiday",
  scope: "india",
  image: "/assets/media/wiki-nainital.jpg",
  gallery: ["/assets/media/wiki-nainital.jpg", "/assets/media/wiki-mussoorie.jpg", "/assets/media/wiki-delhi.jpg"],
  code: "FDUT1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 3,
  region: "Uttarakhand",
  zone: "North India",
  interest: "Mountains & Nature",
  packageType: "Fixed Date Holiday",
  startingPrice: 29000,
  emiPerMonth: 2824,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Uttarakhand", stops: ["Mussoorie (2N)", "Nainital (2N)"] }, { state: "Delhi", stops: ["Delhi (1N)"] }],
  highlights: ["Mussoorie sightseeing", "Nainital sightseeing", "Five-night North India holiday", "Shared road transfers"],
  departureCity: "Delhi",
  departureCities: ["Delhi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Delhi · Mussoorie", state: "Uttarakhand", desc: "Meet at Delhi Airport or station and travel to Mussoorie. Check in for a two-night stay; shared transport and meals follow the confirmed fixed-date schedule.", nights: 2, highlights: ["Mussoorie"] },
    { day: 2, title: "Mussoorie sightseeing", state: "Uttarakhand", desc: "Enjoy the scheduled sightseeing in Mussoorie. Entrance fees and guide charges are not included unless specified in your package details.", highlights: ["Mussoorie"] },
    { day: 3, title: "Mussoorie · Nainital", state: "Uttarakhand", desc: "Travel from Mussoorie to Nainital and check in for a two-night stay. Transfer timings and included meals follow the selected departure itinerary.", nights: 2, highlights: ["Nainital"] },
    { day: 4, title: "Nainital sightseeing", state: "Uttarakhand", desc: "Explore Nainital as scheduled in your fixed-date itinerary. Optional activities and entrance charges depend on the package inclusions.", highlights: ["Nainital"] },
    { day: 5, title: "Nainital · Delhi", state: "Delhi", desc: "Travel from Nainital to Delhi and check in for an overnight stay. Shared transfer and meals are as described in the confirmed package details.", nights: 1, highlights: ["Delhi"] },
    { day: 6, title: "Delhi · Departure", state: "Delhi", desc: "Check out and depart from Delhi for your hometown. Confirm your pickup time and onward travel arrangements against your selected fixed-date itinerary." },
  ],
});
WORLD_TOURS.push({
  slug: "luxury-in-france-shop-wine-and-chateau-stay-shfr20",
  title: "Luxury in France – Shop, Wine and Château Stay",
  scope: "world",
  image: U("1502602898657-3e91760cbb34"),
  gallery: [U("1502602898657-3e91760cbb34"), U("1499856871958-5b9627545d1a"), U("1541849546-216549ae216d")],
  code: "SHFR20",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "France",
  zone: "Europe",
  interest: "Luxury & Culture",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "France", stops: ["Paris", "French wine region", "Château stay"] }],
  highlights: ["Luxury France experience", "Shopping", "Wine experiences", "Château stay"],
  departureCity: "Paris",
  departureCities: ["Paris (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: false, flight: false, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Paris", state: "France", desc: "Arrive in Paris and begin your tailor-made luxury France holiday. The exact hotel, transfers and evening arrangements are confirmed when your itinerary is quoted.", highlights: ["Paris"] },
    { day: 2, title: "Paris · Shopping", state: "France", desc: "Enjoy time for shopping and exploring Paris according to your selected preferences. Specific stores, experiences and transport arrangements are finalized with your tailor-made itinerary.", highlights: ["Shopping", "Paris"] },
    { day: 3, title: "Paris · French wine region", state: "France", desc: "Continue into a French wine region for curated wine experiences. The region, tasting schedule and overnight arrangements are confirmed at enquiry.", highlights: ["Wine experiences"] },
    { day: 4, title: "French wine region", state: "France", desc: "Discover the region through experiences arranged for your trip, with visits and tastings subject to the confirmed itinerary and availability.", highlights: ["Wine experiences"] },
    { day: 5, title: "French wine region · Château stay", state: "France", desc: "Travel to your château accommodation and settle in for a distinctive French countryside stay. The château and included experiences are confirmed in your quotation.", highlights: ["Château stay"] },
    { day: 6, title: "Château stay", state: "France", desc: "Enjoy your château stay and any scheduled local experiences as detailed in your confirmed tailor-made plan.", highlights: ["Château stay"] },
    { day: 7, title: "Château stay · Paris", state: "France", desc: "Return to Paris or continue to the next location according to your finalized routing and transfer plan.", highlights: ["France"] },
    { day: 8, title: "Departure from France", state: "France", desc: "Check out and depart according to your confirmed travel arrangements." },
  ],
});

WORLD_TOURS.push({
  slug: "antarctic-express-fly-the-drake-shus57",
  title: "Antarctic Express – Fly the Drake",
  scope: "world",
  image: U("1518837695005-2083093ee35b"),
  gallery: [U("1518837695005-2083093ee35b"), U("1464822759023-fed622ff2c3b"), U("1500530855697-b586d89ba3ee")],
  code: "SHUS57",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 2,
  statesCount: 2,
  citiesCount: 2,
  region: "Antarctica",
  zone: "World",
  interest: "Nature & Adventure",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Chile", stops: ["Punta Arenas (2N)"] }, { state: "Antarctica", stops: ["Antarctic Peninsula (5N)"] }],
  highlights: ["Charter flight across the Drake Passage", "King George Island", "Antarctic Peninsula", "South Shetland Islands", "Zodiac excursions and wildlife viewing", "Expert-led expedition briefings"],
  departureCity: "Punta Arenas",
  departureCities: ["Punta Arenas (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Punta Arenas", state: "Chile", desc: "Arrive in Punta Arenas, Chile, and prepare for the expedition. Attend the scheduled briefing and overnight in the city; final arrangements depend on your confirmed departure.", nights: 1, highlights: ["Punta Arenas"] },
    { day: 2, title: "Fly across the Drake Passage · King George Island", state: "Antarctica", desc: "Take the expedition charter flight across the Drake Passage to King George Island and board the ship. Flight and embarkation timing can change with weather and operating conditions.", highlights: ["Drake Passage charter flight", "King George Island"] },
    { day: 3, title: "South Shetland Islands · Antarctic Peninsula", state: "Antarctica", desc: "Begin exploring the Antarctic region by ship, with possible Zodiac outings and shore landings. The expedition team adjusts activities to sea, ice and weather conditions.", nights: 1, highlights: ["South Shetland Islands", "Zodiac outings"] },
    { day: 4, title: "Explore Antarctica", state: "Antarctica", desc: "Continue expedition cruising and exploration around the Antarctic Peninsula. Look for penguins, seals and whales; wildlife sightings are not guaranteed and landings depend on conditions.", nights: 1, highlights: ["Antarctic Peninsula", "Wildlife viewing"] },
    { day: 5, title: "Explore Antarctica", state: "Antarctica", desc: "Spend another day discovering the polar landscape with the expedition team. Planned Zodiac excursions and landings remain subject to weather, sea and ice conditions.", nights: 1, highlights: ["Zodiac excursions", "Polar landscapes"] },
    { day: 6, title: "Explore Antarctica", state: "Antarctica", desc: "Continue the voyage through the Antarctic Peninsula region, with opportunities to observe wildlife and learn from the onboard expedition specialists. The precise route is set by conditions.", nights: 1, highlights: ["Antarctic Peninsula", "Expedition team"] },
    { day: 7, title: "Fly from King George Island · Punta Arenas", state: "Chile", desc: "Disembark on King George Island and take the charter flight back to Punta Arenas. Flight operations and timing are weather dependent; overnight in Punta Arenas after arrival.", nights: 1, highlights: ["King George Island", "Punta Arenas"] },
    { day: 8, title: "Depart Punta Arenas", state: "Chile", desc: "Check out and depart Punta Arenas for your onward journey. Confirm your flight arrangements and required buffer time with the expedition operator." },
  ],
});
TOURS.push({ ...WORLD_TOURS[WORLD_TOURS.length - 1], scope: INDIA_REGION_NAMES.has(WORLD_TOURS[WORLD_TOURS.length - 1].region) ? "india" : WORLD_TOURS[WORLD_TOURS.length - 1].scope });
WORLD_TOURS.push({
  slug: "nooe-maldives-kunaavashi-shml40",
  title: "NOOE Maldives Kunaavashi",
  scope: "world",
  image: U("1514282401047-d79a71a590e8"),
  gallery: [U("1514282401047-d79a71a590e8"), U("1500375592092-40eb2168fd21"), U("1540541338287-41700207dee6")],
  code: "SHML40",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Maldives",
  zone: "Asia",
  interest: "Beaches & Relaxation",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Maldives", stops: ["Malé", "NOOE Maldives Kunaavashi (3N)"] }],
  highlights: ["Three-night island stay", "Beach and overwater villas", "Vaavu Atoll marine life", "Optional spa, diving and water sports", "Speedboat or seaplane transfers from Malé"],
  departureCity: "Malé",
  departureCities: ["Malé (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: false, flight: false, sightseeing: false, transport: false, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Malé · NOOE Maldives Kunaavashi", state: "Maldives", desc: "Arrive at Velana International Airport and transfer to NOOE Maldives Kunaavashi in Vaavu Atoll. The resort is reached by speedboat or seaplane; transfer type, timing and cost depend on your confirmed quotation and flight schedule.", nights: 3, highlights: ["Malé", "Vaavu Atoll", "NOOE Maldives Kunaavashi"] },
    { day: 2, title: "Relax at NOOE Maldives Kunaavashi", state: "Maldives", desc: "Enjoy the island at your own pace, from the beach and resort facilities to optional marine activities. Meal plan, villa category and experiences are confirmed with your customized holiday quote.", highlights: ["Island stay", "Beach and overwater villas"] },
    { day: 3, title: "Discover the island", state: "Maldives", desc: "Spend another day relaxing or choose optional activities such as snorkeling, diving, water sports or spa treatments. Availability and additional charges vary by activity and selected package.", highlights: ["Marine life", "Optional water sports", "Spa"] },
    { day: 4, title: "Malé · Departure", state: "Maldives", desc: "Check out and transfer to Velana International Airport for your onward flight. Transfer options and departure timing should be confirmed against your international flight schedule." },
  ],
});
TOURS.push({ ...WORLD_TOURS[WORLD_TOURS.length - 1], scope: INDIA_REGION_NAMES.has(WORLD_TOURS[WORLD_TOURS.length - 1].region) ? "india" : WORLD_TOURS[WORLD_TOURS.length - 1].scope });
WORLD_TOURS.push({
  slug: "nepal-chitwan-pokhara-ibnp2",
  title: "Nepal Chitwan Pokhara",
  scope: "world",
  image: U("1501785888041-af3ef285b470"),
  gallery: [U("1501785888041-af3ef285b470"), U("1464822759023-fed622ff2c3b"), U("1544735716-392fe2489ffa")],
  code: "IBNP2",
  tourType: "INBOUND",
  speciality: "Inbound",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Nepal",
  zone: "Asia",
  interest: "Nature & Culture",
  packageType: "Inbound Tour",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Nepal", stops: ["Kathmandu (2N)", "Pokhara (2N)", "Chitwan (2N)", "Kathmandu (1N)"] }],
  highlights: ["Kathmandu heritage sightseeing", "Pokhara Valley and Phewa Lake", "Chitwan National Park safari", "Canoe ride and local folk dance", "Scenic Himalayan landscapes"],
  departureCity: "Kathmandu",
  departureCities: ["Kathmandu (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: false, sightseeing: true, transport: true, visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Kathmandu", state: "Nepal", desc: "Arrive in Kathmandu and transfer to your hotel. Settle in for a two-night stay; arrival arrangements follow your confirmed itinerary.", nights: 2, highlights: ["Kathmandu"] },
    { day: 2, title: "Kathmandu city tour", state: "Nepal", desc: "Explore Kathmandu on the scheduled city tour, with visits to landmarks such as Pashupatinath, Boudhanath and Swayambhunath as listed in the final itinerary. Entry fees and guide charges are excluded unless stated otherwise.", highlights: ["Pashupatinath Temple", "Boudhanath Stupa", "Swayambhunath Stupa"] },
    { day: 3, title: "Kathmandu · Pokhara", state: "Nepal", desc: "Travel by road from Kathmandu to Pokhara, approximately 210 km and around six hours, subject to traffic and road conditions. Check in for a two-night stay.", nights: 2, highlights: ["Pokhara"] },
    { day: 4, title: "Pokhara valley sightseeing", state: "Nepal", desc: "Discover Pokhara on the planned valley sightseeing tour. Enjoy views around Phewa Lake and other scheduled attractions; activities depend on the confirmed itinerary and local conditions.", highlights: ["Phewa Lake", "Pokhara"] },
    { day: 5, title: "Pokhara · Chitwan", state: "Nepal", desc: "Drive approximately 135 km from Pokhara to Chitwan, around four hours in typical conditions. Check in for a two-night stay near Chitwan National Park.", nights: 2, highlights: ["Chitwan National Park"] },
    { day: 6, title: "Chitwan safari and activities", state: "Nepal", desc: "Enjoy the scheduled Chitwan National Park activities, which may include a safari, canoe ride and cultural program as specified in your confirmed itinerary. Wildlife sightings and activity operations are not guaranteed.", highlights: ["Chitwan National Park", "Safari", "Canoe ride", "Nepali folk dance"] },
    { day: 7, title: "Chitwan · Kathmandu", state: "Nepal", desc: "Return to Kathmandu by road, approximately 175 km and around five hours, depending on traffic and road conditions. Check in for your final overnight stay.", nights: 1, highlights: ["Kathmandu"] },
    { day: 8, title: "Kathmandu · Departure", state: "Nepal", desc: "Check out and depart from Kathmandu for your onward journey. Airfare, entrance fees and guide charges are excluded unless included in your confirmed booking." },
  ],
});
TOURS.push({ ...WORLD_TOURS[WORLD_TOURS.length - 1], scope: INDIA_REGION_NAMES.has(WORLD_TOURS[WORLD_TOURS.length - 1].region) ? "india" : WORLD_TOURS[WORLD_TOURS.length - 1].scope });
WORLD_TOURS.push({
  slug: "womens-special-nepal-npwp",
  title: "Women’s Special Nepal",
  scope: "world",
  image: U("1501785888041-af3ef285b470"),
  gallery: [U("1501785888041-af3ef285b470"), U("1464822759023-fed622ff2c3b"), U("1544735716-392fe2489ffa")],
  code: "NPWP",
  tourType: "GROUP TOUR",
  speciality: "Women’s Special",
  allInclusive: true,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Nepal",
  zone: "Asia",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 79000,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Nepal", stops: ["Kathmandu (1N)", "Chitwan (2N)", "Pokhara (2N)", "Kathmandu (2N)"] }],
  highlights: ["Manakamana Devi Ropeway", "Chitwan National Park safari", "Nepali folk dance", "Canoe ride", "Pokhara boat ride on Phewa Lake", "Sarangkot sunrise", "Kathmandu and Bhaktapur heritage sights"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "New Delhi", "Ahmedabad", "Bengaluru", "Kolkata", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Kathmandu", state: "Nepal", desc: "Arrive in Kathmandu and meet the tour team. Transfer to the hotel and settle in for an overnight stay; flight and transfer arrangements follow your confirmed departure plan.", nights: 1, highlights: ["Kathmandu"] },
    { day: 2, title: "Kathmandu · Chitwan", state: "Nepal", desc: "Travel from Kathmandu to Chitwan and check in for a two-night stay. The scheduled route may include a visit to Manakamana Devi by ropeway, subject to the tour plan and operating conditions.", nights: 2, highlights: ["Manakamana Devi Ropeway", "Chitwan"] },
    { day: 3, title: "Chitwan National Park", state: "Nepal", desc: "Explore Chitwan National Park through activities in the group itinerary, which may include a safari, canoe ride and cultural folk dance. Wildlife sightings and activity schedules depend on local conditions.", highlights: ["Chitwan National Park", "Safari", "Canoe ride", "Nepali folk dance"] },
    { day: 4, title: "Chitwan · Pokhara", state: "Nepal", desc: "Drive from Chitwan to Pokhara and check in for a two-night stay. Enjoy the changing landscapes along the way, with travel time subject to road conditions.", nights: 2, highlights: ["Pokhara"] },
    { day: 5, title: "Pokhara sightseeing", state: "Nepal", desc: "Discover Pokhara on the scheduled valley sightseeing tour. The experience includes a boat ride on Phewa Lake; other sightseeing follows the confirmed itinerary.", highlights: ["Phewa Lake boat ride", "Pokhara Valley"] },
    { day: 6, title: "Pokhara · Kathmandu", state: "Nepal", desc: "Fly from Pokhara to Kathmandu and check in for a two-night stay. Flight schedules and baggage conditions are subject to airline operations.", nights: 2, highlights: ["Pokhara to Kathmandu flight"] },
    { day: 7, title: "Kathmandu sightseeing", state: "Nepal", desc: "Continue sightseeing in Kathmandu and nearby heritage areas as scheduled. Visits may include Bhaktapur Durbar Square, Pashupatinath, Boudhanath and Swayambhunath according to the final itinerary.", highlights: ["Bhaktapur Durbar Square", "Pashupatinath Temple", "Boudhanath Stupa", "Swayambhunath Stupa"] },
    { day: 8, title: "Kathmandu · Departure", state: "Nepal", desc: "Check out and transfer to the airport for your return flight. Confirm departure time and transfer details with your tour manager." },
  ],
});
TOURS.push({ ...WORLD_TOURS[WORLD_TOURS.length - 1], scope: INDIA_REGION_NAMES.has(WORLD_TOURS[WORLD_TOURS.length - 1].region) ? "india" : WORLD_TOURS[WORLD_TOURS.length - 1].scope });
WORLD_TOURS.push({
  slug: "seniors-special-nepal-npzp",
  title: "Senior’s Special Nepal",
  scope: "world",
  image: U("1501785888041-af3ef285b470"),
  gallery: [U("1501785888041-af3ef285b470"), U("1464822759023-fed622ff2c3b"), U("1544735716-392fe2489ffa")],
  code: "NPZP",
  tourType: "GROUP TOUR",
  speciality: "Seniors’ Special",
  allInclusive: true,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Nepal",
  zone: "Asia",
  interest: "Culture & Nature",
  packageType: "Group Tour",
  startingPrice: 81000,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Nepal", stops: ["Kathmandu (1N)", "Chitwan (2N)", "Pokhara (2N)", "Kathmandu (2N)"] }],
  highlights: ["Manakamana Devi Ropeway", "Chitwan National Park safari", "Nepali folk dance", "Canoe ride", "Pokhara boat ride on Phewa Lake", "Sarangkot sunrise", "Kathmandu and Bhaktapur heritage sights"],
  departureCity: "Mumbai",
  departureCities: ["Mumbai", "New Delhi", "Ahmedabad", "Bengaluru", "Kolkata", "Joining/leaving"],
  dates: [],
  inclusions: { hotel: true, meals: true, flight: true, sightseeing: true, transport: true, visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Kathmandu", state: "Nepal", desc: "Arrive in Kathmandu and meet the tour team. Transfer to the hotel and settle in for an overnight stay; arrival arrangements follow your confirmed departure plan.", nights: 1, highlights: ["Kathmandu"] },
    { day: 2, title: "Kathmandu · Chitwan", state: "Nepal", desc: "Travel from Kathmandu to Chitwan and check in for a two-night stay. The scheduled route may include a visit to Manakamana Devi by ropeway, subject to the tour plan and operating conditions.", nights: 2, highlights: ["Manakamana Devi Ropeway", "Chitwan"] },
    { day: 3, title: "Chitwan National Park", state: "Nepal", desc: "Enjoy the planned Chitwan National Park program, which may include a safari, canoe ride and cultural folk dance. Wildlife sightings and activities depend on local conditions and your confirmed itinerary.", highlights: ["Chitwan National Park", "Safari", "Canoe ride", "Nepali folk dance"] },
    { day: 4, title: "Chitwan · Pokhara", state: "Nepal", desc: "Travel by road from Chitwan to Pokhara and check in for a two-night stay. The tour is paced for a comfortable group journey, with stops and timing set by the tour manager.", nights: 2, highlights: ["Pokhara"] },
    { day: 5, title: "Pokhara sightseeing", state: "Nepal", desc: "Explore Pokhara on the scheduled valley sightseeing tour, including a boat ride on Phewa Lake. Other visits follow the confirmed itinerary and local conditions.", highlights: ["Phewa Lake boat ride", "Pokhara Valley"] },
    { day: 6, title: "Pokhara · Kathmandu", state: "Nepal", desc: "Fly from Pokhara to Kathmandu and settle in for a two-night stay. Flight timing and baggage conditions are subject to airline operations.", nights: 2, highlights: ["Pokhara to Kathmandu flight"] },
    { day: 7, title: "Kathmandu sightseeing", state: "Nepal", desc: "Continue sightseeing in Kathmandu and nearby heritage areas as scheduled. Visits may include Bhaktapur Durbar Square, Pashupatinath, Boudhanath and Swayambhunath according to the final itinerary.", highlights: ["Bhaktapur Durbar Square", "Pashupatinath Temple", "Boudhanath Stupa", "Swayambhunath Stupa"] },
    { day: 8, title: "Kathmandu · Departure", state: "Nepal", desc: "Check out and transfer to the airport for your return flight. Confirm your departure schedule and transfer details with the tour manager." },
  ],
});
TOURS.push({ ...WORLD_TOURS[WORLD_TOURS.length - 1], scope: INDIA_REGION_NAMES.has(WORLD_TOURS[WORLD_TOURS.length - 1].region) ? "india" : WORLD_TOURS[WORLD_TOURS.length - 1].scope });

TOURS.push({
  slug: "italy-with-lake-como-shit3",
  title: "Italy with Lake Como",
  scope: "world",
  image: U("1529260830199-42c24126f198"),
  gallery: [U("1529260830199-42c24126f198"), U("1516483638261-f4dbaf036963"), U("1498307833015-e7b400441eb8")],
  code: "SHIT3",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 13,
  nights: 12,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 6,
  region: "Italy",
  zone: "Europe",
  interest: "Culture & Sightseeing",
  packageType: "Customized Holiday",
  startingPrice: 245900,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Italy", stops: ["Rome (2N)", "Naples (2N)", "Florence (2N)", "Venice (2N)", "Lake Como (2N)", "Milan (2N)"] }],
  highlights: ["Rome Hop-on Hop-off City Tour", "Naples Hop-on Hop-off City Tour", "Pisa and the Leaning Tower", "Venice Walking Tour", "Venice Gondola Ride", "Lake Como", "Milan Walking Tour", "Milan Duomo visit", "Italy rail travel"],
  departureCity: "Rome",
  departureCities: ["Rome (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "breakfast", flight: false, sightseeing: true, transport: "Italy rail pass", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Rome", state: "Italy", desc: "Arrive in Rome and check in to your hotel for a two-night stay. Airport transfers and exact arrangements are confirmed with your customized holiday.", nights: 2, highlights: ["Rome"] },
    { day: 2, title: "Rome sightseeing", state: "Italy", desc: "Explore Rome with a hop-on hop-off city sightseeing tour on a shared coach basis. Overnight in Rome.", highlights: ["Rome Hop-on Hop-off City Tour"] },
    { day: 3, title: "Rome · Naples", state: "Italy", desc: "Travel by train from Rome to Naples and check in for a two-night stay. Overnight in Naples.", nights: 2, highlights: ["Italy rail travel", "Naples"] },
    { day: 4, title: "Naples sightseeing", state: "Italy", desc: "Discover Naples with a hop-on hop-off city tour on a shared coach basis. Overnight in Naples.", highlights: ["Naples Hop-on Hop-off City Tour"] },
    { day: 5, title: "Naples · Florence", state: "Italy", desc: "Travel by train from Naples to Florence and check in for a two-night stay. Overnight in Florence.", nights: 2, highlights: ["Italy rail travel", "Florence"] },
    { day: 6, title: "Florence · Pisa", state: "Italy", desc: "Take an afternoon shared-coach excursion to Pisa and see the Leaning Tower. Overnight in Florence.", highlights: ["Pisa", "Leaning Tower of Pisa"] },
    { day: 7, title: "Florence · Venice", state: "Italy", desc: "Travel by train to Venice and check in for a two-night stay. Overnight in Venice.", nights: 2, highlights: ["Italy rail travel", "Venice"] },
    { day: 8, title: "Venice sightseeing", state: "Italy", desc: "Enjoy a Venice walking tour and gondola ride on a shared basis. Overnight in Venice.", highlights: ["Venice Walking Tour", "Gondola Ride"] },
    { day: 9, title: "Venice · Lake Como", state: "Italy", desc: "Travel by train via Milan to Lake Como and check in for a two-night stay. Overnight at Lake Como.", nights: 2, highlights: ["Lake Como", "Italy rail travel"] },
    { day: 10, title: "Lake Como at leisure", state: "Italy", desc: "Enjoy a day at leisure around Lake Como. Optional activities and local arrangements can be selected as part of your customized holiday.", highlights: ["Lake Como"] },
    { day: 11, title: "Lake Como · Milan", state: "Italy", desc: "Travel by train to Milan and check in for a two-night stay. Overnight in Milan.", nights: 2, highlights: ["Italy rail travel", "Milan"] },
    { day: 12, title: "Milan sightseeing", state: "Italy", desc: "Explore Milan on a shared walking tour that includes a visit to the Duomo and the city centre. Overnight in Milan.", highlights: ["Milan Walking Tour", "Milan Duomo"] },
    { day: 13, title: "Milan · Departure", state: "Italy", desc: "Check out and continue to your hometown. Airport transfers and departure arrangements are not included and should be planned for your selected itinerary." },
  ],
});

TOURS.push({
  slug: "sydney-with-port-stephens-hunter-valley-shau41",
  title: "Sydney with Port Stephens and Hunter Valley",
  scope: "world",
  image: U("1523482580672-f109ba8cb9be"),
  gallery: [U("1523482580672-f109ba8cb9be"), U("1506973035872-a4ec16b8e8d9"), U("1524293581917-878a6d017c71")],
  code: "SHAU41",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Australia",
  zone: "Australia & New Zealand",
  interest: "Self Drive & Nature",
  packageType: "Customized Holiday",
  startingPrice: 225952,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Australia", stops: ["Sydney (2N)", "Port Stephens (2N)", "Hunter Valley (1N)", "Sydney (1N)"] }],
  highlights: ["Big Bus Sydney and Bondi Hop-on Hop-off Tour", "Port Stephens Koala Sanctuary", "Dolphin Watching Cruise", "4WD beach and dune tour with sandboarding", "Hunter Valley cheese and wine tasting", "Sunrise hot air balloon flight with bubbly breakfast", "Sydney Harbour sunset dinner cruise", "Self-drive compact SUV"],
  departureCity: "Sydney",
  departureCities: ["Sydney (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "some meals", flight: false, sightseeing: true, transport: "self-drive SUV and shared airport transfers", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Sydney", state: "Australia", desc: "Arrive in Sydney and transfer to your hotel for a two-night stay. The return airport transfers are on a shared coach basis.", nights: 2, highlights: ["Sydney"] },
    { day: 2, title: "Sydney sightseeing", state: "Australia", desc: "Explore Sydney and Bondi on a Big Bus hop-on hop-off tour, and enjoy the Sydney Harbour sunset dinner cruise from Darling Harbour as scheduled. Sightseeing pickup and drop-off points are reached independently.", highlights: ["Big Bus Sydney and Bondi Hop-on Hop-off Tour", "Sydney Harbour sunset dinner cruise"] },
    { day: 3, title: "Sydney · Port Stephens", state: "Australia", desc: "Travel by compact SUV to Port Stephens and check in for a two-night stay. Visit the Port Stephens Koala Sanctuary.", nights: 2, highlights: ["Port Stephens Koala Sanctuary", "Self-drive"] },
    { day: 4, title: "Port Stephens · Dolphins and dunes", state: "Australia", desc: "Enjoy a dolphin watching cruise and a beach and dune 4WD tour with sandboarding in Port Stephens.", highlights: ["Dolphin Watching Cruise", "4WD beach and dune tour", "Sandboarding"] },
    { day: 5, title: "Port Stephens · Hunter Valley", state: "Australia", desc: "Drive to Hunter Valley and check in for an overnight stay. Enjoy a cheese and wine tasting experience in Pokolbin.", nights: 1, highlights: ["Hunter Valley", "Cheese and wine tasting in Pokolbin"] },
    { day: 6, title: "Hunter Valley · Sydney", state: "Australia", desc: "Take a sunrise hot air balloon flight with a bubbly breakfast, then drive back to Sydney for an overnight stay.", nights: 1, highlights: ["Sunrise hot air balloon flight", "Bubbly breakfast", "Self-drive"] },
    { day: 7, title: "Sydney · Departure", state: "Australia", desc: "Check out and depart from Sydney for your hometown. Confirm your transfer pickup and onward travel arrangements against your final booking." },
  ],
});

TOURS.push({
  slug: "best-of-brazil-shbr2",
  title: "Best of Brazil",
  scope: "world",
  image: U("1483729558449-99ef09a8c325"),
  gallery: [U("1483729558449-99ef09a8c325"), U("1516306580123-e6e52b1b7b5f"), U("1516026672322-bc52d61a55d5")],
  code: "SHBR2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 11,
  nights: 10,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Brazil",
  zone: "South America",
  interest: "Nature & Culture",
  packageType: "Customized Holiday",
  startingPrice: 237443,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Brazil", stops: ["Rio de Janeiro (3N)", "Iguazu (2N)", "Manaus / Amazon (3N)", "Salvador (2N)"] }],
  highlights: ["Rio de Janeiro sightseeing", "Iguazu Falls on the Argentine side", "Amazon rainforest", "Manaus", "Salvador de Bahia", "Shared-coach sightseeing with English-speaking guides"],
  departureCity: "Rio de Janeiro",
  departureCities: ["Rio de Janeiro (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "breakfast", flight: false, sightseeing: true, transport: "shared coach", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Rio de Janeiro", state: "Brazil", desc: "Arrive in Rio de Janeiro and check in for a three-night stay. Airport transfers and other arrangements are confirmed with your customized holiday.", nights: 3, highlights: ["Rio de Janeiro"] },
    { day: 2, title: "Rio de Janeiro sightseeing", state: "Brazil", desc: "Explore Rio de Janeiro on the sightseeing program selected for your trip, with shared-coach transfers and an English-speaking guide as included.", highlights: ["Rio de Janeiro"] },
    { day: 3, title: "Rio de Janeiro", state: "Brazil", desc: "Enjoy another day in Rio de Janeiro for the experiences included in your selected itinerary or time at leisure.", highlights: ["Rio de Janeiro"] },
    { day: 4, title: "Rio de Janeiro · Iguazu", state: "Brazil", desc: "Continue to Iguazu and check in for a two-night stay. Any internal flights and airport taxes are excluded from the listed package inclusions.", nights: 2, highlights: ["Iguazu"] },
    { day: 5, title: "Iguazu Falls · Argentine side", state: "Brazil", desc: "Visit the Argentine side of Iguazu Falls as included in the selected itinerary. Sightseeing entrance fees listed in the program are included.", highlights: ["Iguazu Falls (Argentine side)"] },
    { day: 6, title: "Iguazu · Manaus · Amazon", state: "Brazil", desc: "Travel onward to Manaus and the Amazon region for a three-night stay. Internal airfare is not included in the package price.", nights: 3, highlights: ["Manaus", "Amazon"] },
    { day: 7, title: "Amazon", state: "Brazil", desc: "Discover the Amazon region through the activities and guided sightseeing arranged in your confirmed customized itinerary.", highlights: ["Amazon rainforest"] },
    { day: 8, title: "Amazon", state: "Brazil", desc: "Continue exploring the Amazon region or enjoy the experiences selected for your holiday. Final inclusions depend on your confirmed plan.", highlights: ["Amazon rainforest"] },
    { day: 9, title: "Manaus · Salvador de Bahia", state: "Brazil", desc: "Travel to Salvador de Bahia and check in for a two-night stay. Internal airfare and airport taxes are excluded.", nights: 2, highlights: ["Salvador de Bahia"] },
    { day: 10, title: "Salvador de Bahia", state: "Brazil", desc: "Explore Salvador with the sightseeing and English-speaking guide services included in your selected itinerary.", highlights: ["Salvador de Bahia"] },
    { day: 11, title: "Salvador · Departure", state: "Brazil", desc: "Check out and depart from Salvador for your hometown. Confirm onward travel and transfer arrangements with your finalized customized holiday." },
  ],
});

TOURS.push({
  slug: "swiss-paris-sheu2",
  title: "Swiss Paris",
  scope: "world",
  image: U("1502602898657-3e91760cbb34"),
  gallery: [U("1502602898657-3e91760cbb34"), U("1541849546-216549ae216d"), U("1527668752968-14dc70a27c95")],
  code: "SHEU2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 2,
  statesCount: 2,
  citiesCount: 4,
  region: "Switzerland & France",
  zone: "Europe",
  interest: "Culture & Scenic Rail",
  packageType: "Customized Holiday",
  startingPrice: 232939,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "France", stops: ["Paris"] }, { state: "Switzerland", stops: ["Swiss city stays"] }],
  highlights: ["Paris", "Swiss cities and Alpine scenery", "Customized holiday across France and Switzerland"],
  departureCity: "Paris",
  departureCities: ["Paris (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected", transport: "as selected", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Paris", state: "France", desc: "Arrive in Paris and begin your customized France and Switzerland holiday. Hotel, transfers and activities follow the itinerary confirmed for your trip.", nights: 2, highlights: ["Paris"] },
    { day: 2, title: "Paris", state: "France", desc: "Explore Paris at your own pace or enjoy the sightseeing selected for your customized itinerary. Overnight in Paris.", highlights: ["Paris"] },
    { day: 3, title: "Paris · Switzerland", state: "Switzerland", desc: "Continue from Paris to Switzerland using the transport arrangements selected for your trip. Check in at your Swiss hotel for the next part of the holiday.", nights: 2, highlights: ["France to Switzerland"] },
    { day: 4, title: "Switzerland", state: "Switzerland", desc: "Discover your chosen Swiss destination and nearby sights. The city, activities and local transport are finalized as part of your customized holiday.", highlights: ["Switzerland"] },
    { day: 5, title: "Switzerland", state: "Switzerland", desc: "Continue exploring Switzerland, with time for the scenic experiences included in your selected plan.", nights: 2, highlights: ["Swiss Alpine scenery"] },
    { day: 6, title: "Switzerland", state: "Switzerland", desc: "Enjoy another day in Switzerland. Sightseeing, transfers and meals depend on the options confirmed for your holiday.", highlights: ["Switzerland"] },
    { day: 7, title: "Switzerland", state: "Switzerland", desc: "Spend your final full day in Switzerland and prepare for departure. The overnight city and onward arrangements are set in your confirmed itinerary.", nights: 1, highlights: ["Switzerland"] },
    { day: 8, title: "Departure", state: "Switzerland", desc: "Check out and depart for your hometown according to your confirmed travel arrangements." },
  ],
});

TOURS.push({
  slug: "madrid-cordoba-seville-granada-barcelona-shsp8",
  title: "Madrid Cordoba Seville Granada Barcelona",
  scope: "world",
  image: U("1502602898657-3e91760cbb34"),
  gallery: [U("1502602898657-3e91760cbb34"), U("1539037116277-4db20889f2d4"), U("1583422409516-2895a77efded")],
  code: "SHSP8",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Spain",
  zone: "Europe",
  interest: "Culture & City Experiences",
  packageType: "Customized Holiday",
  startingPrice: 229028,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Spain", stops: ["Madrid (2N)", "Cordoba (1N)", "Seville (1N)", "Granada (1N)", "Barcelona (2N)"] }],
  highlights: ["Madrid", "Cordoba", "Seville", "Granada", "Barcelona", "High-speed rail between cities", "Alhambra and Generalife Gardens"],
  departureCity: "Madrid",
  departureCities: ["Madrid (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "breakfast", flight: false, sightseeing: true, transport: "high-speed rail and private transfers", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Madrid", state: "Spain", desc: "Arrive in Madrid and transfer privately to your hotel. The rest of the day is at leisure.", nights: 2, highlights: ["Madrid"] },
    { day: 2, title: "Madrid sightseeing", state: "Spain", desc: "Discover Madrid on a two-hour private sightseeing tour with an English-speaking driver. Enjoy the remainder of the day at leisure.", highlights: ["Private Madrid sightseeing"] },
    { day: 3, title: "Madrid · Cordoba", state: "Spain", desc: "Travel by high-speed train to Cordoba. Join a half-day shared coach city tour featuring the Mosque, Synagogue and Alcazar. Overnight in Cordoba.", nights: 1, highlights: ["High-speed rail", "Cordoba city tour"] },
    { day: 4, title: "Cordoba · Seville", state: "Spain", desc: "Take the high-speed train to Seville and enjoy a half-day shared coach city tour. Overnight in Seville.", nights: 1, highlights: ["High-speed rail", "Seville city tour"] },
    { day: 5, title: "Seville · Granada", state: "Spain", desc: "Continue by high-speed train to Granada and check in at your hotel.", nights: 1, highlights: ["High-speed rail", "Granada"] },
    { day: 6, title: "Granada · Barcelona", state: "Spain", desc: "Visit the Alhambra and Generalife Gardens on a regular shared coach tour, then travel by high-speed train to Barcelona. Check in for a two-night stay.", nights: 2, highlights: ["Alhambra", "Generalife Gardens", "High-speed rail"] },
    { day: 7, title: "Barcelona sightseeing", state: "Spain", desc: "Explore Barcelona on a two-hour private sightseeing tour with an English-speaking driver. Enjoy the rest of the day at leisure.", highlights: ["Private Barcelona sightseeing"] },
    { day: 8, title: "Depart Barcelona", state: "Spain", desc: "Check out and transfer privately to the airport for your onward journey." },
  ],
});

TOURS.push({
  slug: "russia-with-murmansk-shru5",
  title: "Russia with Murmansk",
  scope: "world",
  image: U("1513326738677-b964603b136d"),
  gallery: [U("1513326738677-b964603b136d"), U("1513635269975-59663e0ac1ad"), U("1519608487953-e999c86e7455")],
  code: "SHRU5",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Russia",
  zone: "Europe",
  interest: "Culture & Northern Lights",
  packageType: "Customized Holiday",
  startingPrice: 219005,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Russia", stops: ["Moscow", "St. Petersburg", "Murmansk"] }],
  highlights: ["Moscow", "St. Petersburg", "Murmansk", "Northern Lights experiences in Murmansk"],
  departureCity: "Moscow",
  departureCities: ["Moscow (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected", transport: "as selected", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Moscow", state: "Russia", desc: "Arrive in Moscow and transfer to your hotel according to your customized holiday arrangements. Enjoy the rest of the day at leisure.", nights: 2, highlights: ["Moscow"] },
    { day: 2, title: "Explore Moscow", state: "Russia", desc: "Discover Moscow with the sightseeing selected for your trip. Confirmed activities, transport and meal arrangements are set out in your final customized itinerary.", highlights: ["Moscow city experiences"] },
    { day: 3, title: "Moscow · St. Petersburg", state: "Russia", desc: "Continue to St. Petersburg using the transport arranged for your holiday. Check in and enjoy time at leisure.", nights: 2, highlights: ["St. Petersburg"] },
    { day: 4, title: "Explore St. Petersburg", state: "Russia", desc: "Spend the day discovering St. Petersburg. The sightseeing and local arrangements depend on the options confirmed in your customized itinerary.", highlights: ["St. Petersburg city experiences"] },
    { day: 5, title: "St. Petersburg · Murmansk", state: "Russia", desc: "Travel onward to Murmansk and check in at your hotel. Enjoy the remainder of the day at leisure.", nights: 2, highlights: ["Murmansk"] },
    { day: 6, title: "Murmansk", state: "Russia", desc: "Explore Murmansk and, when conditions and your confirmed plan allow, look out for the Northern Lights. Aurora sightings are a natural phenomenon and cannot be guaranteed.", highlights: ["Murmansk", "Northern Lights opportunity"] },
    { day: 7, title: "Depart Murmansk", state: "Russia", desc: "Check out and transfer for your onward journey according to the arrangements confirmed for your customized holiday." },
  ],
});

TOURS.push({
  slug: "prague-vienna-budapest-fixed-date-holiday-fdeu1",
  title: "Prague Vienna Budapest Fixed Date Holiday",
  scope: "world",
  image: U("1519671482749-fd09be7ccebf"),
  gallery: [U("1519671482749-fd09be7ccebf"), U("1516550893923-42d28e5677af"), U("1541849546-216549ae216d")],
  code: "FDEU1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Fixed Date Holiday",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 3,
  statesCount: 3,
  citiesCount: 3,
  region: "Central Europe",
  zone: "Europe",
  interest: "Culture & Heritage",
  packageType: "Fixed Date Holiday",
  startingPrice: 210000,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Czech Republic", stops: ["Prague (2N)"] },
    { state: "Austria", stops: ["Vienna (2N)"] },
    { state: "Hungary", stops: ["Budapest (2N)"] },
  ],
  highlights: ["Prague", "Vienna", "Budapest", "Three Central European capitals"],
  departureCity: "Prague",
  departureCities: ["Prague (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as per fixed-date itinerary", flight: false, sightseeing: "as per fixed-date itinerary", transport: "as per fixed-date itinerary", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Prague", state: "Czech Republic", desc: "Arrive in Prague and check in for your stay. Transfer and meal arrangements are as specified for your selected fixed-date departure.", nights: 2, highlights: ["Prague"] },
    { day: 2, title: "Prague", state: "Czech Republic", desc: "Explore Prague according to the sightseeing schedule for your selected departure, with time for the city’s historic centre.", highlights: ["Prague"] },
    { day: 3, title: "Prague · Vienna", state: "Austria", desc: "Travel onward to Vienna using the transport arranged for the holiday and check in for your stay.", nights: 2, highlights: ["Vienna"] },
    { day: 4, title: "Vienna", state: "Austria", desc: "Discover Vienna through the sightseeing and activities included in the schedule for your selected fixed-date departure.", highlights: ["Vienna"] },
    { day: 5, title: "Vienna · Budapest", state: "Hungary", desc: "Continue to Budapest using the transport arranged for your holiday and check in for your stay.", nights: 2, highlights: ["Budapest"] },
    { day: 6, title: "Budapest", state: "Hungary", desc: "Explore Budapest according to the sightseeing schedule for your selected departure.", highlights: ["Budapest"] },
    { day: 7, title: "Depart Budapest", state: "Hungary", desc: "Check out and depart from Budapest. Confirm your transfer and onward travel details against the selected departure itinerary." },
  ],
});

TOURS.push({
  slug: "california-nevada-self-drive-shus54",
  title: "California & Nevada Self Drive",
  scope: "world",
  image: U("1501594907352-04cda38ebc29"),
  gallery: [U("1501594907352-04cda38ebc29"), U("1500530855697-b586d89ba3ee"), U("1533105079780-92b9be482077")],
  code: "SHUS54",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 11,
  nights: 10,
  countriesCount: 1,
  statesCount: 2,
  citiesCount: 7,
  region: "California & Nevada",
  zone: "North America",
  interest: "Road Trip & Nature",
  packageType: "Customized Holiday",
  startingPrice: 283533,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "California", stops: ["San Francisco (2N)", "Yosemite (1N)", "Death Valley (1N)", "Palm Springs (1N)", "San Diego (1N)", "Los Angeles (2N)"] },
    { state: "Nevada", stops: ["Las Vegas (2N)"] },
  ],
  highlights: ["California and Nevada self-drive holiday", "San Francisco", "Yosemite", "Death Valley", "Las Vegas", "Palm Springs", "San Diego", "Los Angeles"],
  departureCity: "San Francisco",
  departureCities: ["San Francisco (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "self-drive route; activities as selected", transport: "self-drive arrangements; confirm vehicle inclusions for your selected plan", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in San Francisco", state: "California", desc: "Arrive in San Francisco and begin your California and Nevada self-drive holiday. Hotel and vehicle arrangements follow the customized plan confirmed for your dates.", nights: 2, highlights: ["San Francisco"] },
    { day: 2, title: "San Francisco", state: "California", desc: "Explore San Francisco at your own pace. Sightseeing and activities are selected as part of your customized itinerary.", highlights: ["San Francisco"] },
    { day: 3, title: "San Francisco · Yosemite", state: "California", desc: "Drive toward Yosemite and check in for an overnight stay. The route, drive times and park arrangements should be confirmed with your final itinerary.", nights: 1, highlights: ["Yosemite"] },
    { day: 4, title: "Yosemite · Death Valley", state: "California", desc: "Continue your self-drive journey to Death Valley for an overnight stay. Road conditions and seasonal park access can affect the route.", nights: 1, highlights: ["Death Valley"] },
    { day: 5, title: "Death Valley · Las Vegas", state: "Nevada", desc: "Drive onward to Las Vegas and check in for a two-night stay. Enjoy the city at leisure or choose activities in your customized plan.", nights: 2, highlights: ["Las Vegas"] },
    { day: 6, title: "Las Vegas", state: "Nevada", desc: "Spend the day exploring Las Vegas at your own pace. Optional shows, attractions and excursions depend on your selections.", highlights: ["Las Vegas"] },
    { day: 7, title: "Las Vegas · Palm Springs", state: "California", desc: "Continue by road to Palm Springs and check in for an overnight stay. Confirm the driving route and vehicle arrangements for your travel dates.", nights: 1, highlights: ["Palm Springs"] },
    { day: 8, title: "Palm Springs · San Diego", state: "California", desc: "Drive to San Diego and check in for an overnight stay. Spend the remainder of the day at leisure.", nights: 1, highlights: ["San Diego"] },
    { day: 9, title: "San Diego · Los Angeles", state: "California", desc: "Travel north to Los Angeles and check in for a two-night stay. Any included visits or transfers are listed in your confirmed customized itinerary.", nights: 2, highlights: ["Los Angeles"] },
    { day: 10, title: "Los Angeles", state: "California", desc: "Enjoy a full day in Los Angeles for sightseeing or leisure, according to the experiences selected for your holiday.", highlights: ["Los Angeles"] },
    { day: 11, title: "Depart Los Angeles", state: "California", desc: "Check out and depart from Los Angeles. Confirm your vehicle return, airport transfer and onward travel details against your finalized package." },
  ],
});

TOURS.push({
  slug: "romantic-switzerland-shsw29",
  title: "Romantic Switzerland",
  scope: "world",
  image: U("1531366936337-7c912a4589a7"),
  gallery: [U("1531366936337-7c912a4589a7"), U("1515488764276-beab7607c1e6"), U("1501785888041-af3ef285b470")],
  code: "SHSW29",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Switzerland",
  zone: "Europe",
  interest: "Romantic & Scenic",
  packageType: "Customized Holiday",
  startingPrice: 215422,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Switzerland", stops: ["Interlaken (3N)", "Lucerne (2N)", "Zurich (2N)"] }],
  highlights: ["Interlaken", "Lucerne", "Zurich", "Swiss Alpine scenery", "A romantic Switzerland getaway"],
  departureCity: "Zurich",
  departureCities: ["Zurich (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected", transport: "as selected", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Interlaken", state: "Switzerland", desc: "Arrive in Switzerland and travel to Interlaken according to your confirmed holiday arrangements. Check in and enjoy the rest of the day at leisure.", nights: 3, highlights: ["Interlaken"] },
    { day: 2, title: "Interlaken", state: "Switzerland", desc: "Enjoy a day in Interlaken and the surrounding alpine scenery. Excursions and local transport depend on the options selected for your customized holiday.", highlights: ["Interlaken", "Swiss Alps"] },
    { day: 3, title: "Interlaken", state: "Switzerland", desc: "Spend another day exploring Interlaken or choose an optional mountain excursion. Confirm inclusions and operating schedules for your travel dates.", highlights: ["Interlaken"] },
    { day: 4, title: "Interlaken · Lucerne", state: "Switzerland", desc: "Continue to Lucerne using the transport arranged for your trip. Check in and spend the rest of the day at leisure.", nights: 2, highlights: ["Lucerne"] },
    { day: 5, title: "Lucerne", state: "Switzerland", desc: "Discover Lucerne’s lakeside setting and old town. Sightseeing, excursions and meals follow the selections in your confirmed itinerary.", highlights: ["Lucerne", "Lake Lucerne"] },
    { day: 6, title: "Lucerne · Zurich", state: "Switzerland", desc: "Travel onward to Zurich and check in for your final two-night stay. Transport arrangements are as specified in the customized plan.", nights: 2, highlights: ["Zurich"] },
    { day: 7, title: "Zurich", state: "Switzerland", desc: "Enjoy Zurich at your own pace or take the sightseeing and excursions included in your selected itinerary.", highlights: ["Zurich"] },
    { day: 8, title: "Depart Zurich", state: "Switzerland", desc: "Check out and depart from Zurich. Confirm your transfer and onward travel details with your final holiday plan." },
  ],
});

TOURS.push({
  slug: "paris-in-a-week-shfr4",
  title: "Paris in a Week",
  scope: "world",
  image: U("1499856871958-5b9627545d1a"),
  gallery: [U("1499856871958-5b9627545d1a"), U("1502602898657-3e91760cbb34"), U("1503919005314-30d93d07d823")],
  code: "SHFR4",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "France",
  zone: "Europe",
  interest: "Culture, City & Theme Parks",
  packageType: "Customized Holiday",
  startingPrice: 207256,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "France", stops: ["Paris (6N)"] }],
  highlights: ["Paris Hop-on Hop-off tour", "Seine River cruise", "Eiffel Tower 2nd level", "Louvre Museum", "Paris by 2CV", "Palace of Versailles", "Disney® Parks 1 day, 2 parks", "Champagne region day trip"],
  departureCity: "Paris",
  departureCities: ["Paris (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "breakfast", flight: false, sightseeing: true, transport: "sightseeing tours; airport/train station transfers are excluded", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Paris", state: "France", desc: "Arrive in Paris and check in at your hotel for a six-night stay. Airport or train station transfers are not included in the package.", nights: 6, highlights: ["Paris"] },
    { day: 2, title: "Paris Hop-on Hop-off · Seine cruise · Eiffel Tower · Louvre", state: "France", desc: "Enjoy the Paris Hop-on Hop-off tour with a Seine River cruise, Eiffel Tower 2nd level ticket and Louvre Museum entrance ticket. Sightseeing operates at fixed timings; reach the designated pick-up points on time.", highlights: ["Paris Hop-on Hop-off", "Seine River cruise", "Eiffel Tower 2nd level", "Louvre Museum"] },
    { day: 3, title: "Paris by 2CV", state: "France", desc: "See Paris on the included 2CV tour. The sightseeing schedule and meeting point are subject to the confirmed itinerary.", highlights: ["2CV tour of Paris"] },
    { day: 4, title: "Palace of Versailles", state: "France", desc: "Take the half-day Palace of Versailles tour with audio guide. Please follow the fixed departure time and designated meeting point.", highlights: ["Palace of Versailles", "Audio guide"] },
    { day: 5, title: "Disney® Parks", state: "France", desc: "Spend the day at Disney® Parks with the included one-day, two-park ticket. Transfers are not included; plan your journey to the parks separately.", highlights: ["Disney® Parks", "1 day · 2 parks"] },
    { day: 6, title: "Champagne region", state: "France", desc: "Enjoy the included day trip to the Champagne region. Check the confirmed itinerary for departure time and meeting point.", highlights: ["Champagne region day trip"] },
    { day: 7, title: "Depart Paris", state: "France", desc: "Check out and depart for your hometown. Airport or train station transfers are not included; confirm onward travel arrangements separately." },
  ],
});

TOURS.push({
  slug: "highlights-of-kenya-shke10",
  title: "Highlights of Kenya",
  scope: "world",
  image: U("1516426122078-c23e76319801"),
  gallery: [U("1516426122078-c23e76319801"), U("1547471080-7cc2caa01a7e"), U("1516026672322-bc52d61a55d5")],
  code: "SHKE10",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Kenya",
  zone: "Africa",
  interest: "Wildlife Safari & Nature",
  packageType: "Customized Holiday",
  startingPrice: 201372,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Kenya", stops: ["Nairobi (1N)", "Aberdare (1N)", "Lake Naivasha (1N)", "Masai Mara (2N)"] }],
  highlights: ["Nairobi", "Aberdare National Park", "Lake Naivasha", "Masai Mara", "Safari game drives", "Kenya wildlife and Rift Valley scenery"],
  departureCity: "Nairobi",
  departureCities: ["Nairobi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected", transport: "safari and road transfers as per confirmed itinerary", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Nairobi", state: "Kenya", desc: "Arrive in Nairobi and transfer to your hotel according to your confirmed customized holiday arrangements. Overnight in Nairobi.", nights: 1, highlights: ["Nairobi"] },
    { day: 2, title: "Nairobi · Aberdare", state: "Kenya", desc: "Travel to the Aberdare region and check in for an overnight stay. Enjoy the wildlife-viewing experience arranged at your selected lodge.", nights: 1, highlights: ["Aberdare National Park", "Wildlife viewing"] },
    { day: 3, title: "Aberdare · Lake Naivasha", state: "Kenya", desc: "Continue to the Lake Naivasha area for an overnight stay. Optional lake activities and local experiences depend on your confirmed plan.", nights: 1, highlights: ["Lake Naivasha", "Great Rift Valley"] },
    { day: 4, title: "Lake Naivasha · Masai Mara", state: "Kenya", desc: "Travel to the Masai Mara and check in for a two-night stay. Enjoy a safari game drive as arranged in your customized itinerary.", nights: 2, highlights: ["Masai Mara", "Safari game drive"] },
    { day: 5, title: "Masai Mara", state: "Kenya", desc: "Spend the day exploring the reserve with safari activities arranged in your confirmed plan. Wildlife sightings vary with natural conditions.", highlights: ["Masai Mara", "Wildlife safari"] },
    { day: 6, title: "Masai Mara · Departure", state: "Kenya", desc: "Check out and travel onward for your departure according to the arrangements confirmed for your customized holiday." },
  ],
});

TOURS.push({
  slug: "egypt-with-nile-cruise-sheg1",
  title: "Egypt with Nile Cruise",
  scope: "world",
  image: U("1539768942893-daf53e448371"),
  gallery: [U("1539768942893-daf53e448371"), U("1568322445389-f64ac2515020"), U("1503177119275-0aa32b3a9368")],
  code: "SHEG1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 4,
  region: "Egypt",
  zone: "Africa",
  interest: "History, Culture & Nile Cruise",
  packageType: "Customized Holiday",
  startingPrice: 181966,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Egypt", stops: ["Cairo (3N)", "Nile Cruise (3N)", "Cairo (1N)"] }],
  highlights: ["Pyramids of Giza", "Sphinx", "Egyptian Museum", "Khan El Khalili", "Alexandria", "Abu Simbel", "Kom Ombo", "Edfu", "Esna", "Luxor", "Three-night Nile cruise"],
  departureCity: "Cairo",
  departureCities: ["Cairo (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "breakfast in Cairo; full board on cruise; selected lunches and dinners", flight: false, sightseeing: "guided tours as per itinerary", transport: "airport, hotel and cruise transfers as per itinerary", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Cairo", state: "Egypt", desc: "Arrive in Cairo and settle into your hotel for the first of three nights.", nights: 3, highlights: ["Cairo"] },
    { day: 2, title: "Cairo · Pyramids, Sphinx, Museum & Khan El Khalili", state: "Egypt", desc: "Visit the Pyramids and Sphinx, explore the museum, and experience the Khan El Khalili bazaar with a private local guide.", highlights: ["Pyramids of Giza", "Sphinx", "Museum", "Khan El Khalili"] },
    { day: 3, title: "Full-day Alexandria tour", state: "Egypt", desc: "Take a full-day guided excursion to Alexandria and return to Cairo for the night.", highlights: ["Alexandria"] },
    { day: 4, title: "Cairo · Aswan · Nile cruise", state: "Egypt", desc: "Travel from Cairo to Aswan and board the Nile cruise for a three-night stay. The official itinerary lists the Cairo–Aswan transfer; confirm the transport mode when customizing.", nights: 3, highlights: ["Aswan", "Nile cruise"] },
    { day: 5, title: "Abu Simbel · Kom Ombo · Edfu", state: "Egypt", desc: "Visit Abu Simbel and continue along the Nile cruise itinerary via Kom Ombo to Edfu.", highlights: ["Abu Simbel", "Kom Ombo", "Edfu"] },
    { day: 6, title: "Edfu · Esna · Luxor", state: "Egypt", desc: "Continue the cruise from Edfu via Esna to Luxor, with guided sightseeing as listed in the itinerary.", highlights: ["Edfu", "Esna", "Luxor"] },
    { day: 7, title: "Luxor · Cairo", state: "Egypt", desc: "Travel from Luxor to Cairo and check in for the final overnight stay. Confirm the transfer mode while arranging the customized holiday.", nights: 1, highlights: ["Luxor", "Cairo"] },
    { day: 8, title: "Cairo · Hometown", state: "Egypt", desc: "Check out and continue to your onward departure from Cairo according to your confirmed arrangements." },
  ],
});

TOURS.push({
  slug: "amsterdam-brussels-paris-sheu23",
  title: "Amsterdam Brussels Paris",
  scope: "world",
  image: U("1512470876302-972faa2aa9a4"),
  gallery: [U("1512470876302-972faa2aa9a4"), U("1499856871958-5b9627545d1a"), U("1502602898657-3e91760cbb34")],
  code: "SHEU23",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 3,
  statesCount: 3,
  citiesCount: 3,
  region: "Netherlands, Belgium & France",
  zone: "Europe",
  interest: "City Breaks, Culture & European Rail",
  packageType: "Customized Holiday",
  startingPrice: 203517,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Netherlands", stops: ["Amsterdam"] }, { state: "Belgium", stops: ["Brussels"] }, { state: "France", stops: ["Paris"] }],
  highlights: ["Amsterdam", "Brussels", "Paris", "Three-country European holiday"],
  departureCity: "Amsterdam",
  departureCities: ["Amsterdam (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Amsterdam", state: "Netherlands", desc: "Arrive in Amsterdam and begin your customized stay. Hotel and arrival transfer details depend on the final plan." },
    { day: 2, title: "Explore Amsterdam", state: "Netherlands", desc: "Enjoy Amsterdam at your own pace or add sightseeing and activities to your customized itinerary." },
    { day: 3, title: "Amsterdam", state: "Netherlands", desc: "Continue exploring Amsterdam; optional museums, canal experiences and day trips can be selected while customizing." },
    { day: 4, title: "Amsterdam · Brussels", state: "Belgium", desc: "Travel onward to Brussels using the transport arranged in your confirmed holiday plan." },
    { day: 5, title: "Explore Brussels", state: "Belgium", desc: "Discover Brussels at your own pace. Sightseeing and local transfers depend on the inclusions selected for the customized holiday." },
    { day: 6, title: "Brussels · Paris", state: "France", desc: "Continue to Paris using the transport arranged in your confirmed holiday plan." },
    { day: 7, title: "Explore Paris", state: "France", desc: "Enjoy a day in Paris. Choose sightseeing and experiences with your travel advisor when finalizing the customized itinerary." },
    { day: 8, title: "Depart from Paris", state: "France", desc: "Check out and depart from Paris according to your confirmed onward travel arrangements." },
  ],
});

TOURS.push({
  slug: "finland-glass-igloo-stay-shfn5",
  title: "Finland Glass Igloo Stay",
  scope: "world",
  image: U("1483347756197-71ef80e95f73"),
  gallery: [U("1483347756197-71ef80e95f73"), U("1517299321609-52687d1bc55a"), U("1519681393784-d120267933ba")],
  code: "SHFN5",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Finland",
  zone: "Europe",
  interest: "Northern Lights, Arctic Adventure & Luxury Stays",
  packageType: "Customized Holiday",
  startingPrice: 193743,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Finland", stops: ["Kakslauttanen (3N)"] }],
  highlights: ["Traditional log chalet", "Glass igloo with shower and sauna", "Husky safari", "Reindeer sleigh ride", "Snowmobile safari", "Northern Lights experience", "Ivalo", "Kakslauttanen Arctic Resort"],
  departureCity: "Ivalo",
  departureCities: ["Ivalo (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "breakfast, lunch and dinner as per itinerary", flight: false, sightseeing: "shared husky safari, reindeer sleigh ride, snowmobile safari, resort visits and planetarium film", transport: "return shared airport shuttle transfers", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Ivalo · Kakslauttanen Arctic Resort", state: "Finland", desc: "Arrive at Ivalo Airport and take the included shared shuttle to Kakslauttanen Arctic Resort. Settle into a traditional log chalet for the first of two nights.", nights: 2, highlights: ["Ivalo", "Kakslauttanen", "Traditional log chalet"] },
    { day: 2, title: "Husky safari · Reindeer sleigh ride", state: "Finland", desc: "Enjoy the included shared two-hour husky safari and two-hour reindeer sleigh ride, each with a hot juice break around an open fire. Northern Lights viewing depends on weather and sky conditions.", highlights: ["Husky safari", "Reindeer sleigh ride", "Hot juice break"] },
    { day: 3, title: "Snowmobile safari · Glass igloo · Northern Lights experience", state: "Finland", desc: "Take the included shared two-hour snowmobile safari, visit the Art Gallery, Design Shops and Glass Igloo Tower, and watch a 30-minute Northern Lights film at the planetarium. Spend the night in a small glass igloo with shower and sauna.", nights: 1, highlights: ["Snowmobile safari", "Glass igloo", "Northern Lights planetarium film"] },
    { day: 4, title: "Kakslauttanen · Ivalo Airport · Departure", state: "Finland", desc: "Take the return shared shuttle to Ivalo Airport for your onward journey. Flight tickets are not included in the package.", highlights: ["Kakslauttanen", "Ivalo Airport"] },
  ],
});

TOURS.push({
  slug: "swiss-italy-sheu37",
  title: "Swiss Italy",
  scope: "world",
  image: U("1527668752968-14dc70a27c95"),
  gallery: [U("1527668752968-14dc70a27c95"), U("1514890547357-a9ee288728e0"), U("1533105079780-92b9be482077")],
  code: "SHEU37",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 9,
  nights: 8,
  countriesCount: 2,
  statesCount: 2,
  citiesCount: 5,
  region: "Switzerland & Italy",
  zone: "Europe",
  interest: "Alpine Scenery, Rail Journeys & Italian Cities",
  packageType: "Customized Holiday",
  startingPrice: 200984,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Switzerland", stops: ["Lucerne (3N)", "Zurich"] }, { state: "Italy", stops: ["Venice (2N)", "Florence (1N)", "Rome (2N)"] }],
  highlights: ["Four-day Swiss Travel Pass", "Mount Rigi", "Mount Titlis", "Venice walking tour", "Venice gondola ride", "Pisa and Leaning Tower tour", "Rome Hop-on Hop-off tour"],
  departureCity: "Zurich",
  departureCities: ["Zurich (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "breakfast as mentioned in itinerary", flight: false, sightseeing: "Mount Rigi, Mount Titlis, Venice walking tour and gondola ride, Pisa tour, Rome 24-hour Hop-on Hop-off", transport: "4-day second-class Swiss Travel Pass; second-class trains Venice–Florence–Rome", visa: false },
  itinerary: [
    { day: 1, title: "Zurich · Lucerne", state: "Switzerland", desc: "Arrive in Zurich and continue by direct train to Lucerne, approximately one hour. Check into your hotel for a three-night stay.", nights: 3, highlights: ["Zurich", "Lucerne"] },
    { day: 2, title: "Lucerne · Mount Rigi", state: "Switzerland", desc: "Take the included trip to Mount Rigi using your Swiss Travel Pass. Sightseeing runs at fixed times; arrive at the designated points promptly.", highlights: ["Mount Rigi", "Swiss Travel Pass"] },
    { day: 3, title: "Lucerne · Mount Titlis", state: "Switzerland", desc: "Visit Mount Titlis as included in the package. Check your confirmed vouchers for departure times and meeting point.", highlights: ["Mount Titlis"] },
    { day: 4, title: "Lucerne · Zurich · Venice", state: "Italy", desc: "Travel from Lucerne via Zurich to Venice and check in for a two-night stay. Confirm the specific rail and transfer arrangements in your service vouchers.", nights: 2, highlights: ["Zurich", "Venice"] },
    { day: 5, title: "Venice · Walking tour and gondola ride", state: "Italy", desc: "Explore Venice on the included walking tour and gondola ride. Gondola rides are shared, with a maximum of six guests per gondola.", highlights: ["Venice walking tour", "Gondola ride"] },
    { day: 6, title: "Venice · Florence · Pisa", state: "Italy", desc: "Take the direct train from Venice to Florence, approximately two hours and fifteen minutes. Visit Pisa and the Leaning Tower on the included tour, then stay overnight in Florence.", nights: 1, highlights: ["Florence", "Pisa", "Leaning Tower"] },
    { day: 7, title: "Florence · Rome", state: "Italy", desc: "Travel by direct train from Florence to Rome, approximately one hour and forty-five minutes. Check in for a two-night stay.", nights: 2, highlights: ["Florence", "Rome"] },
    { day: 8, title: "Rome · Hop-on Hop-off", state: "Italy", desc: "Explore Rome with the included 24-hour Hop-on Hop-off coach ticket. Sightseeing operates at fixed times; reach the designated points on time.", highlights: ["Rome", "24-hour Hop-on Hop-off tour"] },
    { day: 9, title: "Rome · Departure", state: "Italy", desc: "Check out and depart from Rome for your onward journey. Airport transfer and airfare are not listed among the package inclusions." },
  ],
});

TOURS.push({
  slug: "eastern-canada-shca12",
  title: "Eastern Canada",
  scope: "world",
  image: U("1517935706615-2717063c2225"),
  gallery: [U("1517935706615-2717063c2225"), U("1519178614-68673b201f36"), U("1519681393784-d120267933ba")],
  code: "SHCA12",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Canada",
  zone: "America",
  interest: "City Experiences, Culture & Scenic Rail",
  packageType: "Customized Holiday",
  startingPrice: 179432,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Canada", stops: ["Toronto", "Ottawa", "Montreal"] }],
  highlights: ["Toronto", "Ottawa", "Montreal", "Eastern Canada city experiences"],
  departureCity: "Toronto",
  departureCities: ["Toronto (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Toronto", state: "Canada", desc: "Arrive in Toronto and begin your customized Eastern Canada holiday. Confirm hotel and airport transfer arrangements in the final itinerary." },
    { day: 2, title: "Toronto", state: "Canada", desc: "Explore Toronto at your own pace or add sightseeing through your travel advisor. Activities and meals depend on the confirmed package." },
    { day: 3, title: "Toronto", state: "Canada", desc: "Continue your Toronto stay. This is a suggested outline only; confirm exact hotel nights and activities when customizing." },
    { day: 4, title: "Toronto · Ottawa", state: "Canada", desc: "Travel onward to Ottawa using the transfer selected for your customized holiday. Confirm departure times and station transfers in your vouchers." },
    { day: 5, title: "Ottawa", state: "Canada", desc: "Enjoy Ottawa at your own pace, with sightseeing and meals as arranged in your confirmed plan." },
    { day: 6, title: "Ottawa · Montreal", state: "Canada", desc: "Continue to Montreal using the transport selected for your customized holiday. Confirm the transfer arrangements before travel." },
    { day: 7, title: "Montreal", state: "Canada", desc: "Explore Montreal at your own pace or add local sightseeing to your customized itinerary." },
    { day: 8, title: "Montreal · Departure", state: "Canada", desc: "Check out and depart according to your confirmed onward travel arrangements. Exact route, overnight allocation and inclusions should be confirmed with Veena World." },
  ],
});

TOURS.push({
  slug: "jewels-of-morocco-shma4",
  title: "Jewels of Morocco",
  scope: "world",
  image: U("1539020140153-e479b8c22e70"),
  gallery: [U("1539020140153-e479b8c22e70"), U("1489749798305-4fea3ae63d43"), U("1518548419970-58e3b4079ab2")],
  code: "SHMA4",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 9,
  nights: 8,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 5,
  region: "Morocco",
  zone: "Africa",
  interest: "Culture, Imperial Cities & Desert Scenery",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Morocco", stops: ["Casablanca", "Rabat", "Fes", "Sahara region", "Marrakech"] }],
  highlights: ["Morocco's imperial cities", "Casablanca", "Rabat", "Fes", "Marrakech", "Sahara region", "Moroccan culture and architecture"],
  departureCity: "Casablanca",
  departureCities: ["Casablanca (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Casablanca", state: "Morocco", desc: "Arrive in Casablanca and start your customized Morocco holiday. Confirm hotel and airport transfer arrangements in the final plan." },
    { day: 2, title: "Casablanca · Rabat", state: "Morocco", desc: "Continue to Rabat and explore the capital according to your confirmed sightseeing plan." },
    { day: 3, title: "Rabat · Fes", state: "Morocco", desc: "Travel onward to Fes. Transport and stopovers depend on your finalized customized itinerary." },
    { day: 4, title: "Explore Fes", state: "Morocco", desc: "Discover Fes and its historic medina at a pace arranged with your travel advisor." },
    { day: 5, title: "Fes · Sahara region", state: "Morocco", desc: "Journey toward the Sahara region. The exact route, overnight location and desert activities need to be confirmed in your quotation." },
    { day: 6, title: "Sahara region · Ouarzazate", state: "Morocco", desc: "Continue through Morocco's desert and mountain scenery toward Ouarzazate, following the route chosen for your customized holiday." },
    { day: 7, title: "Ouarzazate · Marrakech", state: "Morocco", desc: "Travel onward to Marrakech and settle in according to your confirmed accommodation plan." },
    { day: 8, title: "Explore Marrakech", state: "Morocco", desc: "Enjoy Marrakech with sightseeing and activities selected for your customized itinerary." },
    { day: 9, title: "Departure from Morocco", state: "Morocco", desc: "Check out and depart according to your confirmed onward travel arrangements. This is a suggested route outline; verify the exact itinerary, nights, inclusions and price with Veena World." },
  ],
});


const queuedCustomizedTours = [
  ["discover-madagascar-shmg1","Discover Madagascar","SHMG1",7,6,"Madagascar","Africa",["Antananarivo","Morondava","Andasibe"],"Wildlife, nature and scenic drives","1530789253388-582c481c54b0"],
  ["classic-croatia-shcr3","Classic Croatia","SHCR3",7,6,"Croatia","Europe",["Zagreb","Split","Dubrovnik"],"Coastal scenery, history and culture","1513622470522-26c3c8a854bc"],
  ["best-of-russia-shru1","Best of Russia","SHRU1",7,6,"Russia","Europe",["Moscow","St Petersburg"],"Culture, architecture and city experiences","/assets/media/royal-moscow-st-basil.jpg"],
  ["honeymoon-in-maldives-shml45","Honeymoon in Maldives","SHML45",5,4,"Maldives","Asia",["Male","Maldives resort island"],"Romantic island escape and beach experiences","1514282401047-d79a71a590e8"],
  ["swiss-escape-shsw1","Swiss Escape","SHSW1",6,5,"Switzerland","Europe",["Zurich","Lucerne","Interlaken"],"Alpine scenery, lakes and city experiences","1531366936337-7c912a4589a7"],
  ["switzerland-with-glacier-3000-shsw2","Switzerland with Glacier 3000","SHSW2",7,6,"Switzerland","Europe",["Zurich","Lucerne","Interlaken","Montreux"],"Alpine scenery, mountains and glacier experiences","1531366936337-7c912a4589a7"],
  ["germany-with-black-forest-shge6","Germany with Black Forest","SHGE6",7,6,"Germany","Europe",["Frankfurt","Black Forest","Munich"],"Culture, landscapes and city experiences","1467269204594-9661b134dd2b"],
  ["theme-parks-of-orlando-shus7","Theme Parks of Orlando","SHUS7",5,4,"USA","America",["Orlando"],"Theme parks and family experiences","1504457047772-27faf1c00561"],
  ["new-york-niagara-falls-washington-dc-shus2","New York Niagara Falls Washington DC","SHUS2",7,6,"USA","America",["New York","Niagara Falls","Washington DC"],"Iconic cities, nature and landmarks","1496442226666-8d4d0e62e6e9"],
  ["great-southern-touring-route-self-drive-shau32","Great Southern Touring Route Self Drive","SHAU32",7,6,"Australia","Australia & New Zealand",["Melbourne","Great Ocean Road","Grampians"],"Self drive, coastal scenery and nature","1501594907352-04cda38ebc29"],
  ["gold-coast-cairns-great-barrier-reef-shau43","Gold Coast and Cairns with Great Barrier Reef","SHAU43",7,6,"Australia","Australia & New Zealand",["Gold Coast","Cairns"],"Coastal experiences, reef and city breaks","1530789253388-582c481c54b0"],
  ["perth-and-surrounds-shau27","Perth and Surrounds","SHAU27",5,4,"Australia","Australia & New Zealand",["Perth","Fremantle","Rottnest Island"],"Coastal scenery, nature and city experiences","1506973035872-a4ec16b8e8d9"],
  ["madrid-seville-barcelona-shsp7","Madrid Seville Barcelona","SHSP7",6,5,"Spain","Europe",["Madrid","Seville","Barcelona"],"Culture, architecture and city experiences","1539037116277-4db20889f2d4"],
  ["sydney-melbourne-shau31","Sydney Melbourne","SHAU31",7,6,"Australia","Australia & New Zealand",["Sydney","Melbourne"],"City experiences, coast and culture","1506973035872-a4ec16b8e8d9"],
  ["hong-kong-macau-getaway-shhk5","Hong Kong Macau Getaway","SHHK5",5,4,"Hong Kong and Macau","Asia",["Hong Kong","Macau"],"City experiences, culture and entertainment","1536599018102-9f803c140fc1"],
  ["melbourne-city-break-shau24","Melbourne City Break","SHAU24",6,5,"Australia","Australia & New Zealand",["Melbourne"],"City experiences, culture and food","1506973035872-a4ec16b8e8d9"],
  ["romantic-brisbane-with-whitsundays-shau38","Romantic Brisbane with Whitsundays","SHAU38",6,5,"Australia","Australia & New Zealand",["Brisbane","Whitsundays"],"Romantic coast, islands and city experiences","1506973035872-a4ec16b8e8d9"],
  ["paris-with-disneyland-stay-shfr1","Paris with Disneyland Stay","SHFR1",6,5,"France","Europe",["Paris","Disneyland Paris"],"Family fun, theme parks and city experiences","1507146426996-ef05306b995a"],
  ["highlights-of-chiang-mai-chiang-rai-shth31","Highlights of Chiang Mai Chiang Rai","SHTH31",7,6,"Thailand","Asia",["Chiang Mai","Chiang Rai"],"Culture, temples and scenic landscapes","1528181304800-259b08848526"],
  ["argentina-brazil-sham7","Argentina and Brazil","SHAM7",8,7,"Argentina and Brazil","America",["Buenos Aires","Iguazu Falls","Rio de Janeiro"],"Culture, natural wonders and city experiences","1516026672322-bc52d61a55d5"],
  ["istanbul-cappadocia-antalya-shtk14","Istanbul Cappadocia Antalya","SHTK14",7,6,"Turkey","Europe",["Istanbul","Cappadocia","Antalya"],"Culture, history and scenic landscapes","1524231757912-21f4fe3a7200"],
  ["chengdu-chongqing-shch4","Chengdu Chongqing","SHCH4",5,4,"China","Asia",["Chengdu","Chongqing"],"City experiences, culture and cuisine","1508804185872-d7badad00f7d"],
].map(([slug,title,code,days,nights,region,zone,cities,interest,image]) => {
  const stops = cities;
  const countryCount = code === "SHAM7" ? 2 : 1;
  return {
    slug, title, scope: "world", image: U(image),
    gallery: [U(image), U("1518548419970-58e3b4079ab2"), U("1480796927426-fbd5e5bf0a5f")],
    code, tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays",
    allInclusive: false, popularToday: false, days, nights,
    countriesCount: countryCount, statesCount: countryCount, citiesCount: stops.length,
    region, zone, interest, packageType: "Customized Holiday",
    startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
    route: [{ state: region, stops }],
    highlights: [...stops, interest],
    departureCity: stops[0], departureCities: [stops[0] + " (Joining/Leaving)"], dates: [],
    inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
    itinerary: Array.from({ length: days }, (_, index) => {
      const place = stops[Math.min(index, stops.length - 1)];
      const first = index === 0, last = index === days - 1;
      return {
        day: index + 1,
        title: first ? "Arrive in " + place : last ? "Depart from " + place : "Explore " + place,
        state: region,
        desc: first
          ? "Arrive and begin your customized " + title + " holiday. Confirm hotel and transfer arrangements in your final itinerary."
          : last
            ? "Check out and depart according to your confirmed onward travel arrangements. Verify the final itinerary, inclusions and price with Veena World."
            : "Enjoy " + place + " and continue your customized holiday. Sightseeing, meals, transport and overnight allocation depend on your confirmed itinerary.",
        highlights: [place],
      };
    }),
  };
});
TOURS.push(...queuedCustomizedTours);
TOURS.push({
  slug: "rome-florence-venice-shit1",
  title: "Rome Florence Venice",
  scope: "world",
  image: U("1533105079780-92b9be482077"),
  gallery: [U("1533105079780-92b9be482077"), U("1515542622106-78bda8ba0e5b"), U("1514890547357-a9ee288728e0")],
  code: "SHIT1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Italy",
  zone: "Europe",
  interest: "Culture, History & City Experiences",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Italy", stops: ["Rome", "Florence", "Venice"] }],
  highlights: ["Rome", "Florence", "Venice", "Italian culture, art and historic landmarks"],
  departureCity: "Rome",
  departureCities: ["Rome (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Rome", state: "Italy", desc: "Arrive in Rome and begin your customized Italy holiday. Confirm hotel and airport transfer arrangements in your final itinerary." },
    { day: 2, title: "Explore Rome", state: "Italy", desc: "Discover Rome's historic sights and neighborhoods according to the sightseeing plan selected for your customized holiday." },
    { day: 3, title: "Rome · Florence", state: "Italy", desc: "Travel from Rome to Florence using the transport arranged in your confirmed itinerary. Enjoy time in Florence." },
    { day: 4, title: "Explore Florence", state: "Italy", desc: "Explore Florence's art, architecture and historic center at a pace that fits your customized plan." },
    { day: 5, title: "Florence · Venice", state: "Italy", desc: "Continue from Florence to Venice using the transport confirmed for your holiday, then settle into your accommodation." },
    { day: 6, title: "Explore Venice", state: "Italy", desc: "Enjoy Venice and its canals, landmarks and neighborhoods. Exact activities and inclusions depend on your final itinerary." },
    { day: 7, title: "Depart from Venice", state: "Italy", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; confirm the exact itinerary, nights, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "romantic-sri-lanka-shsl16",
  title: "Romantic Sri Lanka",
  scope: "world",
  image: U("1524492412937-b28074a5d7da"),
  gallery: [U("1524492412937-b28074a5d7da"), U("1500530855697-b586d89ba3ee"), U("1518548419970-58e3b4079ab2")],
  code: "SHSL16",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Sri Lanka",
  zone: "Asia",
  interest: "Romance, Beaches & Culture",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Sri Lanka", stops: ["Colombo", "Kandy", "Bentota"] }],
  highlights: ["Colombo", "Kandy", "Bentota", "Sri Lankan culture and coastal experiences"],
  departureCity: "Colombo",
  departureCities: ["Colombo (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Colombo", state: "Sri Lanka", desc: "Arrive in Sri Lanka and begin your customized romantic holiday. Confirm your airport transfer and hotel arrangements in the final plan." },
    { day: 2, title: "Colombo · Kandy", state: "Sri Lanka", desc: "Travel inland toward Kandy. Stops, transport and overnight arrangements depend on your confirmed customized itinerary." },
    { day: 3, title: "Explore Kandy", state: "Sri Lanka", desc: "Enjoy Kandy's cultural sights and lakeside setting, with experiences selected for your customized holiday." },
    { day: 4, title: "Kandy and the hill country", state: "Sri Lanka", desc: "Spend the day exploring Kandy and nearby scenery at a relaxed pace. Confirm the specific activities and hotel with Veena World." },
    { day: 5, title: "Kandy · Bentota", state: "Sri Lanka", desc: "Continue toward the coast and Bentota. The route, stops and transfers depend on the final arrangements for your customized trip." },
    { day: 6, title: "Relax in Bentota", state: "Sri Lanka", desc: "Enjoy time on the coast and choose beach or river experiences according to your confirmed holiday plan." },
    { day: 7, title: "Bentota at leisure", state: "Sri Lanka", desc: "Spend another day at leisure on the coast or add activities selected for your customized itinerary." },
    { day: 8, title: "Depart from Sri Lanka", state: "Sri Lanka", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; confirm the exact route, hotels, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "singapore-with-sentosa-stay-shsg12",
  title: "Singapore with Sentosa Stay",
  scope: "world",
  image: U("1525625293386-3f8f99389edd"),
  gallery: [U("1525625293386-3f8f99389edd"), U("1513415277900-a62401e19be4"), U("1566073771259-6a8506099945")],
  code: "SHSG12",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Singapore",
  zone: "Asia",
  interest: "Family Fun, Theme Parks & City Experiences",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Singapore", stops: ["Singapore", "Sentosa Island"] }],
  highlights: ["Night Safari", "Singapore city tour", "Gardens by the Bay", "Sentosa Island", "Universal Studios Singapore", "Madame Tussauds", "Wings of Time", "SkyHelix"],
  departureCity: "Singapore",
  departureCities: ["Singapore (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Breakfast as mentioned in itinerary", flight: false, sightseeing: "Night Safari, half-day city tour, Gardens by the Bay, Universal Studios and listed Sentosa attractions", transport: "Private airport/hotel/Sentosa transfers; shared coach sightseeing", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Singapore · Night Safari", state: "Singapore", desc: "Arrive in Singapore and transfer to your hotel. Enjoy the Night Safari with admission and tram, as listed in the package inclusions." },
    { day: 2, title: "Singapore city tour · Gardens by the Bay", state: "Singapore", desc: "Take the half-day Singapore city tour and visit Gardens by the Bay, including the Flower Dome and Cloud Forest." },
    { day: 3, title: "Singapore at leisure", state: "Singapore", desc: "Enjoy time in Singapore at your own pace. Optional activities and any additional meals or sightseeing are not included unless confirmed separately." },
    { day: 4, title: "Singapore · Sentosa Island", state: "Singapore", desc: "Transfer to Sentosa Island for the second part of your stay. Enjoy the included one-way cable car and listed Sentosa experiences according to their fixed operating times." },
    { day: 5, title: "Sentosa Island · Universal Studios", state: "Singapore", desc: "Visit Universal Studios Singapore with standard admission. The package also lists Madame Tussauds Singapore, Wings of Time and SkyHelix on Sentosa." },
    { day: 6, title: "Depart from Singapore", state: "Singapore", desc: "Transfer to Singapore Airport for your onward journey. Flights, visa and travel insurance are excluded; verify final hotel and operating arrangements with Veena World." },
  ],
});
TOURS.push({
  slug: "enchanting-tuscany-shit7",
  title: "Enchanting Tuscany",
  scope: "world",
  image: U("1516483638261-f4dbaf036963"),
  gallery: [U("1516483638261-f4dbaf036963"), U("1533105079780-92b9be482077"), U("1515542622106-78bda8ba0e5b")],
  code: "SHIT7",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 6,
  nights: 5,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Italy",
  zone: "Europe",
  interest: "Tuscan Countryside, Art & Culture",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Italy", stops: ["Florence"] }],
  highlights: ["Florence", "Tuscany", "Art, architecture and countryside experiences"],
  departureCity: "Florence",
  departureCities: ["Florence (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Florence", state: "Italy", desc: "Arrive in Florence and begin your customized Tuscany holiday. Confirm airport transfers and hotel arrangements in your final itinerary." },
    { day: 2, title: "Discover Florence", state: "Italy", desc: "Explore Florence's historic center, art and architecture according to the sightseeing plan selected for your holiday." },
    { day: 3, title: "Tuscany countryside", state: "Italy", desc: "Enjoy a day to experience Tuscany beyond the city. Any excursion, transport and meals depend on your confirmed customized arrangements." },
    { day: 4, title: "Florence and Tuscany", state: "Italy", desc: "Continue discovering Florence or the surrounding Tuscan region at your preferred pace. Confirm the specific experiences with Veena World." },
    { day: 5, title: "Leisure in Florence", state: "Italy", desc: "Enjoy a flexible day for further sightseeing, shopping or a selected excursion. Activities are subject to the finalized itinerary." },
    { day: 6, title: "Depart from Florence", state: "Italy", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; verify the exact itinerary, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "best-of-dubai-shdz34",
  title: "Best of Dubai",
  scope: "world",
  image: U("1512453979798-5ea266f8880c"),
  gallery: [U("1512453979798-5ea266f8880c"), U("1518684079-3c830dcef090"), U("1512632578888-169bbbc64f33")],
  code: "SHDZ34",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "United Arab Emirates",
  zone: "Middle East",
  interest: "City Experiences, Desert Safari & Theme Parks",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "United Arab Emirates", stops: ["Dubai", "Abu Dhabi"] }],
  highlights: ["Marina Dhow Cruise", "Dubai city tour", "Burj Khalifa 124th floor", "Dubai Aquarium & Underwater Zoo", "Desert Safari with BBQ dinner", "Dubai Frame", "Museum of the Future", "Abu Dhabi city tour", "Ferrari World", "The View at the Palm"],
  departureCity: "Dubai",
  departureCities: ["Dubai (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Breakfast; buffet dinner on Marina Dhow Cruise and BBQ dinner on Desert Safari", flight: false, sightseeing: "Dubai city tour, Burj Khalifa, Aquarium, Desert Safari, Dubai Frame, Museum of the Future, Abu Dhabi city tour with Ferrari World, View at the Palm", transport: "Return airport transfers and shared coach transfers/sightseeing", visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Dubai · Marina Dhow Cruise", state: "United Arab Emirates", desc: "Arrive at Dubai International Airport and transfer to your hotel. In the evening, enjoy the Marina Dhow Cruise with buffet dinner." },
    { day: 2, title: "Dubai city tour · Burj Khalifa · Aquarium", state: "United Arab Emirates", desc: "Take a half-day Dubai city tour, visit the 124th floor of Burj Khalifa during a non-prime slot, and explore Dubai Aquarium & Underwater Zoo." },
    { day: 3, title: "Desert Safari with BBQ dinner", state: "United Arab Emirates", desc: "Experience the included standard desert safari in a shared four-wheel-drive vehicle, followed by a BBQ dinner." },
    { day: 4, title: "Dubai Frame · Museum of the Future", state: "United Arab Emirates", desc: "Visit Dubai Frame and the Museum of the Future according to the scheduled sightseeing arrangements." },
    { day: 5, title: "Abu Dhabi city tour · Ferrari World", state: "United Arab Emirates", desc: "Join the Abu Dhabi city tour with a visit to Ferrari World. Transfers and sightseeing operate on a shared coach basis." },
    { day: 6, title: "The View at the Palm", state: "United Arab Emirates", desc: "Visit The View at the Palm during a non-prime slot, with return transfer on a shared basis. Enjoy the remainder of the day at leisure." },
    { day: 7, title: "Depart from Dubai", state: "United Arab Emirates", desc: "Check out and transfer to Dubai International Airport for your onward flight. Airfare, travel insurance and Tourism Dirham fee are excluded; verify current terms with Veena World." },
  ],
});
TOURS.push({
  slug: "abu-dhabi-with-yas-island-stay-shdz7",
  title: "Abu Dhabi with Yas Island Stay",
  scope: "world",
  image: U("1512632578888-169bbbc64f33"),
  gallery: [U("1512632578888-169bbbc64f33"), U("1518684079-3c830dcef090"), U("1533105079780-92b9be482077")],
  code: "SHDZ7",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "United Arab Emirates",
  zone: "Middle East",
  interest: "Theme Parks, Culture & Family Experiences",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "United Arab Emirates", stops: ["Abu Dhabi", "Yas Island"] }],
  highlights: ["Yas Island", "One Yas Island park of your choice", "Abu Dhabi city tour", "BAPS Hindu Mandir"],
  departureCity: "Abu Dhabi",
  departureCities: ["Abu Dhabi (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Breakfast as specified in itinerary", flight: false, sightseeing: "One Yas Island park and Abu Dhabi city tour including BAPS Hindu Mandir", transport: "Shared airport transfers and shared coach transfers/sightseeing", visa: true },
  itinerary: [
    { day: 1, title: "Arrive in Abu Dhabi", state: "United Arab Emirates", desc: "Arrive at Abu Dhabi International Airport and transfer to your Yas Island hotel on a shared basis. Breakfast is included as specified in the itinerary." },
    { day: 2, title: "Yas Island · Choose one park", state: "United Arab Emirates", desc: "Enjoy admission to any one Yas Island park included with the package. Confirm the selected park and visit arrangements when booking." },
    { day: 3, title: "Abu Dhabi city tour · BAPS Hindu Mandir", state: "United Arab Emirates", desc: "Join the Abu Dhabi city tour, including BAPS Hindu Mandir. The temple is closed on Mondays; sightseeing operates at fixed timings on a shared coach basis." },
    { day: 4, title: "Depart from Abu Dhabi", state: "United Arab Emirates", desc: "Transfer to Abu Dhabi International Airport for your onward journey. Airfare, Tourism Dirham fee, OTB and optional sightseeing are excluded; confirm current inclusions with Veena World." },
  ],
});
TOURS.push({
  slug: "victoria-falls-zimbabwe-shzb1",
  title: "Victoria Falls - Zimbabwe",
  scope: "world",
  image: U("1504432842672-1a79f78e4084"),
  gallery: [U("1504432842672-1a79f78e4084"), U("1516026672322-bc52d61a55d5"), U("1530789253388-582c481c54b0")],
  code: "SHZB1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Zimbabwe",
  zone: "Africa",
  interest: "Nature, Waterfalls & Adventure",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Zimbabwe", stops: ["Victoria Falls"] }],
  highlights: ["Victoria Falls", "Zambezi River", "Zimbabwean culture and nature"],
  departureCity: "Victoria Falls",
  departureCities: ["Victoria Falls (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Victoria Falls", state: "Zimbabwe", desc: "Arrive in Victoria Falls and begin your customized Zimbabwe holiday. Confirm airport transfers and hotel arrangements in your final itinerary." },
    { day: 2, title: "Discover Victoria Falls", state: "Zimbabwe", desc: "Explore the Victoria Falls area and its spectacular natural scenery. Guided visits and park fees depend on the inclusions confirmed for your holiday." },
    { day: 3, title: "Victoria Falls at leisure", state: "Zimbabwe", desc: "Enjoy a flexible day for experiences around Victoria Falls or the Zambezi River. Optional activities and transfers should be confirmed with Veena World." },
    { day: 4, title: "Depart from Victoria Falls", state: "Zimbabwe", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; verify the exact itinerary, inclusions, visa arrangements and price with Veena World." },
  ],
});
TOURS.push({
  slug: "munich-and-surrounds-shge8",
  title: "Munich and Surrounds",
  scope: "world",
  image: U("1470225620780-dba8ba36b745"),
  gallery: [U("1470225620780-dba8ba36b745"), U("1467269204594-9661b134dd2b"), U("1519671482749-fd09be7ccebf")],
  code: "SHGE8",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Germany",
  zone: "Europe",
  interest: "City Experiences, Culture & Bavarian Scenery",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Germany", stops: ["Munich"] }],
  highlights: ["Munich", "Bavarian culture", "Surrounding region and scenic excursions"],
  departureCity: "Munich",
  departureCities: ["Munich (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Munich", state: "Germany", desc: "Arrive in Munich and begin your customized Germany holiday. Confirm airport transfers and hotel arrangements in your final itinerary." },
    { day: 2, title: "Discover Munich", state: "Germany", desc: "Explore Munich's historic center and Bavarian landmarks according to the sightseeing and transport arrangements selected for your trip." },
    { day: 3, title: "Explore the Munich region", state: "Germany", desc: "Enjoy a day to discover Munich or its surroundings. Any excursion, entrance fees and transport depend on your confirmed customized itinerary." },
    { day: 4, title: "Munich at leisure", state: "Germany", desc: "Spend the day at leisure or choose additional experiences in the region. Confirm activities and meal arrangements with Veena World." },
    { day: 5, title: "Depart from Munich", state: "Germany", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; verify the exact itinerary, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "adaaran-club-rannalhi-maldives-shml8",
  title: "Adaaran Club Rannalhi Maldives",
  scope: "world",
  image: U("1514282401047-d79a71a590e8"),
  gallery: [U("1514282401047-d79a71a590e8"), U("1500375592092-40eb2168fd21"), U("1519046904884-53103b34b206")],
  code: "SHML8",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 4,
  nights: 3,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Maldives",
  zone: "Asia",
  interest: "Island Escape, Beaches & Relaxation",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Maldives", stops: ["Adaaran Club Rannalhi"] }],
  highlights: ["Adaaran Club Rannalhi", "Maldives island stay", "Beach and lagoon scenery"],
  departureCity: "Malé",
  departureCities: ["Malé (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "Resort stay; activities as selected", transport: "Confirm airport-to-resort transfer arrangements", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Malé · Transfer to the resort", state: "Maldives", desc: "Arrive in Malé and continue to Adaaran Club Rannalhi. Confirm the transfer mode, timing and resort check-in arrangements with Veena World." },
    { day: 2, title: "Relax at Adaaran Club Rannalhi", state: "Maldives", desc: "Enjoy a day at the resort and its island setting. Meals, activities and any resort inclusions depend on the final package selected." },
    { day: 3, title: "Leisure day in the Maldives", state: "Maldives", desc: "Spend the day at leisure or choose resort activities. Confirm any activity costs and meal plan before travel." },
    { day: 4, title: "Depart from the Maldives", state: "Maldives", desc: "Check out and transfer to Malé for your onward journey. This is a suggested outline; confirm the exact inclusions, transfer mode, room type and current price with Veena World." },
  ],
});
TOURS.push({
  slug: "malaysia-singapore-shas14",
  title: "Malaysia Singapore",
  scope: "world",
  image: U("1525625293386-3f8f99389edd"),
  gallery: [U("1525625293386-3f8f99389edd"), U("1506939379742-1f9437c1a8c6"), U("1513415277900-a62401e19be4")],
  code: "SHAS14",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 8,
  nights: 7,
  countriesCount: 2,
  statesCount: 2,
  citiesCount: 2,
  region: "Malaysia and Singapore",
  zone: "Asia",
  interest: "City Experiences, Culture & Family Attractions",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [
    { state: "Malaysia", stops: ["Kuala Lumpur"] },
    { state: "Singapore", stops: ["Singapore"] },
  ],
  highlights: ["Kuala Lumpur", "Singapore", "City sightseeing", "Sentosa Island", "Theme park and wildlife experiences"],
  departureCity: "Kuala Lumpur",
  departureCities: ["Kuala Lumpur (Joining)", "Singapore (Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected for customized holiday", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Kuala Lumpur", state: "Malaysia", desc: "Arrive in Kuala Lumpur and transfer to your hotel. Settle in and enjoy the rest of the day at leisure." },
    { day: 2, title: "Discover Kuala Lumpur", state: "Malaysia", desc: "Explore Kuala Lumpur with sightseeing selected for your customized holiday. Confirm attraction entry tickets and transfer arrangements in your final plan." },
    { day: 3, title: "Kuala Lumpur at leisure", state: "Malaysia", desc: "Enjoy a flexible day in Kuala Lumpur. Optional excursions and their costs depend on the arrangements confirmed with Veena World." },
    { day: 4, title: "Kuala Lumpur · Singapore", state: "Singapore", desc: "Continue to Singapore. The inter-country transfer method and its cost must be confirmed as part of your customized holiday." },
    { day: 5, title: "Explore Singapore", state: "Singapore", desc: "Discover Singapore's city sights and neighborhoods according to the sightseeing plan selected for your holiday." },
    { day: 6, title: "Sentosa Island", state: "Singapore", desc: "Spend time on Sentosa Island and choose attractions that fit your customized itinerary. Confirm admission tickets and transfers before travel." },
    { day: 7, title: "Singapore at leisure", state: "Singapore", desc: "Enjoy another day in Singapore for leisure or additional sightseeing selected for your trip." },
    { day: 8, title: "Depart from Singapore", state: "Singapore", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; confirm exact nights by city, inter-country transport, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "romantic-bali-shib27",
  title: "Romantic Bali",
  scope: "world",
  image: U("1537996194471-e657df975ab4"),
  gallery: [U("1537996194471-e657df975ab4"), U("1518548419970-58e3b4079ab2"), U("1519046904884-53103b34b206")],
  code: "SHIB27",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Indonesia",
  zone: "Asia",
  interest: "Romance, Island Life & Culture",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Indonesia", stops: ["Bali"] }],
  highlights: ["Bali", "Tropical beaches", "Balinese culture", "Romantic island experiences"],
  departureCity: "Denpasar",
  departureCities: ["Denpasar (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected for customized holiday", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Bali", state: "Indonesia", desc: "Arrive in Bali and begin your customized romantic holiday. Confirm your airport transfer and hotel arrangements in the final itinerary." },
    { day: 2, title: "Discover Bali", state: "Indonesia", desc: "Enjoy the island at a relaxed pace and explore experiences selected for your customized holiday." },
    { day: 3, title: "Bali at leisure", state: "Indonesia", desc: "Spend the day together at leisure or choose cultural, scenic or beach activities according to your confirmed itinerary." },
    { day: 4, title: "Explore Bali", state: "Indonesia", desc: "Discover more of Bali with sightseeing and transport arranged for your customized trip. Confirm specific attractions and costs with Veena World." },
    { day: 5, title: "Bali at leisure", state: "Indonesia", desc: "Enjoy a flexible day for the beach, relaxation or optional activities selected for your holiday." },
    { day: 6, title: "A final day in Bali", state: "Indonesia", desc: "Spend your last full day at leisure or add experiences confirmed with your travel advisor." },
    { day: 7, title: "Depart from Bali", state: "Indonesia", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; confirm exact inclusions, hotel, activities and price with Veena World." },
  ],
});
TOURS.push({
  slug: "mauritius-with-anelia-resort-and-spa-shmu14",
  title: "Mauritius with Anelia Resort & Spa",
  scope: "world",
  image: U("1514282401047-d79a71a590e8"),
  gallery: [U("1514282401047-d79a71a590e8"), U("1500375592092-40eb2168fd21"), U("1519046904884-53103b34b206")],
  code: "SHMU14",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Mauritius",
  zone: "Africa",
  interest: "Island Escape, Beaches & Relaxation",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Mauritius", stops: ["Anelia Resort & Spa"] }],
  highlights: ["Anelia Resort & Spa", "Mauritius island stay", "Beach and resort experiences"],
  departureCity: "Mauritius",
  departureCities: ["Mauritius (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Mauritius", state: "Mauritius", desc: "Arrive in Mauritius and transfer to Anelia Resort & Spa according to your confirmed arrangements. Settle in and enjoy the rest of the day at leisure." },
    { day: 2, title: "Relax at Anelia Resort & Spa", state: "Mauritius", desc: "Enjoy the resort and its beachside setting. Confirm the meal plan and included resort facilities in your booking details." },
    { day: 3, title: "Discover Mauritius", state: "Mauritius", desc: "Enjoy time at leisure or choose an island excursion arranged for your customized holiday. Excursions and their costs depend on your final plan." },
    { day: 4, title: "Mauritius at leisure", state: "Mauritius", desc: "Spend the day relaxing at the resort or exploring the island according to activities selected for your trip." },
    { day: 5, title: "Explore the island", state: "Mauritius", desc: "Enjoy another flexible day for resort time or sightseeing. Confirm transfers, entrance fees and meal arrangements with Veena World." },
    { day: 6, title: "A final day in Mauritius", state: "Mauritius", desc: "Spend your last full day at leisure and enjoy the resort. Optional experiences are subject to your confirmed itinerary." },
    { day: 7, title: "Depart from Mauritius", state: "Mauritius", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; verify current hotel, meals, transfers, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "mauritius-with-laguna-beach-hotel-and-spa-shmu3",
  title: "Mauritius with Laguna Beach Hotel & Spa",
  scope: "world",
  image: U("1514282401047-d79a71a590e8"),
  gallery: [U("1514282401047-d79a71a590e8"), U("1500375592092-40eb2168fd21"), U("1519046904884-53103b34b206")],
  code: "SHMU3",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 7,
  nights: 6,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Mauritius",
  zone: "Africa",
  interest: "Island Escape, Beaches & Relaxation",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Mauritius", stops: ["Laguna Beach Hotel & Spa"] }],
  highlights: ["Laguna Beach Hotel & Spa", "Mauritius island stay", "Beach and resort experiences"],
  departureCity: "Mauritius",
  departureCities: ["Mauritius (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Mauritius", state: "Mauritius", desc: "Arrive in Mauritius and transfer to Laguna Beach Hotel & Spa according to your confirmed arrangements. Settle in and enjoy the rest of the day at leisure." },
    { day: 2, title: "Relax at Laguna Beach Hotel & Spa", state: "Mauritius", desc: "Enjoy the resort and its coastal setting. Confirm the meal plan and included resort facilities in your booking details." },
    { day: 3, title: "Discover Mauritius", state: "Mauritius", desc: "Enjoy time at leisure or select an island excursion for your customized holiday. Excursions and their costs depend on your final plan." },
    { day: 4, title: "Mauritius at leisure", state: "Mauritius", desc: "Spend the day relaxing at the resort or exploring the island according to activities selected for your trip." },
    { day: 5, title: "Explore the island", state: "Mauritius", desc: "Enjoy a flexible day for resort time or sightseeing. Confirm transfers, entrance fees and meal arrangements with Veena World." },
    { day: 6, title: "A final day in Mauritius", state: "Mauritius", desc: "Spend your last full day at leisure and enjoy the resort. Optional experiences are subject to your confirmed itinerary." },
    { day: 7, title: "Depart from Mauritius", state: "Mauritius", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; verify current hotel, meals, transfers, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "taipei-and-surrounds-shtw1",
  title: "Taipei and Surrounds",
  scope: "world",
  image: U("1470004914212-05527e49370b"),
  gallery: [U("1470004914212-05527e49370b"), U("1493976040374-85c8e12f0c0e"), U("1513415277900-a62401e19be2")],
  code: "SHTW1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Taiwan",
  zone: "Asia",
  interest: "City Experiences, Culture & Scenic Day Trips",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Taiwan", stops: ["Taipei"] }],
  highlights: ["Taipei", "Taipei 101", "Taiwanese culture and cuisine", "Surrounding scenic destinations"],
  departureCity: "Taipei",
  departureCities: ["Taipei (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "as selected for customized holiday", flight: false, sightseeing: "as selected for customized holiday", transport: "as selected for customized holiday", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Taipei", state: "Taiwan", desc: "Arrive in Taipei and begin your customized Taiwan holiday. Confirm airport transfers and hotel arrangements in your final itinerary." },
    { day: 2, title: "Discover Taipei", state: "Taiwan", desc: "Explore Taipei's city sights, markets and cultural landmarks according to the sightseeing plan selected for your holiday." },
    { day: 3, title: "Taipei and its surroundings", state: "Taiwan", desc: "Enjoy a day in or around Taipei. Scenic excursions and attractions such as the north coast or historic villages depend on the plan confirmed with Veena World." },
    { day: 4, title: "Taipei at leisure", state: "Taiwan", desc: "Spend a flexible day exploring at your own pace or choosing additional activities for your customized trip." },
    { day: 5, title: "Depart from Taipei", state: "Taiwan", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline; verify exact itinerary, inclusions and price with Veena World." },
  ],
});TOURS.push({
  slug: "highlights-of-peru-shpr2",
  title: "Highlights of Peru",
  scope: "world",
  image: U("1464822759023-fed622ff2c3b"),
  gallery: [U("1464822759023-fed622ff2c3b"), U("1531065208531-8f74b2f160fa"), U("1516026672322-bc52d61a55d5")],
  code: "SHPR2",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 2,
  region: "Peru",
  zone: "America",
  interest: "Culture, History & Scenic Experiences",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Peru", stops: ["Lima", "Cusco"] }],
  highlights: ["Lima", "Cusco", "Peruvian culture and cuisine", "Optional Machu Picchu excursion — confirm availability and inclusion"],
  departureCity: "Lima",
  departureCities: ["Lima (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Lima", state: "Peru", desc: "Arrive in Lima and settle into your hotel according to your confirmed arrangements. Enjoy the rest of the day at leisure." },
    { day: 2, title: "Discover Lima", state: "Peru", desc: "Explore Lima's historic and contemporary character according to the sightseeing plan selected for your customized holiday." },
    { day: 3, title: "Travel to Cusco", state: "Peru", desc: "Continue to Cusco as arranged in your confirmed itinerary. Allow time to settle in and adjust to the altitude; transport and flights must be confirmed with Veena World." },
    { day: 4, title: "Explore Cusco", state: "Peru", desc: "Enjoy Cusco's culture and historic sights, or choose an excursion such as Machu Picchu if it is available and included in your final plan." },
    { day: 5, title: "Depart Peru", state: "Peru", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline based on the listed 5-day, 2-city holiday; verify the exact route, inclusions and price with Veena World." },
  ],
});TOURS.push({
  slug: "frankfurt-christmas-cruise-sheu52",
  title: "Frankfurt Christmas Cruise",
  scope: "world",
  image: U("1467269204594-9661b134dd2b"),
  gallery: [U("1467269204594-9661b134dd2b"), U("1512389142860-9c449e58a543"), U("1513622470522-26c3c8a854bc")],
  code: "SHEU52",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 1,
  region: "Germany",
  zone: "Europe",
  interest: "Christmas Markets, River Cruise & City Experiences",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Germany", stops: ["Frankfurt"] }],
  highlights: ["Frankfurt", "Christmas season experiences", "Cruise experience — route and inclusions to be confirmed"],
  departureCity: "Frankfurt",
  departureCities: ["Frankfurt (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm transfers and cruise arrangements with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Frankfurt", state: "Germany", desc: "Arrive in Frankfurt and check in according to your confirmed arrangements. Enjoy the rest of the day at leisure." },
    { day: 2, title: "Discover Frankfurt", state: "Germany", desc: "Explore Frankfurt at your own pace or choose city sightseeing for your customized holiday. Confirm all activities and transfers in your final itinerary." },
    { day: 3, title: "Christmas season and cruise experience", state: "Germany", desc: "Enjoy the seasonal atmosphere and cruise experience included in your confirmed plan. The cruise route, sailing schedule and inclusions should be verified with Veena World." },
    { day: 4, title: "Frankfurt at leisure", state: "Germany", desc: "Spend a flexible day in Frankfurt for additional sightseeing or seasonal activities selected for your customized holiday." },
    { day: 5, title: "Depart from Frankfurt", state: "Germany", desc: "Check out and depart according to your onward travel arrangements. This suggested outline follows the published 5-day, 1-city package; confirm exact itinerary, cruise details, inclusions and price with Veena World." },
  ],
});TOURS.push({
  slug: "glimpses-of-jordan-shjr1",
  title: "Glimpses of Jordan",
  scope: "world",
  image: U("1533929736458-ca588d08c8be"),
  gallery: [U("1533929736458-ca588d08c8be"), U("1579606037247-7e8a4ab06c27"), U("1544735716-392fe2489ffa")],
  code: "SHJR1",
  tourType: "CUSTOMIZED HOLIDAYS",
  speciality: "Customized Holidays",
  allInclusive: false,
  popularToday: false,
  days: 5,
  nights: 4,
  countriesCount: 1,
  statesCount: 1,
  citiesCount: 3,
  region: "Jordan",
  zone: "Middle East",
  interest: "Ancient History, Archaeology & Desert Scenery",
  packageType: "Customized Holiday",
  startingPrice: null,
  emiPerMonth: null,
  rating: null,
  reviewsCount: 0,
  route: [{ state: "Jordan", stops: ["Amman", "Petra", "Dead Sea"] }],
  highlights: ["Amman", "Petra", "Dead Sea", "Jordan's historic and desert landscapes"],
  departureCity: "Amman",
  departureCities: ["Amman (Joining/Leaving)"],
  dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Amman", state: "Jordan", desc: "Arrive in Amman and check in according to your confirmed arrangements. Enjoy the rest of the day at leisure." },
    { day: 2, title: "Explore Amman", state: "Jordan", desc: "Discover Amman's historic and modern character, with sightseeing selected for your customized holiday." },
    { day: 3, title: "Journey to Petra", state: "Jordan", desc: "Travel through Jordan toward Petra. Stops and sightseeing en route, such as Madaba or Mount Nebo, depend on your final itinerary." },
    { day: 4, title: "Discover Petra", state: "Jordan", desc: "Explore Petra's archaeological landscape according to the sightseeing plan confirmed with Veena World. Any onward visit to the Dead Sea or Wadi Rum is subject to your selected route." },
    { day: 5, title: "Depart Jordan", state: "Jordan", desc: "Check out and depart according to your onward travel arrangements. This is a suggested outline based on the published 5-day, 3-city holiday; confirm the exact route, inclusions and price with Veena World." },
  ],
});TOURS.push({
  slug: "singapore-family-fun-shsg11", title: "Singapore Family Fun", scope: "world",
  image: U("1525625293386-3f8f99389edd"), gallery: [U("1525625293386-3f8f99389edd"), U("1496939376851-89342e90adcd"), U("1508964942454-1a56651d54ac")],
  code: "SHSG11", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 5, nights: 4, countriesCount: 1, statesCount: 1, citiesCount: 1, region: "Singapore", zone: "Asia", interest: "Family Fun, Attractions & City Experiences", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Singapore", stops: ["Singapore (4N)"] }], highlights: ["Half-day Singapore city tour", "Night Safari", "Gardens by the Bay", "Sentosa Island", "Universal Studios Singapore"], departureCity: "Singapore", departureCities: ["Singapore (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Breakfast as specified", flight: false, sightseeing: "City tour, Night Safari, Gardens by the Bay, Sentosa and Universal Studios as listed", transport: "Shared coach sightseeing and return airport transfers; confirm final details", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Singapore", state: "Singapore", desc: "Arrive in Singapore, transfer to your hotel and settle in for your four-night stay." },
    { day: 2, title: "City tour and Night Safari", state: "Singapore", desc: "Enjoy a half-day city tour followed by the Night Safari experience, including tram, as listed in the package." },
    { day: 3, title: "Gardens by the Bay and Sentosa", state: "Singapore", desc: "Visit Gardens by the Bay and spend time on Sentosa, with the included cable car, Madame Tussauds, Wings of Time and SkyHelix experiences, subject to the final schedule." },
    { day: 4, title: "Universal Studios Singapore", state: "Singapore", desc: "Enjoy a full day at Universal Studios Singapore with the standard admission ticket included in the package." },
    { day: 5, title: "Singapore · Departure", state: "Singapore", desc: "Check out and transfer to the airport for your onward journey. Confirm shared transfer timings and inclusions in your booking." },
  ],
});
TOURS.push({
  slug: "best-of-bali-shib23", title: "Best of Bali", scope: "world",
  image: U("1537996194471-e657df975ab4"), gallery: [U("1537996194471-e657df975ab4"), U("1518548419970-58e3b4079ab2"), U("1533105079780-92b9be482077")],
  code: "SHIB23", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 7, nights: 6, countriesCount: 1, statesCount: 1, citiesCount: 1, region: "Bali", zone: "Asia", interest: "Island Culture, Beaches & Scenic Experiences", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Indonesia", stops: ["Bali"] }], highlights: ["Bali island stay", "Ubud and Kuta experiences", "Temples, beaches and local culture"], departureCity: "Bali", departureCities: ["Bali (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Bali", state: "Indonesia", desc: "Arrive in Bali and transfer to your selected accommodation according to your confirmed arrangements." },
    { day: 2, title: "Discover Bali", state: "Indonesia", desc: "Explore Bali's culture and scenery with activities chosen for your customized holiday." },
    { day: 3, title: "Temples and local experiences", state: "Indonesia", desc: "Choose from island excursions, temples or local experiences available for your selected plan." },
    { day: 4, title: "Bali at leisure", state: "Indonesia", desc: "Enjoy a flexible day for beaches, markets or relaxation. Optional activities depend on your final itinerary." },
    { day: 5, title: "Explore the island", state: "Indonesia", desc: "Continue discovering Bali at your own pace or add excursions arranged through Veena World." },
    { day: 6, title: "Bali at leisure", state: "Indonesia", desc: "Spend another day enjoying the island and experiences confirmed for your trip." },
    { day: 7, title: "Depart from Bali", state: "Indonesia", desc: "Check out and depart according to your onward travel arrangements. Confirm the exact itinerary, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "honeymoon-special-bali-shib24", title: "Honeymoon Special Bali", scope: "world",
  image: U("1537996194471-e657df975ab4"), gallery: [U("1537996194471-e657df975ab4"), U("1518548419970-58e3b4079ab2"), U("1533105079780-92b9be482077")],
  code: "SHIB24", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 7, nights: 6, countriesCount: 1, statesCount: 1, citiesCount: 1, region: "Bali", zone: "Asia", interest: "Romantic Island Escape & Beach Experiences", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Indonesia", stops: ["Bali"] }], highlights: ["Bali island stay", "Romantic beach experiences", "Private experiences and excursions as selected"], departureCity: "Bali", departureCities: ["Bali (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Bali", state: "Indonesia", desc: "Arrive in Bali and settle into your selected accommodation. Transfers and hotel arrangements follow your confirmed plan." },
    { day: 2, title: "A day for two in Bali", state: "Indonesia", desc: "Enjoy a relaxed day together or choose a romantic experience included in your final customized itinerary." },
    { day: 3, title: "Discover Bali", state: "Indonesia", desc: "Explore the island's temples, landscapes or local culture through excursions selected for your trip." },
    { day: 4, title: "Bali at leisure", state: "Indonesia", desc: "Spend the day relaxing or enjoying the experiences arranged for your honeymoon holiday." },
    { day: 5, title: "Island experiences", state: "Indonesia", desc: "Choose beach time or an optional excursion, subject to availability and your confirmed arrangements." },
    { day: 6, title: "A final full day in Bali", state: "Indonesia", desc: "Enjoy another flexible day together and confirm any activities with your travel advisor." },
    { day: 7, title: "Depart from Bali", state: "Indonesia", desc: "Check out and depart according to your onward travel arrangements. Confirm the exact itinerary, inclusions and price with Veena World." },
  ],
});
TOURS.push({
  slug: "dubai-with-miracle-garden-shdz31", title: "Dubai with Miracle Garden", scope: "world",
  image: U("1512453979798-5ea266f8880c"), gallery: [U("1512453979798-5ea266f8880c"), U("1518684079-3c830dce4c1a"), U("1512632578888-169bbbc64f33")],
  code: "SHDZ31", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 6, nights: 5, countriesCount: 1, statesCount: 1, citiesCount: 1, region: "Dubai", zone: "Middle East", interest: "City Experiences, Gardens & Attractions", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "United Arab Emirates", stops: ["Dubai (5N)"] }], highlights: ["Dubai", "Dubai Miracle Garden", "City and leisure experiences"], departureCity: "Dubai", departureCities: ["Dubai (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday; confirm Miracle Garden operating dates", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Dubai", state: "United Arab Emirates", desc: "Arrive in Dubai and check in according to your confirmed arrangements." },
    { day: 2, title: "Discover Dubai", state: "United Arab Emirates", desc: "Explore Dubai's city sights with activities chosen for your customized holiday." },
    { day: 3, title: "Visit Miracle Garden", state: "United Arab Emirates", desc: "Visit Dubai Miracle Garden if open during your travel dates; confirm entry and transfer arrangements in your final itinerary." },
    { day: 4, title: "Dubai at leisure", state: "United Arab Emirates", desc: "Enjoy a flexible day for additional sightseeing, shopping or relaxation." },
    { day: 5, title: "Explore Dubai", state: "United Arab Emirates", desc: "Continue exploring the city or select optional experiences for your customized trip." },
    { day: 6, title: "Depart from Dubai", state: "United Arab Emirates", desc: "Check out and depart according to your onward travel arrangements. Confirm exact itinerary and inclusions with Veena World." },
  ],
});
TOURS.push({
  slug: "phuket-krabi-bangkok-shth32", title: "Phuket Krabi Bangkok", scope: "world",
  image: U("1528181304800-259b08848526"), gallery: [U("1528181304800-259b08848526"), U("1534008897995-27a23e859048"), U("1508009603885-50cf7c579365")],
  code: "SHTH32", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 7, nights: 6, countriesCount: 1, statesCount: 1, citiesCount: 3, region: "Thailand", zone: "Asia", interest: "Islands, Beaches & City Experiences", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Thailand", stops: ["Krabi (2N)", "Phuket (2N)", "Bangkok (2N)"] }], highlights: ["Krabi Four Island Tour", "Phuket city tour", "Phi Phi Island", "Phuket FantaSea", "Bangkok temple tour"], departureCity: "Phuket", departureCities: ["Phuket (Joining)", "Bangkok (Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Breakfast; selected sightseeing lunches and dinner as listed", flight: false, sightseeing: "Four Island Tour, Phuket city tour, Phi Phi Island tour, FantaSea and Bangkok temple tour as listed", transport: "Airport and intercity transfers as described; confirm shared/private arrangements", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Phuket · Krabi", state: "Thailand", desc: "Arrive in Phuket and transfer onward to Krabi for a two-night stay." },
    { day: 2, title: "Krabi Four Island Tour", state: "Thailand", desc: "Enjoy the Four Island Tour with picnic lunch on a shared basis. National Park fees are extra as indicated by the operator." },
    { day: 3, title: "Krabi · Phuket", state: "Thailand", desc: "Transfer from Krabi to Phuket and check in for a two-night stay. Enjoy the Phuket city tour and FantaSea show according to the confirmed schedule." },
    { day: 4, title: "Phi Phi Island", state: "Thailand", desc: "Take a shared boat excursion to Phi Phi Island with lunch. National Park fees are extra as indicated by the operator." },
    { day: 5, title: "Phuket · Bangkok", state: "Thailand", desc: "Travel from Phuket to Bangkok according to your booked arrangements and check in for a two-night stay." },
    { day: 6, title: "Bangkok temple tour", state: "Thailand", desc: "Enjoy a guided city tour featuring the Golden Buddha and Marble Temple, as listed in the package." },
    { day: 7, title: "Bangkok · Departure", state: "Thailand", desc: "Check out and depart for your hometown according to your onward travel arrangements." },
  ],
});
TOURS.push({
  slug: "mauritius-with-tarisa-resort-and-spa-shmu25", title: "Mauritius with Tarisa Resort & Spa", scope: "world",
  image: U("1514282401047-d79a71a590e8"), gallery: [U("1514282401047-d79a71a590e8"), U("1500375592092-40eb2168fd21"), U("1519046904884-53103b34b206")],
  code: "SHMU25", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 7, nights: 6, countriesCount: 1, statesCount: 1, citiesCount: 1, region: "Mauritius", zone: "Africa", interest: "Island Escape, Beaches & Relaxation", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Mauritius", stops: ["Tarisa Resort & Spa"] }], highlights: ["Tarisa Resort & Spa", "Mauritius island stay", "Beach and resort experiences"], departureCity: "Mauritius", departureCities: ["Mauritius (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Mauritius", state: "Mauritius", desc: "Arrive in Mauritius and transfer to Tarisa Resort & Spa according to your confirmed arrangements." },
    { day: 2, title: "Relax at Tarisa Resort & Spa", state: "Mauritius", desc: "Settle into the resort and enjoy its facilities and coastal setting. Confirm the meal plan included in your booking." },
    { day: 3, title: "Discover Mauritius", state: "Mauritius", desc: "Choose an island excursion or spend the day at leisure according to your selected holiday plan." },
    { day: 4, title: "Mauritius at leisure", state: "Mauritius", desc: "Enjoy resort time or explore the island with optional activities selected for your trip." },
    { day: 5, title: "Explore the island", state: "Mauritius", desc: "Spend a flexible day at the resort or on sightseeing arranged for your customized holiday." },
    { day: 6, title: "A final day in Mauritius", state: "Mauritius", desc: "Enjoy another day at leisure and make the most of the resort. Check optional excursions and meal arrangements with Veena World." },
    { day: 7, title: "Depart from Mauritius", state: "Mauritius", desc: "Check out and depart according to your onward travel arrangements. Confirm exact inclusions and transfers with Veena World." },
  ],
});
TOURS.push({
  slug: "innsbruck-and-surrounds-shat7", title: "Innsbruck and Surrounds", scope: "world",
  image: U("1516483638261-f4dbaf036963"), gallery: [U("1516483638261-f4dbaf036963"), U("1519681393784-d120267933ba"), U("1501785888041-af3ef285b470")],
  code: "SHAT7", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 4, nights: 3, countriesCount: 1, statesCount: 1, citiesCount: 1, region: "Austria", zone: "Europe", interest: "Alpine Scenery, Culture & City Experiences", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Austria", stops: ["Innsbruck (3N)"] }], highlights: ["Innsbruck", "Alpine scenery", "Historic city centre and surrounding destinations"], departureCity: "Innsbruck", departureCities: ["Innsbruck (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Innsbruck", state: "Austria", desc: "Arrive in Innsbruck and check in according to your confirmed hotel and transfer arrangements." },
    { day: 2, title: "Discover Innsbruck", state: "Austria", desc: "Explore Innsbruck's historic centre and mountain setting with sightseeing selected for your customized holiday." },
    { day: 3, title: "Innsbruck and its surroundings", state: "Austria", desc: "Enjoy a day for alpine scenery or a nearby excursion chosen for your itinerary. Confirm seasonal operation and transport details." },
    { day: 4, title: "Depart from Innsbruck", state: "Austria", desc: "Check out and depart according to your onward travel arrangements. Confirm the exact itinerary and inclusions with Veena World." },
  ],
});
TOURS.push({
  slug: "classic-sri-lanka-shsl2", title: "Classic Sri Lanka", scope: "world",
  image: U("1546708973-b339540b5162"), gallery: [U("1546708973-b339540b5162"), U("1588598198321-9735fd524c0b"), U("1586611292717-f828b167408c")],
  code: "SHSL2", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 8, nights: 7, countriesCount: 1, statesCount: 1, citiesCount: 4, region: "Sri Lanka", zone: "Asia", interest: "Heritage, Hill Country & Coastal Experiences", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Sri Lanka", stops: ["Kandy (2N)", "Nuwara Eliya (2N)", "Bentota (2N)", "Colombo (1N)"] }], highlights: ["Kandy", "Nuwara Eliya", "Bentota", "Colombo", "Scenic drive via Kitulgala"], departureCity: "Colombo", departureCities: ["Colombo (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Breakfast and dinner as specified", flight: false, sightseeing: "Sightseeing as listed; entrance fees not included", transport: "Return airport transfers and sightseeing by air-conditioned vehicle with English-speaking chauffeur guide", visa: false },
  itinerary: [
    { day: 1, title: "Colombo · Kandy", state: "Sri Lanka", desc: "Arrive in Colombo and travel to Kandy for a two-night stay." },
    { day: 2, title: "Explore Kandy", state: "Sri Lanka", desc: "Discover Kandy and its surroundings according to the sightseeing plan confirmed for your holiday." },
    { day: 3, title: "Kandy · Nuwara Eliya", state: "Sri Lanka", desc: "Travel to Nuwara Eliya through Sri Lanka's scenic hill country and check in for two nights." },
    { day: 4, title: "Nuwara Eliya", state: "Sri Lanka", desc: "Enjoy time in Nuwara Eliya and explore the town and nearby landscapes as arranged." },
    { day: 5, title: "Nuwara Eliya · Bentota via Kitulgala", state: "Sri Lanka", desc: "Travel toward Bentota via Kitulgala and settle in for a two-night stay." },
    { day: 6, title: "Bentota", state: "Sri Lanka", desc: "Spend the day in Bentota, with coastal activities and sightseeing as selected for your trip." },
    { day: 7, title: "Bentota · Colombo", state: "Sri Lanka", desc: "Return to Colombo and check in for your final night." },
    { day: 8, title: "Colombo · Departure", state: "Sri Lanka", desc: "Transfer to the airport for your onward journey. Entrance fees and any unlisted services should be confirmed with Veena World." },
  ],
});
TOURS.push({
  slug: "sydney-city-break-shau3", title: "Sydney City Break", scope: "world",
  image: U("1506973035872-a4ec16b8e8d9"), gallery: [U("1506973035872-a4ec16b8e8d9"), U("1523482580672-f109ba8cb9be"), U("1506976785307-8732e854ad03")],
  code: "SHAU3", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 4, nights: 3, countriesCount: 1, statesCount: 1, citiesCount: 1, region: "Australia", zone: "Australia & New Zealand", interest: "City Experiences, Harbour & Coastal Scenery", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Australia", stops: ["Sydney (3N)"] }], highlights: ["Sydney", "Sydney Harbour", "City and coastal experiences"], departureCity: "Sydney", departureCities: ["Sydney (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Sydney", state: "Australia", desc: "Arrive in Sydney and check in according to your confirmed arrangements." },
    { day: 2, title: "Discover Sydney", state: "Australia", desc: "Explore Sydney's harbour, landmarks and city neighbourhoods with sightseeing selected for your customized holiday." },
    { day: 3, title: "Sydney at leisure", state: "Australia", desc: "Enjoy a flexible day for coastal scenery, shopping or optional experiences arranged for your trip." },
    { day: 4, title: "Depart from Sydney", state: "Australia", desc: "Check out and depart according to your onward travel arrangements. Confirm exact inclusions and transfers with Veena World." },
  ],
});
TOURS.push({
  slug: "hanoi-halong-shvn2", title: "Hanoi Halong", scope: "world",
  image: U("1528127269322-539801943592"), gallery: [U("1528127269322-539801943592"), U("1531058020387-3be344556be6"), U("1555921015-5532091f6026")],
  code: "SHVN2", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 5, nights: 4, countriesCount: 1, statesCount: 1, citiesCount: 2, region: "Vietnam", zone: "Asia", interest: "Culture, City Experiences & Halong Bay", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Vietnam", stops: ["Hanoi (3N)", "Halong Bay (1N)"] }], highlights: ["Hanoi", "Halong Bay boat trip", "Ninh Binh excursion"], departureCity: "Hanoi", departureCities: ["Hanoi (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Breakfast as specified", flight: false, sightseeing: "Halong Bay boat trip and listed sightseeing; confirm all entry fees", transport: "Private return transfers and sightseeing with English-speaking guide as specified", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Hanoi", state: "Vietnam", desc: "Arrive in Hanoi and settle in for your first night in the city." },
    { day: 2, title: "Hanoi · Halong Bay", state: "Vietnam", desc: "Travel to Halong Bay, approximately 160 km and around four hours, and stay overnight." },
    { day: 3, title: "Halong Bay · Hanoi", state: "Vietnam", desc: "Enjoy a shared boat trip on Halong Bay before returning to Hanoi for a two-night stay." },
    { day: 4, title: "Hanoi · Ninh Binh", state: "Vietnam", desc: "Enjoy the planned excursion from Hanoi to Ninh Binh, then return to the city according to the confirmed schedule." },
    { day: 5, title: "Hanoi · Departure", state: "Vietnam", desc: "Check out and depart for your hometown. Confirm hotel, guide, transfer and sightseeing arrangements with Veena World." },
  ],
});
TOURS.push({
  slug: "highlights-of-georgia-shgo1", title: "Highlights of Georgia", scope: "world",
  image: U("1527838832700-5059252407fa"), gallery: [U("1527838832700-5059252407fa"), U("1565008447742-97f6f38c985c"), U("1555993539-1732b0258235")],
  code: "SHGO1", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 5, nights: 4, countriesCount: 1, statesCount: 1, citiesCount: 1, region: "Georgia", zone: "Europe", interest: "Culture, Historic City & Caucasus Scenery", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Georgia", stops: ["Tbilisi (4N)"] }], highlights: ["Tbilisi", "Georgian culture and cuisine", "Historic landmarks and scenic day-trip options"], departureCity: "Tbilisi", departureCities: ["Tbilisi (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm airport transfers and excursions with Veena World", visa: false },
  itinerary: [
    { day: 1, title: "Arrive in Tbilisi", state: "Georgia", desc: "Arrive in Tbilisi and check in according to your confirmed hotel and transfer arrangements." },
    { day: 2, title: "Discover Tbilisi", state: "Georgia", desc: "Explore the historic streets, architecture and food culture of Tbilisi with sightseeing selected for your customized holiday." },
    { day: 3, title: "Tbilisi and its surroundings", state: "Georgia", desc: "Enjoy a flexible day in the city or choose a nearby excursion available for your selected itinerary." },
    { day: 4, title: "Tbilisi at leisure", state: "Georgia", desc: "Spend the day at leisure or add activities arranged with Veena World." },
    { day: 5, title: "Depart from Tbilisi", state: "Georgia", desc: "Check out and depart according to your onward travel arrangements. Confirm exact itinerary and inclusions with Veena World." },
  ],
});
TOURS.push({
  slug: "best-of-bhutan-shbt2", title: "Best of Bhutan", scope: "world",
  image: U("1544735716-392fe2489ffa"), gallery: [U("1544735716-392fe2489ffa"), U("1579606037247-7e8a4ab06c27"), U("1533158326339-7f3cf2404354")],
  code: "SHBT2", tourType: "CUSTOMIZED HOLIDAYS", speciality: "Customized Holidays", allInclusive: false, popularToday: false,
  days: 7, nights: 6, countriesCount: 1, statesCount: 1, citiesCount: 3, region: "Bhutan", zone: "Asia", interest: "Himalayan Landscapes, Buddhist Heritage & Culture", packageType: "Customized Holiday", startingPrice: null, emiPerMonth: null, rating: null, reviewsCount: 0,
  route: [{ state: "Bhutan", stops: ["Thimphu", "Punakha", "Paro"] }], highlights: ["Thimphu", "Punakha Dzong", "Paro", "Bhutanese culture and Himalayan scenery"], departureCity: "Paro", departureCities: ["Paro (Joining/Leaving)"], dates: [],
  inclusions: { hotel: true, meals: "Confirm meal plan when booking", flight: false, sightseeing: "As selected for customized holiday", transport: "Confirm road transfers and excursions with Veena World", visa: "Confirm entry permit requirements for your nationality" },
  itinerary: [
    { day: 1, title: "Arrive in Paro · Thimphu", state: "Bhutan", desc: "Arrive in Paro and travel to Thimphu according to your confirmed transfer arrangements." },
    { day: 2, title: "Explore Thimphu", state: "Bhutan", desc: "Discover Bhutan's capital and its cultural landmarks with sightseeing selected for your customized holiday." },
    { day: 3, title: "Thimphu · Punakha", state: "Bhutan", desc: "Travel to Punakha through the Himalayan landscape. Confirm the route and any stop at Dochula Pass with Veena World." },
    { day: 4, title: "Discover Punakha", state: "Bhutan", desc: "Explore Punakha and its landmarks, such as Punakha Dzong, if included in your final sightseeing plan." },
    { day: 5, title: "Punakha · Paro", state: "Bhutan", desc: "Continue to Paro and settle in according to your confirmed accommodation plan." },
    { day: 6, title: "Explore Paro", state: "Bhutan", desc: "Enjoy Paro's cultural sights or choose the Tiger's Nest excursion if it is available and included in your customized itinerary." },
    { day: 7, title: "Depart from Paro", state: "Bhutan", desc: "Check out and depart according to your onward travel arrangements. This suggested outline follows the published 7-day, 3-city holiday; confirm exact route, entry requirements and inclusions with Veena World." },
  ],
});
// Each tour gets its own destination photo as banner + matching gallery
TOURS.forEach((t) => {
  const imgs = TOUR_IMAGES[t.slug];
  if (imgs?.length) {
    t.image = imgs[0];
    t.gallery = imgs;
  }
});
